'use strict';

(function () {
  'use strict';

  angular.module('app.usuario.nuevo', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'user',
      create: true,
      type: 'allow'
    }];
    // State
    $stateProvider.state('app.usuario.nuevo', {
      url: '/nuevo',
      templateUrl: 'app/pages/admin/usuario/nuevo/nuevo.tmpl.html',
      controller: 'NuevoUsuarioController as vm',
      user: true,
      permissions: permissions
    });
    try {
      var user = localStorage.getItem('ls.$auth.user');
      user = JSON.parse(user);
      if (user) {
        if (user.profile == 'GOD') {
          msNavigationServiceProvider.saveItem('usuarios.nuevo', {
            title: 'Nuevo Usuario',
            icon: 'fi flaticon-add',
            state: 'app.usuario.nuevo',
            weight: 1,
            permissions: permissions
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var NuevoUsuarioController = function () {
        function NuevoUsuarioController($scope, $q, $toast, $state, $request, $log) {
            _classCallCheck(this, NuevoUsuarioController);

            this.name = 'app.usuario.nuevo';
            this.start($scope);
            this.$q = $q;
            this.$toast = $toast;
            this.$state = $state;
            this.$request = $request;
            this.$log = $log;
            this.maxDate = new Date();
            this.minDate = new Date(angular.copy(this.maxDate).setYear(this.maxDate.getYear() - 100));
            this.loading = false;
            this.profileList = [];
        }

        _createClass(NuevoUsuarioController, [{
            key: 'start',
            value: function start(scope) {
                var _this = this;

                scope.$on('$stateChangeSuccess', function (ev, state) {
                    if (state.name === _this.name) {
                        _this.setup();
                    }
                });
            }
        }, {
            key: 'setup',
            value: function setup() {
                var _this2 = this;

                var filterProfiles = {
                    filter: {
                        'where': {
                            state: true
                        } }
                };
                this.$request('Profile', 'find', filterProfiles).then(function (res) {
                    _this2.loading = false;
                    _this2.profiles = res;
                }, function (err) {
                    if (!err.handled) {
                        if (err.statusCode == 422) {
                            _this2.$toast.error('No se obtener los perfiles de usuario');
                        } else {
                            _this2.$toast.error('No se logró obtener los perfiles de usuario' + err.data.error.message);
                        }
                    }
                });
            }
        }, {
            key: 'doCreate',
            value: function doCreate() {
                var _this3 = this;

                if (this.usuario.password === this.usuario.repeatPassword) {
                    this.loading = true;
                    this.$toast.info('Creando usuario...');
                    this.$request('User', 'create', this.parseUsuario(this.usuario)).then(function (res) {
                        _this3.$toast.info('Usuario creado');
                        _this3.loading = false;
                        _this3.$state.go('app.usuario.listarGod');
                    }, function (err) {
                        if (!err.handled) {
                            if (err.statusCode == 422) {
                                _this3.$toast.error('No se pudo crear el usuario. Ya existe un usuario con este email registrado');
                            } else {
                                _this3.$toast.error('No se logró crear el usuario.' + err.data.error.message);
                            }
                        }
                    }).finally(function () {
                        _this3.loading = false;
                    });
                } else {
                    this.$toast.error('Las contraseñas no coinciden');
                }
            }
        }, {
            key: 'parseUsuario',
            value: function parseUsuario(user) {
                var usuario = angular.copy(user);
                delete usuario.repeatPassword;
                return usuario;
            }
        }]);

        return NuevoUsuarioController;
    }();

    angular.module('app.usuario.nuevo').controller('NuevoUsuarioController', NuevoUsuarioController);
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.usuario.listar', []).config(config);

    function config($stateProvider, msNavigationServiceProvider) {
        var permissions = [{
            key: 'user',
            access: 'none',
            type: 'deny'
        }];
        // State
        $stateProvider.state('app.usuario.listar', {
            url: '/listar',
            templateUrl: 'app/pages/admin/usuario/listar/listar.tmpl.html',
            controller: 'ListarUsuarioController as vm',
            user: true,
            permissions: permissions
        });

        var user = JSON.parse(localStorage.getItem('ls.$auth.user'));
        if (user && user.profile == 'GOD') {
            msNavigationServiceProvider.saveItem('usuarios.listar', {
                title: 'Todos los usuarios',
                icon: 'fi flaticon-list',
                state: 'app.usuario.listar',
                weight: 2,
                permissions: permissions
            });
        }
    }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	var ListarUsuarioController = function ListarUsuarioController($state, $scope, $rootScope) {
		var _this = this;

		_classCallCheck(this, ListarUsuarioController);

		this.$scope = $scope;
		this.$rootScope = $rootScope;
		this.listConfig = {
			model: {
				name: 'User',
				filter: {
					order: 'created DESC',
					where: {
						state: true
					}
				},
				paginate: true,
				errorMessage: 'No se lograron obtener los usuarios',
				successMessage: null
			},
			permission: 'user',
			columns: [{
				key: 'name',
				title: 'Nombre',
				order: true
			}, {
				key: 'lastname',
				title: 'Apellido',
				order: true
			}, {
				key: 'email',
				title: 'Correo electrónico',
				order: true
			}],
			buttons: [{
				title: 'Editar',
				action: {
					type: 'edit'
				},
				clase: 'md-primary md-raised'
			}, {
				title: 'Logs',
				icon: 'icon-file',
				action: function action(ev, user) {
					$state.go('app.logs.ver', { userId: user.id });
				},
				clase: 'md-primary md-raised'
			}, {
				title: 'Borrar',
				model: "User",
				action: {
					type: 'delete',
					title: '¿Borrar usuario?',
					content: 'Esto no se podrá deshacer luego',
					errorMessage: 'No se logró borrar el usuario',
					successMessage: 'Usuario borrado correctamente'
				},
				clase: 'md-warn md-raise'
			}],
			routes: {
				edit: 'app.usuario.editar'
			}
		};

		this.$scope.$watch('vm.search', function (newVal, oldVal) {
			console.log('new val', newVal);
			if (newVal != undefined && oldVal != undefined) {
				var where = {
					state: {
						neq: false
					}
				};

				if (newVal == '' || newVal == undefined) {} else if (newVal) {
					where.or = [];
					where.or.push({ name: { like: ".*" + newVal + ".*", options: "igm" } });
					where.or.push({ lastName: { like: ".*" + newVal + ".*", options: "igm" } });
					where.or.push({ email: { like: ".*" + newVal + ".*", options: "igm" } });
				}

				if (_timeout) {
					clearTimeout(_timeout);
				}
				var _timeout = setTimeout(function () {
					_this.$rootScope.$broadcast('$UpdateUser', where);
				}, 2000);
			}
		});
	};

	angular.module('app.usuario.listar').controller('ListarUsuarioController', ListarUsuarioController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.usuario.editar', []).config(config);

	function config($stateProvider) {
		// State
		var permissions = [{
			key: 'user',
			edit: true,
			type: 'allow'
		}];

		$stateProvider.state('app.usuario.editar', {
			url: '/editar/:id',
			templateUrl: 'app/pages/admin/usuario/editar/editar.tmpl.html',
			controller: 'EditarUsuarioController as vm',
			user: true,
			permissions: permissions
		});
	}
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditarUsuarioController = function () {
    function EditarUsuarioController($scope, $q, $auth, $state, $toast, $timeout, $load, $stateParams, $request, $log) {
        _classCallCheck(this, EditarUsuarioController);

        this.name = 'app.usuario.editar';
        this.start($scope);
        this.$q = $q;
        this.$state = $state;
        this.$toast = $toast;
        this.$auth = $auth;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$request = $request;
        this.$load = $load;
        this.$log = $log;

        this.usuario = {};
    }

    _createClass(EditarUsuarioController, [{
        key: 'start',
        value: function start(scope) {
            var _this = this;

            scope.$on('$stateChangeSuccess', function (ev, state) {
                if (state.name === _this.name) {
                    _this.setup();
                }
            });
        }
    }, {
        key: 'setup',
        value: function setup() {
            var _this2 = this;

            var filterProfiles = {
                filter: {
                    'where': {
                        state: true
                    } }
            };
            if (this.$stateParams.id) {
                this.$request('Profile', 'find', filterProfiles).then(function (res) {
                    _this2.loading = false;
                    _this2.profiles = res;
                }, function (err) {
                    if (!err.handled) {
                        if (err.statusCode == 422) {
                            _this2.$toast.error('No se obtener los perfiles de usuario');
                        } else {
                            _this2.$toast.error('No se logró obtener los perfiles de usuario' + err.data.error.message);
                        }
                    }
                });

                this.logedId = this.$auth.user().id;

                this.$load(this.$stateParams.id, 'User', { include: ['profiles'] }, function (res) {
                    _this2.leerUsuario(res);
                }).catch(function () {
                    _this2.$timeout(function () {
                        _this2.$state.go('app.usuario.listar');
                    }, 2000);
                });
            } else {
                this.$state.go('app.usuario.listar');
            }
        }
    }, {
        key: 'doEdit',
        value: function doEdit() {
            var _this3 = this;

            if (!this.validatePassword(this.usuario)) {
                return false;
            }
            var user = angular.copy(this.usuario);
            this.loading = true;
            this.$toast.info('Actualizando usuario...');
            if (!user.password || user.password.length === 0) {
                delete user.password;
            }
            delete user.repeatPassword;
            user.$save().then(function (user) {
                _this3.$toast.info('Usuario editado correctamente');
                _this3.loading = false;
            }, function (err) {
                _this3.$toast.error('No se logró completar la edición del usuario');
                _this3.loading = false;
            });

            //
        }
    }, {
        key: 'validatePassword',
        value: function validatePassword(user) {
            if (user.password || user.repeatPassword) {
                if (user.password !== user.repeatPassword) {
                    this.$toast.error('Las contraseñas no coinciden');
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }
    }, {
        key: 'leerUsuario',
        value: function leerUsuario(res) {
            this._usuario = angular.copy(res);
            this.usuario = angular.copy(res);
            this.usuario.id = res.id;
        }
    }]);

    return EditarUsuarioController;
}();

angular.module('app.usuario.editar').controller('EditarUsuarioController', EditarUsuarioController);
'use strict';

(function () {
  'use strict';

  angular.module('app.template.nuevo', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'user',
      create: true,
      type: 'allow'
    }];
    // State
    $stateProvider.state('app.template.nuevo', {
      url: '/nuevo',
      templateUrl: 'app/pages/admin/template/nuevo/nuevo.tmpl.html',
      controller: 'NuevoTemplateController as vm',
      user: true,
      permissions: permissions
    });
    try {
      var user = localStorage.getItem('ls.$auth.user');
      user = JSON.parse(user);
      if (user) {
        if (user.profile == 'GOD') {
          msNavigationServiceProvider.saveItem('template.nuevo', {
            title: 'Nuevo Template',
            icon: 'fi flaticon-add',
            state: 'app.template.nuevo',
            weight: 1,
            permissions: permissions
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	var NuevoTemplateController = function () {
		function NuevoTemplateController($scope, $q, $toast, $state, $request, $log) {
			_classCallCheck(this, NuevoTemplateController);

			this.name = 'app.template.nuevo';
			this.start($scope);
			this.$q = $q;
			this.$toast = $toast;
			this.$state = $state;
			this.$request = $request;
			this.$log = $log;
			this.loading = false;
		}

		_createClass(NuevoTemplateController, [{
			key: 'start',
			value: function start(scope) {
				var _this = this;

				scope.$on('$stateChangeSuccess', function (ev, state) {
					if (state.name === _this.name) {
						_this.setup();
					}
				});
			}
		}, {
			key: 'setup',
			value: function setup() {
				this.colorOptions = {
					icon: "brush",
					default: "#f00",
					genericPalette: false,
					history: false
				};
				this.template = {
					header: {
						fonts: {
							defaultColor: '',
							titleColor: ''
						},
						logo: {},
						backgroundColor: '',
						backgroundImage: {}
					},
					body: {
						fonts: {
							defaultColor: '',
							titleColor: ''
						},
						backgroundColor: ''
					},
					details: {
						tab: {
							backgroundActive: '',
							backgroundNormal: '',
							colorActive: '',
							colorDefault: ''
						},
						body: {
							backgroundColor: '',
							titleColor: '',
							colorDefault: ''
						}

					}
				};
			}
		}, {
			key: 'doCreate',
			value: function doCreate() {
				var _this2 = this;

				this.loading = true;
				this.$toast.info('Creando template...');
				this.$request('Template', 'create', this.parseTemplate(this.template)).then(function (res) {
					_this2.$toast.info('Template creada');
					_this2.loading = false;
					_this2.$state.go("app.template.listar");
				}, function (err) {
					if (!err.handled) {
						if (err.statusCode == 422) {
							_this2.$toast.error('No se pudo crear el template. ');
						} else {
							_this2.$toast.error('No se logró crear el template.' + err.data.error.message);
						}
					}
				}).finally(function () {
					_this2.loading = false;
				});
			}
		}, {
			key: 'parseTemplate',
			value: function parseTemplate(user) {
				var template = angular.copy(user);

				return template;
			}
		}]);

		return NuevoTemplateController;
	}();

	angular.module('app.template.nuevo').controller('NuevoTemplateController', NuevoTemplateController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.template.editar', []).config(config);

	function config($stateProvider) {
		// State
		var permissions = [{
			key: 'user',
			edit: true,
			type: 'allow'
		}];

		$stateProvider.state('app.template.editar', {
			url: '/editar/:id',
			templateUrl: 'app/pages/admin/template/editar/editar.tmpl.html',
			controller: 'EditarTemplateController as vm',
			user: true,
			permissions: permissions
		});
	}
})();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditarTemplateController = function () {
	function EditarTemplateController($scope, $q, $auth, $state, $toast, $timeout, $load, $stateParams, $request, $log) {
		_classCallCheck(this, EditarTemplateController);

		this.name = "app.template.editar";
		this.start($scope);
		this.$q = $q;
		this.$state = $state;
		this.$toast = $toast;
		this.$auth = $auth;
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.$request = $request;
		this.$load = $load;
		this.$log = $log;
		this.versions = [1, 2];

		this.template = {};
	}

	_createClass(EditarTemplateController, [{
		key: "start",
		value: function start(scope) {
			var _this = this;

			scope.$on("$stateChangeSuccess", function (ev, state) {
				if (state.name === _this.name) {
					_this.setup();
				}
			});
		}
	}, {
		key: "traerCategorias",
		value: function traerCategorias() {
			var _this2 = this;

			return new Promise(function (resolve, reject) {
				_this2.$request.http("Categoria", "find", {
					filter: {
						where: {
							state: true
						}
					}
				}).then(function (categorias) {
					_this2.categorias = categorias;
					resolve();
				});
			});
		}
	}, {
		key: "changeCategoria",
		value: function changeCategoria() {
			var _this3 = this;

			var fieldsCategorias = _.filter(this.categorias, function (categoria) {
				return _this3.template.categoriaId == categoria.id;
			});
			if (fieldsCategorias.length) {
				fieldsCategorias = _.first(fieldsCategorias).fields;
				console.log('changeCategoria', fieldsCategorias);
				this.fieldsCategorias = fieldsCategorias;
			}
			if (this.template.specs) {
				_.forEach(this.fieldsCategorias, function (field) {
					field.order = _.find(_this3.template.specs, function (val) {
						return val.value == field.value;
					}) ? _.find(_this3.template.specs, function (val) {
						return val.value == field.value;
					}).order : null;
				});
			}
			this.template.specs = this.fieldsCategorias;
		}
	}, {
		key: "setup",
		value: function setup() {
			var _this4 = this;

			if (this.$stateParams.id) {
				this.traerCategorias().then(function () {

					_this4.$load(_this4.$stateParams.id, "Template", { include: ["categoria"] }, function (res) {
						_this4.leerTemplate(res);
					}).catch(function () {
						_this4.$timeout(function () {
							_this4.$state.go("app.template.listar");
						}, 2000);
					});
				});
			} else {
				this.$state.go("app.template.listar");
			}
		}
	}, {
		key: "doEdit",
		value: function doEdit() {
			var _this5 = this;

			var template = angular.copy(this.template);
			this.loading = true;
			this.$toast.info('Actualizando template...');
			template.$save().then(function (res) {
				_this5.$toast.info("Template editado correctamente");
				_this5.loading = false;
			}, function (err) {
				_this5.$toast.error("No se logró completar la edición del template");
				_this5.loading = false;
			});
		}
	}, {
		key: "leerTemplate",
		value: function leerTemplate(res) {
			this.template = angular.copy(res);
			if (!this.template.specs && this.template.categoria) {
				this.template.specs = this.template.categoria.fields;
			}
			this.template.id = res.id;
		}
	}]);

	return EditarTemplateController;
}();

angular.module("app.template.editar").controller("EditarTemplateController", EditarTemplateController);
'use strict';

(function () {
  'use strict';

  angular.module('app.template.listar', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'user',
      access: 'none',
      type: 'deny'
    }];
    // State
    $stateProvider.state('app.template.listar', {
      url: '/listar',
      templateUrl: 'app/pages/admin/template/listar/listar.tmpl.html',
      controller: 'ListarTemplateController as vm',
      user: true,
      permissions: permissions
    });

    var user = JSON.parse(localStorage.getItem('ls.$auth.user'));
    if (user) {
      if (user.profile == 'GOD') {

        msNavigationServiceProvider.saveItem('template.listar', {
          title: 'Listar Templates',
          icon: 'fi flaticon-list',
          state: 'app.template.listar',
          weight: 2,
          permissions: permissions
        });
      }
    }
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	var ListarTemplateController = function ListarTemplateController($state, $scope, $rootScope) {
		var _this = this;

		_classCallCheck(this, ListarTemplateController);

		this.$scope = $scope;
		this.$rootScope = $rootScope;
		this.listConfig = {
			model: {
				name: 'Template',
				filter: {
					order: 'created DESC',
					where: {
						state: true
					}
				},
				paginate: true,
				errorMessage: 'No se lograron obtener los templates',
				successMessage: null
			},
			columns: [{
				key: 'name',
				title: 'Nombre',
				order: true
			}],
			buttons: [{
				title: 'Editar',
				action: {
					type: 'edit'
				},
				clase: 'md-primary md-raised'
			}, {
				title: 'Borrar',
				action: {
					type: 'delete',
					title: '¿Borrar template?',
					content: 'Esto no se podrá deshacer luego',
					errorMessage: 'No se logró borrar el template',
					successMessage: 'Template borrado correctamente'
				},
				clase: 'md-warn md-raise'
			}],
			routes: {
				edit: 'app.template.editar'
			}
		};

		this.$scope.$watch('vm.search', function (newVal, oldVal) {

			if (newVal != undefined && oldVal != undefined) {
				var where = {
					state: {
						neq: false
					}
				};

				if (newVal == '' || newVal == undefined) {} else if (newVal) {
					where.or = [];
					where.or.push({ nombre: { like: ".*" + newVal + ".*", options: "igm" } });
				}

				if (_timeout) {
					clearTimeout(_timeout);
				}
				var _timeout = setTimeout(function () {
					_this.$rootScope.$broadcast('$UpdateTemplate', where);
				}, 2000);
			}
		});
	};

	angular.module('app.template.listar').controller('ListarTemplateController', ListarTemplateController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.reportes.resumen', []).config(config);

	function config($stateProvider, msNavigationServiceProvider) {
		var permissions = [{
			key: 'vehiculo',
			create: true,
			type: 'allow'
		}];
		// State
		$stateProvider.state('app.reportes.resumen', {
			url: '/resumen',
			templateUrl: 'app/pages/admin/reportes/resumen/resumen.tmpl.html',
			controller: 'ReportesResumenController as vm',
			permissions: permissions
		});

		msNavigationServiceProvider.saveItem('reportes.resumen', {
			title: 'Resumen Reportes',
			icon: 'fi flaticon-add',
			state: 'app.reportes.resumen',
			weight: 2,
			permissions: permissions
		});
	}
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.reportes.resumen').controller('ReportesResumenController', ReportesResumenController);

  /** @ngInject */
  function ReportesResumenController($scope, $q, $rootScope, $auth, $request, $state, $toast, NgMap) {
    var vm = this;
    vm.API_KEY = 'ydPaSNoglenWdrFjw2fR3hefLPrGfQ';
    vm.color = "#28B463";
    vm.obtenerFlota = obtenerFlota;

    if ($auth.isAdminFlota()) {
      vm.isAdminFlota = true;
    }
    vm.horas = [];
    for (var i = 0; i <= 23; i++) {
      vm.horas.push({ hora: i, horaF: i < 10 ? '0' + i + ':00' : i + ':00' });
    }
    vm.horas.push({ hora: 23.1, horaF: '24:00' });

    vm.horaInicio = 0;
    vm.horaFin = 23.1;

    NgMap.getMap().then(function (map) {
      vm.map = map;
    });

    function obtenerFlota() {
      if ($auth.isAdminFlota()) {
        vm.flotaId = $auth.isAdminFlota();
        listVehiculos();
      } else {
        var filter = {
          filter: {
            where: {
              state: true
            },
            include: ['vehiculos']
          }
        };
        $request.http('Flota', 'find', filter, function (res) {
          vm.flotas = res;
        });
      }
    }

    obtenerFlota();

    vm.listVehiculos = listVehiculos;

    function listVehiculos() {

      var filter = {
        where: {
          flotaId: vm.flotaId,
          state: true
        }
      };
      $request.http('Vehiculo', 'find', { filter: filter }, function (res) {
        vm.vehiculos = res;
        vm.loading = false;
      });
    }

    vm.print = print;
    function print() {

      window.print();
    }

    /**
     * Obtiene las geo dado cierto rango horario
     * @param startDate
     * @param endDate
     * @param vehiculoId
     */

    vm.buscar = buscar;

    function buscar() {

      $toast.info('Cargando información...');
      vm.loading = true;
      $rootScope.loadingProgress = true;
      vm.markers = [];
      try {
        vm.map.shapes.foo.setMap(null);
      } catch (e) {
        console.log(e);
      }
      var data = {
        vehiculoId: vm.vehiculoId,
        horaInicio: vm.horaInicio,
        horaFin: vm.horaFin,
        day: moment(vm.fecha).dayOfYear() + 1
      };

      $request.http('Ubicacion', 'obtenerData', data, function (res) {

        vm.loading = false;
        $rootScope.loadingProgress = false;
        vm.data = res.ubicaciones;
        vm.distancia = res.distancia;

        if (res.ubicaciones.length == 0) {
          $toast.info('No existen datos registrados');
        }

        try {
          vm.map.shapes.foo.setMap(vm.map);
        } catch (e) {
          console.log(e);
        }

        formatPath(false);

        estadisticas(vm.data);
      });
    }

    vm.ajustar = ajustar;

    function ajustar() {

      $toast.info('Cargando información...');
      vm.markers = [];
      try {
        vm.map.shapes.foo.setMap(null);
      } catch (e) {
        console.log(e);
      }

      var data = {
        vehiculoId: vm.vehiculoId,
        horaInicio: vm.horaInicio,
        horaFin: vm.horaFin,
        day: moment(vm.fecha).dayOfYear() + 1
      };

      vm.loading = true;
      $rootScope.loadingProgress = true;

      $request.http('Ubicacion', 'ajustar', data, function (ubicacionGoogle) {

        if (ubicacionGoogle.ubicaciones.length == 0) {
          $toast.info('No existen datos registrados');
          return;
        }
        vm.data = ubicacionGoogle.ubicaciones;
        vm.distancia = ubicacionGoogle.distancia;

        formatPath(true);
        vm.map.shapes.foo.setMap(vm.map);
        estadisticas(vm.data);

        vm.loading = false;
        $rootScope.loadingProgress = false;
      });
    }

    function formatPath(ajustado) {
      vm.markers = [];
      var path = [];
      var markers = [];
      vm.color = "#28B463";
      var conductor = void 0;
      var lastPoint;
      _.forEach(vm.data, function (point, index) {
        if (point.conductor) {
          conductor = point.conductor;
        }
        var marker = void 0;
        if (!ajustado) {
          if (lastPoint && moment(point.time).diff(lastPoint.time, 'seconds') > 40) {
            console.log(moment(point.time).diff(lastPoint.time, 'seconds'), 'sec');
            vm.color = "#28B463";
            marker = {
              id: point.id,
              position: point.coords2.latitude + ',' + point.coords2.longitude,
              hora: moment(point.time).format('DD-MM-Y H:mm:ss'),
              velocidad: Math.round(point.velocidad),
              icon: '/assets/images/negro.png'
            };

            if (conductor) {
              marker.conductor = conductor.name;
              if (conductor.lastname) {
                marker.conductor = conductor.name + ' ' + (conductor.lastname || conductor.lastName);
              }
            }
            markers.push(marker);
            lastPoint = point;
          } else if (!lastPoint) {
            marker = {
              id: point.id,
              position: point.coords2.latitude + ',' + point.coords2.longitude,
              hora: moment(point.time).format('DD-MM-Y H:mm:ss'),
              velocidad: Math.round(point.velocidad),
              icon: '/assets/images/negro.png'
            };
            markers.push(marker);
            lastPoint = point;
          } else {
            console.log(moment(point.time).diff(lastPoint.time, 'seconds'), 'sec');
          }
        }
        path.push(point.coords3);
      });
      vm.center = path[0];
      vm.markers = angular.copy(markers);
      vm.path = angular.copy(path);

      vm.loading = false;
      $rootScope.loadingProgress = false;
    }

    vm.printDiv = function () {
      var printContents = document.getElementById("print").innerHTML;
      var popupWin = window.open('', '_blank', 'width=800,height=1000');
      popupWin.document.open();
      popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + printContents + '</body></html>');
      popupWin.document.close();
    };

    vm.showDetail = function (e, marker) {
      vm.nombreConductor = marker.conductor;
      vm.velocidad = marker.velocidad;
      vm.hora = marker.hora;
      vm.map.showInfoWindow('foo-iw', marker.id);
    };

    vm.hideDetail = function () {
      vm.map.hideInfoWindow('foo-iw');
    };

    function estadisticas(data) {
      vm.tiempoInicio = moment('2020-01-01');
      vm.tiempoFin = moment('2000-01-01');
      vm.vMax = 0;
      vm.vMin = 0;
      vm.vProm = 0;

      _.forEach(data, function (point, index) {
        if (point.time) {

          if (moment(point.time).isBefore(moment(vm.tiempoInicio))) {
            vm.tiempoInicio = point.time;
          }
          if (moment(point.time).isAfter(moment(vm.tiempoFin))) {
            vm.tiempoFin = point.time;
          }
          if (point.velocidad > vm.vMax) {
            if (point.velocidad < 150) {
              vm.vMax = point.velocidad.toFixed(1);
            }
          }
          if (point.velocidad < vm.vMin) {}
        }
      });

      vm.durationHours = Math.round(moment(vm.tiempoFin).diff(moment(vm.tiempoInicio), 'hours', true) * 100) / 100;
      var duration = moment.duration(moment(vm.tiempoFin).diff(moment(vm.tiempoInicio)));
      vm.duration = duration.hours() + ':' + duration.minutes() + ':' + duration.seconds();
      vm.vProm = Math.round(vm.distancia / vm.durationHours * 100) / 100;
      vm.tiempoInicio = moment(vm.tiempoInicio).format('DD-MM-Y H:mm:ss');
      vm.tiempoFin = moment(vm.tiempoFin).format('DD-MM-Y H:mm:ss');
    }
  }
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.settings.settings', []).config(config);

	function config($stateProvider, msNavigationServiceProvider) {
		var permissions = [{
			key: 'admin',
			access: 'none',
			type: 'deny'
		}];
		// State
		$stateProvider.state('app.settings.settings', {
			url: '/terms',
			templateUrl: 'app/pages/admin/settings/settings/settings.tmpl.html',
			controller: 'SettingsController as vm',
			permissions: permissions
		});
	}
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var $s = new Map();
  var $inject = ['$request', '$toast', '$log'];

  var SettingsController = function () {
    function SettingsController() {
      _classCallCheck(this, SettingsController);

      this.terms = {
        content: ''
      };
      this.service(arguments);
      this.distancias = [0, 10, 100, 1000];
      this.cargar();
    }

    _createClass(SettingsController, [{
      key: 'service',
      value: function service(args) {
        if (angular.isString(args)) {
          return $s.get(args);
        } else {
          _.each(args, function (arg, i) {
            $s.set($inject[i], arg);
          });
        }
      }
    }, {
      key: 'cargar',
      value: function cargar() {
        var _this = this;

        $s.get('$toast').show('Obteniendo...');
        $s.get('$request')('Settings', 'findOne').then(function (settings) {
          _this.settings = settings;
        }).catch(function (err) {
          $s.get('$log').error(err);
          $s.get('$toast').error('No se logró obtener la configuración actual');
        });
      }
    }, {
      key: 'guardar',
      value: function guardar() {
        $s.get('$toast').show('Guardando...');
        $s.get('$request')('Settings', 'upsert', this.settings).then(function () {
          $s.get('$toast').success('Términos actualizados correctamente');
        }).catch(function (err) {
          $s.get('$log').error(err);
          $s.get('$toast').error('No se lograron actualizar los términos y condiciones');
        });
      }
    }]);

    return SettingsController;
  }();

  SettingsController.$inject = $inject;

  angular.module('app.settings.settings').controller('SettingsController', SettingsController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.reportes.realtime', []).config(config);

	function config($stateProvider, msNavigationServiceProvider) {
		var permissions = [{
			key: 'vehiculo',
			create: true,
			type: 'allow'
		}];
		// State
		$stateProvider.state('app.reportes.realtime', {
			url: '/realtime',
			templateUrl: 'app/pages/admin/reportes/realtime/realtime.tmpl.html',
			controller: 'ReportesRealtimeController as vm',
			permissions: permissions
		});

		msNavigationServiceProvider.saveItem('reportes.realtime', {
			title: 'Real time',
			icon: 'fi flaticon-add',
			state: 'app.reportes.realtime',
			weight: 1,
			permissions: permissions
		});
	}
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.reportes.realtime').controller('ReportesRealtimeController', ReportesRealtimeController);

	/** @ngInject */
	function ReportesRealtimeController($scope, $q, $auth, $request, $interval, $state, $toast, NgMap) {
		var vm = this;
		vm.API_KEY = 'ydPaSNoglenWdrFjw2fR3hefLPrGfQ';
		vm.color = '#28B463';
		vm.obtenerFlota = obtenerFlota;
		vm.markers = [];
		vm.vehiculosSelected = [];

		$scope.$on('$stateChangeSuccess', function (ev, state) {
			if (state.name === 'app.reportes.realtime') {
				vm.actualizar();
				vm.actualizando = $interval(vm.actualizar, 4000);
				//console.log(vm.actualizar());
			} else {
				if (vm.actualizando) {
					$interval.cancel(vm.actualizando);
				}
			}
		});

		if ($auth.isAdminFlota()) {
			vm.isAdminFlota = true;
		}

		NgMap.getMap().then(function (map) {
			vm.map = map;
		});

		function obtenerFlota() {
			if ($auth.isAdminFlota()) {
				vm.flotaId = $auth.isAdminFlota();
				listVehiculos();
			} else {
				var filter = {
					filter: {
						where: {
							state: true
						},
						include: ['vehiculos']
					}
				};
				$request.http('Flota', 'find', filter, function (res) {
					vm.flotas = res;
				});
			}
		}

		obtenerFlota();

		vm.listVehiculos = listVehiculos;

		function listVehiculos() {
			var filter = {
				where: {
					flotaId: vm.flotaId
				}
			};
			$request.http('Vehiculo', 'find', { filter: filter }, function (res) {
				vm.vehiculos = res;
				// SI EL USUARIO ES ADMIN DE FLOTA, MARCAMOS TODOS LOS VEHICULOS POR DEFAULT
				if ($auth.isAdminFlota()) {
					_.forEach(vm.vehiculos, function (vehiculo) {
						vm.vehiculosSelected.push(vehiculo.id);
					});
				}
				vm.loading = false;
			});
		}

		/**
   * Obtiene las geo dado cierto rango horario
   * @param startDate
   * @param endDate
   * @param vehiculoId
   */

		vm.actualizar = actualizar;
		function actualizar() {
			//_.forEach(vm.vehiculosSelected, function (vehiculoId) {
			if (vm.vehiculosSelected && vm.vehiculosSelected.length > 0) {
				obtenerUbicacion(vm.vehiculosSelected);
			}
			//});
		}

		vm.changeVehiculos = changeVehiculos;
		function changeVehiculos() {
			vm.markers = [];
		}

		function obtenerUbicacion(vehiculos) {
			/*if (!vm.markers[vehiculoId]) {
    vm.markers[vehiculoId] = [];
    }*/
			var filter = { vehiculosId: vehiculos };
			if (vm.box) {
				filter.box = vm.box;
			}
			$request.http('Ubicacion', 'realtime', filter).then(function (ubicaciones) {
				var markers = [];
				_.each(ubicaciones, function (point) {
					if (point) {
						var marker = {
							id: point.vehiculo.id,
							vehiculoId: point.vehiculo.id,
							position: point.coords2.latitude + ',' + point.coords2.longitude,
							coords: point.coords2,
							hora: moment(point.time).format('DD-MM-YYYY H:mm:ss'),
							templateInfo: '<b>Patente:</b> ' + point.vehiculo.patente + ' <br/>\n\t\t\t\t\t\t\t\t\t<b>Hora:</b> ' + moment(point.time).format('DD-MM-YYYY H:mm:ss') + ' <br/>\n\t\t\t\t\t                <b>Conductor:</b> ' + point.conductor.name + ' ' + point.conductor.lastname + '<br/>'
						};
						if (point.vehiculo) {
							marker.patente = point.vehiculo.patente;
						}
						if (point.conductor) {
							marker.conductor = point.conductor.name + ' ' + point.conductor.lastname;
						}
						var now = moment();
						var timeMarker = moment(point.time);
						var diferenciaMinutos = moment().diff(timeMarker, 'minutes');

						if (diferenciaMinutos > 3) {
							marker.icon = '/assets/images/rojo.png';
						} else {
							marker.icon = '/assets/images/negro.png';
						}
						markers.push(marker);
						vm.oneRequest = true;
					}
				});

				vm.markers = markers;

				/*let marker = {
     id: point.id,
     vehiculoId: point.vehiculoId,
     position: point.coords2.latitude + ',' +
     point.coords2.longitude,
     coords: point.coords2,
     hora: moment(point.time).format('DD-MM-YYYY H:mm:ss')
     };
     if (point.vehiculo) {
     marker.patente = point.vehiculo.patente;
     }
     if (point.conductor) {
     marker.conductor = point.conductor.name;
     if (point.conductor.lastname) {
     marker.conductor = point.conductor.name + ' ' +
     point.conductor.lastname;
     }
     }
     let now = moment();
     let timeMarker = moment(point.time);
    	 let diferencia = moment.duration(now.diff(timeMarker))
     .minutes();
     //console.log('diferencia', diferencia);
     if (diferencia > 3) {
     marker.icon = '/assets/images/colectivo4.png';
     } else {
     marker.icon = '/assets/images/colectivo3.png';
     }
     marker.diferencia = diferencia;
    	 updateMarker(vehiculoId, marker);*/
			});
		}

		vm.showDetail = function (e, marker) {
			vm.nombreConductor = marker.conductor;
			vm.hora = marker.hora;
			vm.patente = marker.patente || '';
			vm.diferencia = marker.diferencia || '';
			vm.map.showInfoWindow('foo-iw', marker.id);
		};

		vm.hideDetail = function () {
			vm.map.hideInfoWindow('foo-iw');
		};

		vm.onMove = function (map, bounds) {
			var boundJSON = bounds.toJSON();
			var box = [];

			box.push([boundJSON.south, boundJSON.east]);
			box.push([boundJSON.north, boundJSON.west]);

			if (vm.markers && vm.oneRequest) {
				vm.box = box;
				vm.actualizar();
			}
		};

		var updateMarker = function updateMarker(vehiculoId, marker) {
			if (!vm.center) {
				vm.center = marker.position;
			}
			var index = _.findIndex(vm.markers, function (marker) {
				return marker.vehiculoId === vehiculoId;
			});
			if (index < 0) {
				vm.markers.push(marker);
				//console.log('se pushea');
			} else {
				vm.markers[index] = marker;
				//console.log('se actualiza');
			}
			//console.log(vm.markers);
		};
	}
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.playbooks.ver', []).config(config);

	function config($stateProvider, msNavigationServiceProvider) {
		// State
		var permissions = [{
			key: 'user',
			edit: true,
			type: 'allow'
		}];

		$stateProvider.state('app.playbooks.ver', {
			url: '/ver',
			templateUrl: 'app/pages/admin/playbooks/ver/ver.tmpl.html',
			controller: 'VerPlaybooksController as vm',
			user: true,
			permissions: permissions
		});

		try {
			var user = localStorage.getItem('ls.$auth.user');
			user = JSON.parse(user);
			if (user) {
				if (user.profile == 'GOD' || user.profile == 'HP' || user.profile == 'REVISOR' || user.profile == 'RETAIL') {

					msNavigationServiceProvider.saveItem('playbooks.ver', {
						title: 'Explorar Playbooks',
						icon: 'fi flaticon-add',
						state: 'app.playbooks.ver',
						weight: 1,
						permissions: permissions
					});
				}
			}
		} catch (e) {
			console.log(e);
		}
	}
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VerPlaybooksController = function () {
    function VerPlaybooksController($scope, $q, $auth, $state, $toast, $timeout, $load, $stateParams, $request, $log) {
        _classCallCheck(this, VerPlaybooksController);

        this.name = 'app.playbooks.ver';
        this.start($scope);
        this.$q = $q;
        this.$state = $state;
        this.$toast = $toast;
        this.$auth = $auth;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$request = $request;
        this.$load = $load;
        this.$log = $log;

        this.playbooks = {};
    }

    _createClass(VerPlaybooksController, [{
        key: 'start',
        value: function start(scope) {
            var _this = this;

            scope.$on('$stateChangeSuccess', function (ev, state) {
                if (state.name === _this.name) {
                    _this.setup();
                }
            });
        }
    }, {
        key: 'setup',
        value: function setup() {
            var _this2 = this;

            this.$request('Playbook', 'find', { filter: { where: { 'state': true } } }).then(function (res) {
                _this2.playbooks = res;
                _this2.loading = false;
            }, function (err) {}).finally(function () {
                _this2.loading = false;
            });
        }
    }, {
        key: 'setPlaybook',
        value: function setPlaybook(playbook) {
            this.playbook = playbook;
            this.ciclos = _.groupBy(this.playbook.items, function (item) {
                return item.ciclo;
            });
            this.ciclosKeys = _.keys(this.ciclos);
        }
    }, {
        key: 'verTodos',
        value: function verTodos(playbook) {
            this.playbook = playbook;
            this.allItems = _.orderBy(playbook.items, ['ano', 'ciclo'], ['desc', 'desc']);
        }
    }, {
        key: 'cerrarTodos',
        value: function cerrarTodos() {
            this.playbook = null;
            this.allItems = null;
        }
    }, {
        key: 'setCiclo',
        value: function setCiclo(ciclo) {
            this.ciclo = ciclo;
            this.items = _.filter(this.playbook.items, function (item) {
                return item.ciclo == ciclo;
            });

            this.items = _.orderBy(this.items, ['ano', 'ciclo'], ['desc', 'desc']);
        }
    }, {
        key: 'volverAciclos',
        value: function volverAciclos() {
            this.items = null;
            this.ciclo = null;
        }
    }, {
        key: 'cerrarCiclos',
        value: function cerrarCiclos() {
            this.playbook = null;
            this.ciclos = null;
        }
    }]);

    return VerPlaybooksController;
}();

angular.module('app.playbooks.ver').controller('VerPlaybooksController', VerPlaybooksController);
'use strict';

(function () {
  'use strict';

  angular.module('app.playbooks.nuevo', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'user',
      create: true,
      type: 'allow'
    }];
    // State
    $stateProvider.state('app.playbooks.nuevo', {
      url: '/nuevo',
      templateUrl: 'app/pages/admin/playbooks/nuevo/nuevo.tmpl.html',
      controller: 'NuevoPlaybooksController as vm',
      user: true,
      permissions: permissions
    });
    try {
      var user = localStorage.getItem('ls.$auth.user');
      user = JSON.parse(user);
      if (user) {
        if (user.profile == 'GOD') {
          msNavigationServiceProvider.saveItem('playbooks.nuevo', {
            title: 'Nuevo Playbooks',
            icon: 'fi flaticon-add',
            state: 'app.playbooks.nuevo',
            weight: 1,
            permissions: permissions
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var NuevoPlaybooksController = function () {
        function NuevoPlaybooksController($scope, $q, $toast, $state, $request, $log) {
            _classCallCheck(this, NuevoPlaybooksController);

            this.name = 'app.playbooks.nuevo';
            this.start($scope);
            this.$q = $q;
            this.$toast = $toast;
            this.$state = $state;
            this.$request = $request;
            this.$log = $log;
            this.loading = false;
            this.profileList = [];
            this.meses = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        }

        _createClass(NuevoPlaybooksController, [{
            key: 'start',
            value: function start(scope) {
                var _this = this;

                scope.$on('$stateChangeSuccess', function (ev, state) {
                    if (state.name === _this.name) {
                        _this.setup();
                    }
                });
            }
        }, {
            key: 'removeItem',
            value: function removeItem($index) {
                this.playbook.items.splice($index, 1);
            }
        }, {
            key: 'setup',
            value: function setup() {
                this.playbook = {
                    name: '',
                    items: [{ 'name': 'Nombre...', ciclo: 'Ciclo 1', 'mes': 1, 'ano': 2020, 'fechaCreacion': new Date(), descripcion: 'desc', file: null, editing: true }]
                };
            }
        }, {
            key: 'addItem',
            value: function addItem() {
                var newValue = { 'name': 'Nombre...', ciclo: 'Ciclo 1', 'mes': 'Enero', 'ano': 2020, 'fechaCreacion': new Date(), descripcion: 'desc', file: null, editing: true };
                this.playbook.items.push(newValue);
            }
        }, {
            key: 'removeItem',
            value: function removeItem($index) {
                this.playbook.items.splice($index, 1);
            }
        }, {
            key: 'doCreate',
            value: function doCreate() {
                var _this2 = this;

                this.loading = true;
                this.playbook.state = true;

                this.$toast.info('Creando playbook...');
                this.$request('Playbook', 'create', this.parsePlaybooks(this.playbook)).then(function (res) {
                    _this2.$toast.info('Playbooks creado');
                    _this2.loading = false;
                    _this2.$state.go('app.playbooks.listar');
                }, function (err) {}).finally(function () {
                    _this2.loading = false;
                });
            }
        }, {
            key: 'parsePlaybooks',
            value: function parsePlaybooks(user) {
                var playbook = angular.copy(user);
                return playbook;
            }
        }]);

        return NuevoPlaybooksController;
    }();

    angular.module('app.playbooks.nuevo').controller('NuevoPlaybooksController', NuevoPlaybooksController);
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.playbooks.listar', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'user',
      access: 'none',
      type: 'deny'
    }];
    // State
    $stateProvider.state('app.playbooks.listar', {
      url: '/listar',
      templateUrl: 'app/pages/admin/playbooks/listar/listar.tmpl.html',
      controller: 'ListarPlaybooksController as vm',
      user: true,
      permissions: permissions
    });

    var user = JSON.parse(localStorage.getItem('ls.$auth.user'));
    if (user) {
      if (user.profile == 'GOD') {
        msNavigationServiceProvider.saveItem('playbooks.listar', {
          title: 'Listar Playbooks',
          icon: 'fi flaticon-list',
          state: 'app.playbooks.listar',
          weight: 2,
          permissions: permissions
        });
      }
    }
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	var ListarPlaybooksController = function ListarPlaybooksController($state, $scope, $rootScope) {
		_classCallCheck(this, ListarPlaybooksController);

		this.$scope = $scope;
		this.$rootScope = $rootScope;
		this.listConfig = {
			model: {
				name: 'Playbook',
				filter: {
					order: 'created DESC',
					where: {
						state: true
					}
				},
				paginate: true,
				errorMessage: 'No se lograron obtener los playbooks',
				successMessage: null
			},
			columns: [{
				key: 'name',
				title: 'Nombre',
				order: true
			}],
			buttons: [{
				title: 'Editar',
				action: {
					type: 'edit'
				},
				clase: 'md-primary md-raised'
			}, {
				title: 'Borrar',
				action: {
					type: 'delete',
					title: '¿Borrar playbooks?',
					content: 'Esto no se podrá deshacer luego',
					errorMessage: 'No se logró borrar el playbooks',
					successMessage: 'Playbooks borrado correctamente'
				},
				clase: 'md-warn md-raise'
			}],
			routes: {
				edit: 'app.playbooks.editar'
			}
		};
	};

	angular.module('app.playbooks.listar').controller('ListarPlaybooksController', ListarPlaybooksController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.playbooks.editar', []).config(config);

	function config($stateProvider) {
		// State
		var permissions = [{
			key: 'user',
			edit: true,
			type: 'allow'
		}];

		$stateProvider.state('app.playbooks.editar', {
			url: '/editar/:id',
			templateUrl: 'app/pages/admin/playbooks/editar/editar.tmpl.html',
			controller: 'EditarPlaybooksController as vm',
			user: true,
			permissions: permissions
		});
	}
})();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditarPlaybooksController = function () {
	function EditarPlaybooksController($scope, $q, $auth, $state, $toast, $timeout, $load, $stateParams, $request, $log) {
		_classCallCheck(this, EditarPlaybooksController);

		this.name = "app.playbooks.editar";
		this.start($scope);
		this.$q = $q;
		this.$state = $state;
		this.$toast = $toast;
		this.$auth = $auth;
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.$request = $request;
		this.$load = $load;
		this.$log = $log;
		this.meses = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
		this.playbooks = {};
	}

	_createClass(EditarPlaybooksController, [{
		key: "start",
		value: function start(scope) {
			var _this = this;

			scope.$on("$stateChangeSuccess", function (ev, state) {
				if (state.name === _this.name) {
					_this.setup();
				}
			});
		}
	}, {
		key: "setup",
		value: function setup() {
			var _this2 = this;

			if (this.$stateParams.id) {

				this.$load(this.$stateParams.id, "Playbook", function (res) {
					_this2.leerPlaybook(res);
				}).catch(function () {
					_this2.$timeout(function () {
						_this2.$state.go("app.playbooks.listar");
					}, 2000);
				});
			} else {
				this.$state.go("app.playbooks.listar");
			}
		}
	}, {
		key: "removeItem",
		value: function removeItem($index) {
			this.playbook.items.splice($index, 1);
		}
	}, {
		key: "addItem",
		value: function addItem() {
			var newValue = { 'name': 'Nombre...', ciclo: 'Ciclo 1', 'mes': 1, 'ano': 2020, 'fechaCreacion': new Date(), descripcion: 'desc', file: null, editing: true };
			this.playbook.items.push(newValue);
		}
	}, {
		key: "doEdit",
		value: function doEdit() {
			var _this3 = this;

			var playbook = angular.copy(this.playbook);

			this.$toast.info('Actualizando playbook...');

			playbook.$save().then(function (playbookEditado) {
				_this3.$toast.info("playbook editado");
			}).catch(function () {
				_this3.$toast.error("No se logró completar la edición del playbook");
			}).finally(function () {
				_this3.loading = false;
			});
		}
	}, {
		key: "leerPlaybook",
		value: function leerPlaybook(res) {
			this.playbook = angular.copy(res);
			this.playbook.id = res.id;
		}
	}]);

	return EditarPlaybooksController;
}();

angular.module("app.playbooks.editar").controller("EditarPlaybooksController", EditarPlaybooksController);
'use strict';

(function () {
  'use strict';

  angular.module('app.perfil.nuevo', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'perfil',
      create: true,
      type: 'allow'
    }];
    // State
    $stateProvider.state('app.perfiles.nuevo', {
      url: '/nuevo',
      templateUrl: 'app/pages/admin/perfiles/nuevo/nuevo.tmpl.html',
      controller: 'NuevoPerfilController as vm',
      permissions: permissions
    });
    var user = JSON.parse(localStorage.getItem('ls.$auth.user'));
    if (_.findIndex(user.profiles, function (profile) {
      return profile.identifier == 'GOD';
    }) != -1) {
      msNavigationServiceProvider.saveItem('perfiles.nuevo', {
        permissions: permissions,
        title: 'Nuevo perfil',
        icon: 'fi flaticon-add',
        state: 'app.perfiles.nuevo',
        weight: 2
      });
    }
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	var NuevoPerfilController = function () {
		function NuevoPerfilController($scope, $permission, $toast, $profile, $state, $request, $log) {
			_classCallCheck(this, NuevoPerfilController);

			this.name = 'app.perfiles.nuevo';
			this.$permission = $permission;
			this.$log = $log;
			this._$profile = $profile;
			this.$toast = $toast;
			this.$request = $request;
			this.$state = $state;

			this.start($scope);
		}

		_createClass(NuevoPerfilController, [{
			key: 'start',
			value: function start(scope) {
				var _this = this;

				scope.$on('$stateChangeSuccess', function (ev, state) {
					if (state.name === _this.name) {
						_this.setup();
					}
				});
			}
		}, {
			key: 'setup',
			value: function setup() {
				var _this2 = this;

				this.loading = true;
				this.profiles = this._$profile.getProfile();
				this.$permission.settings().then(function (res) {
					_this2.permissions = res;
				}).catch(function (err) {
					_this2.$log.error(err);
				}).finally(function () {
					_this2.loading = false;
				});
			}
		}, {
			key: 'parsePermission',
			value: function parsePermission() {
				var permissions = {};
				_.each(this.permissions, function (permission) {
					permission.name = angular.copy(permission.type);
					delete permission.type;
					permissions[permission.name] = permission;
				});
				return permissions;
			}
		}, {
			key: 'isAllowed',
			value: function isAllowed(permiso, key, value) {
				if (permiso && this.profiles && this.profiles[permiso.type]) {
					var permi = angular.copy(this.profiles[permiso.type]);
					if (key) {
						if (value) {
							if (value === 'all') {
								return permi[key] === value;
							} else if (value === 'owner') {
								return permi[key] === 'all' || permi[key] === 'owner';
							} else if (value === 'none') {
								return true;
							}
						} else {
							return permi[key];
						}
					} else {
						if (permi.create || permi.edit || permi.remove || permi.access !== 'none') {
							return true;
						}
					}
				}
				return false;
			}
		}, {
			key: 'crear',
			value: function crear() {
				var _this3 = this;

				this.loading = true;
				this.$request.http('Profile', 'create', this.perfil).then(function (profile) {
					_this3.$request.http('Profile', 'permisos', 'create', { id: profile.id }, _this3.parsePermission()).then(function () {
						_this3.$toast.success('Perfil creado correctamente');
						_this3.$state.go('app.perfiles.listar');
					}).catch(function (err) {
						_this3.$log.error(err);
						_this3.$toast.error('No se lograron crear los permisos, inténtalo de nuevo');
						_this3.$request.http('Profile', 'deleteById', { id: profile.id });
					}).finally(function () {
						_this3.loading = false;
					});
				}).catch(function (err) {
					_this3.$log.error(err);
					_this3.$toast.error('No se logró crear el perfil, inténtalo de nuevo');
					_this3.loading = false;
				});
			}
		}]);

		return NuevoPerfilController;
	}();

	angular.module('app.perfil.nuevo').controller('NuevoPerfilController', NuevoPerfilController);
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.perfil.listar', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {

    var permissions = [{
      key: 'perfil',
      access: 'none',
      type: 'deny'
    }];
    // State
    $stateProvider.state('app.perfiles.listar', {
      url: '/listar',
      templateUrl: 'app/pages/admin/perfiles/listar/ver.tmpl.html',
      controller: 'ListarPerfilController as vm',
      permissions: permissions,
      user: true,
      root: true
    });
    var user = JSON.parse(localStorage.getItem('ls.$auth.user'));
    if (_.findIndex(user.profiles, function (profile) {
      return profile.identifier == 'GOD';
    }) != -1) {
      msNavigationServiceProvider.saveItem('perfiles.listar', {
        permissions: permissions,
        title: 'Ver perfiles',
        icon: 'fi flaticon-list',
        state: 'app.perfiles.listar',
        weight: 2
      });
    }
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	var ListarPerfilController = function ListarPerfilController() {
		_classCallCheck(this, ListarPerfilController);

		this.listConfig = {
			model: {
				name: 'Profile',
				filter: {
					order: 'created DESC',
					include: ['permisos', 'user'],
					where: {
						state: true
					}
				},
				paginate: true,
				errorMessage: 'No se lograron obtener los perfiles',
				successMessage: null
			},
			permission: 'perfil',
			columns: [{
				key: 'name',
				title: 'Nombre',
				order: true
			}, {
				key: 'user.name',
				title: 'Autor'
			}],
			buttons: [{
				title: 'Editar',
				action: {
					type: 'edit'
				},
				condition: function condition(element) {
					return !element.readonly;
				},
				clase: 'md-primary md-raised'
			}, {
				title: 'Borrar',
				action: {
					type: 'delete',
					title: '¿Borrar perfil?',
					content: 'Esto no se podrá deshacer luego',
					errorMessage: 'No se logró borrar el perfil',
					successMessage: 'Perfil borrado correctamente'
				},
				condition: function condition(element) {
					return !element.readonly;
				},
				clase: 'md-warn md-raise'
			}],
			routes: {
				edit: 'app.perfiles.editar'
			}
		};
	};

	angular.module('app.perfil.listar').controller('ListarPerfilController', ListarPerfilController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.perfil.editar', []).config(config);

	function config($stateProvider) {
		var permissions = [{
			key: 'perfil',
			edit: true,
			type: 'allow'
		}];
		// State
		$stateProvider.state('app.perfiles.editar', {
			url: '/editar/:id',
			templateUrl: 'app/pages/admin/perfiles/editar/editar.tmpl.html',
			controller: 'EditarPerfilController as vm',
			permissions: permissions,
			user: true,
			root: true
		});
	}
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	var EditarPerfilController = function () {
		function EditarPerfilController($load, $log, $permission, $request, $profile, $scope, $state, $stateParams, $timeout, $toast) {
			_classCallCheck(this, EditarPerfilController);

			this.name = 'app.perfiles.editar';
			this.start($scope);
			this._$load = $load;
			this._$log = $log;
			this._$permission = $permission;
			this._$profile = $profile;
			this._$request = $request;
			this._$state = $state;
			this._$stateParams = $stateParams;
			this._$timeout = $timeout;
			this._$toast = $toast;

			this.loading = false;
		}

		_createClass(EditarPerfilController, [{
			key: 'start',
			value: function start(scope) {
				var _this = this;

				scope.$on('$stateChangeSuccess', function (ev, state) {
					if (state.name === _this.name) {
						_this.setup();
					}
				});
			}
		}, {
			key: 'setup',
			value: function setup() {
				var _this2 = this;

				if (this._$stateParams.id) {
					this.loading = true;
					this.profiles = this._$profile.getProfile();
					this._$load(this._$stateParams.id, 'Profile', { include: ['permisos'] }, function (res) {
						_this2._leerPerfil(res);
					}).catch(function () {
						_this2._$timeout(function () {
							_this2._$state.go('app.perfiles.listar');
						}, 2000);
						_this2.loading = false;
					});
				} else {
					this._$state.go('app.perfiles.listar');
				}
			}
		}, {
			key: 'isAllowed',
			value: function isAllowed(permiso, key, value) {
				if (permiso && this.profiles && this.profiles[permiso.type]) {
					var permi = this.profiles[permiso.type];
					if (key) {
						if (value) {
							if (value === 'all') {
								return permi[key] === value;
							} else if (value === 'owner') {
								return permi[key] === 'all' || permi[key] === 'owner';
							} else if (value === 'none') {
								return true;
							}
						} else {
							return permi[key];
						}
					} else {
						if (permi.create || permi.edit || permi.remove || permi.access !== 'none') {
							return true;
						}
					}
				}
				return false;
			}
		}, {
			key: 'guardar',
			value: function guardar() {
				var _this3 = this;

				this.loading = true;
				this._$request.http('Profile', 'prototype$updateAttributes', {
					id: this._perfil.id
				}, this.perfil).then(function (perfil) {
					if (_this3._perfil.permisos && _this3._perfil.permisos.id) {
						_this3._$request.http('Permiso', 'prototype$updateAttributes', {
							id: _this3._perfil.permisos.id
						}, _this3._parsePermissions()).then(function () {
							_this3._$toast.success('Perfil actualizado correctamente');
						}).catch(function (err) {
							_this3._$log.error(err);
							_this3._$toast.error('No se logró completar la edición del perfil');
						}).finally(function () {
							_this3.loading = false;
						});
					} else {
						_this3._$request.http('Profile', 'permisos', 'create', { id: perfil.id }, _this3._parsePermissions()).then(function () {
							_this3._$toast.success('Perfil actualizado correctamente');
						}).finally(function () {
							_this3.loading = false;
						});
					}
				}).catch(function (err) {
					_this3._$log.error(err);
					_this3._$toast.error('No se logró completar la edición del perfil');
					_this3.loading = false;
				});
			}
		}, {
			key: '_parsePerfil',
			value: function _parsePerfil(perfil) {
				return {
					name: perfil.name
				};
			}
		}, {
			key: '_parsePermissions',
			value: function _parsePermissions() {
				var permissions = {};
				_.each(angular.copy(this.permissions), function (permission) {
					permission.name = angular.copy(permission.type);
					delete permission.type;
					permissions[permission.name] = permission;
				});
				return permissions;
			}
		}, {
			key: '_parsePermission',
			value: function _parsePermission(permisos) {
				var _this4 = this;

				this._$permission.settings(permisos).then(function (res) {
					_this4.permissions = res;
				}).catch(function (err) {
					_this4._$log.error(err);
				}).finally(function () {
					_this4.loading = false;
				});
			}
		}, {
			key: '_leerPerfil',
			value: function _leerPerfil(perfil) {
				this._perfil = perfil;
				this.perfil = this._parsePerfil(angular.copy(perfil));
				this._parsePermission(angular.copy(perfil.permisos));
			}
		}]);

		return EditarPerfilController;
	}();

	angular.module('app.perfil.editar').controller('EditarPerfilController', EditarPerfilController);
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.modelos.ver', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'modelo',
      create: true,
      type: 'allow'
    }];
    // State
    $stateProvider.state('app.modelos.ver', {
      url: '/ver/:id',
      templateUrl: 'app/pages/admin/modelos/ver/ver.tmpl.html',
      controller: 'VerModeloController as vm',
      permissions: permissions
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var VerModeloController = function () {
        function VerModeloController($scope, $q, $http, $load, $mdDialog, $window, $mdToast, $server, $logger, Modelo, $auth, $request, $state, $toast, $stateParams) {
            _classCallCheck(this, VerModeloController);

            this.name = 'app.modelos.ver';
            this.start($scope);
            this.$q = $q;
            this.$auth = $auth;
            this.$request = $request;
            this.$state = $state;
            this.$toast = $toast;
            this.$stateParams = $stateParams;
            this.$load = $load;
            this.$logger = $logger;
            this.states = [];
            this.$window = $window;
            this.$mdToast = $mdToast;
            this.$mdDialog = $mdDialog;
            this.$server = $server;
            this.hostImages = 'https://media.alquimio.cloud/imagenes/';
            this.$http = $http;
            this.isEditing = false;
            this.changesOnFiles = false;
            this.tags = [{ id: '1_PRODUCT_IMAGE', name: 'Imagen de producto' }, { id: '2_SECONDARY_IMAGE', name: 'Imagen Secundaria' }, { id: '3_HIDDEN', name: 'Ocultar' }];
            // Variables para ordenamiento de archivos
            this.sortBy = 'viewName';
            this.reverse = false;
            this.sortField = 'viewName';

            console.log('🚀 VerModeloController inicializado con ordenamiento:', {
                sortBy: this.sortBy,
                reverse: this.reverse,
                sortField: this.sortField
            });
            if ($auth.isGod()) {

                console.log('is god');
                this.isGod = true;
            } else {
                console.log('not god');
                this.isGod = false;
            }
            // Verificar si es REVISOR
            if ($auth.isRevisor()) {
                this.isRevisor = true;
                console.log('is revisor');
            } else {
                this.isRevisor = false;
                console.log('not revisor');
            }

            // Verificar si es RETAIL (para excluir del tab Contenido Inpage)
            if ($auth.isRetail()) {
                this.isRetail = true;
            } else {
                this.isRetail = false;
            }

            // Verificar si es HP
            if ($auth.isHp()) {
                this.isHp = true;
                console.log('is hp');
            } else {
                this.isHp = false;
                console.log('not hp');
            }

            this.downloadXls = function () {
                var _this = this;

                this.$toast.info('Generando Excel. Por favor espere');
                $logger.trackDownload('XLSX');

                this.$request.http('Modelo', 'excel').then(function () {
                    var url = 'https://files.alquimio.cloud/imagenes/export2.xlsx';
                    _this.$window.open(url, '_blank');
                }).finally(function () {
                    _this.loading = false;
                });
            };
            this.downloadEstatico = function (estatico) {
                $logger.trackDownload('DOWNLOAD', estatico);
                this.$window.open(estatico.link, '_blank');
            };
        }

        _createClass(VerModeloController, [{
            key: 'start',
            value: function start(scope) {
                var _this2 = this;

                scope.$on('$stateChangeSuccess', function (ev, state) {
                    if (state.name === _this2.name) {
                        _this2.traerEstaticos();
                        _this2.setup();
                    }
                });
            }
        }, {
            key: 'goBack',
            value: function goBack() {
                this.$window.history.back();
            }
        }, {
            key: 'isBasicField',
            value: function isBasicField(fieldName) {
                return ['nombreRecomendado', 'nombre', 'eanString', 'sku', 'status', 'introduccion', 'keywords'].indexOf(fieldName) !== -1;
            }
        }, {
            key: 'hasFieldValue',
            value: function hasFieldValue(fieldName) {
                var langs = this.modelo && this.modelo.langs || {};
                var pt = langs.PT || {};
                var esCL = langs.esCL || {};
                return this.fieldHasContent(pt[fieldName]) || this.fieldHasContent(esCL[fieldName]);
            }
        }, {
            key: 'getFieldValue',
            value: function getFieldValue(fieldName) {
                var langs = this.modelo && this.modelo.langs || {};
                var pt = langs.PT || {};
                var esCL = langs.esCL || {};
                return this.fieldHasContent(pt[fieldName]) ? pt[fieldName] : esCL[fieldName] || '';
            }
        }, {
            key: 'isSpanishFallback',
            value: function isSpanishFallback(fieldName) {
                var langs = this.modelo && this.modelo.langs || {};
                var pt = langs.PT || {};
                var esCL = langs.esCL || {};
                return !this.fieldHasContent(pt[fieldName]) && this.fieldHasContent(esCL[fieldName]);
            }
        }, {
            key: 'fieldHasContent',
            value: function fieldHasContent(value) {
                return value !== undefined && value !== null && value !== '';
            }
        }, {
            key: 'getModelFieldLabels',
            value: function getModelFieldLabels() {
                return {
                    nombreRecomendadoLargo: 'Nome recomendado longo',
                    urlIndexado: 'URL indexada',
                    scriptText: 'Script',
                    tamanoPantalla: 'Tamanho da tela',
                    resolucionPantalla: 'Resolução',
                    relacionAspecto: 'Proporção da tela',
                    tipoPanel: 'Tipo de painel',
                    tasaRefresco: 'Taxa de atualização',
                    tiempoRespuesta: 'Tempo de resposta',
                    contrasteEstatico: 'Contraste estático',
                    puertos: 'Portas',
                    color: 'Cor',
                    alto: 'Altura',
                    ancho: 'Largura',
                    profundidad: 'Profundidade',
                    peso: 'Peso',
                    accesoriosIncluidos: 'Acessórios incluídos',
                    garantia: 'Garantia',
                    brillo: 'Brilho',
                    profundidaddebitsdelpanel: 'Profundidade de bits do painel',
                    gamacolores: 'Gama de cores',
                    modelo: 'Modelo',
                    dimensiones: 'Dimensões',
                    camara: 'Câmera',
                    headline: 'Título'
                };
            }
        }, {
            key: 'getFieldLabel',
            value: function getFieldLabel(field) {
                var labels = this.getModelFieldLabels();
                return labels[field.value] || field.label;
            }
        }, {
            key: 'downloadHtml',
            value: function downloadHtml(mobile, isFalabella) {

                this.$toast.info('Generando HTML. Por favor espere');
                var URL = this.$server.url() + '/modelos/downloadHtml?modelId=' + this.$stateParams.id + '&mobile=' + mobile + '&showFalabella=' + isFalabella;
                //  let URL = "http://localhost:3000/api/modelos/downloadHtml?modelId="+ this.$stateParams.id+"&mobile="+mobile+"&showFalabella="+this.showFalabella;
                this.$window.open(URL, '_blank');
                // this.$request
                //     .http("Modelo", "downloadHtml",{modelId :this.$stateParams.id })
                //     .then((res) => {
                //         this.loading = false;
                //     })
                //     .finally(() => {
                //         this.loading = false;
                //     });
            }
        }, {
            key: 'aprobar',
            value: function aprobar(ev, modelo) {
                var _this3 = this;

                // Appending dialog to document.body to cover sidenav in docs app
                var confirm = this.$mdDialog.confirm().title('Deseja aprovar este modelo?').textContent('Confirme que deseja aprovar o modelo: ' + modelo.nombre).ariaLabel('Si').targetEvent(ev).ok('Aprovar').cancel('Cancelar');

                this.$mdDialog.show(confirm).then(function () {
                    _this3.doAprobar();
                }, function () {
                    this.status = 'Ação cancelada';
                });
            }
        }, {
            key: 'doAprobar',
            value: function doAprobar() {
                var _this4 = this;

                this.modeloOriginal.langs.PT.status = 'Aprovado';
                this.modeloOriginal.$save().then(function (modeloEdited) {
                    _this4.$toast.info('Modelo editado');
                    _this4.goBack();
                }).catch(function () {
                    _this4.$toast.error('No se logró completar la edición del modelo');
                }).finally(function () {
                    _this4.loading = false;
                });
            }
        }, {
            key: 'traerCategorias',
            value: function traerCategorias() {
                var _this5 = this;

                return new Promise(function (resolve, reject) {
                    _this5.$request.http('Categoria', 'find', {
                        filter: {
                            where: {
                                state: true
                            }
                        }
                    }).then(function (categorias) {
                        _this5.categorias = categorias;
                        resolve(categorias);
                    });
                });
            }
        }, {
            key: 'traerEstaticos',
            value: function traerEstaticos() {
                var _this6 = this;

                this.$request.http('Estatico', 'find', {
                    filter: {
                        where: {
                            state: true
                        }
                    }
                }).then(function (estaticos) {
                    _this6.estaticos = estaticos;
                }).finally(function () {
                    _this6.loading = false;
                });
            }
        }, {
            key: 'setup',
            value: function setup() {
                var _this7 = this;

                if (this.$stateParams.id) {

                    this.subcategoriasCamapana = [{ 'subCatId': '1', 'nombre': 'Argentina', 'orden': 1 }, { 'subCatId': '2', 'nombre': 'CAC', 'orden': 2 }, { 'subCatId': '3', 'nombre': 'Chile', 'orden': 3 }, { 'subCatId': '4', 'nombre': 'Colombia', 'orden': 4 }, { 'subCatId': '5', 'nombre': 'México', 'orden': 5 }, { 'subCatId': '6', 'nombre': 'Perú', 'orden': 6 }, { 'subCatId': '7', 'nombre': 'HP Shopping', 'orden': 7 }, { 'subCatId': '8', 'nombre': 'Marketing', 'orden': 8 }, { subCatId: '9', nombre: 'Partners', orden: 9 }];

                    var email = this.$auth.user().email;

                    this.traerCategorias().then(function (categoriasFound) {
                        _this7.categorias = categoriasFound;

                        _this7.$load(_this7.$stateParams.id, 'Modelo', { include: ['categoria'] }, function (res) {

                            _this7.leerModelo(res);

                            _this7.$logger.trackAction('VER', res);
                        }).catch(function () {
                            _this7.$timeout(function () {
                                _this7.$state.go('app.modelos.listar');
                            }, 2000);
                        });
                    }, function (err) {
                        //TODO: manejar error
                    });
                } else {
                    this.$state.go('app.modelos.listar');
                }
            }
        }, {
            key: 'downloadPDFNormal',
            value: function downloadPDFNormal() {

                var URL = this.urlSindicado + '/#!/' + this.modelo.id + '/PDF/';
            }
        }, {
            key: 'downloadPDFMobile',
            value: function downloadPDFMobile() {
                var _this8 = this;

                this.$toast.info('Generando HTML. Por favor espere');
                var URL = this.urlSindicado + '/#!/' + this.modelo.id + '/PDF/';

                this.$request.http('Modelo', 'downloadPdf', { modelId: this.$stateParams.id, url: URL, mobile: true }).then(function (res) {
                    _this8.loading = false;
                    var url = 'https://files.alquimio.cloud/imagenes/' + res.name;
                    _this8.$window.open(url, '_blank');
                }).finally(function () {

                    _this8.loading = false;
                });
            }
        }, {
            key: 'download',
            value: function download(file) {
                var url;
                if (file.origin && file.categoria == 'CAP') {
                    url = file.url;
                } else if (file.url) {
                    url = file.url;
                } else {
                    url = 'https://files.alquimio.cloud/imagenes/' + file.name;
                }
                this.$window.open(url, '_blank');
            }
        }, {
            key: 'editFiles',
            value: function editFiles() {
                this.isEditing = true;
                this.changesOnFiles = true;
            }
        }, {
            key: 'saveFiles',
            value: function saveFiles(file) {
                var _this9 = this;

                _.forEach(this.files, function (file) {
                    if (file.categoria == 'Galería') {
                        _.map(_this9.modelo.langs.PT.galeria, function (curFile) {
                            if (curFile.id == file.id) {
                                curFile = file;
                            }
                        });
                    } else if (file.categoria == 'Video') {
                        _.map(_this9.modelo.langs.PT.videos, function (curFile) {
                            if (curFile.id == file.id) {
                                curFile = file;
                            }
                        });
                    } else if (file.categoria == 'Visual') {
                        _.map(_this9.modelo.langs.PT.visuales, function (curFile) {
                            if (curFile.imagen && curFile.imagen.id && curFile.imagen.id == file.id) {
                                curFile.imagen = file;
                            }
                        });
                    } else if (file.categoria == 'Ficha' && _this9.modelo.langs.PT.ficha && _this9.modelo.langs.PT.ficha[0]) {
                        _this9.modelo.langs.PT.ficha[0] = file;
                    }
                    _this9.isEditing = false;
                });

                this.modelo.$save().then(function (modeloEdited) {
                    _this9.$toast.info('Archivos editados');
                    _this9.leerArchivos(modeloEdited);
                }).catch(function () {
                    _this9.$toast.error('No se logró completar la edición del modelo');
                }).finally(function () {
                    _this9.loading = false;
                    _this9.isEditing = false;
                    _this9.changesOnFiles = false;
                });
            }
        }, {
            key: 'leerArchivos',
            value: function leerArchivos(modelo) {
                var _this10 = this;

                var isActiveFile = function isActiveFile(file) {
                    return file && file.state === true && file.estado === true;
                };

                var countInactiveArray = function countInactiveArray(files) {
                    if (!Array.isArray(files)) {
                        return 0;
                    }
                    return files.filter(function (file) {
                        return file && !isActiveFile(file);
                    }).length;
                };

                var pt = modelo && modelo.langs && modelo.langs.PT ? modelo.langs.PT : {};
                var hiddenInactiveFilesCount = 0;
                hiddenInactiveFilesCount += countInactiveArray(pt.galeria);
                hiddenInactiveFilesCount += countInactiveArray(pt.videos);
                hiddenInactiveFilesCount += countInactiveArray(pt.ficha);
                hiddenInactiveFilesCount += countInactiveArray(pt.documentos);

                if (Array.isArray(pt.visuales)) {
                    hiddenInactiveFilesCount += pt.visuales.filter(function (visual) {
                        var visualFile = null;
                        if (visual && visual.imagen && visual.imagen.id) {
                            visualFile = visual.imagen;
                        } else if (visual && visual.name) {
                            visualFile = visual;
                        }
                        return visualFile && !isActiveFile(visualFile);
                    }).length;
                }

                this.hiddenInactiveFilesCount = hiddenInactiveFilesCount;

                var newFiles = [];
                if (modelo.langs.PT.galeria) {
                    var newGaleria = _.map(_.filter(modelo.langs.PT.galeria, isActiveFile), function (imagen) {
                        imagen.categoria = 'Galería';
                        // Crear viewName con formato mejorado para ordenamiento
                        imagen.viewName = _this10.formatFileNameForSorting(imagen.name);
                        return imagen;
                    });
                    newFiles = newFiles.concat(newGaleria);
                }

                if (modelo.langs.PT.videos) {
                    var videos = _.map(_.filter(modelo.langs.PT.videos, isActiveFile), function (imagen) {
                        imagen.categoria = 'Video';
                        imagen.viewName = _this10.formatFileNameForSorting(imagen.name);
                        return imagen;
                    });
                    newFiles = newFiles.concat(videos);
                }

                if (modelo.langs.PT.visuales) {
                    var newVisuales = _.map(modelo.langs.PT.visuales, function (visual) {
                        if (visual.imagen && visual.imagen.id && isActiveFile(visual.imagen)) {
                            visual.imagen.categoria = 'Visual';
                            visual.imagen.viewName = _this10.formatFileNameForSorting(visual.imagen.name);
                            return visual.imagen;
                        }
                    });

                    newFiles = newFiles.concat(newVisuales);
                }
                if (modelo.langs.PT.ficha && modelo.langs.PT.ficha[0]) {
                    var newFicha = _.filter(modelo.langs.PT.ficha, isActiveFile);
                    if (newFicha[0]) {
                        newFicha[0].categoria = 'Ficha de Producto';
                        newFicha[0].viewName = this.formatFileNameForSorting(newFicha[0].name);
                        newFiles = newFiles.concat(newFicha);
                    }
                }

                _.map(newFiles, function (file) {
                    try {
                        if (file.ext === 'mp4' || file.ext === 'mov') {
                            return file;
                        }
                        file.nameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
                        file.thumbUrl = _this10.hostImages + 'azure_thumb-' + file.nameWithoutExtension + '_size_200.' + file.ext;
                        return file;
                    } catch (e) {
                        console.log('Error formating files : ', e);
                    }
                });

                if (!this.isGod) {
                    var filesBeforeFilter = newFiles.length;
                    newFiles = _.filter(newFiles, function (file) {
                        return file && file.tag != '3_HIDDEN';
                    });
                }
                _.map(newFiles, function (curFile) {
                    if (curFile && curFile.tag) {
                        var curTag = _.find(_this10.tags, function (tag) {
                            return tag.id == curFile.tag;
                        });
                        if (curTag && curTag.name) {
                            curFile.tagName = curTag.name;
                        }
                    }
                });
                newFiles = _.filter(newFiles, function (file) {
                    if (file && file.name) {
                        if (file.name.toUpperCase().indexOf('BUNDLE') !== -1) {
                            file.tag = '1_bundle';
                        }
                        // Asegurar que todos los archivos tengan viewName
                        if (!file.viewName) {
                            file.viewName = _this10.formatFileNameForSorting(file.name);
                        }
                        return file;
                    }
                });

                return newFiles;
            }
        }, {
            key: 'descargarZip',
            value: function descargarZip() {
                var _this11 = this;

                this.loading = true;

                this.$toast.info('Por favor espere. Gerando ZIP');

                this.$request.http('Modelo', 'zip', { id: this.modelo.id }).then(function (res) {

                    _this11.$toast.info('Zip Gerado. Lembre-se de permitir pop-ups');
                    var url = 'https://files.alquimio.cloud/imagenes/' + res.response.name;
                    _this11.$window.open(url, '_blank');
                }).finally(function () {
                    _this11.loading = false;
                });
            }
        }, {
            key: 'leerModelo',
            value: function leerModelo(res) {
                var _this12 = this;

                this.files = this.leerArchivos(res);
                this.modelo = res;

                // Não exibir materiais Inpage quando não houver um ZIP ativo.
                if (this.modelo.langs && this.modelo.langs.PT) {
                    var zips = this.modelo.langs.PT.materialsZip;
                    var hasActiveZip = Array.isArray(zips) && zips.some(function (file) {
                        return file && file.state === true && file.estado === true;
                    });
                    if (!hasActiveZip) {
                        this.modelo.langs.PT.materialsLink = null;
                    }
                }
                this.categoriaModelo = _.find(this.categorias, function (categoria) {
                    return categoria.id == res.categoriaId;
                });

                this.modeloOriginal = angular.copy(res);

                if (!this.modelo.categoriaId) {
                    this.modelo.categoriaId = this.modelo.langs.PT.categoriaId;
                    if (!this.modelo.documentos) this.modelo.documentos = [];
                    var categoriaFound = _.find(this.categorias, function (categoria) {
                        return categoria.id == _this12.modelo.categoriaId;
                    });
                    this.modelo.categoria = categoriaFound;
                    this.categoriaModelo = categoriaFound;
                }

                // La relación incluida puede no venir en la respuesta aunque exista categoriaId.
                // En ese caso, reutilizar la categoría cargada para que la vista tenga sus fields.
                if ((!this.modelo.categoria || !angular.isArray(this.modelo.categoria.fields) || !this.modelo.categoria.fields.length) && this.categoriaModelo) {
                    this.modelo.categoria = this.categoriaModelo;
                }

                if (!this.categoriaModelo && this.modelo.categoria) {
                    this.categoriaModelo = this.modelo.categoria;
                }

                var includedCategoryFields = this.modelo.categoria && this.modelo.categoria.fields || [];
                var currentCategoryFields = this.categoriaModelo && this.categoriaModelo.fields || [];
                this.fieldsModelo = [];
                _.forEach(includedCategoryFields.concat(currentCategoryFields), function (field) {
                    var fieldAlreadyAdded = _.some(_this12.fieldsModelo, function (currentField) {
                        return currentField.value === field.value;
                    });
                    if (!fieldAlreadyAdded) {
                        _this12.fieldsModelo.push(field);
                    }
                });

                var ptValues = this.modelo.langs && this.modelo.langs.PT || {};
                var knownFieldLabels = this.getModelFieldLabels();
                var categoryFieldKeys = _.map(this.fieldsModelo, 'value');
                var ptKeysIgnoredByCategory = _.filter(Object.keys(knownFieldLabels), function (fieldName) {
                    return _this12.fieldHasContent(ptValues[fieldName]) && categoryFieldKeys.indexOf(fieldName) === -1;
                });

                // La API puede devolver la categoría sin fields. Agregar las características
                // conocidas permite mostrar los valores existentes en PT/esCL de todos modos.
                _.forEach(Object.keys(knownFieldLabels), function (fieldName) {
                    var fieldAlreadyAdded = _.some(_this12.fieldsModelo, function (field) {
                        return field.value === fieldName;
                    });
                    if (!fieldAlreadyAdded) {
                        _this12.fieldsModelo.push({
                            value: fieldName,
                            label: knownFieldLabels[fieldName]
                        });
                    }
                });

                this.hasModelCharacteristics = _.some(this.fieldsModelo, function (field) {
                    return !_this12.isBasicField(field.value) && _this12.hasFieldValue(field.value);
                });

                console.groupCollapsed('[ver/PT] Diagnóstico de características del modelo');
                console.log('Keys PT ignoradas por categoria.fields:', ptKeysIgnoredByCategory);
                console.table(_.map(this.fieldsModelo, function (field) {
                    return {
                        key: field.value,
                        valorPT: ptValues[field.value],
                        usaFallbackES: _this12.isSpanishFallback(field.value),
                        visible: !_this12.isBasicField(field.value) && _this12.hasFieldValue(field.value)
                    };
                }));
                console.groupEnd();

                // if (this.modelo.categoria && this.modelo.categoria.documentos) {
                //     console.debug('DOCUMENTOS', this.modelo.documentos, this.modelo.categoria)
                //     this.modelo.documentos = [...this.modelo.documentos, ...this.modelo.categoria.documentos]
                // }
                console.log('🔥 Categoria cargada:', this.modelo.categoria);
                this.getUrlBySKU();

                try {

                    if (this.modelo.langs.PT.ficha && !angular.isArray(this.modelo.langs.PT.ficha)) {
                        this.modelo.langs.PT.ficha = [this.modelo.langs.PT.ficha];
                    }

                    if (this.modelo.langs.PT.documentos && !angular.isArray(this.modelo.langs.PT.documentos)) {
                        this.modelo.langs.PT.documentos = [this.modelo.langs.PT.documentos];
                    }

                    var isActiveFile = function isActiveFile(file) {
                        return file && file.state === true && file.estado === true;
                    };
                    this.modelo.langs.PT.ficha = _.filter(this.modelo.langs.PT.ficha || [], isActiveFile);
                    this.modelo.langs.PT.documentos = _.filter(this.modelo.langs.PT.documentos || [], isActiveFile);

                    if (this.modelo.langs.PT.diferenciadores) {
                        this.modelo.langs.PT.diferenciadores = _.map(this.modelo.langs.PT.diferenciadores, function (diferenciador) {
                            if (!angular.isArray(diferenciador.imagen)) {
                                diferenciador.imagen = [diferenciador.imagen];
                            }
                            return diferenciador;
                        });
                    }
                    if (this.modelo.langs.PT.visuales) {
                        var newVisuales = [];
                        _.forEach(this.modelo.langs.PT.visuales, function (visual, index) {
                            if (visual && visual.imagen && visual.imagen.id) {
                                newVisuales.push(visual.imagen);
                            } else if (visual && visual.name) {
                                newVisuales.push(visual);
                            }
                        });
                        this.modelo.langs.PT.visuales = newVisuales;
                    }
                    this.urlSindicado = '';
                    // IMPRESORAS

                    if (this.modelo.categoriaId == '56c677fb2405ddbf462d40e4') {
                        this.urlSindicado = 'https://br.indexado.alquimio.cloud/impresoras';
                    }

                    // TINTAS || BOTELLA || TONNER
                    if (this.modelo.categoriaId == '56c678022405ddbf462d40e6' || this.modelo.categoriaId == '57ab452792623112e483e371' || this.modelo.categoriaId == '5cf3ffa1f1b7b48c7ae6222e') {
                        this.urlSindicado = 'https://br.indexado.alquimio.cloud/tintas';
                    }

                    // NOTEBOOKS O AIO
                    if (this.modelo.categoriaId == '56c677ff2405ddbf462d40e5' || this.modelo.categoriaId == '56c678072405ddbf462d40e7') {
                        this.urlSindicado = 'https://br.indexado.alquimio.cloud';
                    }
                    //MONITORES
                    if (this.modelo.categoriaId == '590a3eeb77c84c53dc8cace4') {
                        this.urlSindicado = 'https://br.indexado.alquimio.cloud';
                    }

                    //ACCESORIOS
                    if (this.modelo.categoriaId == '57ab44ce92623112e483e370') {
                        this.urlSindicado = 'https://br.indexado.alquimio.cloud/accesorios';
                    }

                    //POS
                    if (this.modelo.categoriaId == '5e74ac02ad5afe6b087119fc') {
                        this.urlSindicado = 'https://br.indexado.alquimio.cloud';
                    }

                    this.hidePDF = false;
                    this.qrUrl = this.urlSindicado + '/#!/' + this.$stateParams.id;
                    this.urlMinisitio = this.urlSindicado + '/#!/' + this.$stateParams.id + '/web';
                    this.qrUrlEncoded = window.encodeURIComponent(this.qrUrl);
                    this.preUrlPdf = this.urlSindicado + '/#!/' + this.modelo.id + '/PDF/';
                    this.preUrlPdfFull = this.urlSindicado + '/#!/' + this.modelo.id + '/PDFFULL/';

                    var templateId = this.modelo.langs.PT.templateId || this.modelo.templateId;

                    if (templateId == '5ec5386c864e24a3acd37a0a') {
                        this.urlMinisitio = 'https://br.indexado.alquimio.cloud/impresorasV2?modelId=' + this.modelo.id;
                        this.qrUrl = 'https://br.indexado.alquimio.cloud/impresorasV2?modelId=' + this.modelo.id + '&qr=true';
                        this.qrUrlEncoded = window.encodeURIComponent(this.qrUrl);
                        this.hidePDF = true;
                    }

                    if (templateId == '5ec53880864e24a3acd37a0c' || templateId == '5eecd39b11dee292483f238c') {
                        this.urlMinisitio = 'https://br.indexado.alquimio.cloud/computoV2?modelId=' + this.modelo.id;
                        this.qrUrl = 'https://br.indexado.alquimio.cloud/computoV2?modelId=' + this.modelo.id + '&qr=true';
                        this.qrUrlEncoded = window.encodeURIComponent(this.qrUrl);
                        this.hidePDF = true;
                    }

                    if (templateId == '5f0cd69420215c2aa50312ec') {
                        this.urlMinisitio = 'https://br.indexado.alquimio.cloud/monitoresV2?modelId=' + this.modelo.id;
                        this.qrUrl = 'https://br.indexado.alquimio.cloud/monitoresV2?modelId=' + this.modelo.id + '&qr=true';
                        this.qrUrlEncoded = window.encodeURIComponent(this.qrUrl);
                        this.hidePDF = true;
                    }

                    if (templateId == '5ec5386c864e24a3acd37a0a') {
                        this.urlMinisitio = 'https://br.indexado.alquimio.cloud/impresorasV2?modelId=' + this.modelo.id;
                        this.qrUrl = 'https://br.indexado.alquimio.cloud/impresorasV2?modelId=' + this.modelo.id + '&qr=true';
                        this.qrUrlEncoded = window.encodeURIComponent(this.qrUrl);
                        this.hidePDF = true;
                    }

                    if (templateId == '5f7482f21d54fa39824dd6e7') {
                        this.urlMinisitio = 'https://br.indexado.alquimio.cloud/accesoriosV2?modelId=' + this.modelo.id;
                        this.qrUrl = 'https://br.indexado.alquimio.cloud/accesoriosV2?modelId=' + this.modelo.id + '&qr=true';
                        this.qrUrlEncoded = window.encodeURIComponent(this.qrUrl);
                        this.hidePDF = true;
                    }

                    if (templateId == '6054cc4f15d36d64ea2faaf0') {
                        this.urlMinisitio = 'https://br.indexado.alquimio.cloud/rpos?modelId=' + this.modelo.id;
                        this.qrUrl = 'https://br.indexado.alquimio.cloud/rpos?modelId=' + this.modelo.id + '&qr=true';
                        this.qrUrlEncoded = window.encodeURIComponent(this.qrUrl);
                        this.hidePDF = true;
                    }

                    if (templateId == '609e9e38e13aba5494af4269') {
                        this.urlMinisitio = 'https://br.indexado.alquimio.cloud/impresorasV2?modelId=' + this.modelo.id;
                        this.qrUrl = 'https://br.indexado.alquimio.cloud/impresorasV2?modelId=' + this.modelo.id + '&qr=true';
                        this.qrUrlEncoded = window.encodeURIComponent(this.qrUrl);
                        this.hidePDF = true;
                    }

                    this.urlPdfDesktop = 'https://www.sejda.com/html-to-pdf?save-link=' + window.encodeURIComponent(this.preUrlPdf) + '&viewportWidth=1440';
                    this.urlPdfMobile = 'https://www.sejda.com/html-to-pdf?save-link=' + window.encodeURIComponent(this.preUrlPdf) + '&viewportWidth=700';

                    this.urlPdfDesktopFull = 'https://www.sejda.com/html-to-pdf?save-link=' + window.encodeURIComponent(this.preUrlPdfFull) + '&viewportWidth=1440';

                    var heightImpresora = '2950px';
                    var heightSupplies = '2350px';

                    if (this.modelo.langs.PT.indexadoDefault) {
                        this.urlMinisitio = 'https://front.indexado.production.alquimio.cloud/spec?modelId=' + this.modelo.id.toString() + '&lang=PT&version=' + this.modelo.langs.PT.indexadoDefault;
                        this.qrUrl = 'https://front.indexado.production.alquimio.cloud/spec?modelId=' + this.modelo.id.toString() + '&lang=PT&version=' + this.modelo.langs.PT.indexadoDefault + '&qr=true';
                        this.qrUrlEncoded = window.encodeURIComponent(this.qrUrl);
                        this.hidePDF = true;
                    } else {
                        if (this.modelo.langs.PT.hasIndexado4 && this.modelo.langs.PT.indexado4Url) {
                            this.urlMinisitio = this.modelo.langs.PT.indexado4Url + '&version=V4';
                            this.qrUrl = this.modelo.langs.PT.indexado4Url + '&version=V4&qr=true';
                            this.qrUrlEncoded = window.encodeURIComponent(this.qrUrl);
                            this.hidePDF = true;
                        }
                        if (this.modelo.langs.PT.hasIndexado5) {
                            this.urlMinisitio = 'https://front.indexado.production.alquimio.cloud/spec?modelId=' + this.modelo.id.toString() + '&lang=PT&version=V5';
                            this.qrUrl = 'https://front.indexado.production.alquimio.cloud/spec?modelId=' + this.modelo.id.toString() + '&lang=PT&version=V5&qr=true';
                            this.qrUrlEncoded = window.encodeURIComponent(this.qrUrl);
                            this.hidePDF = true;
                        }
                    }

                    // URL gerada pelo Playbook 3.0, quando estiver habilitada no modelo.
                    this.hasPlaybook3 = !!(this.modelo.playbook3Url && this.modelo.playbook3Url.enabled && this.modelo.playbook3Url.url);
                    if (this.hasPlaybook3) {
                        this.playbook3UrlMinisitio = this.modelo.playbook3Url.url;
                        this.playbook3QrUrl = this.modelo.playbook3Url.url;
                        this.playbook3QrUrlEncoded = window.encodeURIComponent(this.playbook3QrUrl);
                    }

                    this.urlPdfDesktop = 'https://www.sejda.com/html-to-pdf?save-link=' + window.encodeURIComponent(this.preUrlPdf) + '&viewportWidth=1440';
                    this.urlPdfMobile = 'https://www.sejda.com/html-to-pdf?save-link=' + window.encodeURIComponent(this.preUrlPdf) + '&viewportWidth=700';

                    this.urlPdfDesktopFull = 'https://www.sejda.com/html-to-pdf?save-link=' + window.encodeURIComponent(this.preUrlPdfFull) + '&viewportWidth=1440';

                    var script = this.getScriptByModel(this.modelo);
                    this.script = script;

                    if (this.urlMinisitio.indexOf('impresoras') > -1 || this.urlMinisitio.indexOf('front') > -1 || this.urlMinisitio.indexOf('tintas') > -1 || this.modelo.indexado4Url) {

                        this.showIndexado = true;
                    }
                } catch (e) {

                    console.log('err leer modelo', e);
                }
            }
        }, {
            key: 'getUrlBySKU',
            value: function getUrlBySKU() {

                var availableLanguages = this.modelo.availableLanguages || this.modelo.langsAvailable; //TODO: homologar en bd y verificar por qué aparecen "langsAvailable"

                if (availableLanguages && availableLanguages.indexOf('PT') > -1 && this.modelo.langs.PT.indexado4) {
                    var id = this.modelo.langs.PT.originalId;
                    var url = 'https://front.indexado.staging.alquimio.cloud/spec?modelId=' + id + '&lang=PT';
                    this.urlMinisitio = url;
                }
            }
        }, {
            key: 'getScriptByModel',
            value: function getScriptByModel(model) {
                //if (model.indexadoActive) {
                // if (true) {
                if (model.langs.PT.indexadoActive || model.playbook3Url && model.playbook3Url.enabled && model.playbook3Url.url) {
                    try {
                        var ean = null;
                        var sku = null;
                        var textScript = null;
                        if (model.langs.PT.eanString && model.langs.PT.eanString.length > 5) {
                            if (model.langs.PT.eanString.indexOf('|') > -1) {
                                ean = model.langs.PT.eanString.substr(0, model.langs.PT.eanString.indexOf('|'));
                            } else {
                                ean = model.langs.PT.eanString;
                            }
                        } else if (model.langs.PT.ean && model.langs.PT.ean.length > 5) {
                            if (model.langs.PT.ean.indexOf('|') > -1) {
                                ean = model.langs.PT.ean.substr(0, model.langs.PT.ean.indexOf('|'));
                            } else {
                                ean = model.langs.PT.ean;
                            }
                        } else if (model.sku) {
                            sku = model.sku;
                        }
                        if (ean != null) {
                            textScript = '<div id=\"contenidoIndexado\"></div> <script async type=\"text/javascript\" src=\"https://storage.googleapis.com/indexado/assets/alquimioIndexado.v2.js\" data-ean=\"' + ean + '\" data-lang="PT" data-country="BR" data-brand=\"' + model.clientId + '\"></script>';
                        } else if (sku != null) {
                            textScript = '<div id=\"contenidoIndexado\"></div> <script async type=\"text/javascript\" src=\"https://storage.googleapis.com/indexado/assets/alquimioIndexado.v2.js\" data-sku=\"' + sku + '\" data-lang="PT" data-country="BR" data-brand=\"' + model.clientId + '\"></script>';
                        }

                        return textScript;
                    } catch (e) {
                        return null;
                    }
                } else {
                    return null;
                }
            }

            /**
             * Formatea el nombre del archivo para mejorar el ordenamiento visual
             * Agrega cero delante a números del 1-9 para que aparezcan antes que 10, 11, etc.
             * Solo aplica el cambio si el número no tiene ya un cero delante.
             */

        }, {
            key: 'formatFileNameForSorting',
            value: function formatFileNameForSorting(fileName) {
                if (!fileName) return fileName;

                // Buscar patrón: nombre_[número de 1 dígito NO precedido por 0]texto.extension
                // Ejemplo: BM2J2LA_1ImagenPrincipal.jpg -> BM2J2LA_01ImagenPrincipal.jpg
                // Pero BM2J2LA_01ImagenPrincipal.jpg permanece sin cambios
                return fileName.replace(/(_)(?!0)([1-9])([A-Za-z]|\.)/g, '$10$2$3');
            }
            /**
             * Sort by name column
             * Función para ordenar archivos por nombre
             */

        }, {
            key: 'sortByName',
            value: function sortByName() {
                console.log('🔥 CLICK DETECTADO - sortByName ejecutándose en VerModeloController');

                // Asegurar que las variables existan
                this.sortField = this.sortField || 'viewName';
                this.sortBy = this.sortBy || 'viewName';
                this.reverse = this.reverse || false;

                console.log('📋 Estado actual:', {
                    sortField: this.sortField,
                    reverse: this.reverse,
                    sortBy: this.sortBy
                });

                // Alternar dirección si ya estamos ordenando por nombre
                if (this.sortField === 'viewName') {
                    this.reverse = !this.reverse;
                    console.log('🔄 Alternando dirección:', this.reverse);
                } else {
                    // Cambiar a ordenamiento por nombre
                    this.sortField = 'viewName';
                    this.sortBy = 'viewName';
                    this.reverse = false;
                    console.log('📝 Cambiando a ordenamiento por nombre');
                }

                console.log('✅ Estado final:', {
                    sortField: this.sortField,
                    reverse: this.reverse,
                    sortBy: this.sortBy
                });
            }
        }]);

        return VerModeloController;
    }();

    angular.module('app.modelos.ver').controller('VerModeloController', VerModeloController);
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.modelos.nuevo', []).config(config);

    function config($stateProvider, msNavigationServiceProvider) {
        var permissions = [{
            key: 'modelo',
            create: true,
            type: 'allow'
        }];
        // State
        $stateProvider.state('app.modelos.nuevo', {
            url: '/nuevo',
            templateUrl: 'app/pages/admin/modelos/nuevo/nuevo.tmpl.html',
            controller: 'NuevoModeloController as vm'
        });

        try {
            var user = localStorage.getItem('ls.$auth.user');
            user = JSON.parse(user);
            if (user) {
                if (user.profile == 'GOD') {
                    msNavigationServiceProvider.saveItem('modelos.nuevo', {
                        title: 'Adicionar modelo',
                        icon: 'fi flaticon-add',
                        state: 'app.modelos.nuevo',
                        weight: 2
                    });
                }
            }
        } catch (e) {
            console.log(e);
        }
    }
})();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    "use strict";

    var NuevoModeloController = function () {
        function NuevoModeloController($scope, $q, $auth, $logger, $request, $state, $toast, $mdDialog) {
            _classCallCheck(this, NuevoModeloController);

            this.name = "app.modelos.nuevo";
            this.start($scope);
            this.$logger = $logger;
            this.$q = $q;
            this.$auth = $auth;
            this.$request = $request;
            this.$state = $state;
            this.$toast = $toast;
            this.$mdDialog = $mdDialog;

            this.states = [];
        }

        _createClass(NuevoModeloController, [{
            key: "changeCategoria",
            value: function changeCategoria() {
                var _this = this;

                var fieldsCategorias = _.filter(this.categorias, function (categoria) {
                    return _this.modelo.categoriaId == categoria.id;
                });
                if (fieldsCategorias.length) {
                    fieldsCategorias = _.first(fieldsCategorias).fields;
                    console.log('changeCategoria', fieldsCategorias);
                    this.fieldsCategorias = fieldsCategorias;
                }
            }
        }, {
            key: "modalConfirm",
            value: function modalConfirm(langsAvailables, modeloId) {
                var _this2 = this;

                langsAvailables = langsAvailables.length > 1 ? langsAvailables.join(" ,") : _.first(langsAvailables);
                var confirm = this.$mdDialog.confirm().title('Modelo existente').textContent("Este SKU se encuentra disponible en los siguientes lenguajes: " + langsAvailables + " .Desea editarlos ?").ariaLabel('Lucky day').clickOutsideToClose(true).parent(angular.element(document.body)).ok('Si, editar').cancel('No, cambiaré el SKU');
                this.$mdDialog.show(confirm).then(function () {
                    _this2.$state.go("app.modelos.editar", { id: modeloId, getOtherLang: true });
                }, function () {});
            }
        }, {
            key: "getDataBySku",
            value: function getDataBySku() {
                var _this3 = this;

                var sku = this.modelo.sku;
                if (sku.length > 2) {
                    this.loading = true;

                    var filter = {
                        filter: {
                            where: {
                                sku: sku,
                                state: true
                            }
                        }
                    };

                    this.$request.http("Modelo", "findOne", filter).then(function (modelo) {
                        _this3.loading = false;
                        if (modelo.langs && (modelo.langs.PT || modelo.langs.esCL)) {
                            _this3.modalConfirm(modelo.availableLanguages, modelo.id);
                        }
                    }, function (err) {
                        console.log('Modelo not found', err);
                        _this3.loading = false;
                    });
                }
            }
        }, {
            key: "traerCategorias",
            value: function traerCategorias() {
                var _this4 = this;

                return new Promise(function (resolve, reject) {
                    _this4.$request.http("Categoria", "find", {
                        filter: {
                            where: {
                                state: true
                            }
                        }
                    }).then(function (categorias) {
                        _this4.categorias = categorias;
                        resolve();
                    });
                });
            }
        }, {
            key: "start",
            value: function start(scope) {
                var _this5 = this;

                scope.$on("$stateChangeSuccess", function (ev, state) {
                    if (state.name === _this5.name) {
                        _this5.setup();
                    }
                });
            }
        }, {
            key: "setup",
            value: function setup() {
                this.modelo = {};
                this.modelo.diferenciadores = [];
                this.traerCategorias();
                this.subcategoriasCamapana = [{ subCatId: "1", nombre: "Argentina", orden: 1 }, { subCatId: "2", nombre: "CAC", orden: 2 }, { subCatId: "3", nombre: "Chile", orden: 3 }, { subCatId: "4", nombre: "Colombia", orden: 4 }, { subCatId: "5", nombre: "México", orden: 5 }, { subCatId: "6", nombre: "Perú", orden: 6 }, { subCatId: "7", nombre: "HP Shopping", orden: 7 }, { subCatId: "8", nombre: "Marketing", orden: 8 }, { subCatId: "9", nombre: "Partners", orden: 9 }];
            }
        }, {
            key: "agregarDiferenciador",
            value: function agregarDiferenciador() {
                var newValue = { title: '', value: '', editing: true };
                this.modelo.diferenciadores.push(newValue);
            }
        }, {
            key: "eliminarDiferenciador",
            value: function eliminarDiferenciador($index) {
                this.modelo.diferenciadores.splice($index, 1);
            }
        }, {
            key: "doCreate",
            value: function doCreate() {
                var _this6 = this;

                this.loading = true;
                this.modeloOriginal = this.modelo;
                this.newModelo = {
                    sku: this.modelo.sku,
                    categoriaId: this.modelo.categoriaId,
                    langs: {
                        'PT': this.modelo
                    },
                    langsAvailable: ['PT'],
                    state: true
                };
                this.newModelo.langs.PT.status = 'En Revisión';
                this.newModelo.clientId = 'HP';
                var $toast = this.$toast;
                var $state = this.$state;

                this.$request.http("Modelo", "create", this.newModelo).then(function (modeloOriginal) {
                    _this6.$logger.trackAction("EDIT", modeloOriginal);
                    $toast.info("Modelo creada exitosamente");
                    $state.go("app.modelos.listar");
                }).finally(function () {
                    _this6.loading = false;
                });
            }
        }]);

        return NuevoModeloController;
    }();

    angular.module("app.modelos.nuevo").controller("NuevoModeloController", NuevoModeloController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.modelos.editar', []).config(config);

	function config($stateProvider) {
		var permissions = [{
			key: 'vehiculo',
			edit: true,
			type: 'allow'
		}];
		// State
		$stateProvider.state('app.modelos.editar', {
			url: '/editar/:id/:getOtherLang',
			templateUrl: 'app/pages/admin/modelos/editar/editar.tmpl.html',
			controller: 'EditarModeloController as vm',
			user: true,
			root: true,
			permissions: permissions
		});
	}
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var EditarModeloController = function () {
        function EditarModeloController($load, $q, $auth, $logger, $request, $scope, $state, $stateParams, $timeout, $toast) {
            _classCallCheck(this, EditarModeloController);

            this.name = 'app.modelos.editar';
            this.$logger = $logger;
            this.start($scope);
            this.$load = $load;
            this.$q = $q;
            this.$request = $request;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.$timeout = $timeout;
            this.$toast = $toast;
            this.$auth = $auth;
            this.loading = false;
            this.modelo = {};
            this.modeloOriginal = {};
            this.propertiesAvailableOnLangOfSource = [];
            this.otherLangAvailable = false;
            this.otherLang;
            this.curLang = 'PT';

            // Verificar si es GOD para mostrar tab de Contenido Inpage
            if ($auth.isGod()) {
                this.isGod = true;
            } else {
                this.isGod = false;
            }
        }

        _createClass(EditarModeloController, [{
            key: 'traerCategorias',
            value: function traerCategorias() {
                var _this = this;

                return new Promise(function (resolve, reject) {
                    _this.$request.http('Categoria', 'find', {
                        filter: {
                            where: {
                                state: true
                            }
                        }
                    }).then(function (categorias) {
                        _this.categorias = categorias;
                        resolve();
                    });
                });
            }
        }, {
            key: 'start',
            value: function start(scope) {
                var _this2 = this;

                scope.$on('$stateChangeSuccess', function (ev, state) {
                    if (state.name === _this2.name) {
                        _this2.setup();
                    }
                });
            }
        }, {
            key: 'traerTemplates',
            value: function traerTemplates() {
                var _this3 = this;

                this.$request.http('Template', 'find', {
                    filter: {
                        where: {
                            state: true
                        }
                    }
                }).then(function (templates) {
                    _this3.templates = templates;
                });
            }
        }, {
            key: 'traerFamilias',
            value: function traerFamilias() {
                var _this4 = this;

                this.$request.http('Familia', 'find', {
                    filter: {
                        where: {
                            state: true
                        }
                    }
                }).then(function (familias) {
                    _this4.familias = familias;
                });
            }
        }, {
            key: 'setup',
            value: function setup() {
                var _this5 = this;

                this.loading = true;
                this.subcategoriasCamapana = [{ subCatId: '1', nombre: 'Argentina', orden: 1 }, { subCatId: '2', nombre: 'CAC', orden: 2 }, { subCatId: '3', nombre: 'Chile', orden: 3 }, { subCatId: '4', nombre: 'Colombia', orden: 4 }, { subCatId: '5', nombre: 'México', orden: 5 }, { subCatId: '6', nombre: 'Perú', orden: 6 }, { subCatId: '7', nombre: 'HP Shopping', orden: 7 }, { subCatId: '8', nombre: 'Marketing', orden: 8 }, { subCatId: '9', nombre: 'Partners', orden: 9 }];

                if (this.$stateParams.id) {
                    this.traerCategorias().then(function () {

                        _this5.traerFamilias();
                        _this5.traerTemplates();

                        _this5.$load(_this5.$stateParams.id, 'Modelo', { include: ['categoria'] }, function (res) {
                            _this5.leerModelo(res);
                            _this5.loading = false;
                        }).catch(function () {
                            _this5.$timeout(function () {
                                _this5.$state.go('app.modelos.listar');
                            }, 2000);
                        });
                    });
                } else {
                    this.$state.go('app.modelos.listar');
                }
            }
        }, {
            key: 'agregarDiferenciador',
            value: function agregarDiferenciador() {
                var newValue = { titulo: '', descripcion: '', editing: true };
                if (!this.modelo.langs.PT.diferenciadores) {
                    this.modelo.langs.PT.diferenciadores = [];
                }
                this.modelo.langs.PT.diferenciadores.push(newValue);
            }
        }, {
            key: 'eliminarDiferenciador',
            value: function eliminarDiferenciador($index) {
                this.modelo.langs.PT.diferenciadores.splice($index, 1);
            }
        }, {
            key: 'agregarDiferenciadorSL',
            value: function agregarDiferenciadorSL() {
                var newValue = { titulo: '', descripcion: '', editing: true };
                if (!this.modelo.langs.PT.diferenciadoresSL) {
                    this.modelo.langs.PT.diferenciadoresSL = [];
                }
                this.modelo.langs.PT.diferenciadoresSL.push(newValue);
            }
        }, {
            key: 'eliminarDiferenciadorSL',
            value: function eliminarDiferenciadorSL($index) {
                this.modelo.diferenciadoresSL.splice($index, 1);
            }
        }, {
            key: 'changeCategoria',
            value: function changeCategoria() {
                var _this6 = this;

                var categoriaModelo = _.find(this.categorias, function (categoria) {
                    return _this6.modelo.categoriaId == categoria.id;
                });

                if (categoriaModelo) {
                    this.categoriaModelo = categoriaModelo;
                    this.buildModelFields();
                }
            }
        }, {
            key: 'isBasicField',
            value: function isBasicField(fieldName) {
                return ['nombreRecomendado', 'nombre', 'eanString', 'sku', 'status', 'introduccion', 'keywords'].indexOf(fieldName) !== -1;
            }
        }, {
            key: 'getModelFieldLabels',
            value: function getModelFieldLabels() {
                return {
                    nombreRecomendadoLargo: 'Nome recomendado longo',
                    urlIndexado: 'URL indexada',
                    scriptText: 'Script',
                    tamanoPantalla: 'Tamanho da tela',
                    resolucionPantalla: 'Resolução',
                    relacionAspecto: 'Proporção da tela',
                    tipoPanel: 'Tipo de painel',
                    tasaRefresco: 'Taxa de atualização',
                    tiempoRespuesta: 'Tempo de resposta',
                    contrasteEstatico: 'Contraste estático',
                    puertos: 'Portas',
                    color: 'Cor',
                    alto: 'Altura',
                    ancho: 'Largura',
                    profundidad: 'Profundidade',
                    peso: 'Peso',
                    accesoriosIncluidos: 'Acessórios incluídos',
                    garantia: 'Garantia',
                    brillo: 'Brilho',
                    profundidaddebitsdelpanel: 'Profundidade de bits do painel',
                    gamacolores: 'Gama de cores',
                    modelo: 'Modelo',
                    dimensiones: 'Dimensões',
                    camara: 'Câmera',
                    headline: 'Título'
                };
            }
        }, {
            key: 'getFieldLabel',
            value: function getFieldLabel(field) {
                var labels = this.getModelFieldLabels();
                return labels[field.value] || field.label;
            }
        }, {
            key: 'buildModelFields',
            value: function buildModelFields() {
                var _this7 = this;

                var includedCategoryFields = this.modelo.categoria && this.modelo.categoria.fields || [];
                var currentCategoryFields = this.categoriaModelo && this.categoriaModelo.fields || [];
                var knownFieldLabels = this.getModelFieldLabels();
                this.fieldsModelo = [];

                _.forEach(includedCategoryFields.concat(currentCategoryFields), function (field) {
                    var fieldAlreadyAdded = _.some(_this7.fieldsModelo, function (currentField) {
                        return currentField.value === field.value;
                    });
                    if (!fieldAlreadyAdded) {
                        _this7.fieldsModelo.push(field);
                    }
                });

                _.forEach(Object.keys(knownFieldLabels), function (fieldName) {
                    var fieldAlreadyAdded = _.some(_this7.fieldsModelo, function (field) {
                        return field.value === fieldName;
                    });
                    if (!fieldAlreadyAdded) {
                        _this7.fieldsModelo.push({
                            value: fieldName,
                            label: knownFieldLabels[fieldName]
                        });
                    }
                });
            }
        }, {
            key: 'agregarVisualSindicado',
            value: function agregarVisualSindicado() {
                var newValue = { titulo: '', descripcion: '', editing: true };
                if (!this.modelo.langs.PT.sindicado) {
                    this.modelo.langs.PT.sindicado = {};
                }
                if (!this.modelo.langs.PT.sindicado.visuales) {
                    this.modelo.langs.PT.sindicado.visuales = [];
                }
                this.modelo.langs.PT.sindicado.visuales.push(newValue);
            }
        }, {
            key: 'eliminarVisualSindicado',
            value: function eliminarVisualSindicado($index) {
                this.modelo.langs.PT.sindicado.visuales.splice($index, 1);
            }
        }, {
            key: 'agregarTintaSindicado',
            value: function agregarTintaSindicado() {
                var newValue = { titulo: '', descripcion: '', editing: true };
                if (!this.modelo.langs.PT.sindicado) {
                    this.modelo.langs.PT.sindicado = {};
                }
                if (!this.modelo.langs.PT.sindicado.tintas) {
                    this.modelo.langs.PT.sindicado.tintas = [];
                }
                this.modelo.langs.PT.sindicado.tintas.push(newValue);
            }
        }, {
            key: 'eliminarTintaSindicado',
            value: function eliminarTintaSindicado($index) {
                this.modelo.langs.PT.sindicado.tintas.splice($index, 1);
            }
        }, {
            key: 'doEdit',
            value: function doEdit() {
                var _this8 = this;

                this.loading = true;
                this.modeloOriginal = angular.copy(this.modelo);
                // Extraer URL del archivo ZIP de materialsZip y guardar en materialsLink
                if (this.modelo.langs.PT.materialsZip && this.modelo.langs.PT.materialsZip.length > 0) {
                    var zipFile = this.modelo.langs.PT.materialsZip[0];
                    if (zipFile && zipFile.url) {
                        this.modelo.langs.PT.materialsLink = zipFile.url;
                    } else if (zipFile && zipFile.name) {
                        // Si no tiene url pero tiene name, construir la URL
                        this.modelo.langs.PT.materialsLink = 'https://files.alquimio.cloud/imagenes/' + zipFile.name;
                    }
                    this.modeloOriginal.langs.PT.materialsLink = this.modelo.langs.PT.materialsLink;
                    this.modeloOriginal.langs.PT.materialsZip = this.modelo.langs.PT.materialsZip;
                }

                this.$logger.trackAction('EDIT', this.modelo);

                this.modeloOriginal.$save().then(function (modeloEdited) {
                    _this8.$toast.info('Modelo editado');
                }).catch(function () {
                    _this8.$toast.error('No se logró completar la edición del modelo');
                }).finally(function () {
                    _this8.loading = false;
                });
            }
        }, {
            key: 'replaceValuesEmptyOfOtherLang',
            value: function replaceValuesEmptyOfOtherLang(langOfDestionation, langOfSource) {
                var _this9 = this;

                _.forEach(this.modelo.langs[langOfSource], function (property, index) {
                    if (!_this9.propertyIsNullOrEmpty(langOfDestionation, property) && !_this9.isCapProperty(property) && _this9.propertyIsNullOrEmpty(langOfSource, property)) {
                        _this9.modelo.langs[langOfDestionation][property] = _this9.modelo.langs[langOfSource][property];
                    }
                });
            }
        }, {
            key: 'propertyIsNullOrEmpty',
            value: function propertyIsNullOrEmpty(lang, property) {
                return !this.modelo.langs[lang][property] || this.modelo.langs[lang][property] && this.modelo.langs[lang][property] == '';
            }
        }, {
            key: 'checkValuesEmptyOnOtherLangIfIsAvailable',
            value: function checkValuesEmptyOnOtherLangIfIsAvailable(langOfDestionation, langOfSource) {
                var _this10 = this;

                _.forEach(this.modelo.langs[langOfSource], function (value, propertyName) {
                    if (_this10.propertyIsValidToReplace(value, propertyName) && _this10.propertyIsNullOrEmpty(langOfDestionation, propertyName) && !_this10.propertyIsNullOrEmpty(langOfSource, propertyName) && !_this10.isCapProperty(propertyName)) {
                        _this10.propertiesAvailableOnLangOfSource.push(_defineProperty({}, propertyName, value));
                    }
                });
                console.log('Properties to replace', this.propertiesAvailableOnLangOfSource);
            }
        }, {
            key: 'propertyIsValidToReplace',
            value: function propertyIsValidToReplace(value, propertyName) {
                var propertiesNotAllowed = ['status', 'script', 'originalId'];
                return typeof value === 'string' && propertiesNotAllowed.indexOf(propertyName) === -1;
            }
        }, {
            key: 'modalConfirmReplace',
            value: function modalConfirmReplace(langOfDestination, langOfSource) {
                var _this11 = this;

                var confirm = this.$mdDialog.confirm().title('Datos existentes en otro idioma').textContent('Este SKU se encuentra disponible en los siguientes lenguajes ' + langOfSource + '. Desea completar los datos desde ' + langOfSource + ' ?').ariaLabel('Lucky day').clickOutsideToClose(true).parent(angular.element(document.body)).ok('Si, editar').cancel('No, cambiaré el SKU');
                this.$mdDialog.show(confirm).then(function () {
                    _this11.replaceValuesEmptyOfOtherLang(langOfDestination, langOfSource);
                }, function () {});
            }
        }, {
            key: 'isCapProperty',
            value: function isCapProperty(property) {

                return typeof property === 'string' && property.indexOf('cap') > -1;
            }
        }, {
            key: 'leerModelo',
            value: function leerModelo(res) {
                var _this12 = this;

                this.loading = true;

                try {
                    this.modelo = angular.copy(res);
                    if (!this.modelo.langs.PT) {
                        this.modelo.langs.PT = {};

                        if (!this.modelo.availableLanguages) {
                            this.modelo.availableLanguages = ['PT'];
                        } else {
                            this.modelo.availableLanguages.push('PT');
                        }
                        this.modelo.langs.PT.status = 'En Revisión';
                    }
                    this.categoriaModelo = _.find(this.categorias, function (categoria) {
                        return (_this12.modelo.categoriaId || _this12.modelo.langs.PT.categoriaId) == categoria.id;
                    });
                    this.changeCategoria();
                    this.buildModelFields();
                    this.modelo.langs.PT.sku = this.modelo.sku;

                    if (this.modelo.langs.PT.ficha && !angular.isArray(this.modelo.langs.PT.ficha)) {
                        this.modelo.langs.PT.ficha = [this.modelo.langs.PT.ficha];
                    }
                    if (this.modelo.langs.PT.imagen && !angular.isArray(this.modelo.langs.PT.imagen)) {
                        this.modelo.langs.PT.imagen = [this.modelo.langs.PT.imagen];
                    }
                    if (this.modelo.langs.PT.zip && !angular.isArray(this.modelo.langs.PT.zip)) {
                        this.modelo.langs.PT.zip = [this.modelo.langs.PT.zip];
                    }
                    if (this.modelo && !this.modelo.langs.PT.diferenciadoresSL) {
                        this.modelo.langs.PT.diferenciadoresSL = [];
                    }

                    // Inicializar materialsZip si existe materialsZip guardado o materialsLink
                    if (this.modelo.langs.PT.materialsZip && !angular.isArray(this.modelo.langs.PT.materialsZip)) {
                        this.modelo.langs.PT.materialsZip = [this.modelo.langs.PT.materialsZip];
                    } else if (!this.modelo.langs.PT.materialsZip && this.modelo.langs.PT.materialsLink) {
                        // Si existe materialsLink pero no materialsZip, crear el objeto de archivo
                        this.modelo.langs.PT.materialsZip = [{
                            url: this.modelo.langs.PT.materialsLink,
                            name: this.modelo.langs.PT.materialsLink.split('/').pop()
                        }];
                    }

                    if (this.modelo.langs.PT.visuales) {
                        var newVisuales = [];
                        _.forEach(this.modelo.langs.PT.visuales, function (visual, index) {
                            if (visual && visual.imagen) {
                                newVisuales.push(visual.imagen);
                            } else if (visual && visual.name) {
                                newVisuales.push(visual);
                            }
                        });
                        this.modelo.langs.PT.visuales = newVisuales;
                    }

                    if (this.modelo.langs.PT.diferenciadores) {
                        this.modelo.langs.PT.diferenciadores = _.map(this.modelo.langs.PT.diferenciadores, function (diferenciador) {
                            if (!angular.isArray(diferenciador.imagen)) {
                                diferenciador.imagen = [diferenciador.imagen];
                            }
                            return diferenciador;
                        });
                    }
                    if (this.modelo.langs.PT.diferenciadoresSL) {
                        this.modelo.langs.PT.diferenciadoresSL = _.map(this.modelo.langs.PT.diferenciadoresSL, function (diferenciador) {
                            if (!angular.isArray(diferenciador.imagen)) {
                                diferenciador.imagen = [diferenciador.imagen];
                            }
                            return diferenciador;
                        });
                    }

                    if (this.modelo.langs.esCL) {
                        this.otherLangAvailable = true;
                        this.otherLang = 'esCL';
                    }

                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log('Error parsing elements ', e);
                }
            }
        }]);

        return EditarModeloController;
    }();

    angular.module('app.modelos.editar').controller('EditarModeloController', EditarModeloController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.modelos.listar', []).config(config);

	function config($stateProvider, msNavigationServiceProvider) {
		var permissions = [{
			key: 'modelo',
			access: 'none',
			type: 'deny'
		}];
		// State
		$stateProvider.state('app.modelos.listar', {
			url: '/listar/',
			templateUrl: 'app/pages/admin/modelos/listar/listar.tmpl.html',
			controller: 'ListarModeloController as vm',
			user: true,
			root: true,
			permissions: permissions
		});

		msNavigationServiceProvider.saveItem('modelos.listar', {
			title: 'Ver modelos',
			icon: 'fi flaticon-list',
			state: 'app.modelos.listar',
			weight: 2,
			permissions: permissions
		});
	}
})();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	"use strict";

	var ListarModeloController = function () {
		function ListarModeloController($state, $stateParams, $logger, $window, $q, $request, $scope, $rootScope, $toast, $auth, $localStorage, $mdDialog) {
			var _this = this;

			_classCallCheck(this, ListarModeloController);

			this.$request = $request;
			this.$auth = $auth;
			this.$toast = $toast;
			this.$q = $q;
			this.$logger = $logger;
			this.name = "app.modelos.listar";
			this.start($scope);
			this.$rootScope = $rootScope;
			this.$state = $state;
			this.$window = $window;
			this.$scope = $scope;
			this.$localStorage = $localStorage;
			this.$mdDialog = $mdDialog;

			if ($auth.isGod()) {
				this.isGod = true;
			} else {
				this.isGod = false;
			}

			this.categorias = [{
				id: "56c677fb2405ddbf462d40e4",
				nombre: "Impresoras"
			}, {
				id: "56c677ff2405ddbf462d40e5",
				nombre: "AIO"
			}, {
				id: "56c678022405ddbf462d40e6",
				nombre: "Tintas"
			}, {
				id: "56c678072405ddbf462d40e7",
				nombre: "Notebooks"
			}, {
				id: "571034a1d4c653eec41f5e95",
				nombre: "Campañas"
			}, {
				id: "57ab44ce92623112e483e370",
				nombre: "Accesorios"
			}, {
				id: "57ab452792623112e483e371",
				nombre: "Toners"
			}, {
				id: "590a3eeb77c84c53dc8cace4",
				nombre: "Monitores"
			}];

			this.subcategoriasCamapana = [{ subCatId: "1", nombre: "Argentina", orden: 1 }, { subCatId: "2", nombre: "CAC", orden: 2 }, { subCatId: "3", nombre: "Chile", orden: 3 }, { subCatId: "4", nombre: "Colombia", orden: 4 }, { subCatId: "5", nombre: "México", orden: 5 }, { subCatId: "6", nombre: "Perú", orden: 6 }, { subCatId: "7", nombre: "HP Shopping", orden: 7 }, { subCatId: "8", nombre: "Marketing", orden: 8 }, { subCatId: "9", nombre: "Partners", orden: 9 }];

			this.filterByYearQueryCondition = this.isGod ? {} : {
				or: [{
					"langs.PT.year": { exists: false }
				}, {
					"langs.PT.year": { gte: 2020 }
				}, { "langs.PT.listAlways": true }]
			};

			this.listConfig = {
				model: {
					name: "Modelo",
					filter: {
						order: "modified DESC",
						include: ["categoria"],
						where: {
							and: [{ "langs.PT.status": "Aprovado" }, {
								state: {
									neq: false
								}
							}, this.filterByYearQueryCondition]
						}
					},
					paginate: true,
					errorMessage: "No se lograron obtener los modelos",
					successMessage: null
				},
				permission: "modelo",
				columns: [{
					key: "langs.PT.nombre",
					title: "Nome",
					order: true,
					tag: "a",
					onClick: function onClick($event, modelo) {
						$state.go("app.modelos.ver", { id: modelo.id });
					}
				}, {
					key: "categoria.nombre",
					title: "Categoria",
					select: true,
					model: "Categoria",
					order: true,
					filter: function filter(categoria, modelo) {
						if (modelo.subcategoria) {
							modelo.categoria.nombre = modelo.categoria.nombre + " - " + modelo.subcategoria;
							return modelo;
						}
					}
				}, {
					key: "langs.PT.status",
					title: "Estado",
					order: true
				}, {
					key: "created",
					title: "Data",
					order: true,
					filter: function filter(created, modelo) {
						if (!modelo.created) {
							var date = new Date(parseInt(modelo.id.substring(0, 8), 16) * 1000);
							modelo.created = moment(date).format("DD-MM-YYYY HH:mm:ss");
						} else {
							modelo.created = moment(created).format("DD-MM-YYYY HH:mm:ss");
						}

						return modelo;
					}
				}],
				buttons: [{
					title: "Ações",
					icon: "icon-list",
					action: {
						type: "menus",
						menus: [{
							title: "Ver",
							icon: "icon-eye",
							action: function action(ev, modelo) {
								$state.go("app.modelos.ver", { id: modelo.id });
							},
							profiles: ["GOD", "RETAIL", "REVISOR", "HP", "APROBADOR"]
						},
						// {
						// 	title: "Docs",
						// 	icon: "icon-file",
						// 	action: function(ev, modelo) {
						// 		$state.go("app.file-manager", { id: modelo.id });
						// 	},
						// 	profiles: ["GOD", "RETAIL", "REVISOR", "HP", "APROBADOR"]
						// },
						{
							title: "Zip",
							icon: "icon-archive",
							action: function action(ev, modelo) {
								$toast.info("Por favor espere. Generando Zip. Recuerde permitir los elementos emergentes", { delay: 6000 });
								_this.loading = true;
								$request.http("Modelo", "zip", { id: modelo.id }).then(function (res) {
									$logger.trackDownload("ZIP", res, modelo.id);
									$toast.success("Zip Generado. Recuerde permitir los elementos emergentes", { delay: 5000 });
									var url = "https://files.alquimio.cloud/imagenes/" + res.response.name;
									$window.open(url, "_blank");
								}).finally(function () {
									_this.loading = false;
								});
							},
							profiles: ["GOD", "RETAIL", "REVISOR", "HP", "APROBADOR"]
						}, {
							title: "Editar",
							icon: "icon-pencil",
							action: {
								type: "edit"
							},
							profiles: ["GOD"]
						},

						// {
						// 	title: "Logs",
						// 	icon: "icon-book",
						// 	action: (ev, modelo) => {
						// 		$state.go("app.logs.ver", { modeloId: modelo.id });
						// 	},
						// 	profiles: ["GOD"]
						// },
						{
							title: "Excluir localização PT",
							icon: "icon-trash",
							profiles: ["GOD"],
							action: function action(ev, modelo) {
								_this.softDeletePortugueseLocalization(ev, modelo);
							}
						}]
					}
				}],
				routes: {
					edit: "app.modelos.editar"
				}
			};

			this.$scope.$watch("vm.search", function (newVal, oldVal) {
				if (timeout) {
					clearTimeout(timeout);
				}
				_this.search = newVal;
				var timeout = setTimeout(function () {
					_this.forceSearch(newVal);
				}, 2000);
			});

			this.forceSearch = function () {
				console.log("search term", _this.search);
				console.log("categoria ", _this.filterCategoria);

				var where = {
					and: [{
						state: {
							neq: false
						}
					}, { "langs.PT.status": "Aprovado" }, _this.filterByYearQueryCondition]
				};

				if (_this.filterCategoria) {
					where.and.push({ categoriaId: _this.filterCategoria.id });
				}

				if (_this.search != undefined && _this.search != "" && _this.search != undefined) {
					if (!where.or) {
						where.or = [];
					}
					where.or.push({
						"langs.PT.nombre": { like: ".*" + _this.search + ".*", options: "igm" }
					});
					where.or.push({
						"sku": { like: ".*" + _this.search + ".*", options: "igm" }
					});
					where.or.push({
						"langs.PT.keywords": { like: ".*" + _this.search + ".*", options: "igm" }
					});
				}
				_this.$rootScope.$broadcast("$UpdateModelo", where);
				_this.$localStorage.setItem("searchParams", _this.search);
			};

			this.setCategoria = function (categoria) {
				console.log("set categoria", categoria.nombre);
				_this.filterCategoria = categoria;
				_this.forceSearch();
			};

			this.setSubCategoria = function (subcategoria) {
				console.log("set subcategoria", subcategoria.nombre);
				_this.filterSubCategoria = subcategoria;
				_this.forceSearch();
			};

			var data = {
				lang: 'PT'
			};

			this.downloadXls = function () {
				var _this2 = this;

				this.$toast.info("Generando Excel. Por favor espere");
				$logger.trackDownload("XLSX");
				this.loading = true;
				// fetch('https://api.br.repositorio.production.alquimio.cloud/api/modelos/excel', {
				fetch('https://api.repositorio.production.alquimio.cloud/api/modelos/excel', {
					method: 'POST',
					body: JSON.stringify(data)
				}).finally(function (res) {
					_this2.loading = false;
					var url = "https://files.alquimio.cloud/imagenes/productosHP_br.xlsx";
					_this2.$window.open(url, "_blank");
				});
				/*
    this.$request
    	.http("Modelo", "excel", {
    		lang: 'PT'
    	})
    	.finally(() => {
    		this.loading = false;
    		let url = "https://files.alquimio.cloud/imagenes/productosHP_br.xlsx";
    		this.$window.open(url, "_blank");		
    	}
    );
    */
			};
			this.downloadEstatico = function (estatico) {
				$logger.trackDownload("DOWNLOAD", estatico);
				this.$window.open(estatico.link, "_blank");
			};
		}

		_createClass(ListarModeloController, [{
			key: "softDeletePortugueseLocalization",
			value: function softDeletePortugueseLocalization(ev, modelo) {
				var _this3 = this;

				var confirm = this.$mdDialog.confirm().title("Excluir localização PT?").textContent("Se existirem outros idiomas, somente PT e seus indexados serão desativados. Se PT for o único idioma e não houver indexados de outros idiomas, o modelo completo será desativado.").ariaLabel("Excluir localização PT").targetEvent(ev).ok("Excluir PT").cancel("Cancelar");

				this.$mdDialog.show(confirm).then(function () {
					_this3.loading = true;
					_this3.$request.http("Modelo", "softDeletePortugueseLocalization", {
						id: modelo.id
					}).then(function (result) {
						if (result.action === "model-deactivated") {
							_this3.$toast.success("Modelo desativado porque PT era seu único idioma");
						} else {
							_this3.$toast.success("Localização PT e seus indexados foram desativados");
						}
						_this3.forceSearch();
					}).catch(function (error) {
						var message = error && error.data && error.data.error && error.data.error.message;
						_this3.$toast.error(message || "Não foi possível excluir a localização PT");
					}).finally(function () {
						_this3.loading = false;
					});
				});
			}
		}, {
			key: "start",
			value: function start(scope) {
				var _this4 = this;

				scope.$on("$stateChangeSuccess", function (ev, state) {
					if (state.name === _this4.name) {

						_this4.setup();
						_this4.traerEstaticos();
						var searchParams = _this4.$localStorage.getItem("searchParams");
						if (searchParams != "" || searchParams != undefined) {
							_this4.search = searchParams;
							_this4.forceSearch();
						}
					}
				});
			}
		}, {
			key: "clearFilter",
			value: function clearFilter(clearTerm) {
				switch (clearTerm) {
					case "categoria":
						this.filterCategoria = null;
						break;
					case "subcategoria":
						this.filterSubCategoria = null;
						break;
					case "search":
						this.search = null;
						break;
					default:
						this.search = null;
						this.filterCategoria = null;
						break;
				}
				this.forceSearch();
			}
		}, {
			key: "traerEstaticos",
			value: function traerEstaticos() {
				var _this5 = this;

				this.$request.http("Estatico", "find", {
					filter: {
						where: {
							state: true
						}
					}
				}).then(function (estaticos) {
					_this5.estaticos = estaticos;
				}).finally(function () {
					_this5.loading = false;
				});
			}
		}, {
			key: "setup",
			value: function setup() {
				if (this.isGod) {
					console.log("es super usuario");
				} else {
					console.log("NO ES super usuario");
				}
			}
		}]);

		return ListarModeloController;
	}();

	angular.module("app.modelos.listar").controller("ListarModeloController", ListarModeloController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.modelos.aprobacion', []).config(config);

	function config($stateProvider, msNavigationServiceProvider) {
		var permissions = [{
			key: 'modelo',
			access: 'none',
			type: 'deny'
		}];
		// State
		$stateProvider.state('app.modelos.aprobacion', {
			url: '/aprobacion/',
			templateUrl: 'app/pages/admin/modelos/aprobacion/listar.tmpl.html',
			controller: 'ListarAprobacionController as vm',
			user: true,
			root: true,
			permissions: permissions
		});
		try {
			var user = localStorage.getItem('ls.$auth.user');
			user = JSON.parse(user);
			if (user) {
				if (user.profile == 'GOD' || user.profile == 'APROBADOR') {
					msNavigationServiceProvider.saveItem('modelos.aprobacion', {
						title: 'Por Aprobar',
						icon: 'icon-checkbox-marked-outline',
						state: 'app.modelos.aprobacion',
						weight: 2
					});
				}
			}
		} catch (e) {
			console.log('error', e);
		}
	}
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var ListarAprobacionController = function () {
        function ListarAprobacionController($state, $stateParams, $logger, $window, $q, $request, $scope, $rootScope, $toast, $auth, $localStorage) {
            var _this = this;

            _classCallCheck(this, ListarAprobacionController);

            this.$request = $request;
            this.$auth = $auth;
            this.$toast = $toast;
            this.$q = $q;
            this.$logger = $logger;
            this.name = 'app.modelos.aprobacion';
            this.start($scope);
            this.$rootScope = $rootScope;
            this.$state = $state;
            this.$window = $window;
            this.$scope = $scope;
            this.$localStorage = $localStorage;

            this.categorias = [{
                'id': '56c677fb2405ddbf462d40e4',
                'nombre': 'Impresoras'
            }, {
                'id': '56c677ff2405ddbf462d40e5',
                'nombre': 'AIO'
            }, {
                'id': '56c678022405ddbf462d40e6',
                'nombre': 'Tintas'
            }, {
                'id': '56c678072405ddbf462d40e7',
                'nombre': 'Notebooks'
            }, {
                'id': '571034a1d4c653eec41f5e95',
                'nombre': 'Campañas'
            }, {
                'id': '57ab44ce92623112e483e370',
                'nombre': 'Accesorios'
            }, {
                'id': '57ab452792623112e483e371',
                'nombre': 'Toners'
            }, {
                'id': '590a3eeb77c84c53dc8cace4',
                'nombre': 'Monitores'
            }];

            this.subcategoriasCamapana = [{ subCatId: '1', nombre: 'Argentina', orden: 1 }, { subCatId: '2', nombre: 'CAC', orden: 2 }, { subCatId: '3', nombre: 'Chile', orden: 3 }, { subCatId: '4', nombre: 'Colombia', orden: 4 }, { subCatId: '5', nombre: 'México', orden: 5 }, { subCatId: '6', nombre: 'Perú', orden: 6 }, { subCatId: '7', nombre: 'HP Shopping', orden: 7 }, { subCatId: '8', nombre: 'Marketing', orden: 8 }, { subCatId: '9', nombre: 'Partners', orden: 9 }];

            this.listConfig = {
                model: {
                    name: 'Modelo',
                    filter: {
                        order: 'created DESC',
                        include: ['categoria'],
                        where: {
                            'langs.PT.status': 'En Revisión',
                            state: {
                                neq: false
                            }
                        }
                    },
                    paginate: true,
                    errorMessage: 'No se lograron obtener los modelos',
                    successMessage: null
                },
                permission: 'modelo',
                columns: [{
                    key: 'langs.PT.nombre',
                    title: 'Nome',
                    order: true
                }, {
                    key: 'categoria.nombre',
                    title: 'Categoria',
                    select: true,
                    model: 'Categoria',
                    order: true
                }, {
                    key: 'langs.PT.status',
                    title: 'Estado',
                    order: true
                }, {
                    key: 'created',
                    title: 'Data',
                    order: true,
                    filter: function filter(created, modelo) {
                        if (!modelo.created) {
                            var date = new Date(parseInt(modelo.id.substring(0, 8), 16) * 1000);
                            modelo.created = moment(date).format('DD-MM-YYYY HH:mm:ss');
                        } else {
                            modelo.created = moment(created).format('DD-MM-YYYY HH:mm:ss');
                        }

                        return modelo;
                    }
                }],
                buttons: [{
                    title: 'Ações',
                    icon: 'icon-list',
                    action: {
                        type: 'menus',
                        menus: [{
                            title: 'Aprobar',
                            icon: 'icon-eye',
                            action: function action(ev, modelo) {
                                $state.go('app.modelos.ver', { id: modelo.id });
                            },
                            profiles: ['GOD', 'RETAIL', 'REVISOR', 'HP', 'APROBADOR']
                        }, {
                            title: 'Editar',
                            icon: 'icon-pencil',
                            action: {
                                type: 'edit'
                            },
                            profiles: ['GOD']
                        }, {
                            title: 'Docs',
                            icon: 'icon-file',
                            action: function action(ev, modelo) {
                                $state.go('app.file-manager', { id: modelo.id });
                            },
                            profiles: ['GOD', 'REVISOR', 'APROBADOR', 'HP']
                        }, {
                            title: 'Zip',
                            icon: 'icon-archive',
                            action: function action(ev, modelo) {
                                $toast.info('Por favor espere. Generando Zip. Recuerde permitir los elementos emergentes', { delay: 6000 });
                                _this.loading = true;
                                $request.http('Modelo', 'zip', { id: modelo.id }).then(function (res) {
                                    $logger.trackDownload('ZIP', res, modelo.id);
                                    $toast.success('Zip Generado. Recuerde permitir los elementos emergentes', { delay: 5000 });
                                    var url = 'https://files.alquimio.cloud/imagenes/' + res.response.name;
                                    $window.open(url, '_blank');
                                }).finally(function () {
                                    _this.loading = false;
                                });
                            },
                            profiles: ['GOD', 'RETAIL', 'REVISOR', 'HP', 'APROBADOR']
                        }, {
                            title: 'Borrar',
                            icon: 'icon-trash',
                            profiles: ['GOD'],
                            action: {
                                type: 'delete',
                                title: '¿Borrar modelo?',
                                content: 'Esto no se podrá deshacer luego',
                                errorMessage: 'No se logró borrar el modelo',
                                successMessage: 'Modelo borrado correctamente'
                            }
                        }]
                    }
                }],
                routes: {
                    edit: 'app.modelos.editar'
                }
            };

            this.$scope.$watch('vm.search', function (newVal, oldVal) {
                if (timeout) {
                    clearTimeout(timeout);
                }
                _this.search = newVal;
                var timeout = setTimeout(function () {
                    _this.forceSearch(newVal);
                }, 2000);
            });

            this.forceSearch = function () {
                var where = {
                    state: {
                        neq: false
                    },
                    'langs.PT.status': 'En Revisión'
                };

                if (_this.filterCategoria) {
                    where.categoriaId = _this.filterCategoria.id;
                }
                if (_this.filterSubCategoria) {
                    where.subcategoria = _this.filterSubCategoria.nombre;
                }
                if (_this.search != undefined && _this.search != '' && _this.search != undefined) {
                    if (!where.or) {
                        where.or = [];
                    }

                    where.or.push({
                        'langs.PT.nombre': { like: '.*' + _this.search + '.*', options: 'igm' }
                    });
                    where.or.push({
                        'sku': { like: '.*' + _this.search + '.*', options: 'igm' }
                    });
                    where.or.push({
                        'langs.PT.keywords': { like: '.*' + _this.search + '.*', options: 'igm' }
                    });
                }
                _this.$rootScope.$broadcast('$UpdateModelo', where);
                _this.$localStorage.setItem('searchParams', _this.search);
            };

            this.setCategoria = function (categoria) {
                console.log('set categoria', categoria.nombre);
                _this.filterCategoria = categoria;
                _this.forceSearch();
            };

            this.setSubCategoria = function (subcategoria) {
                console.log('set subcategoria', subcategoria.nombre);
                _this.filterSubCategoria = subcategoria;
                _this.forceSearch();
            };

            if ($auth.isGod()) {
                this.isGod = true;
            } else {
                this.isGod = false;
            }

            this.downloadXls = function () {
                var _this2 = this;

                this.$toast.info('Generando Excel. Por favor espere');
                $logger.trackDownload('XLSX');

                this.$request.http('Modelo', 'excel').then(function () {
                    var url = 'https://files.alquimio.cloud/imagenes/export2.xlsx';
                    _this2.$window.open(url, '_blank');
                }).finally(function () {
                    _this2.loading = false;
                });
            };
            this.downloadEstatico = function (estatico) {
                $logger.trackDownload('DOWNLOAD', estatico);
                this.$window.open(estatico.link, '_blank');
            };
        }

        _createClass(ListarAprobacionController, [{
            key: 'start',
            value: function start(scope) {
                var _this3 = this;

                scope.$on('$stateChangeSuccess', function (ev, state) {
                    if (state.name === _this3.name) {
                        _this3.setup();
                        _this3.traerEstaticos();
                        var searchParams = _this3.$localStorage.getItem('searchParams');
                        if (searchParams != '' || searchParams != undefined) {
                            _this3.search = searchParams;
                            _this3.forceSearch();
                        }
                    }
                });
            }
        }, {
            key: 'clearFilter',
            value: function clearFilter(clearTerm) {
                switch (clearTerm) {
                    case 'categoria':
                        this.filterCategoria = null;
                        break;
                    case 'subcategoria':
                        this.filterSubCategoria = null;
                        break;
                    case 'search':
                        this.search = null;
                        break;
                    default:
                        this.search = null;
                        this.filterCategoria = null;
                        break;
                }
                this.forceSearch();
            }
        }, {
            key: 'traerEstaticos',
            value: function traerEstaticos() {
                var _this4 = this;

                this.$request.http('Estatico', 'find').then(function (estaticos) {
                    _this4.estaticos = estaticos;
                }).finally(function () {
                    _this4.loading = false;
                });
            }
        }, {
            key: 'setup',
            value: function setup() {
                if (this.isGod) {
                    console.log('es super usuario');
                } else {
                    console.log('NO ES super usuario');
                }
            }
        }]);

        return ListarAprobacionController;
    }();

    angular.module('app.modelos.aprobacion').controller('ListarAprobacionController', ListarAprobacionController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.logs.ver', []).config(config);

	function config($stateProvider) {
		// State
		var permissions = [{
			key: 'user',
			edit: true,
			type: 'allow'
		}];

		$stateProvider.state('app.logs.ver', {
			url: '/ver/:userId/:modeloId',
			templateUrl: 'app/pages/admin/logs/ver/ver.tmpl.html',
			controller: 'VerLogsController as vm',
			permissions: permissions
		});
	}
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VerLogsController = function () {
    function VerLogsController($scope, $q, $window, $rootScope, $auth, $state, $toast, $timeout, $load, $stateParams, $request, $log) {
        _classCallCheck(this, VerLogsController);

        this.name = 'app.logs.ver';
        this.start($scope);
        this.$q = $q;
        this.$state = $state;
        this.$toast = $toast;
        this.$auth = $auth;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$request = $request;
        this.$log = $log;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$toast = $toast;

        this.logs = {};

        this.timelineOptions = {
            scrollEl: '#content'
        };

        this.currentPage = 1;
        this.totalPages = 3;
        this.pauseScroll = false;
        this.timeline = [];
        this.limit = 10;
    }

    _createClass(VerLogsController, [{
        key: 'start',
        value: function start(scope) {
            var _this = this;

            scope.$on('$stateChangeSuccess', function (ev, state) {
                if (state.name === _this.name) {
                    _this.setup();
                }
            });
        }
    }, {
        key: 'setup',
        value: function setup() {
            if (this.$stateParams.userId) {
                this.vType = 'USERLOGS';
                this.userId = this.$stateParams.userId;
                this.logsUsuario(this.$stateParams.userId);
            } else if (this.$stateParams.modeloId) {
                this.modeloId = this.$stateParams.modeloId;
                this.vType = 'MODELLOGS';
                this.logsModelo(this.$stateParams.modeloId);
            }
        }
    }, {
        key: 'logsUsuario',
        value: function logsUsuario() {
            var _this2 = this;

            var deferred = this.$q.defer();
            console.log('log modelos');
            this.skip = (this.currentPage == 1 ? 0 : this.currentPage) * this.limit;
            this.loading = true;
            var filter = {
                where: {
                    userId: this.userId
                },
                include: ["modelo"],
                order: 'created DESC',
                limit: 10,
                skip: this.skip
            };

            this.$request.http('Log', 'find', { filter: filter }).then(function (res) {
                console.log('modelos', res);
                var newLogs = _this2.formatLogs(res);
                _this2.timeline = _this2.timeline.concat(newLogs);

                if (res.length < _this2.limit) {
                    deferred.reject();
                }
            }).finally(function () {
                _this2.loading = false;
            });
            return deferred.promise;
        }
    }, {
        key: 'logsModelo',
        value: function logsModelo() {
            var _this3 = this;

            var deferred = this.$q.defer();
            console.log('log modelos');
            this.skip = (this.currentPage == 1 ? 0 : this.currentPage) * this.limit;
            this.loading = true;
            var filter = {
                where: {
                    modeloId: this.modeloId
                },
                include: ["modelo"],
                order: 'created DESC',
                limit: 10,
                skip: this.skip
            };

            this.$request.http('Log', 'find', { filter: filter }).then(function (res) {
                console.log('modelos', res);
                var newLogs = _this3.formatLogs(res);
                _this3.timeline = _this3.timeline.concat(newLogs);

                if (res.length < _this3.limit) {
                    deferred.reject();
                }
            }).finally(function () {
                _this3.loading = false;
            });
            return deferred.promise;
        }
    }, {
        key: 'formatLogs',
        value: function formatLogs(logs) {

            if (this.vType == 'MODELLOGS') {
                var newLogs = [];
                _.forEach(logs, function (log) {
                    var newLog = {
                        card: {
                            template: "app/core/directives/ms-card/templates/template-1/template-1.html",
                            subtitle: log.nombreModelo,
                            title: log.details
                        },
                        icon: "icon-document",
                        time: log.created,
                        event: log.userData.name + ' ' + (log.userData.lastname ? log.userData.lastname : '')
                    };
                    newLogs.push(newLog);
                });
                return newLogs;
            } else {
                var _newLogs = [];
                _.forEach(logs, function (log) {
                    var newLog = {
                        card: {
                            template: "app/core/directives/ms-card/templates/template-1/template-1.html",
                            title: log.nombreModelo,
                            subtitle: log.details
                        },
                        icon: "icon-document",
                        time: log.created,
                        event: log.userData.name + ' ' + (log.userData.lastname ? log.userData.lastname : '')
                    };
                    _newLogs.push(newLog);
                });
                return _newLogs;
            }
        }
    }, {
        key: 'loadNextPage',
        value: function loadNextPage() {

            if (this.vType == 'USERLOGS') {
                return this.logsUsuario();
            } else if (this.vType == 'MODELLOGS') {
                return this.logsModelo();
            }
        }
    }, {
        key: 'leerLogs',
        value: function leerLogs(res) {

            this._logs = angular.copy(res);
        }
    }]);

    return VerLogsController;
}();

angular.module('app.logs.ver').controller('VerLogsController', VerLogsController);
'use strict';

(function () {
  'use strict';

  angular.module('app.logs.listar', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    // State
    var permissions = [{
      key: 'user',
      edit: true,
      type: 'allow'
    }];

    $stateProvider.state('app.logs.listar', {
      url: '/listar/',
      templateUrl: 'app/pages/admin/logs/listar/listar.tmpl.html',
      controller: 'ListarLogsController as vm',
      permissions: permissions
    });

    try {
      var user = localStorage.getItem('ls.$auth.user');
      user = JSON.parse(user);
      if (user && user.profile) {
        if (user.profile == 'GOD') {
          // Navigation
          msNavigationServiceProvider.saveItem('logs.listar', {
            title: 'Listar Logs',
            icon: 'fi flaticon-list',
            state: 'app.logs.listar',
            weight: 2,
            permissions: permissions
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var ListarLogsController = function () {
        function ListarLogsController($scope, $q, $window, $rootScope, $auth, $state, $toast, $timeout, $load, $stateParams, $request, $log) {
            var _this = this;

            _classCallCheck(this, ListarLogsController);

            this.name = 'app.logs.listar';
            this.start($scope);
            this.$q = $q;
            this.$state = $state;
            this.$toast = $toast;
            this.$auth = $auth;
            this.$timeout = $timeout;
            this.$stateParams = $stateParams;
            this.$request = $request;
            this.$log = $log;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$window = $window;
            this.$toast = $toast;

            this.logs = {};

            this.$scope.$watch('vm.search', function (newVal, oldVal) {
                if (newVal != undefined && oldVal != undefined) {
                    var where = {};
                    console.log('new val', newVal);

                    if (newVal == '' || newVal == undefined) {} else if (newVal) {
                        where.or = [];
                        where.or.push({ 'userData.name': { like: ".*" + newVal + ".*", options: "igm" } });
                        where.or.push({ 'userData.email': { like: ".*" + newVal + ".*", options: "igm" } });
                        where.or.push({ details: { like: ".*" + newVal + ".*", options: "igm" } });
                    }

                    if (_timeout) {
                        clearTimeout(_timeout);
                    }
                    var _timeout = setTimeout(function () {
                        _this.$rootScope.$broadcast('$UpdateLog', where);
                    }, 2000);
                }
            });

            this.listConfig = {
                model: {
                    name: 'Log',
                    filter: {
                        order: 'created DESC',
                        include: ["modelo"],
                        where: {
                            state: true
                        }
                    },
                    paginate: true,
                    errorMessage: 'No se lograron obtener los modelos',
                    successMessage: null
                },
                columns: [{
                    key: 'nombre',
                    title: 'Nombre',
                    order: true,
                    filter: function filter(nombre, fila) {
                        fila.nombre = fila.userData.name + ' ' + (fila.userData.lastName ? fila.userData.lastName : '');
                        return fila;
                    }
                }, {
                    key: 'userData.email',
                    title: 'email',
                    order: true

                }, {
                    key: 'modelo.nombre',
                    title: 'Modelo',
                    order: false
                }, {
                    key: 'details',
                    title: 'Acción',
                    order: true
                }, {
                    key: 'created',
                    title: 'Fecha',
                    order: true,
                    filter: function filter(created, fila) {
                        return fila.created = moment(created).format('DD-MM-YYYY HH:mm:ss');
                    }
                }],
                buttons: []

            };
        }

        _createClass(ListarLogsController, [{
            key: 'start',
            value: function start(scope) {
                var _this2 = this;

                scope.$on('$stateChangeSuccess', function (ev, state) {
                    if (state.name === _this2.name) {
                        _this2.setup();
                    }
                });
            }
        }, {
            key: 'setup',
            value: function setup() {
                if (this.isGod) {
                    console.log('es super usuario');
                } else {
                    console.log('NO ES super usuario');
                }
            }
        }, {
            key: 'downloadXls',
            value: function downloadXls() {
                var _this3 = this;

                this.loading = true;
                this.$toast.info('Por favor espere. Estamos generando el archivo de logs. Recuerde permitir los elementos emergentes', { delay: 6000 });

                this.$request.http('Log', 'excel').then(function (res) {
                    _this3.loading = false;
                    var url = "https://files.alquimio.cloud/imagenes/logs.xlsx";
                    _this3.$window.open(url, "_blank");
                }, function (err) {});
            }
        }, {
            key: 'leerLogs',
            value: function leerLogs(res) {
                this._logs = angular.copy(res);
            }
        }]);

        return ListarLogsController;
    }();

    angular.module('app.logs.listar').controller('ListarLogsController', ListarLogsController);
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.familia.listar', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'user',
      access: 'none',
      type: 'deny'
    }];
    // State
    $stateProvider.state('app.familia.listar', {
      url: '/listar',
      templateUrl: 'app/pages/admin/familia/listar/listar.tmpl.html',
      controller: 'ListarFamiliaController as vm',
      user: true,
      permissions: permissions
    });

    var user = JSON.parse(localStorage.getItem('ls.$auth.user'));
    if (user) {
      if (user.profile == 'GOD') {

        msNavigationServiceProvider.saveItem('familia.listar', {
          title: 'Listar Familias',
          icon: 'fi flaticon-list',
          state: 'app.familia.listar',
          weight: 2,
          permissions: permissions
        });
      }
    }
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	var ListarFamiliaController = function ListarFamiliaController($state, $scope, $rootScope) {
		var _this = this;

		_classCallCheck(this, ListarFamiliaController);

		this.$scope = $scope;
		this.$rootScope = $rootScope;
		this.listConfig = {
			model: {
				name: 'Familia',
				filter: {
					order: 'created DESC',
					where: {
						state: true
					}
				},
				paginate: true,
				errorMessage: 'No se lograron obtener los familias',
				successMessage: null
			},
			columns: [{
				key: 'nombre',
				title: 'Nombre',
				order: true
			}],
			buttons: [{
				title: 'Editar',
				action: {
					type: 'edit'
				},
				clase: 'md-primary md-raised'
			}, {
				title: 'Borrar',
				action: {
					type: 'delete',
					title: '¿Borrar familia?',
					content: 'Esto no se podrá deshacer luego',
					errorMessage: 'No se logró borrar el familia',
					successMessage: 'Familia borrado correctamente'
				},
				clase: 'md-warn md-raise'
			}],
			routes: {
				edit: 'app.familia.editar'
			}
		};

		this.$scope.$watch('vm.search', function (newVal, oldVal) {

			if (newVal != undefined && oldVal != undefined) {
				var where = {
					state: {
						neq: false
					}
				};

				if (newVal == '' || newVal == undefined) {} else if (newVal) {
					where.or = [];
					where.or.push({ nombre: { like: ".*" + newVal + ".*", options: "igm" } });
				}

				if (_timeout) {
					clearTimeout(_timeout);
				}
				var _timeout = setTimeout(function () {
					_this.$rootScope.$broadcast('$UpdateFamilia', where);
				}, 2000);
			}
		});
	};

	angular.module('app.familia.listar').controller('ListarFamiliaController', ListarFamiliaController);
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.familia.nuevo', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'user',
      create: true,
      type: 'allow'
    }];
    // State
    $stateProvider.state('app.familia.nuevo', {
      url: '/nuevo',
      templateUrl: 'app/pages/admin/familia/nuevo/nuevo.tmpl.html',
      controller: 'NuevoFamiliaController as vm',
      user: true,
      permissions: permissions
    });
    try {
      var user = localStorage.getItem('ls.$auth.user');
      user = JSON.parse(user);
      if (user) {
        if (user.profile == 'GOD') {
          msNavigationServiceProvider.saveItem('familia.nuevo', {
            title: 'Nueva Familia',
            icon: 'fi flaticon-add',
            state: 'app.familia.nuevo',
            weight: 1,
            permissions: permissions
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	var NuevoFamiliaController = function () {
		function NuevoFamiliaController($scope, $q, $toast, $state, $request, $log) {
			_classCallCheck(this, NuevoFamiliaController);

			this.name = 'app.familia.nuevo';
			this.start($scope);
			this.$q = $q;
			this.$toast = $toast;
			this.$state = $state;
			this.$request = $request;
			this.$log = $log;
			this.loading = false;
		}

		_createClass(NuevoFamiliaController, [{
			key: 'start',
			value: function start(scope) {
				var _this = this;

				scope.$on('$stateChangeSuccess', function (ev, state) {
					if (state.name === _this.name) {
						_this.setup();
					}
				});
			}
		}, {
			key: 'setup',
			value: function setup() {}
		}, {
			key: 'doCreate',
			value: function doCreate() {
				var _this2 = this;

				this.loading = true;
				this.$toast.info('Creando familia...');
				this.$request('Familia', 'create', this.parseFamilia(this.familia)).then(function (res) {
					_this2.$toast.info('Familia creada');
					_this2.loading = false;
					_this2.$state.go("app.familia.listar");
				}, function (err) {
					if (!err.handled) {
						if (err.statusCode == 422) {
							_this2.$toast.error('No se pudo crear el familia. ');
						} else {
							_this2.$toast.error('No se logró crear el familia.' + err.data.error.message);
						}
					}
				}).finally(function () {
					_this2.loading = false;
				});
			}
		}, {
			key: 'parseFamilia',
			value: function parseFamilia(user) {
				var familia = angular.copy(user);

				return familia;
			}
		}]);

		return NuevoFamiliaController;
	}();

	angular.module('app.familia.nuevo').controller('NuevoFamiliaController', NuevoFamiliaController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.familia.editar', []).config(config);

	function config($stateProvider) {
		// State
		var permissions = [{
			key: 'user',
			edit: true,
			type: 'allow'
		}];

		$stateProvider.state('app.familia.editar', {
			url: '/editar/:id',
			templateUrl: 'app/pages/admin/familia/editar/editar.tmpl.html',
			controller: 'EditarFamiliaController as vm',
			user: true,
			permissions: permissions
		});
	}
})();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditarFamiliaController = function () {
	function EditarFamiliaController($scope, $q, $auth, $state, $toast, $timeout, $load, $stateParams, $request, $log) {
		_classCallCheck(this, EditarFamiliaController);

		this.name = "app.familia.editar";
		this.start($scope);
		this.$q = $q;
		this.$state = $state;
		this.$toast = $toast;
		this.$auth = $auth;
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.$request = $request;
		this.$load = $load;
		this.$log = $log;

		this.familia = {};
	}

	_createClass(EditarFamiliaController, [{
		key: "start",
		value: function start(scope) {
			var _this = this;

			scope.$on("$stateChangeSuccess", function (ev, state) {
				if (state.name === _this.name) {
					_this.setup();
				}
			});
		}
	}, {
		key: "setup",
		value: function setup() {
			var _this2 = this;

			if (this.$stateParams.id) {
				this.$load(this.$stateParams.id, "Familia", function (res) {
					_this2.leerFamilia(res);
				}).catch(function () {
					_this2.$timeout(function () {
						_this2.$state.go("app.familia.listar");
					}, 2000);
				});
			} else {
				this.$state.go("app.familia.listar");
			}
		}
	}, {
		key: "doEdit",
		value: function doEdit() {
			var _this3 = this;

			var familia = angular.copy(this.familia);
			this.loading = true;
			this.$toast.info('Actualizando familia...');
			delete familia.id;

			this.$request("Familia", "updateAttributes", { id: this.familia.id }, familia).then(function (res) {

				_this3.$toast.info("Familia editado correctamente");
				_this3.loading = false;
			}, function (err) {

				_this3.$toast.error("No se logró completar la edición del familia");
				_this3.loading = false;
			});
		}
	}, {
		key: "leerFamilia",
		value: function leerFamilia(res) {
			this.familia = angular.copy(res);
			this.familia.id = res.id;
		}
	}]);

	return EditarFamiliaController;
}();

angular.module("app.familia.editar").controller("EditarFamiliaController", EditarFamiliaController);
'use strict';

(function () {
  'use strict';

  angular.module('app.estatico.nuevo', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'user',
      create: true,
      type: 'allow'
    }];
    // State
    $stateProvider.state('app.estatico.nuevo', {
      url: '/nuevo',
      templateUrl: 'app/pages/admin/estatico/nuevo/nuevo.tmpl.html',
      controller: 'NuevoEstaticoController as vm',
      user: true,
      permissions: permissions
    });
    try {
      var user = localStorage.getItem('ls.$auth.user');
      user = JSON.parse(user);
      if (user) {
        if (user.profile == 'GOD') {
          msNavigationServiceProvider.saveItem('estatico.nuevo', {
            title: 'Nuevo Estatico',
            icon: 'fi flaticon-add',
            state: 'app.estatico.nuevo',
            weight: 1,
            permissions: permissions
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	var NuevoEstaticoController = function () {
		function NuevoEstaticoController($scope, $q, $toast, $state, $request, $log) {
			_classCallCheck(this, NuevoEstaticoController);

			this.name = 'app.estatico.nuevo';
			this.start($scope);
			this.$q = $q;
			this.$toast = $toast;
			this.$state = $state;
			this.$request = $request;
			this.$log = $log;
			this.loading = false;
			this.profileList = [];
		}

		_createClass(NuevoEstaticoController, [{
			key: 'start',
			value: function start(scope) {
				var _this = this;

				scope.$on('$stateChangeSuccess', function (ev, state) {
					if (state.name === _this.name) {
						_this.setup();
					}
				});
			}
		}, {
			key: 'setup',
			value: function setup() {}
		}, {
			key: 'doCreate',
			value: function doCreate() {
				var _this2 = this;

				this.loading = true;
				this.estatico.state = true;
				this.estatico.link = _.first(this.estatico.file).url;
				this.$toast.info('Creando estatico...');
				this.$request('Estatico', 'create', this.parseEstatico(this.estatico)).then(function (res) {
					_this2.$toast.info('Estatico creado');
					_this2.loading = false;
					_this2.$state.go("app.estatico.listar");
				}, function (err) {}).finally(function () {
					_this2.loading = false;
				});
			}
		}, {
			key: 'parseEstatico',
			value: function parseEstatico(user) {
				var estatico = angular.copy(user);

				return estatico;
			}
		}]);

		return NuevoEstaticoController;
	}();

	angular.module('app.estatico.nuevo').controller('NuevoEstaticoController', NuevoEstaticoController);
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.estatico.listar', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'user',
      access: 'none',
      type: 'deny'
    }];
    // State
    $stateProvider.state('app.estatico.listar', {
      url: '/listar',
      templateUrl: 'app/pages/admin/estatico/listar/listar.tmpl.html',
      controller: 'ListarEstaticoController as vm',
      user: true,
      permissions: permissions
    });

    var user = JSON.parse(localStorage.getItem('ls.$auth.user'));
    if (user) {
      if (user.profile == 'GOD') {
        msNavigationServiceProvider.saveItem('estatico.listar', {
          title: 'Listar Estaticos',
          icon: 'fi flaticon-list',
          state: 'app.estatico.listar',
          weight: 2,
          permissions: permissions
        });
      }
    }
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	var ListarEstaticoController = function ListarEstaticoController($state, $scope, $rootScope) {
		var _this = this;

		_classCallCheck(this, ListarEstaticoController);

		this.$scope = $scope;
		this.$rootScope = $rootScope;
		this.listConfig = {
			model: {
				name: 'Estatico',
				filter: {
					order: 'created DESC',
					where: {
						state: true
					}
				},
				paginate: true,
				errorMessage: 'No se lograron obtener los categorias',
				successMessage: null
			},
			columns: [{
				key: 'name',
				title: 'Nombre',
				order: true
			}],
			buttons: [{
				title: 'Editar',
				action: {
					type: 'edit'
				},
				clase: 'md-primary md-raised'
			}, {
				title: 'Borrar',
				action: {
					type: 'delete',
					title: '¿Borrar estatico?',
					content: 'Esto no se podrá deshacer luego',
					errorMessage: 'No se logró borrar el estatico',
					successMessage: 'Estatico borrado correctamente'
				},
				clase: 'md-warn md-raise'
			}],
			routes: {
				edit: 'app.estatico.editar'
			}
		};

		this.$scope.$watch('vm.search', function (newVal, oldVal) {

			if (newVal != undefined && oldVal != undefined) {
				var where = {
					state: {
						neq: false
					}
				};

				if (newVal == '' || newVal == undefined) {} else if (newVal) {
					where.or = [];
					where.or.push({ name: { like: ".*" + newVal + ".*", options: "igm" } });
				}

				if (_timeout) {
					clearTimeout(_timeout);
				}
				var _timeout = setTimeout(function () {
					_this.$rootScope.$broadcast('$UpdateEstatico', where);
				}, 2000);
			}
		});
	};

	angular.module('app.estatico.listar').controller('ListarEstaticoController', ListarEstaticoController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.estatico.editar', []).config(config);

	function config($stateProvider) {
		// State
		var permissions = [{
			key: 'user',
			edit: true,
			type: 'allow'
		}];

		$stateProvider.state('app.estatico.editar', {
			url: '/editar/:id',
			templateUrl: 'app/pages/admin/estatico/editar/editar.tmpl.html',
			controller: 'EditarEstaticoController as vm',
			user: true,
			permissions: permissions
		});
	}
})();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditarEstaticoController = function () {
	function EditarEstaticoController($scope, $q, $auth, $state, $toast, $timeout, $load, $stateParams, $request, $log) {
		_classCallCheck(this, EditarEstaticoController);

		this.name = "app.estatico.editar";
		this.start($scope);
		this.$q = $q;
		this.$state = $state;
		this.$toast = $toast;
		this.$auth = $auth;
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.$request = $request;
		this.$load = $load;
		this.$log = $log;

		this.estatico = {};
	}

	_createClass(EditarEstaticoController, [{
		key: "start",
		value: function start(scope) {
			var _this = this;

			scope.$on("$stateChangeSuccess", function (ev, state) {
				if (state.name === _this.name) {
					_this.setup();
				}
			});
		}
	}, {
		key: "setup",
		value: function setup() {
			var _this2 = this;

			if (this.$stateParams.id) {

				this.$load(this.$stateParams.id, "Estatico", function (res) {
					_this2.leerEstatico(res);
				}).catch(function () {
					_this2.$timeout(function () {
						_this2.$state.go("app.estatico.listar");
					}, 2000);
				});
			} else {
				this.$state.go("app.estatico.listar");
			}
		}
	}, {
		key: "doEdit",
		value: function doEdit() {
			var _this3 = this;

			var estatico = angular.copy(this.estatico);
			estatico.link = _.first(this.estatico.file).url;
			this.$toast.info('Actualizando estatico...');

			estatico.$save().then(function (estaticoEditado) {
				_this3.$toast.info("estatico editado");
			}).catch(function () {
				_this3.$toast.error("No se logró completar la edición del estatico");
			}).finally(function () {
				_this3.loading = false;
			});
		}
	}, {
		key: "leerEstatico",
		value: function leerEstatico(res) {
			this.estatico = angular.copy(res);
			this.estatico.id = res.id;
		}
	}]);

	return EditarEstaticoController;
}();

angular.module("app.estatico.editar").controller("EditarEstaticoController", EditarEstaticoController);
'use strict';

(function () {
    'use strict';

    angular.module('app.dashboards.server', [
    // 3rd Party Dependencies
    'nvd3', 'datatables']).config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider.state('app.dashboards_server', {
            url: '/dashboard-server',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/server/dashboard-server.html',
                    controller: 'DashboardServerController as vm'
                }
            },
            resolve: {
                DashboardData: function DashboardData(msApi) {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });

        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.dashboards.server').controller('DashboardServerController', DashboardServerController);

    /** @ngInject */
    function DashboardServerController($scope, $interval, DashboardData) {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;

        // Widget 1
        vm.widget1 = {
            title: vm.dashboardData.widget1.title,
            chart: {
                options: {
                    chart: {
                        type: 'lineChart',
                        color: ['#4caf50', '#3f51b5', '#ff5722'],
                        height: 320,
                        margin: {
                            top: 32,
                            right: 32,
                            bottom: 32,
                            left: 48
                        },
                        useInteractiveGuideline: true,
                        clipVoronoi: false,
                        interpolate: 'cardinal',
                        x: function x(d) {
                            return d.x;
                        },
                        y: function y(d) {
                            return d.y;
                        },
                        xAxis: {
                            tickFormat: function tickFormat(d) {
                                return d + ' min.';
                            },
                            showMaxMin: false
                        },
                        yAxis: {
                            tickFormat: function tickFormat(d) {
                                return d + ' MB';
                            }
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                right: 0,
                                bottom: 32,
                                left: 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data: vm.dashboardData.widget1.chart
            }
        };

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = {
            title: vm.dashboardData.widget4.title,
            value: vm.dashboardData.widget4.value,
            footnote: vm.dashboardData.widget4.footnote,
            detail: vm.dashboardData.widget4.detail,
            chart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'lineChart',
                        color: ['rgba(0, 0, 0, 0.27)'],
                        height: 50,
                        margin: {
                            top: 8,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        duration: 1,
                        clipEdge: true,
                        interpolate: 'cardinal',
                        interactive: false,
                        isArea: true,
                        showLegend: false,
                        showControls: false,
                        showXAxis: false,
                        showYAxis: false,
                        x: function x(d) {
                            return d.x;
                        },
                        y: function y(d) {
                            return d.y;
                        },
                        yDomain: [0, 4]
                    }
                },
                data: vm.dashboardData.widget4.chart
            },
            init: function init() {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget4.chart[0].values.length - 1,
                    x = vm.dashboardData.widget4.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function latencyTicker(min, max) {
                    // Increase the x value
                    x++;

                    var randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

                    var newValue = {
                        x: x,
                        y: randomNumber
                    };

                    vm.widget4.chart.data[0].values.shift();
                    vm.widget4.chart.data[0].values.push(newValue);

                    // Randomize the value
                    vm.widget4.value = 20 + randomNumber + 'ms';
                }

                // Set interval
                var latencyTickerInterval = $interval(function () {
                    latencyTicker(1, 4);
                }, 1000);

                // Cleanup
                $scope.$on('$destroy', function () {
                    $interval.cancel(latencyTickerInterval);
                });
            }
        };

        // Widget 5
        vm.widget5 = vm.dashboardData.widget5;

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            chart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'lineChart',
                        color: ['#03A9F4'],
                        height: 140,
                        margin: {
                            top: 8,
                            right: 32,
                            bottom: 16,
                            left: 48
                        },
                        duration: 1,
                        clipEdge: true,
                        clipVoronoi: false,
                        interpolate: 'cardinal',
                        isArea: true,
                        useInteractiveGuideline: true,
                        showLegend: false,
                        showControls: false,
                        x: function x(d) {
                            return d.x;
                        },
                        y: function y(d) {
                            return d.y;
                        },
                        yDomain: [0, 100],
                        xAxis: {
                            tickFormat: function tickFormat(d) {
                                return d + ' sec.';
                            },
                            showMaxMin: false
                        },
                        yAxis: {
                            tickFormat: function tickFormat(d) {
                                return d + '%';
                            }
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data: vm.dashboardData.widget6.chart
            },
            init: function init() {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget6.chart[0].values.length - 1,
                    x = vm.dashboardData.widget6.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function cpuTicker(min, max) {
                    // Increase the x value
                    x = x + 5;

                    var newValue = {
                        x: x,
                        y: Math.floor(Math.random() * (max - min + 1)) + min
                    };

                    vm.widget6.chart.data[0].values.shift();
                    vm.widget6.chart.data[0].values.push(newValue);
                }

                // Set interval
                var cpuTickerInterval = $interval(function () {
                    cpuTicker(0, 100);
                }, 5000);

                // Cleanup
                $scope.$on('$destroy', function () {
                    $interval.cancel(cpuTickerInterval);
                });
            }
        };

        // Widget 7
        vm.widget7 = {
            title: vm.dashboardData.widget7.title,
            table: vm.dashboardData.widget7.table,
            dtOptions: {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                pageLength: 10,
                lengthMenu: [10, 20, 50, 100],
                autoWidth: false,
                responsive: true,
                columnDefs: [{
                    width: '20%',
                    targets: [0, 1, 2, 3, 4]
                }],
                columns: [{}, {}, {
                    render: function render(data, type) {
                        if (type === 'display') {
                            return data + ' KB/s';
                        } else {
                            return data;
                        }
                    }
                }, {
                    render: function render(data, type) {
                        if (type === 'display') {
                            return data + '%';
                        } else {
                            return data;
                        }
                    }
                }, {
                    render: function render(data, type) {
                        if (type === 'display') {
                            var el = angular.element(data);
                            el.html(el.text() + ' MB');

                            return el[0].outerHTML;
                        } else {
                            return data;
                        }
                    }
                }]
            }
        };

        // Widget 8
        vm.widget8 = vm.dashboardData.widget8;

        // Methods

        //////////

        // Init Widget 4
        vm.widget4.init();

        // Init Widget 6
        vm.widget6.init();
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.dashboards.project', [
    // 3rd Party Dependencies
    'nvd3', 'datatables']).config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider.state('app.dashboards_project', {
            url: '/dashboard-project',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/project/dashboard-project.html',
                    controller: 'DashboardProjectController as vm'
                }
            },
            resolve: {
                DashboardData: function DashboardData(msApi) {
                    return msApi.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });

        // Api
        msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.dashboards.project').controller('DashboardProjectController', DashboardProjectController);

    /** @ngInject */
    function DashboardProjectController($scope, $interval, $mdSidenav, DashboardData) {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;

        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            title: vm.dashboardData.widget5.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'multiBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function x(d) {
                            return d.x;
                        },
                        y: function y(d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function tickFormat(d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            supporting: {
                widgets: {
                    created: {
                        data: vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed: {
                        data: vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened: {
                        data: vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix: {
                        data: vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data: vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed: {
                        data: vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart: {
                    config: {
                        refreshDataOnly: true,
                        deepWatchData: true
                    },
                    options: {
                        chart: {
                            type: 'lineChart',
                            color: ['#03A9F4'],
                            height: 50,
                            margin: {
                                top: 8,
                                right: 0,
                                bottom: 0,
                                left: 0
                            },
                            isArea: true,
                            interpolate: 'cardinal',
                            clipEdge: true,
                            duration: 500,
                            showXAxis: false,
                            showYAxis: false,
                            showLegend: false,
                            useInteractiveGuideline: true,
                            x: function x(d) {
                                return d.x;
                            },
                            y: function y(d) {
                                return d.y;
                            },
                            yDomain: [0, 9],
                            xAxis: {
                                tickFormat: function tickFormat(d) {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer: {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data: []
                }
            },
            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange: function changeRange(range) {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index) {
                    vm.widget5.mainChart.data[index] = {
                        key: chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name) {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key: widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init: function init() {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: true,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: 'percent',
                        padAngle: 0.02,
                        x: function x(d) {
                            return d.label;
                        },
                        y: function y(d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            footerLeft: vm.dashboardData.widget6.footerLeft,
            footerRight: vm.dashboardData.widget6.footerRight,
            ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function changeRange(range) {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index) {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init: function init() {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title: vm.dashboardData.widget7.title,
            ranges: vm.dashboardData.widget7.ranges,
            schedule: vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        // Widget 8
        vm.widget8 = {
            title: vm.dashboardData.widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function x(d) {
                            return d.label;
                        },
                        y: function y(d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: vm.dashboardData.widget8.mainChart
            }
        };

        // Widget 9
        vm.widget9 = {
            title: vm.dashboardData.widget9.title,
            weeklySpent: {
                title: vm.dashboardData.widget9.weeklySpent.title,
                count: vm.dashboardData.widget9.weeklySpent.count,
                chartData: []
            },
            totalSpent: {
                title: vm.dashboardData.widget9.totalSpent.title,
                count: vm.dashboardData.widget9.totalSpent.count,
                chartData: []
            },
            remaining: {
                title: vm.dashboardData.widget9.remaining.title,
                count: vm.dashboardData.widget9.remaining.count,
                chartData: []
            },
            totalBudget: vm.dashboardData.widget9.totalBudget,
            chart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'lineChart',
                        color: ['#00BCD4'],
                        height: 50,
                        margin: {
                            top: 8,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        isArea: true,
                        interpolate: 'cardinal',
                        clipEdge: true,
                        duration: 500,
                        showXAxis: false,
                        showYAxis: false,
                        showLegend: false,
                        useInteractiveGuideline: true,
                        x: function x(d) {
                            return d.x;
                        },
                        y: function y(d) {
                            return d.y;
                        },
                        yDomain: [0, 9],
                        xAxis: {
                            tickFormat: function tickFormat(d) {
                                return vm.widget9.days[d];
                            }
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: 'e',
                                classes: 'gravity-e'
                            }
                        }
                    }
                }
            },
            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: vm.dashboardData.widget9.ranges,
            currentRange: '',
            changeRange: function changeRange(range) {
                vm.widget9.currentRange = range;

                /**
                 * Update mini charts. They only have 1 dataset
                 * so we can do [0] without needing to iterate
                 * through in their data arrays
                 */
                vm.widget9.weeklySpent.chartData[0] = {
                    key: vm.dashboardData.widget9.weeklySpent.chart.label,
                    values: vm.dashboardData.widget9.weeklySpent.chart.values[range]
                };

                vm.widget9.totalSpent.chartData[0] = {
                    key: vm.dashboardData.widget9.totalSpent.chart.label,
                    values: vm.dashboardData.widget9.totalSpent.chart.values[range]
                };

                vm.widget9.remaining.chartData[0] = {
                    key: vm.dashboardData.widget9.remaining.chart.label,
                    values: vm.dashboardData.widget9.remaining.chart.values[range]
                };
            },
            init: function init() {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget9.changeRange('TW');
            }
        };

        // Widget 10
        vm.widget10 = vm.dashboardData.widget10;

        // Widget 11
        vm.widget11 = {
            title: vm.dashboardData.widget11.title,
            table: vm.dashboardData.widget11.table,
            dtOptions: {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                order: [1, 'asc'],
                columnDefs: [{
                    width: '40',
                    orderable: false,
                    targets: [0]
                }, {
                    width: '20%',
                    targets: [1, 2, 3, 4, 5]
                }]
            }
        };

        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function ticker() {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();

        // Initialize Widget 9
        vm.widget9.init();

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.dashboards.analytics', [
    // 3rd Party Dependencies
    'nvd3']).config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider.state('app.dashboards_analytics', {
            url: '/dashboard-analytics',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/analytics/dashboard-analytics.html',
                    controller: 'DashboardAnalyticsController as vm'
                }
            },
            resolve: {
                DashboardData: function DashboardData(msApi) {
                    return msApi.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-analytics'
        });

        // Api
        msApiProvider.register('dashboard.analytics', ['app/data/dashboard/analytics/data.json']);
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.dashboards.analytics').controller('DashboardAnalyticsController', DashboardAnalyticsController);

    /** @ngInject */
    function DashboardAnalyticsController(DashboardData, uiGmapGoogleMapApi) {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.widget1 = {
            title: vm.dashboardData.widget1.title,
            onlineUsers: vm.dashboardData.widget1.onlineUsers,
            bigChart: {
                options: {
                    chart: {
                        type: 'lineWithFocusChart',
                        color: ['#2196F3'],
                        height: 400,
                        margin: {
                            top: 32,
                            right: 32,
                            bottom: 64,
                            left: 48
                        },
                        isArea: true,
                        useInteractiveGuideline: true,
                        duration: 1,
                        clipEdge: true,
                        clipVoronoi: false,
                        interpolate: 'cardinal',
                        showLegend: false,
                        x: function x(d) {
                            return d.x;
                        },
                        y: function y(d) {
                            return d.y;
                        },
                        xAxis: {
                            showMaxMin: false,
                            tickFormat: function tickFormat(d) {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        yAxis: {
                            showMaxMin: false
                        },
                        x2Axis: {
                            showMaxMin: false,
                            tickFormat: function tickFormat(d) {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        y2Axis: {
                            showMaxMin: false
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                right: 0,
                                bottom: 32,
                                left: 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data: vm.dashboardData.widget1.bigChart.chart
            },
            sessions: {
                title: vm.dashboardData.widget1.sessions.title,
                value: vm.dashboardData.widget1.sessions.value,
                previous: vm.dashboardData.widget1.sessions.previous,
                options: {
                    chart: {
                        type: 'lineChart',
                        color: ['#03A9F4'],
                        height: 40,
                        margin: {
                            top: 4,
                            right: 4,
                            bottom: 4,
                            left: 4
                        },
                        isArea: true,
                        interpolate: 'cardinal',
                        clipEdge: true,
                        duration: 500,
                        showXAxis: false,
                        showYAxis: false,
                        showLegend: false,
                        useInteractiveGuideline: true,
                        x: function x(d) {
                            return d.x;
                        },
                        y: function y(d) {
                            return d.y;
                        },
                        xAxis: {
                            tickFormat: function tickFormat(d) {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data: vm.dashboardData.widget1.sessions.chart
            },
            pageviews: {
                title: vm.dashboardData.widget1.pageviews.title,
                value: vm.dashboardData.widget1.pageviews.value,
                previous: vm.dashboardData.widget1.pageviews.previous,
                options: {
                    chart: {
                        type: 'lineChart',
                        color: ['#3F51B5'],
                        height: 40,
                        margin: {
                            top: 4,
                            right: 4,
                            bottom: 4,
                            left: 4
                        },
                        isArea: true,
                        interpolate: 'cardinal',
                        clipEdge: true,
                        duration: 500,
                        showXAxis: false,
                        showYAxis: false,
                        showLegend: false,
                        useInteractiveGuideline: true,
                        x: function x(d) {
                            return d.x;
                        },
                        y: function y(d) {
                            return d.y;
                        },
                        xAxis: {
                            tickFormat: function tickFormat(d) {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data: vm.dashboardData.widget1.pageviews.chart
            },
            pagesSessions: {
                title: vm.dashboardData.widget1.pagesSessions.title,
                value: vm.dashboardData.widget1.pagesSessions.value,
                previous: vm.dashboardData.widget1.pagesSessions.previous,
                options: {
                    chart: {
                        type: 'lineChart',
                        color: ['#E91E63'],
                        height: 40,
                        margin: {
                            top: 4,
                            right: 4,
                            bottom: 4,
                            left: 4
                        },
                        isArea: true,
                        interpolate: 'cardinal',
                        clipEdge: true,
                        duration: 500,
                        showXAxis: false,
                        showYAxis: false,
                        showLegend: false,
                        useInteractiveGuideline: true,
                        x: function x(d) {
                            return d.x;
                        },
                        y: function y(d) {
                            return d.y;
                        },
                        xAxis: {
                            tickFormat: function tickFormat(d) {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data: vm.dashboardData.widget1.pagesSessions.chart
            },
            avgSessionDuration: {
                title: vm.dashboardData.widget1.avgSessionDuration.title,
                value: vm.dashboardData.widget1.avgSessionDuration.value,
                previous: vm.dashboardData.widget1.avgSessionDuration.previous,
                options: {
                    chart: {
                        type: 'lineChart',
                        color: ['#009688'],
                        height: 40,
                        margin: {
                            top: 4,
                            right: 4,
                            bottom: 4,
                            left: 4
                        },
                        isArea: true,
                        interpolate: 'cardinal',
                        clipEdge: true,
                        duration: 500,
                        showXAxis: false,
                        showYAxis: false,
                        showLegend: false,
                        useInteractiveGuideline: true,
                        x: function x(d) {
                            return d.x;
                        },
                        y: function y(d) {
                            return d.y;
                        },
                        xAxis: {
                            tickFormat: function tickFormat(d) {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        yAxis: {
                            tickFormat: function tickFormat(d) {
                                var formatTime = d3.time.format('%M:%S');
                                return formatTime(new Date('2012', '0', '1', '0', '0', d));
                            }
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data: vm.dashboardData.widget1.avgSessionDuration.chart
            }
        };

        // Widget 2
        vm.widget2 = {
            title: vm.dashboardData.widget2.title
        };

        // Widget 3
        vm.widget3 = {
            title: vm.dashboardData.widget3.title,
            pages: vm.dashboardData.widget3.pages,
            ranges: vm.dashboardData.widget3.ranges,
            currentRange: vm.dashboardData.widget3.currentRange,
            changeRange: function changeRange(range) {
                vm.widget3.currentRange(range);
            }
        };

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Methods

        //////////

        // Widget 2
        uiGmapGoogleMapApi.then(function () {
            vm.widget2.map = vm.dashboardData.widget2.map;
        });
    }
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.categoria.nuevo', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'user',
      create: true,
      type: 'allow'
    }];
    // State
    $stateProvider.state('app.categoria.nuevo', {
      url: '/nuevo',
      templateUrl: 'app/pages/admin/categoria/nuevo/nuevo.tmpl.html',
      controller: 'NuevoCategoriaController as vm',
      user: true,
      permissions: permissions
    });
    try {
      var user = localStorage.getItem('ls.$auth.user');
      user = JSON.parse(user);
      if (user) {
        if (user.profile == 'GOD') {
          msNavigationServiceProvider.saveItem('categoria.nuevo', {
            title: 'Nueva Categoria',
            icon: 'fi flaticon-add',
            state: 'app.categoria.nuevo',
            weight: 1,
            permissions: permissions
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    var NuevoCategoriaController = function () {
        function NuevoCategoriaController($scope, $q, $toast, $state, $request, $log) {
            _classCallCheck(this, NuevoCategoriaController);

            this.name = 'app.categoria.nuevo';
            this.start($scope);
            this.$q = $q;
            this.$toast = $toast;
            this.$state = $state;
            this.$request = $request;
            this.$log = $log;
            this.maxDate = new Date();
            this.minDate = new Date(angular.copy(this.maxDate).setYear(this.maxDate.getYear() - 100));
            this.loading = false;
            this.profileList = [];
        }

        _createClass(NuevoCategoriaController, [{
            key: 'start',
            value: function start(scope) {
                var _this = this;

                scope.$on('$stateChangeSuccess', function (ev, state) {
                    if (state.name === _this.name) {
                        _this.setup();
                    }
                });
            }
        }, {
            key: 'setup',
            value: function setup() {}
        }, {
            key: 'doCreate',
            value: function doCreate() {
                var _this2 = this;

                this.loading = true;
                this.$toast.info('Creando categoria...');
                this.$request('Categoria', 'create', this.parseCategoria(this.categoria)).then(function (res) {
                    _this2.$toast.info('Categoria creada');
                    _this2.loading = false;
                    _this2.$state.go('app.categoria.listar');
                }, function (err) {
                    if (!err.handled) {
                        if (err.statusCode == 422) {
                            _this2.$toast.error('No se pudo crear la categoria. ');
                        } else {
                            _this2.$toast.error('No se logró crear la categoria.' + err.data.error.message);
                        }
                    }
                }).finally(function () {
                    _this2.loading = false;
                });
            }
        }, {
            key: 'leerCategoria',
            value: function leerCategoria(res) {
                this.categoria = angular.copy(res);
                this.categoria.id = res.id;
            }
        }, {
            key: 'addField',
            value: function addField() {
                if (!this.categoria.fields) {
                    this.categoria.fields = [];
                }
                var newField = { label: '', value: '' };
                this.categoria.fields.push(newField);
            }
        }, {
            key: 'deleteField',
            value: function deleteField(index) {
                this.categoria.fields.splice(index, 1);
            }
        }, {
            key: 'parseCategoria',
            value: function parseCategoria(categoria) {
                categoria = angular.copy(categoria);
                return categoria;
            }
        }]);

        return NuevoCategoriaController;
    }();

    angular.module('app.categoria.nuevo').controller('NuevoCategoriaController', NuevoCategoriaController);
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.categoria.listar', []).config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    var permissions = [{
      key: 'user',
      access: 'none',
      type: 'deny'
    }];
    // State
    $stateProvider.state('app.categoria.listar', {
      url: '/listar',
      templateUrl: 'app/pages/admin/categoria/listar/listar.tmpl.html',
      controller: 'ListarCategoriaController as vm',
      user: true,
      permissions: permissions
    });

    var user = JSON.parse(localStorage.getItem('ls.$auth.user'));
    if (user) {
      if (user.profile == 'GOD') {

        msNavigationServiceProvider.saveItem('categoria.listar', {
          title: 'Listar Categorias',
          icon: 'fi flaticon-list',
          state: 'app.categoria.listar',
          weight: 2,
          permissions: permissions
        });
      }
    }
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	var ListarCategoriaController = function ListarCategoriaController($state, $scope, $rootScope) {
		var _this = this;

		_classCallCheck(this, ListarCategoriaController);

		this.$scope = $scope;
		this.$rootScope = $rootScope;
		this.listConfig = {
			model: {
				name: 'Categoria',
				filter: {
					order: 'created DESC',
					where: {
						state: true
					}
				},
				paginate: true,
				errorMessage: 'No se lograron obtener los categorias',
				successMessage: null
			},
			columns: [{
				key: 'nombre',
				title: 'Nombre',
				order: true
			}],
			buttons: [{
				title: 'Editar',
				action: {
					type: 'edit'
				},
				clase: 'md-primary md-raised'
			}, {
				title: 'Borrar',
				action: {
					type: 'delete',
					title: '¿Borrar categoria?',
					content: 'Esto no se podrá deshacer luego',
					errorMessage: 'No se logró borrar el categoria',
					successMessage: 'Categoria borrado correctamente'
				},
				clase: 'md-warn md-raise'
			}],
			routes: {
				edit: 'app.categoria.editar'
			}
		};

		this.$scope.$watch('vm.search', function (newVal, oldVal) {

			if (newVal != undefined && oldVal != undefined) {
				var where = {
					state: {
						neq: false
					}
				};

				if (newVal == '' || newVal == undefined) {} else if (newVal) {
					where.or = [];
					where.or.push({ nombre: { like: ".*" + newVal + ".*", options: "igm" } });
				}

				if (_timeout) {
					clearTimeout(_timeout);
				}
				var _timeout = setTimeout(function () {
					_this.$rootScope.$broadcast('$UpdateCategoria', where);
				}, 2000);
			}
		});
	};

	angular.module('app.categoria.listar').controller('ListarCategoriaController', ListarCategoriaController);
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.categoria.editar', []).config(config);

	function config($stateProvider) {
		// State
		var permissions = [{
			key: 'user',
			edit: true,
			type: 'allow'
		}];

		$stateProvider.state('app.categoria.editar', {
			url: '/editar/:id',
			templateUrl: 'app/pages/admin/categoria/editar/editar.tmpl.html',
			controller: 'EditarCategoriaController as vm',
			user: true,
			permissions: permissions
		});
	}
})();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditarCategoriaController = function () {
	function EditarCategoriaController($scope, $q, $auth, $state, $toast, $timeout, $load, $stateParams, $request, $log) {
		_classCallCheck(this, EditarCategoriaController);

		this.name = "app.categoria.editar";
		this.start($scope);
		this.$q = $q;
		this.$state = $state;
		this.$toast = $toast;
		this.$auth = $auth;
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.$request = $request;
		this.$load = $load;
		this.$log = $log;

		this.categoria = {};
	}

	_createClass(EditarCategoriaController, [{
		key: "start",
		value: function start(scope) {
			var _this = this;

			scope.$on("$stateChangeSuccess", function (ev, state) {
				if (state.name === _this.name) {
					_this.setup();
				}
			});
		}
	}, {
		key: "setup",
		value: function setup() {
			var _this2 = this;

			if (this.$stateParams.id) {

				this.$load(this.$stateParams.id, "Categoria", function (res) {
					_this2.leerCategoria(res);
				}).catch(function () {
					_this2.$timeout(function () {
						_this2.$state.go("app.categoria.listar");
					}, 2000);
				});
			} else {
				this.$state.go("app.categoria.listar");
			}
		}
	}, {
		key: "doEdit",
		value: function doEdit() {
			var _this3 = this;

			var categoria = angular.copy(this.categoria);
			this.loading = true;
			this.$toast.info('Actualizando categoria...');

			categoria.$save().then(function (res) {
				_this3.$toast.info("Categoria editado correctamente");
				_this3.loading = false;
			}, function (err) {
				_this3.$toast.error("No se logró completar la edición del categoria");
				_this3.loading = false;
			});
			// this.$request
			// 	("Categoria", "updateAttributes", { id: this.categoria.id }, categoria)
			// 	.then(
			// 		(res) => {

			// 			this.$toast.info("Categoria editado correctamente");
			// 			this.loading = false;
			// 		},
			// 		(err) => {

			// 			this.$toast.error("No se logró completar la edición del categoria");
			// 			this.loading = false;
			// 		}
			// 	);
		}
	}, {
		key: "leerCategoria",
		value: function leerCategoria(res) {
			this.categoria = angular.copy(res);
			this.categoria.id = res.id;
		}
	}, {
		key: "addField",
		value: function addField() {
			if (!this.categoria.fields) {
				this.categoria.fields = [];
			}
			var newField = { label: '', value: '' };
			this.categoria.fields.push(newField);
		}
	}, {
		key: "deleteField",
		value: function deleteField(index) {
			this.categoria.fields.splice(index, 1);
		}
	}]);

	return EditarCategoriaController;
}();

angular.module("app.categoria.editar").controller("EditarCategoriaController", EditarCategoriaController);
'use strict';

(function () {
    'use strict';

    angular.module('app.usuario', ['app.usuario.nuevo', 'app.usuario.listar', 'app.usuario.editar']).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        var permissions = [{
            key: 'user',
            access: 'none',
            type: 'deny'
        }];
        // State
        $stateProvider.state('app.usuario', {
            url: '/usuario',
            abstract: true,
            views: {
                'content@app': {
                    template: '<ui-view></ui-view>'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/admin/usuario');
        try {
            var user = localStorage.getItem('ls.$auth.user');
            user = JSON.parse(user);
            if (user.profile == 'GOD') {
                // Navigation
                msNavigationServiceProvider.saveItem('usuarios', {
                    permissions: permissions,
                    icon: 'icon-people',
                    title: 'Usuarios',
                    group: false,
                    weight: 4
                });
            }
        } catch (e) {
            console.log(e);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.template', ['app.template.listar', 'app.template.nuevo', 'app.template.editar']).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        var permissions = [{
            key: 'user',
            access: 'none',
            type: 'deny'
        }];
        // State
        $stateProvider.state('app.template', {
            url: '/template',
            abstract: true,
            views: {
                'content@app': {
                    template: '<ui-view></ui-view>'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/admin/template');
        try {
            var user = localStorage.getItem('ls.$auth.user');

            user = JSON.parse(user);
            if (user.profile == 'GOD') {
                // Navigation
                msNavigationServiceProvider.saveItem('template', {
                    permissions: permissions,
                    icon: 'icon-view-list',
                    title: 'Templates',
                    group: false,
                    weight: 4
                });
            }
        } catch (e) {
            console.log(e);
        }
    }
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.settings', ['app.settings.settings']).config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		var permissions = [{
			key: 'admin',
			access: 'none',
			type: 'deny'
		}];
		// State
		$stateProvider.state('app.settings', {
			url: '/settings',
			abstract: true,
			views: {
				'content@app': {
					template: '<ui-view></ui-view>'
				}
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/pages/admin/settings');

		try {
			var user = localStorage.getItem('ls.$auth.user');
			user = JSON.parse(user);
			if (user && user.profiles) {
				if (_.findIndex(user.profiles, function (profile) {
					return profile.identifier == 'GOD';
				}) != -1) {
					// Navigation
					msNavigationServiceProvider.saveItem('settings', {
						permissions: permissions,
						title: 'Configuracion',
						icon: 'zmdi zmdi-receipt',
						state: 'app.settings.settings',
						weight: 2
					});
				}
			}
		} catch (e) {
			console.log('error', e);
		}
	}
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.reportes', ['app.reportes.resumen', 'app.reportes.realtime']).config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		var permissions = [{
			key: 'reportes',
			access: 'none',
			type: 'deny'
		}];
		// State
		$stateProvider.state('app.reportes', {
			url: '/realtime',
			abstract: true,
			views: {
				'content@app': {
					template: '<ui-view></ui-view>'
				}
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/pages/admin/reportes');

		// Navigation
		msNavigationServiceProvider.saveItem('reportes', {
			title: 'Reportes',
			group: false,
			icon: 'zmdi zmdi-file',
			weight: 1,
			permissions: permissions
		});
	}
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.playbooks', ['app.playbooks.listar', 'app.playbooks.nuevo', 'app.playbooks.editar', 'app.playbooks.ver']).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        var permissions = [{
            key: 'user',
            access: 'none',
            type: 'deny'
        }];
        // State
        $stateProvider.state('app.playbooks', {
            url: '/playbooks',
            abstract: true,
            views: {
                'content@app': {
                    template: '<ui-view></ui-view>'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/admin/playbooks');
        try {
            var user = localStorage.getItem('ls.$auth.user');
            user = JSON.parse(user);
            if (user.profile == 'GOD') {
                // Navigation
                msNavigationServiceProvider.saveItem('playbooks', {
                    permissions: permissions,
                    icon: 'icon-file-excel-box',
                    title: 'Playbooks',
                    group: false,
                    weight: 4
                });
            }
        } catch (e) {
            console.log(e);
        }
    }
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.perfiles', ['app.perfil.nuevo', 'app.perfil.listar', 'app.perfil.editar']).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.perfiles', {
      url: '/perfiles',
      abstract: true,
      views: {
        'content@app': {
          template: '<ui-view></ui-view>'
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/pages/admin/perfiles');

    // Navigation
    msNavigationServiceProvider.saveItem('perfiles', {
      permissions: [{
        key: 'perfil',
        access: 'none',
        type: 'deny'
      }],
      title: 'Perfiles',
      group: false,
      icon: 'fi flaticon-lights',
      weight: 6
    });
  }
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.modelos', ['app.modelos.nuevo', 'app.modelos.editar', 'app.modelos.listar', 'app.modelos.aprobacion', 'app.modelos.ver']).config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		var permissions = [{
			key: 'modelo',
			access: 'none',
			type: 'deny'
		}];

		// State
		$stateProvider.state('app.modelos', {
			url: '/modelos',
			abstract: true,
			views: {
				'content@app': {
					template: '<ui-view></ui-view>'
				}
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/pages/admin/modelos');

		// Navigation
		msNavigationServiceProvider.saveItem('modelos', {
			title: 'Modelo',
			group: false,
			icon: 'icon-printer',
			weight: 4,
			permissions: permissions
		});
	}
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.logs', ['app.logs.listar', 'app.logs.ver']).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        var permissions = [{
            key: 'user',
            access: 'none',
            type: 'deny'
        }];
        // State
        $stateProvider.state('app.logs', {
            url: '/logs',
            abstract: true,
            views: {
                'content@app': {
                    template: '<ui-view></ui-view>'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/admin/logs');
        try {
            var user = localStorage.getItem('ls.$auth.user');
            user = JSON.parse(user);
            if (user) {
                if (user.profile == 'GOD') {
                    // Navigation
                    msNavigationServiceProvider.saveItem('logs', {
                        permissions: permissions,
                        icon: 'icon-history',
                        title: "Logs",
                        group: false,
                        weight: 4
                    });
                }
            }
        } catch (e) {
            console.log(e);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.file-manager', [
    // 3rd Party Dependencies
    'flow']).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.file-manager', {
            url: '/file-manager/:id',
            views: {
                'content@app': {

                    templateUrl: 'app/pages/admin/file-manager/file-manager.html',
                    controller: 'FileManagerController as vm'
                }
            },
            resolve: {
                Documents: function Documents(msApi) {
                    return msApi.resolve('fileManager.documents@get');
                }
            },
            bodyClass: 'file-manager'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/admin/file-manager');

        // Api
        msApiProvider.register('fileManager.documents', ['app/data/file-manager/documents.json']);

        // Navigation
        // msNavigationServiceProvider.saveItem('apps.file-manager', {
        //     title : 'File Manager',
        //     icon  : 'icon-folder',
        //     state : 'app.file-manager',
        //     weight: 6
        // });
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.file-manager').controller('FileManagerController', FileManagerController);

    /** @ngInject */
    function FileManagerController($mdSidenav, $imagen, $logger, Documents, $window, $request, $load, $q, $auth, $scope, $state, $stateParams, $timeout, $toast) {
        var vm = this;
        var goBack = function goBack() {
            $window.history.back();
        };
        vm.goBack = goBack;
        // Data
        vm.accounts = {
            creapond: 'johndoe@creapond.com',
            withinpixels: 'johndoe@withinpixels.com'
        };
        vm.selectedAccount = 'creapond';
        vm.currentView = 'list';
        vm.showDetails = true;

        vm.path = Documents.data.path;

        // Variables para ordenamiento
        vm.sortBy = ['order', 'tag']; // Campo actual de ordenamiento
        vm.reverse = false; // Dirección del ordenamiento
        vm.sortField = ''; // Campo específico para tracking
        // vm.selected = vm.files[0];

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive

            flow: {}
        };

        // Methods
        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;

        vm.select = select;
        vm.toggleDetails = toggleDetails;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleView = toggleView;
        vm.leerModelo = leerModelo;
        vm.sortByName = sortByName;

        setup();

        function setup() {
            if ($stateParams.id) {
                $load($stateParams.id, 'Modelo', { include: ['categoria'] }, function (res) {
                    leerModelo(res);
                }).catch(function () {
                    $timeout(function () {
                        $state.go('app.modelos.listar');
                    }, 2000);
                });
            }
        }

        vm.download = function (file) {
            if (file.origin && file.origin == 'fromCap') {
                var url = file.url;
            } else {
                var url = 'https://files.alquimio.cloud/imagenes/' + file.name;
            }
            $window.open(url, '_blank');
            $logger.trackDownload('DOWNLOAD', file, $stateParams.id);
            $window.open(url, '_blank');
        };

        function leerArchivos(modelo) {
            _.forEach(modelo.langs.PT, function (property, key) {
                modelo[key] = property;
            });

            var newFiles = [];
            if (modelo.galeria) {
                var newGaleria = _.map(modelo.galeria, function (imagen) {
                    imagen.categoria = 'Galeria';
                    return imagen;
                });
                newFiles = newFiles.concat(newGaleria);
            }
            if (modelo.visuales) {
                var newVisuales = _.map(modelo.visuales, function (visual) {
                    visual.categoria = 'Visual';
                    return visual;
                });
                newFiles = newFiles.concat(newVisuales);
            }
            if (modelo.ficha && modelo.ficha[0]) {
                var newFicha = modelo.ficha;
                newFicha[0].categoria = 'Ficha de Producto';
                newFiles = newFiles.concat(newFicha);
            }
            if (modelo.documentos) {
                var newDocumentos = _.map(modelo.documentos, function (documento) {
                    documento.categoria = 'Documentos';
                    return documento;
                });
                newFiles = newFiles.concat(newDocumentos);
            }

            if (modelo.videos) {
                var newVideos = _.map(modelo.videos, function (video) {
                    video.categoria = 'Videos';
                    return video;
                });
                newFiles = newFiles.concat(newVideos);
            }
            return newFiles;
        }

        vm.descargarZip = descargarZip;

        function descargarZip() {
            var _this = this;

            this.loading = true;

            $toast.info('Por favor espere. Generando ZIP');

            $request.http('Modelo', 'zip', { id: vm.modelo.id }).then(function (res) {
                $logger.trackDownload('ZIP', res, $stateParams.id);

                $toast.info('Zip Generado. Recuerde permitir los elementos emergentes');
                var url = 'https://files.alquimio.cloud/imagenes/' + res.response.name;
                $window.open(url, '_blank');
            }).finally(function () {
                _this.loading = false;
            });
        }

        //////////
        function leerModelo(res) {
            vm.modelo = angular.copy(res);

            if (vm.modelo.ficha && !angular.isArray(vm.modelo.ficha)) {
                vm.modelo.ficha = [];
                vm.modelo.ficha.push(res.ficha);
            }
            if (vm.modelo.imagen && !angular.isArray(vm.modelo.imagen)) {
                vm.modelo.imagen = [];
                vm.modelo.imagen.push(res.ficha);
            }
            if (vm.modelo.zip && !angular.isArray(vm.modelo.zip)) {
                vm.modelo.zip = [];
                vm.modelo.zip.push(res.zip);
            }
            if (vm.modelo.visuales) {
                var newVisuales = [];
                _.forEach(vm.modelo.visuales, function (visual, index) {
                    if (visual.imagen) {
                        newVisuales.push(visual.imagen);
                    }
                });
                vm.modelo.visuales = newVisuales;
            }
            if (vm.modelo.diferenciadores) {
                var newDiferenciadores = [];
                _.forEach(vm.modelo.diferenciadores, function (diferenciador, index) {
                    newDiferenciadores.push(diferenciador.imagen);
                });
                vm.modelo.diferenciadores = newDiferenciadores;
            }
            vm.files = leerArchivos(vm.modelo);
        }

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file) {
            // Prepare the temp file data for file list
            var uploadingFile = {
                id: file.uniqueIdentifier,
                file: file,
                type: '',
                owner: 'Emily Bennett',
                size: '',
                modified: moment().format('MMMM D, YYYY'),
                opened: '',
                created: moment().format('MMMM D, YYYY'),
                extention: '',
                location: 'My Files > Documents',
                offline: false,
                preview: 'assets/images/etc/sample-file-preview.jpg'
            };

            // Append it to the file list
            vm.files.push(uploadingFile);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload() {
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest'
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message) {
            // Iterate through the file list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm.files, function (item, index) {
                if (item.id && item.id === file.uniqueIdentifier) {
                    // Normally you would update the file from
                    // database but we are cheating here!

                    // Update the file info
                    item.name = file.file.name;
                    item.type = 'document';

                    // Figure out & upddate the size
                    if (file.file.size < 1024) {
                        item.size = parseFloat(file.file.size).toFixed(2) + ' B';
                    } else if (file.file.size >= 1024 && file.file.size < 1048576) {
                        item.size = parseFloat(file.file.size / 1024).toFixed(2) + ' Kb';
                    } else if (file.file.size >= 1048576 && file.file.size < 1073741824) {
                        item.size = parseFloat(file.file.size / (1024 * 1024)).toFixed(2) + ' Mb';
                    } else {
                        item.size = parseFloat(file.file.size / (1024 * 1024 * 1024)).toFixed(2) + ' Gb';
                    }
                }
            });
        }

        /**
         * Select an item
         *
         * @param item
         */
        function select(item) {
            vm.selected = item;
        }

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item) {
            vm.selected = item;

            toggleSidenav('details-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle view
         */
        function toggleView() {
            vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
        }

        /**
         * Sort by name column
         * Alterna entre orden ascendente y descendente al hacer click en la columna nombre
         */
        function sortByName() {
            if (vm.sortField === 'viewName') {
                // Si ya estamos ordenando por nombre, alternar dirección
                vm.reverse = !vm.reverse;
            } else {
                // Si estamos ordenando por otro campo, cambiar a nombre ascendente
                vm.sortField = 'viewName';
                vm.sortBy = 'viewName';
                vm.reverse = false;
            }
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.familia', ['app.familia.listar', 'app.familia.nuevo', 'app.familia.editar']).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        var permissions = [{
            key: 'user',
            access: 'none',
            type: 'deny'
        }];
        // State
        $stateProvider.state('app.familia', {
            url: '/familia',
            abstract: true,
            views: {
                'content@app': {
                    template: '<ui-view></ui-view>'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/admin/familia');
        try {
            var user = localStorage.getItem('ls.$auth.user');

            user = JSON.parse(user);
            if (user.profile == 'GOD') {
                // Navigation
                msNavigationServiceProvider.saveItem('familia', {
                    permissions: permissions,
                    icon: 'icon-view-list',
                    title: 'Familias',
                    group: false,
                    weight: 4
                });
            }
        } catch (e) {
            console.log(e);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.estatico', ['app.estatico.listar', 'app.estatico.nuevo', 'app.estatico.editar']).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        var permissions = [{
            key: 'user',
            access: 'none',
            type: 'deny'
        }];
        // State
        $stateProvider.state('app.estatico', {
            url: '/estatico',
            abstract: true,
            views: {
                'content@app': {
                    template: '<ui-view></ui-view>'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/admin/estatico');
        try {
            var user = localStorage.getItem('ls.$auth.user');
            user = JSON.parse(user);
            if (user.profile == 'GOD') {
                // Navigation
                msNavigationServiceProvider.saveItem('estatico', {
                    permissions: permissions,
                    icon: 'icon-file-excel-box',
                    title: 'Estaticos',
                    group: false,
                    weight: 4
                });
            }
        } catch (e) {
            console.log(e);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.dashboards', ['app.dashboards.project']).config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider) {
        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title: 'APPS',
            group: true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.dashboards', {
            title: 'Dashboards',
            icon: 'icon-tile-four',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.project', {
            title: 'General',
            state: 'app.dashboards_project'
        });
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.categoria', ['app.categoria.listar', 'app.categoria.editar', 'app.categoria.nuevo']).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        var permissions = [{
            key: 'user',
            access: 'none',
            type: 'deny'
        }];
        // State
        $stateProvider.state('app.categoria', {
            url: '/categoria',
            abstract: true,
            views: {
                'content@app': {
                    template: '<ui-view></ui-view>'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/admin/categoria');
        try {
            var user = localStorage.getItem('ls.$auth.user');

            user = JSON.parse(user);
            if (user.profile == 'GOD') {
                // Navigation
                msNavigationServiceProvider.saveItem('categoria', {
                    permissions: permissions,
                    icon: 'icon-view-list',
                    title: 'Categorias',
                    group: false,
                    weight: 4
                });
            }
        } catch (e) {
            console.log(e);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.quick-panel', []).config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider) {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.quick-panel').controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout) {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact) {
            vm.chatActive = !vm.chatActive;

            if (vm.chatActive) {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply() {
            if (vm.replyMessage === '') {
                return;
            }

            if (!vm.chat.contact.dialog) {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who: 'user',
                message: vm.replyMessage,
                time: 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed) {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function () {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);
        }
    }
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.auth.login', []).config(config);

	function config($stateProvider, $translatePartialLoaderProvider) {
		// State
		$stateProvider.state('app.pages_auth_login-v2', {
			url: '/auth/login',
			views: {
				'main@': {
					templateUrl: 'app/core/layouts/content-only.html',
					controller: 'MainController as vm'
				},
				'content@app.pages_auth_login-v2': {
					templateUrl: 'app/pages/auth/login/login.tmpl.html',
					controller: 'LoginAuthController as vm'
				}
			},
			bodyClass: 'login-v2',
			user: false,
			root: true
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/pages/auth/login');
	}
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoginAuthController = function () {
    function LoginAuthController($toast, $auth, $logger, $log) {
        _classCallCheck(this, LoginAuthController);

        this.$toast = $toast;
        this.$logger = $logger;
        this.$auth = $auth;
        this.$log = $log;
    }

    _createClass(LoginAuthController, [{
        key: 'doLogin',
        value: function doLogin(form) {
            var _this = this;

            this.loading = true;
            this.$auth.login(form.email.$viewValue, form.password.$viewValue).then(function (res) {
                if (res.me && res.me.name) {
                    try {
                        var user = localStorage.getItem('ls.$auth.user');
                        user = JSON.parse(user);
                        if (user) {
                            _this.$toast.success('Bienvenido ' + res.me.name);
                        }
                    } catch (e) {}
                }
            }).finally(function () {
                _this.loading = false;
            });
        }
    }, {
        key: 'checkLogin',
        value: function checkLogin() {}
    }]);

    return LoginAuthController;
}();

angular.module('app.auth.login').controller('LoginAuthController', LoginAuthController);
'use strict';

angular.module('toast.factory', []).factory('$toast', function ($mdToast, $timeout) {

	function show(message, options) {
		var opt = {
			position: 'top right',
			delay: 5000,
			capsule: true,
			type: ''
		};
		opt = angular.extend(opt, options);
		var toast = $mdToast.show($mdToast.simple().textContent(message).position(opt.position).hideDelay(opt.delay).capsule(opt.capsule).toastClass(opt.type));
	}

	function info(message, options) {
		var opt = {
			type: ''
		};
		opt = angular.extend(opt, options);
		show(message, opt);
	}

	function success(message, options) {
		var opt = {
			type: 'success'
		};
		opt = angular.extend(opt, options);
		show(message, opt);
	}

	function error(message, options) {
		var opt = {
			type: 'error'
		};
		opt = angular.extend(opt, options);
		show(message, opt);
	}

	return {
		show: show,
		info: info,
		error: error,
		success: success
	};
});
'use strict';

angular.module('server.provider', []).provider('$server', function () {

	var codename = null;
	var ENV_VARS = null;

	return {
		setCodeName: function setCodeName(cn) {
			codename = cn;
		},
		setEnvVariables: function setEnvVariables(cn) {
			ENV_VARS = cn;
		},
		$get: function $get($q, $http, $localStorage, $auth) {
			function getUrl() {
				return $localStorage.getItem('server.api');
			}

			function getUrlBase() {
				var url = $localStorage.getItem('server.api');
				var bases = url.split('/');
				return bases[0] + '//' + bases[2];
			}

			function getDownload() {
				return $localStorage.getItem('server.download');
			}

			function settings() {
				var defer = $q.defer();
				var apiUrl = ENV_VARS.apiLocal;
				if (window.location.hostname.indexOf('staging') > -1) {
					apiUrl = ENV_VARS.apiStaging;
				} else if (window.location.hostname.indexOf('br.hp.alquimio.cloud') > -1) {
					apiUrl = ENV_VARS.apiProduction;
				}
				var res = {
					'version': '0.0.1',
					'api': apiUrl,
					'reset': false,
					'download': 'https://files.alquimio.cloud/imagenes/'
				};
				defer.resolve(res);
				$localStorage.setItem('server.api', res.api);
				$localStorage.setItem('server.version', res.version);
				$localStorage.setItem('server.download', res.download);
				if (res.reset && $auth.isLogued()) {
					$auth.logout();
				}
				return defer.promise;
			}

			return {
				settings: settings,
				url: getUrl,
				base: getUrlBase,
				download: getDownload
			};
		}
	};
});
'use strict';

/**
 * @class $request
 * @memberOf Core.Factories
 * @description Servicio para manejar request de [Loopback]{@link https://loopback.io/doc/en/lb2/AngularJS-JavaScript-SDK.html} (con caché)
 *
 */

angular.module('request.factory', []).factory('$request', function ($q, $timeout, $auth, $log, $localStorage, $injector) {

	var progress = false;
	var request = [];

	String.prototype.hashCode = function () {
		var hash = 0,
		    i = void 0,
		    chr = void 0,
		    len = void 0;
		if (this.length === 0) return hash;
		for (i = 0, len = this.length; i < len; i++) {
			chr = this.charCodeAt(i);
			hash = (hash << 5) - hash + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	};

	/**
  * @function http
  * @param {String} model Nombre del modelo de Loopback
  * @param {String} method Nombre del metodo del {model} de Loopback
  * @memberOf Core.Factories.$request
  * @return {Promise} Retorna una promesa que se resuelve si existe la petición a Loopback sin caché
  */
	function http(model, method) {
		var args = Array.prototype.slice.call(arguments).slice(2);
		if (!model) {
			throw 'Model not defined';
		}
		var argsOriginal = [];
		var greeter = $injector.get(model);
		var methodFunction = greeter[method];
		_.each(args, function (arg) {
			if (angular.isString(arg)) {
				if (angular.isFunction(methodFunction[arg])) {
					methodFunction = methodFunction[arg];
				} else {
					argsOriginal.push(arg);
				}
			} else {
				argsOriginal.push(arg);
			}
		});
		try {
			var g = Function.prototype.bind.call(methodFunction, greeter);
			var req = g.apply(methodFunction, argsOriginal);
			return req.$promise;
		} catch (err) {

			return $q.reject();
		}
	}

	/**
  * @function user
  * @memberOf Core.Factories.$request
  * @return {Promise} Retorna una promesa que se resulve si existe la petición en modelos pertenecientes al User
  */
	function user() {
		var defer = $q.defer();
		if ($auth.isLogued()) {
			var argsOriginal = Array.prototype.slice.call(arguments);
			argsOriginal.unshift('User');
			var userId = $auth.user('id');
			// let f = angular.extend(filter || {}, {id: userId});
			if (angular.isObject(argsOriginal[argsOriginal.length - 1])) {
				argsOriginal[argsOriginal.length - 1] = angular.extend(argsOriginal[argsOriginal.length - 1], {
					id: userId
				});
			} else {
				argsOriginal.push({
					id: userId
				});
			}
			var g = Function.prototype.bind.call($request);
			return g.apply($request, argsOriginal);
		} else {
			defer.reject('User not found');
			throw 'User not found';
		}
	}

	/**
  * @function cache
  * @param {String} model Nombre del modelo de Loopback
  * @param {String} method Nombre del metodo del {model} de Loopback
  * @param {...*} [filter] Se puede agregar un filtro o bien lo que sea necesario
  * @memberOf Core.Factories.$request
  * @return {Promise} Retorna una promesa que se resulve si existe la petición en caché, de lo contrario la peticion de $request
  */
	function cache(model, method, filter) {
		var defer = $q.defer();
		var argsOriginal = Array.prototype.slice.call(arguments);
		var args = Array.prototype.slice.call(arguments).slice(2);
		if (!args) {
			args = 'request';
		}
		var jsonArgs = angular.toJson(args).hashCode();
		var nameLocalStorage = model + '.' + method + '.' + jsonArgs;
		var modelSaved = $localStorage.getItem(nameLocalStorage);
		if (modelSaved) {
			defer.resolve(modelSaved);
			return defer.promise;
		} else {
			var g = Function.prototype.bind.call($request);
			return g.apply($request, argsOriginal);
		}
	}

	/**
  * @function offline
  * @description Se agrega el parametro offline a la request, esto permite que falla por estar offline la peticion se volverá a ejecutar
  * @param {String} model Nombre del modelo de Loopback
  * @param {String} method Nombre del metodo del {model} de Loopback
  * @param {...*} [filter] Se puede agregar un filtro o bien lo que sea necesario
  * @memberOf Core.Factories.$request
  * @return {Promise} Retorna una promesa de loopback $promise
  */
	function offline(model, method, filter) {
		var defer = $q.defer();
		var progressInner = false;
		var args = Array.prototype.slice.call(arguments).slice(2);
		if (!args[0]) {
			args[0] = {};
		}
		args[0].headers = {
			offline: true
		};
		if (!model) {
			defer.reject();
			throw 'Model not defined';
		}

		var greeter = $injector.get(model);
		var g = Function.prototype.bind.call(greeter[method], greeter);
		var req = g.apply(greeter[method], args);
		$timeout(function () {
			try {
				if (!args) {
					args = 'request';
				}
				var jsonArgs = angular.toJson(args).hashCode();
				var nameLocalStorage = model + '.' + method + '.' + jsonArgs;
				var modelSaved = $localStorage.getItem(nameLocalStorage);
				if (modelSaved) {
					modelSaved.__cache = true;
					defer.notify(modelSaved);
				} else {
					if (!progress) {
						// $cordovaSpinnerDialog.show('Actualizando', null, true);
						progress = true;
						progressInner = true;
					}
				}
				if (_.findIndex(request, {
					index: nameLocalStorage
				}) < 0) {
					request.push({
						index: nameLocalStorage,
						promise: defer.promise
					});
					req.$promise.then(function (res) {
						$localStorage.setItem(nameLocalStorage, res);
						defer.notify(res);
						defer.resolve(res);
					}, function (err) {
						$log.error('Reject: ', err);
						defer.reject(err);
					}).finally(function () {
						if (progress && window.plugins && window.plugins.spinnerDialog && progressInner) {
							progress = false;
						}
						request = _.remove(request, function (value) {
							return value.index !== nameLocalStorage;
						});
					});
				} else {
					var r = _.find(request, {
						index: nameLocalStorage
					});
					return r.promise;
				}
			} catch (e) {
				defer.reject(e);
				$log.debug('Catch: ', e);
			}
		}, 50);
		/* Pequeño delay */
		return defer.promise;
	}

	/**
  * @description Peticion se realiza a los metodo de loopback, notifica si encuentra el valor en caché,
  * notifica y resulve al terminar la petición
  * para usar simplemente debe usar:
  * @example {@lang javascript}
  * // Previamente injectado $request
  * $request(model, method, ...)
  *     .then(
  *         res => { console.log(res) },
  *         null,
  *         not => { console.log(not) })
  * @param {String} model Nombre del modelo de Loopback
  * @param {String} method Nombre del metodo del {model} de Loopback
  * @param {...*} [filter] Se puede agregar un filtro o bien lo que sea necesario
  * @memberOf Core.Factories.$request
  * @return {Promise} Retorna una promesa de loopback $promise
  */
	function $request(model, method, filter) {
		var defer = $q.defer();
		var progressInner = false;
		var args = Array.prototype.slice.call(arguments).slice(2);
		if (!model) {
			defer.reject();
			throw 'Model not defined';
		}

		var greeter = $injector.get(model);
		var methodFunction = greeter[method];
		_.each(args, function (arg) {
			if (angular.isString(arg)) {
				if (angular.isFunction(methodFunction[arg])) {
					methodFunction = methodFunction[arg];
				}
			}
		});
		var g = Function.prototype.bind.call(methodFunction, greeter);
		var req = g.apply(methodFunction, args);
		$timeout(function () {
			try {
				if (!args) {
					args = 'request';
				}
				var jsonArgs = angular.toJson(args).hashCode();
				var nameLocalStorage = model + '.' + method + '.' + jsonArgs;
				var modelSaved = $localStorage.getItem(nameLocalStorage);
				if (modelSaved) {
					modelSaved.__cache = true;
					defer.notify(modelSaved);
				} else {
					if (!progress) {
						// $cordovaSpinnerDialog.show('Actualizando', null, true);
						progress = true;
						progressInner = true;
					}
				}
				if (_.findIndex(request, {
					index: nameLocalStorage
				}) < 0) {
					request.push({
						index: nameLocalStorage,
						promise: defer.promise
					});
					req.$promise.then(function (res) {
						$localStorage.setItem(nameLocalStorage, res);
						defer.notify(res);
						defer.resolve(res);
					}, function (err) {
						$log.error('Reject: ', err);
						defer.reject(err);
					}).finally(function () {
						if (progress && progressInner) {
							progress = false;
						}
						request = _.remove(request, function (value) {
							return value.index !== nameLocalStorage;
						});
					});
				} else {
					var r = _.find(request, {
						index: nameLocalStorage
					});
					return r.promise;
				}
			} catch (e) {
				defer.reject(e);
				$log.debug('Catch: ', e);
			}
		}, 50);
		/* Pequeño delay */
		return defer.promise;
	}

	$request.http = http;
	$request.offline = offline;
	$request.cache = cache;
	$request.user = user;

	return $request;
});
'use strict';

angular.module('profile.factory', []).directive('profile', function ($profile) {
	return {
		scope: {
			profile: '='
		},
		link: function link(s, e) {
			var permissions = [];
			_.each(s.profile, function (profile, key) {
				var permiso = {
					type: 'allow'
				};
				permiso.key = key;
				if (profile === 'access') {
					permiso[profile] = 'none';
					permiso.type = 'deny';
				} else {
					permiso[profile] = true;
				}
				permissions.push(permiso);
			});
			if ($profile.isForbidden(permissions)) {
				angular.element(e).remove();
			}
		}
	};
}).provider('$profile', function () {

	var deniesProfiles = [];
	var profiles = [];

	function denyProfile(profiles) {
		deniesProfiles = deniesProfiles.concat(profiles);
	}

	function mergePermission(permisosOriginal) {
		var p = {};
		_.each(permisosOriginal, function (permisoGroup, key) {
			_.each(permisoGroup.permisos, function (permiso, key) {
				if (angular.isObject(permiso)) {
					delete permiso.name;
					if (!p[key]) {
						p[key] = permiso;
					} else {
						_.each(permiso, function (values, subkey) {
							if (values !== p[key][subkey]) {
								if (!p[key][subkey] && !angular.isString(values)) {
									p[key][subkey] = values;
								} else {
									if (p[key][subkey] !== 'owner' && values === 'all') {
										p[key][subkey] = 'all';
									} else if (p[key][subkey] === 'none') {
										p[key][subkey] = values;
									}
								}
							}
						});
					}
				}
			});
		});
		return p;
	}

	return {
		denyProfiles: denyProfile,
		$get: function $get($localStorage) {
			return {
				isAllowed: function isAllowed(pfiles) {
					var allowed = _.filter(pfiles, function (profile) {
						return _.findIndex(deniesProfiles, {
							identifier: profile.identifier
						}) < 0;
					});
					return allowed.length > 0;
				},
				isForbidden: function isForbidden(permissions) {
					var forbiddenKey = '';
					var permisos = mergePermission($localStorage.getItem('profiles'));
					_.each(permissions, function (permission) {
						// console.log(permission.key);
						var key = permission.key;
						if (permisos[key]) {
							var permiso = permisos[key];
							_.each(permission, function (value, key) {
								if (angular.isDefined(permiso[key])) {
									if (angular.isString(value)) {
										value = value.toLowerCase();
										if (permiso[key] === value) {
											if (permission.type.toLowerCase() === 'allow') {
												forbiddenKey = 'allow';
											} else {
												if (forbiddenKey !== 'allow') {
													forbiddenKey = 'deny';
												}
											}
										} else {
											if (permission.type.toLowerCase() === 'deny') {
												forbiddenKey = 'allow';
											} else {
												if (forbiddenKey !== 'allow') {
													forbiddenKey = 'deny';
												}
											}
										}
									} else {
										if (permiso[key] === value) {
											if (permission.type.toLowerCase() === 'allow') {
												forbiddenKey = 'allow';
											} else {
												if (forbiddenKey !== 'allow') {
													forbiddenKey = 'deny';
												}
											}
										} else {
											if (permission.type.toLowerCase() === 'deny') {
												forbiddenKey = 'allow';
											} else {
												if (forbiddenKey !== 'allow') {
													forbiddenKey = 'deny';
												}
											}
										}
									}
								} else {
									if (key !== 'key' && key !== 'type') {
										if (!value) {
											if (permission.type.toLowerCase() === 'allow') {
												forbiddenKey = 'allow';
											} else {
												if (forbiddenKey !== 'allow') {
													forbiddenKey = 'deny';
												}
											}
										} else {
											if (permission.type.toLowerCase() === 'deny') {
												forbiddenKey = 'allow';
											} else {
												if (forbiddenKey !== 'allow') {
													forbiddenKey = 'deny';
												}
											}
										}
									}
								}
							});
						}
					});

					return forbiddenKey === 'deny';
				},
				setProfiles: function setProfiles(pfiles) {
					$localStorage.setItem('profiles', pfiles);
					profiles = profiles.concat(pfiles);
				},
				getProfile: function getProfile() {
					profiles = $localStorage.getItem('profiles');
					return mergePermission(profiles || []);
				},
				cleanProfiles: function cleanProfiles() {
					profiles = [];
					$localStorage.removeItem('profiles');
				},
				getDeny: function getDeny() {
					return deniesProfiles;
				}
			};
		}
	};
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {

	function setupSettings(resource, start) {
		var permission = [];
		_.each(resource, function (setting, key) {
			if (angular.isString(setting)) {
				if (!start || !start[key]) {
					permission.push({
						name: setting,
						type: key,
						create: false,
						edit: false,
						remove: false,
						access: 'none',
						hidden: false
					});
				} else {
					permission.push({
						name: setting,
						type: key,
						create: start[key].create,
						edit: start[key].edit,
						remove: start[key].remove,
						access: start[key].access,
						hidden: start[key].hidden
					});
				}
			}
		});

		return permission;
	}

	var $permission = function () {
		function $permission($resource, $q, $log) {
			_classCallCheck(this, $permission);

			this.$log = $log;
			this.$q = $q;
			this.Config = $resource('../assets/permissions.json');
		}

		_createClass($permission, [{
			key: 'settings',
			value: function settings(start) {
				var defer = this.$q.defer();
				this.Config.get().$promise.then(function (res) {
					defer.resolve(setupSettings(res, start));
				}).catch(function (err) {
					defer.reject(err);
				});
				return defer.promise;
			}
		}]);

		return $permission;
	}();

	angular.module('permission.factory', []).factory('$permission', function ($resource, $q, $log) {
		return new $permission($resource, $q, $log);
	});
})();
'use strict';

angular.module('logger.factory', []).factory('$logger', function ($q, $log, $toast, $state, $profile, $rootScope, $localStorage, Log, LoopBackAuth, SERVER) {

    /* Authorization */

    function trackAction(action, modelo) {
        try {

            var user = $localStorage.getItem('$auth.user');
            var details = '';
            switch (action) {
                case 'VER':
                    details = 'Visualiza ' + modelo.nombre;
                    break;
                case 'LOGIN':
                    details = 'Ingreso a sistema ';
                    break;
                case 'LOGOUT':
                    details = 'Abandona sistema';
                    break;
                case 'EDIT':
                    details = 'Edita modelo';
                    break;
                case 'DELETE':
                    details = 'Elimina modelo';
                    break;
                case 'CREATE':
                    details = 'Elimina modelo';
                    break;
            }
            var logData = {
                userData: {
                    name: user.name,
                    email: user.email,
                    image: user.imagenUrl,
                    lastName: user.lastName
                },
                userId: user.id,
                action: action,
                details: details

            };
            if (modelo && modelo.id) {
                logData.nombreModelo = modelo.nombre;
                logData.modeloId = modelo.id;
            };

            Log.create(logData).$promise.then(function (res) {
                console.log('Accion registrada', res);
            }).catch(function (err) {
                console.log('ERR registrando log', err);
            });
        } catch (e) {
            console.log('error registrando log', log);
        }
    }

    function trackDownload(action, archivo, modeloId) {
        try {
            var user = $localStorage.getItem('$auth.user');
            var details = '';
            switch (action) {
                case 'UPLOAD':
                    details = 'sube archivo "' + archivo.name;
                    break;
                case 'DOWNLOAD':
                    details = 'descarga archivo "' + archivo.name + '"';
                    break;
                case 'ZIP':
                    details = 'genera zip';
                    break;
                case 'XLSX':
                    details = 'Genera excel de modelos ';
                    break;
            }
            var logData = {
                userData: {
                    name: user.name,
                    email: user.email,
                    image: user.imagenUrl,
                    lastName: user.lastName
                },
                userId: user.id,
                archivoId: archivo ? archivo.id : '',
                nombreArchivo: archivo ? archivo.name : '',
                action: action,
                details: details,
                modeloId: modeloId
            };

            Log.create(logData).$promise.then(function (res) {
                console.log('Accion registrada', res);
            }).catch(function (err) {
                console.log('ERR registrando log', err);
            });
        } catch (e) {
            console.log(e);
        }
    }

    return {
        trackDownload: trackDownload,
        trackAction: trackAction
    };
});
'use strict';

angular.module('localstorage.factory', []).factory('$localStorage', function (localStorageService) {

	var localStorage = localStorageService;

	function getItem(key, defaultValue) {
		if (localStorage.get(key)) {
			return localStorage.get(key) || defaultValue;
		}
		return defaultValue || null;
	}

	function setItem(key, value) {
		return localStorage.set(key, value);
	}

	function removeItem(key) {
		return localStorage.remove(key);
	}

	function existItem(key) {
		return angular.isDefined(getItem(key));
	}

	function clear() {
		return localStorage.clearAll();
	}

	return {
		getItem: getItem,
		setItem: setItem,
		removeItem: removeItem,
		existItem: existItem,
		clear: clear
	};
});
'use strict';

angular.module('load.factory', []).factory('$load', function ($q, $request, $toast) {
	return function (id, model, f, callback) {
		var defer = $q.defer();
		var filter = {
			where: {
				id: id
			}
		};
		if (angular.isObject(f)) {
			filter = angular.extend({
				where: {
					id: id
				}
			}, f);
		}

		$request.http(model, 'findOne', {
			filter: filter
		}).then(function (res) {
			if (angular.isFunction(f)) {
				f(res);
			} else if (angular.isFunction(callback)) {
				callback(res);
			}
			defer.resolve(res);
		}).catch(function (err) {
			defer.reject(err);
			$toast.error('No se logró obtener el elemento, intenta más tarde');
		});

		return defer.promise;
	};
});
'use strict';

/**
 * @directive('$imagen', function factory() {})
 * @name Manejador de imágen
 * @description Permite obtener la url de una imagen, guardarla en caché de tipo filename o bien la url directa del archivo
 * @requires $q, $server
 */

angular.module('imagen.factory', []).factory('$imagen', function ($q, $timeout, $server) {

    var defaultImage = 'assets/images/avatars/profile.jpg';

    function getImageFromDocument(archivo) {
        if (archivo.ext == 'PNG' || archivo.ext == 'png' || archivo.ext == 'JPG' || archivo.ext == 'jpg' || archivo.ext == 'JPEG' || archivo.ext == 'jpeg' || archivo.ext == 'GIF') {
            return $server.download() + archivo.name;
        } else {
            return $server.download() + 'documents.png';
        }
    }

    function getThumbFromDocument(archivo) {
        if (archivo.ext == 'PNG' || archivo.ext == 'png' || archivo.ext == 'JPG' || archivo.ext == 'jpg' || archivo.ext == 'JPEG' || archivo.ext == 'jpeg' || archivo.ext == 'GIF') {
            return $server.download() + 'thumb-' + archivo.name;
        } else {
            return $server.download() + 'documents.png';
        }
    }

    /**
     * @param {URI} str FileName o bien URL directa de archivo
     * @returns {boolean} Verdadero si es una URL, Falso si es una URI
     * @description Valida si {@link URI} es un nombre o bien una url completa
     */
    function isURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + '((\\d{1,3}\\.){3}\\d{1,3}))' + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + '(\\?[;&a-z\\d%_.~+=-]*)?' + '(\\#[-a-z\\d_]*)?$', 'i');
        return pattern.test(str);
    }

    /**
     *
     * @param {string} name Nombre del fichero
     * @returns {string} URL del servidor concatenado con {@link string}
     * @description Le agrega la URL del servidor a el {@link string} de archivo
     */
    function addServerToUrl(name) {
        return $server.download() + name;
    }

    function addServerToUrlThumb(name) {
        return $server.download() + name;
    }

    /**
     *
     * @param {Loopback model} model Modelo a modificar
     * @returns {Loopback model} Retorna {@link Loopback model} modificado
     * @description Se ingresa un {@link Loopback model}, se busca si contiene la propiedad {@link Loopback model}, si contienen se busca el nombre del archivo
     *
     */

    function addUrlToModel(model) {
        if (model.imagen) {
            model.imagenURL = addServerToUrl(model.imagen.name);
        }
        return model;
    }

    function getUrlFromModel(model) {
        var thumb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (model.imagen) {
            var imagenURL = addServerToUrl(model.imagen.name);
            if (thumb) {
                if (model.imagen.thumbnail) {
                    imagenURL = addServerToUrlThumb(model.imagen.thumbnail.name);
                }
            }
            return imagenURL;
        } else {
            return defaultImage;
        }
    }

    function getUrl(uri) {
        var thumb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (angular.isString(uri)) {
            if (isURL(uri)) {
                return uri;
            } else {
                return getUrlFromModel(uri, thumb);
            }
        } else if (angular.isObject(uri)) {
            return getUrlFromModel(uri, thumb);
        }
    }

    /**
     *
     * @param {string} uri nombre de archivo o bien una url de la ubicación del archivo
     * @param {function} cb
     * @returns {promise} Promose que resuelve en cuantp termine el proceso de encontra la url
     * @description fileURL se encarga de buscar la ruta más rápida para acceder a {uri}, mediante un proceso
     * de ir a buscar en el servidor, luego guarda local o bien solo muestra la imagen local.
     *
     */
    function fileURL(uri, cb) {
        var url = uri;

        function callback(result, resolve) {
            if (angular.isFunction(cb)) {
                cb(result);
            }
            return result;
        }

        if (uri) {
            url = getUrl(uri, true);
            $timeout(function () {
                /* Se notifica cada cambio en fileURL */
                callback(url);
            }, 0);
            if (url && angular.isString(url)) {
                if (url !== defaultImage) {
                    var file = url.substr(url.lastIndexOf('/') + 1);
                    callback(getUrl(uri), true);
                } else {
                    return callback(url, true);
                }
                return url;
            }
        }
        return 'assets/profile-image.jpg';
    }

    return {
        addURL: addUrlToModel,
        fileURL: fileURL,
        image: getImageFromDocument,
        thumb: getThumbFromDocument
    };
});
'use strict';

angular.module('form.factory', []).factory('$form', function ($q, $log) {
	var send = function send(url, formdata, method) {
		var loaded = 0;
		var q = $q.defer();
		if (!method) method = 'POST';

		var oReq = new XMLHttpRequest();

		var updateProgress = function updateProgress(ev) {
			if (ev.type === 'progress') {
				if (loaded < ev.loaded) {
					loaded = ev.loaded;
					q.notify(ev);
				} else {
					q.reject(ev);
				}
			}
		};
		var transferComplete = function transferComplete(ev) {
			var target = ev.target || ev.srcElement;

			//let response = ev.srcElement.response;
			var response = target.response;
			try {
				q.resolve(angular.fromJson(response));
			} catch (e) {
				q.resolve(response);
			}
		};
		var transferFailed = function transferFailed(ev) {
			q.reject(ev);
		};
		var transferCanceled = function transferCanceled(ev) {
			q.reject(ev);
		};

		var transferLoaded = function transferLoaded(ev) {
			q.notify(ev);
		};

		oReq.upload.addEventListener('progress', updateProgress);
		oReq.addEventListener('load', transferComplete);
		oReq.upload.addEventListener('load', transferLoaded);
		oReq.upload.addEventListener('error', transferFailed);
		oReq.upload.addEventListener('abort', transferCanceled);

		oReq.open(method, url);
		oReq.timeout = 600000 * 10;

		oReq.send(formdata);

		return q.promise;
	};

	function chunked(url, blob, file, method) {
		var loaded = 0;
		var q = $q.defer();
		if (!method) method = 'POST';

		var oReq = new XMLHttpRequest();

		var updateProgress = function updateProgress(ev) {
			if (ev.type === 'progress') {
				if (loaded < ev.loaded) {
					loaded = ev.loaded;
					q.notify(ev);
				} else {
					q.reject(ev);
				}
			}
		};
		var transferComplete = function transferComplete(ev) {
			var target = ev.target || ev.srcElement;

			//let response = ev.srcElement.response;
			var response = target.response;
			try {
				q.resolve(angular.fromJson(response));
			} catch (e) {
				q.resolve(response);
			}
		};
		var transferFailed = function transferFailed(ev) {
			q.reject(ev);
		};
		var transferCanceled = function transferCanceled(ev) {
			q.reject(ev);
		};

		var transferLoaded = function transferLoaded(ev) {
			q.notify(ev);
		};

		oReq.upload.addEventListener('progress', updateProgress);
		oReq.addEventListener('load', transferComplete);
		oReq.upload.addEventListener('load', transferLoaded);
		oReq.upload.addEventListener('error', transferFailed);
		oReq.upload.addEventListener('abort', transferCanceled);

		oReq.open(method, url, true);
		oReq.timeout = 600000 * 10;
		// oReq.setRequestHeader('Content-Type', file.type);
		oReq.setRequestHeader('Content-Range', 'bytes ' + file.start + '-' + file.end + '/' + file.size);
		var form = new FormData();
		// let reader = new FileReader();
		// reader.onload = function(ev) {
		// 	form.append('file', ev.target.result);
		// 	oReq.send(form);
		// };
		// reader.readAsBinaryString(blob);

		form.append('file', blob);
		oReq.send(form);
		// let fr = new FileReader();
		// fr.onload = function(event) {
		// let form = new FormData();
		// form.append('zorra', event.target.result);
		// };
		// fr.readAsBinaryString(blob);
		return q.promise;
	}

	return {
		send: send,
		chunked: chunked
	};
});
'use strict';

angular.module('auth.factory', []).factory('$auth', function ($q, $log, $toast, $state, $logger, $profile, $rootScope, $localStorage, User, LoopBackAuth, SERVER) {

    /* Authorization */

    function login(username, password) {
        var defer = $q.defer();

        User.login({
            email: username,
            password: password,
            ttl: SERVER.ttl
        }).$promise.then(function () {
            me(true).then(function (res) {
                $state.go('app.modelos.listar');
                defer.resolve(res);
            }).catch(function (err) {
                $toast.error(err.message || 'No es posible obtener el usuario');
                defer.reject(err);
            });
        }).catch(function (err) {
            if (!err.handled) {
                if (err.status === 401) {
                    $toast.error('Error de Usuario o Contraseña (API_AUTH_LOGIN)');
                } else {
                    $toast.error('Error desconocido (API_AUTH_UNKNOWN)');
                }
                err.handled = true;
            }
            defer.reject(err);
        });

        return defer.promise;
    }

    function loginFacebook(idProvider, token) {

        var defer = $q.defer();

        User.loginFacebook({
            id: idProvider,
            access_token: token,
            ttl: SERVER.ttl
        }).$promise.then(function () {
            me(true).then(function (res) {
                $state.home();
                defer.resolve(res);
            }).catch(function (err) {
                $toast.error('No es posible obtener el usuario');
                defer.reject(err);
            });
        }).catch(function (err) {
            if (!err.handled) {
                $toast.error('El usuario no existe');
            }
            defer.reject(err);
        });

        return defer.promise;
    }

    function save(user) {
        $localStorage.setItem('$auth.user', user);
        $rootScope.$broadcast('$auth.user', user);
    }

    function saveToken(id, token) {
        $localStorage.setItem('$auth.token', token);
        $localStorage.setItem('$auth.userId', id);
    }

    function me(logining) {
        var defer = $q.defer();
        if (isLogued() || logining) {
            User.me().$promise.then(function (res) {
                $profile.setProfiles(res.me.profiles);
                saveToken(res.access_token.userId, res.access_token);
                save(res.me);
                $logger.trackAction('LOGIN');
                defer.resolve(res);
            }).catch(function (err) {
                defer.reject(err);
            });
        } else {
            defer.reject();
        }
        return defer.promise;
    }

    function logout() {
        var defer = $q.defer();
        $localStorage.removeItem('$auth.token');
        $localStorage.removeItem('$auth.user');
        $localStorage.removeItem('$auth.userId');
        $localStorage.removeItem('$auth.settings');
        LoopBackAuth.clearStorage();
        $profile.cleanProfiles();
        LoopBackAuth.clearUser();
        $profile.cleanProfiles();
        $toast.info('Sesión cerrada correctamente');

        $state.login();

        return defer.promise;
    }

    function recovery(email) {
        var defer = $q.defer();
        User.resetPassword({
            email: email
        }).$promise.then(function (res) {
            defer.resolve(res);
        }).catch(function (err) {
            defer.reject(err);
        });
        return defer.promise;
    }

    /* User Data */

    function isLogued() {
        return $localStorage.getItem('$auth.token') && $localStorage.getItem('$auth.user') && $localStorage.getItem('$auth.userId');
    }

    function getProfiles() {
        var user = $localStorage.getItem('$auth.user');
        return user;
    }

    function getProfile() {
        var user = $localStorage.getItem('$auth.user');
        return user.profile;
    }

    function isAdminFlota() {

        var user = $localStorage.getItem('$auth.user');
        if (_.findIndex(user.profiles, function (profile) {
            return profile.identifier == 'ADMINFLOTA';
        }) != -1) {
            return user.flotaId;
        } else {
            return false;
        }
    }

    function isGod() {
        var user = $localStorage.getItem('$auth.user');

        if (_.findIndex(user.profiles, function (profile) {
            return profile.identifier == 'GOD';
        }) != -1) {
            return user.id;
        } else if (user.profile == 'GOD') {
            return user.id;
        } else {
            return false;
        }
    }

    function isConductor() {
        var user = $localStorage.getItem('$auth.user');

        if (_.findIndex(user.profiles, function (profile) {
            return profile.identifier == 'CONDUCTOR';
        }) != -1) {
            return user.id;
        } else {
            return false;
        }
    }
    function isRevisor() {
        var user = $localStorage.getItem('$auth.user');

        if (user.profiles && _.findIndex(user.profiles, function (profile) {
            return profile.identifier == 'REVISOR';
        }) != -1) {
            return user.id;
        } else if (user.profile == 'REVISOR') {
            return user.id;
        } else {
            return false;
        }
    }

    function isRetail() {
        var user = $localStorage.getItem('$auth.user');

        if (user.profiles && _.findIndex(user.profiles, function (profile) {
            return profile.identifier == 'RETAIL';
        }) != -1) {
            return user.id;
        } else if (user.profile == 'RETAIL') {
            return user.id;
        } else {
            return false;
        }
    }

    function isHp() {
        var user = $localStorage.getItem('$auth.user');

        if (user.profiles && _.findIndex(user.profiles, function (profile) {
            return profile.identifier == 'HP';
        }) != -1) {
            return user.id;
        } else if (user.profile == 'HP') {
            return user.id;
        } else {
            return false;
        }
    }

    function create(user) {
        var defer = $q.defer();
        User.create(user).$promise.then(function (res) {
            defer.resolve(res);
        }).catch(function (err) {
            if (err.status === 422) {
                err.handled = true;
                $toast.show('Nombre de usuario o email ya existe');
            }
            defer.reject(err);
        });
        return defer.promise;
    }

    function register(user) {
        var defer = $q.defer();
        create(user).then(function () {
            login(user.username, user.password).then(function (res) {
                defer.resolve(res);
            }).catch(function (err) {
                defer.reject(err);
            });
        }).catch(function (err) {
            defer.reject(err);
        });
        return defer.promise;
    }

    function registerFacebook(idProvider, token) {
        var defer = $q.defer();

        User.registerFacebook({
            id: idProvider,
            access_token: token
        }).$promise.then(function () {
            loginFacebook(idProvider, token).then(function (res) {
                defer.resolve(res);
            }).catch(function (err) {
                defer.reject(err);
            });
        }).catch(function (err) {
            defer.reject(err);
        });

        return defer.promise;
    }

    function connectFacebook(idProvider, token) {
        var defer = $q.defer();

        User.connectFacebook({
            id: idProvider,
            access_token: token
        }).$promise.then(function () {
            me().then(function (user) {
                defer.resolve(user);
            }).catch(function (err) {
                defer.reject(err);
            });
        }).catch(function (err) {
            defer.reject(err);
        });

        return defer.promise;
    }

    function disconnectFacebook() {
        var defer = $q.defer();
        User.prototype$updateAttributes({ id: id() }, {
            idProvider: null,
            nameProvider: null,
            emailProvider: null
        }).$promise.then(function () {
            me().then(function (me) {
                defer.resolve(me);
            }).catch(function (err) {
                defer.reject(err);
            });
        }).catch(function (err) {
            defer.reject(err);
        });
        return defer.promise;
    }

    function token() {
        return $localStorage.getItem('$auth.token');
    }

    function id() {
        return $localStorage.getItem('$auth.userId');
    }

    function user(data) {
        if (isLogued()) {
            if (!data) {
                return $localStorage.getItem('$auth.user');
            } else {
                if (data === 'token') {
                    return token();
                }
                if (data === 'id') {
                    return id();
                }
                if (data) {
                    return $localStorage.getItem('$auth.user')[data];
                }
            }
        }

        return null;
    }

    function refreshToken() {
        var defer = $q.defer();
        User.refreshToken({
            token: LoopBackAuth.accessTokenId,
            ttl: SERVER.ttl
        }).$promise.then(function (res) {
            LoopBackAuth.accessTokenId = res.access_token.id;
            $localStorage.setItem('$auth.token', res.access_token);
            LoopBackAuth.save();
            defer.resolve();
        }).catch(function (err) {

            defer.reject(err);
            logout();
        });

        return defer.promise;
    }

    function update(uData) {
        var defer = $q.defer();
        /* Informacion Innecesaria */
        var userData = angular.copy(uData);
        delete userData.id;
        delete userData.file;
        /* ------ o -------- */
        User.prototype$updateAttributes({ id: id() }, userData).$promise.then(function () {
            // Se actualiza el usuario en localStorage
            me().then(function (res) {
                defer.resolve(res);
            }).catch(function (err) {
                defer.reject(err);
            });
        }).catch(function (err) {
            if (!err.handled) {
                $toast.error('No se pudo guardar el perfil', 'Hubo un problema al actualizar (API_PROFILE_UPDATE_' + err.status + ' )');
            }
            $log.error(err);
            defer.reject(err);
        });

        return defer.promise;
    }

    function changePassword(password) {
        var defer = $q.defer();
        var userData = user();

        User.prototype$updateAttributes({ id: userData.id }, {
            password: password
        }).$promise.then(function (res) {
            defer.resolve(res);
        }).catch(function (err) {
            defer.reject(err);
        });

        return defer.promise;
    }

    function password(password) {
        var _this = this;

        String.prototype.hashCode = function () {
            var hash = 0,
                i = void 0,
                chr = void 0,
                len = void 0;
            if (_this.length === 0) return hash;
            for (i = 0, len = _this.length; i < len; i++) {
                chr = _this.charCodeAt(i);
                hash = (hash << 5) - hash + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        };

        return '' + password.hashCode();
    }

    return {
        password: password,
        login: login,
        getProfile: getProfile,
        loginFacebook: loginFacebook,
        registerFacebook: registerFacebook,
        connectFacebook: connectFacebook,
        disconnectFacebook: disconnectFacebook,
        logout: logout,
        isLogued: isLogued,
        refreshToken: refreshToken,
        register: register,
        me: me,
        changePassword: changePassword,
        recovery: recovery,
        user: user,
        update: update,
        getProfiles: getProfiles,
        isAdminFlota: isAdminFlota,
        isGod: isGod,
        isConductor: isConductor,
        isRevisor: isRevisor,
        isRetail: isRetail,
        isHp: isHp
    };
});
'use strict';

angular.module('time.filter', []).filter('time', function () {
	return function (input) {

		var totalSeconds = angular.copy(input);
		var hours = Math.floor(totalSeconds / 3600);
		totalSeconds = totalSeconds % 3600;
		var minutes = Math.floor(totalSeconds / 60);
		totalSeconds = totalSeconds % 60;
		var seconds = Math.floor(totalSeconds);

		if (hours < 10) hours = '0' + hours;
		if (minutes < 10) minutes = '0' + minutes;
		if (seconds < 10) seconds = '0' + seconds;

		return hours + ':' + minutes + ':' + seconds;
	};
});
'use strict';

angular.module('money.filter', []).filter('money', function () {
	return function (money, freeDefault) {
		if (!angular.isNumber(money)) {
			money = parseInt(money);
		}
		if (money) {
			if (parseInt(money) === 0) {
				return freeDefault || 'Gratis';
			}
			money = money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
			return '$ ' + money;
		} else {
			return freeDefault || 'Sin precio';
		}
	};
});
'use strict';

angular.module('fecha.filter', []).filter('fecha', function ($rootScope, $log) {
	return function () {
		var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
		var formato = arguments[1];

		var fecha = f;
		if (!angular.isDate(f)) {
			fecha = new Date(f);
		}
		/* Se obtiene el offset de la fecha */
		var offset = fecha.getTimezoneOffset();
		var offsetDevices = fecha.getTimezoneOffset();
		/* Offset global si existe */
		if ($rootScope.datePattern) {
			offsetDevices = ($rootScope.datePattern.utc_offset + $rootScope.datePattern.dst_offset) / 60;
		}
		if (offset !== offsetDevices) {
			fecha.setMinutes(fecha.getMinutes() + offsetDevices);
		}
		return moment(fecha).format(formato);
	};
});
'use strict';

angular.module('age.filter', []).filter('age', function () {
	return function (input) {
		if (!angular.isDate(input)) {
			input = new Date(input);
		}

		return moment().diff(input, 'years');
	};
});
'use strict';

angular.module('aHora.filter', []).filter('aHoras', function () {
	return function (input) {
		if (angular.isNumber(input) && !isNaN(input)) {
			var minutosXHora = 60;
			var minutos = input * minutosXHora;
			var hora = Math.floor(minutos / minutosXHora);
			var minutero = minutos % minutosXHora;
			if (minutero < 10) {
				minutero = '0' + minutero;
			}
			if (hora >= 24) {
				hora -= 24;
			}

			return hora + ':' + minutero;
		} else {
			return 'Debes seleccionar minutos de juego';
		}
	};
});
'use strict';

(function () {
	'use strict';

	angular.module('table.directive', []).directive('triTable', triTable);

	/* @ngInject */
	function triTable($filter) {
		var directive = {
			restrict: 'E',
			scope: {
				columns: '=',
				contents: '=',
				filters: '='
			},
			link: link,
			templateUrl: 'app/core/directives/table/table-directive.tmpl.html'
		};
		return directive;

		function link($scope, $element, attrs) {
			var sortableColumns = [];
			var activeSortColumn = null;
			var activeSortOrder = false;

			// init page size if not set to default
			$scope.pageSize = angular.isUndefined(attrs.pageSize) ? 0 : attrs.pageSize;

			// init page if not set to default
			$scope.page = angular.isUndefined(attrs.page) ? 0 : attrs.page;

			// make an array of all sortable columns
			angular.forEach($scope.columns, function (column) {
				if (column.sortable) {
					sortableColumns.push(column.field);
				}
			});

			$scope.refresh = function (resetPage) {
				if (resetPage === true) {
					$scope.page = 0;
				}
				$scope.contents = $filter('orderBy')($scope.contents, activeSortColumn, activeSortOrder);
			};

			// if we have sortable columns sort by first by default
			if (sortableColumns.length > 0) {
				// sort first column by default
				activeSortOrder = false;
				activeSortColumn = sortableColumns[0];
				$scope.refresh();
			}

			$scope.sortClick = function (field) {
				if (sortableColumns.indexOf(field) !== -1) {
					if (field === activeSortColumn) {
						activeSortOrder = !activeSortOrder;
					}
					activeSortColumn = field;
					$scope.refresh();
				}
			};

			$scope.showSortOrder = function (field, orderDown) {
				return field === activeSortColumn && activeSortOrder === orderDown;
			};

			$scope.headerClass = function (field) {
				var classes = [];
				if (sortableColumns.indexOf(field) !== -1) {
					classes.push('sortable');
				}
				if (field === activeSortColumn) {
					classes.push('sorted');
				}
				return classes;
			};

			$scope.cellContents = function (column, content) {
				if (angular.isDefined(column.filter)) {
					return $filter(column.filter)(content[column.field]);
				} else {
					return content[column.field];
				}
			};

			$scope.totalItems = function () {
				return $scope.contents.length;
			};

			$scope.numberOfPages = function () {
				return Math.ceil($scope.contents.length / $scope.pageSize);
			};

			$scope.pageStart = function () {
				return $scope.page * $scope.pageSize + 1;
			};

			$scope.pageEnd = function () {
				var end = ($scope.page + 1) * $scope.pageSize;
				if (end > $scope.contents.length) {
					end = $scope.contents.length;
				}
				return end;
			};

			$scope.goToPage = function (page) {
				$scope.page = page;
			};
		}
	}
})();
'use strict';

(function () {
    'use strict';

    angular.module('table.directive').filter('startFrom', startFrom);

    function startFrom() {
        return filterFilter;

        ////////////////

        function filterFilter(input, start) {
            start = +start;
            return input.slice(start);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('table.directive').filter('tableImage', tableImage);

    function tableImage($sce) {
        return filterFilter;

        ////////////////

        function filterFilter(value) {
            return $sce.trustAsHtml('<div style=\"background-image: url(\'' + value + '\')\"/>');
        }
    }
})();
'use strict';

angular.module('replace.directive', []).directive('replace', function ($rootScope) {
	return {
		require: 'ngModel',
		transclude: true,
		replace: true,
		templateUrl: 'app/core/directives/replace/replace.html',
		scope: {
			otherlang: '=',
			othervalue: '='
		},
		link: function link(scope, element, attr, model) {
			scope.replaced = false;

			console.log('ol:', scope.otherLang);

			scope.setValue = function () {
				model.$setViewValue(scope.othervalue);
				scope.replaced = true;
			};
		}

	};
});
'use strict';

(function () {
	'use strict';

	angular.module('app.core', ['ngAnimate', 'ngAria', 'ngCookies', 'ngMessages', 'ngResource', 'ngSanitize', 'ngMaterial', 'lbServices', 'md.data.table', 'mdPickers', 'LocalStorageModule', 'pascalprecht.translate', 'angularMoment', 'filter.module', 'directives.module', 'factories.module', 'decorator.module', 'ui.router']);
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('MsWidgetController', MsWidgetController).directive('msWidget', msWidgetDirective).directive('msWidgetFront', msWidgetFrontDirective).directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element) {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip() {
            if (!isFlippable()) {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable() {
            return angular.isDefined($scope.flippable) && $scope.flippable === true;
        }
    }

    /** @ngInject */
    function msWidgetDirective() {
        return {
            restrict: 'E',
            scope: {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile: function compile(tElement) {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
                    // Custom transclusion
                    transcludeFn(function (clone) {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective() {
        return {
            restrict: 'E',
            require: '^msWidget',
            transclude: true,
            compile: function compile(tElement) {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
                    // Custom transclusion
                    transcludeFn(function (clone) {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective() {
        return {
            restrict: 'E',
            require: '^msWidget',
            transclude: true,
            compile: function compile(tElement) {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
                    // Custom transclusion
                    transcludeFn(function (clone) {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('MsTimelineController', MsTimelineController).directive('msTimeline', msTimelineDirective).directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController() {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl) {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl() {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective() {
        return {
            scope: {
                msTimeline: '=?',
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile: function compile(tElement) {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl) {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll() {
                        if (scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top) {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                            // Success
                            function () {
                                // Hide the loader
                                loadMoreEl.removeClass('show');

                                // Register the onScroll event again
                                registerOnScroll();
                            },

                            // Error
                            function () {
                                // Remove the loader completely
                                loadMoreEl.remove();
                            });
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll() {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll() {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q) {
        return {
            scope: true,
            require: '^msTimeline',
            compile: function compile(tElement) {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl) {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Check if the timeline item has ms-card
                        if (iElement.find('ms-card')) {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args) {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function () {
                                    $timeout(function () {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        } else {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function () {
                                $timeout(function () {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(function () {
                        return itemLoaded && itemInViewport;
                    }, function (current, old) {
                        if (angular.equals(current, old)) {
                            return;
                        }

                        if (current) {
                            iElement.removeClass('hidden').addClass('animate');

                            // Unbind itemReadyWatcher
                            itemReadyWatcher();
                        }
                    }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element) {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if (imgEl.length > 0) {
                            imgEl.on('load', function () {
                                deferred.resolve('Image is loaded');
                            });
                        } else {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility() {
                        if (scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold) {
                            $timeout(function () {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('MsStepperController', MsStepperController).directive('msHorizontalStepper', msHorizontalStepperDirective).directive('msHorizontalStepperStep', msHorizontalStepperStepDirective).directive('msVerticalStepper', msVerticalStepperDirective).directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout) {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation) {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form) {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form) {
            var step = {
                element: element,
                scope: scope,
                form: form,
                stepNumber: scope.step || vm.steps.length + 1,
                stepTitle: scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b) {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps() {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm() {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function () {
                // Reset all the steps
                for (var x = 0; x < vm.steps.length; x++) {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if (vm.orientation === 'horizontal') {
                // Hide all steps
                for (var i = 0; i < vm.steps.length; i++) {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            } else if (vm.orientation === 'vertical') {
                // Hide all step content
                for (var j = 0; j < vm.steps.length; j++) {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber) {
            // If the step we are about to go
            // is hidden, bail...
            if (isStepHidden(stepNumber)) {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep() {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for (var s = stepNumber; s >= 1; s--) {
                if (!isStepHidden(s)) {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep() {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for (var s = stepNumber; s <= vm.steps.length; s++) {
                if (!isStepHidden(s)) {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep() {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep() {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep() {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep() {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            var disabled = false;

            for (var i = 1; i < stepNumber; i++) {
                if (!isStepValid(i)) {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step) {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            // If the step is optional, always return true
            if (isStepOptional(stepNumber)) {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber) {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid() {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective() {
        return {
            restrict: 'A',
            scope: {},
            require: ['form', 'msHorizontalStepper'],
            priority: 1001,
            controller: 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile: function compile(tElement) {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective() {
        return {
            restrict: 'E',
            require: ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope: {
                step: '=?',
                stepTitle: '=?',
                stepTitleTranslate: '=?',
                optionalStep: '=?',
                hideStep: '=?'
            },
            compile: function compile(tElement) {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout) {
        return {
            restrict: 'A',
            scope: {},
            require: ['form', 'msVerticalStepper'],
            priority: 1001,
            controller: 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile: function compile(tElement) {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function () {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective() {
        return {
            restrict: 'E',
            require: ['form', '^msVerticalStepper'],
            priority: 1000,
            scope: {
                step: '=?',
                stepTitle: '=?',
                stepTitleTranslate: '=?',
                optionalStep: '=?',
                hideStep: '=?'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile: function compile(tElement) {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate) {
        return {
            restrict: 'E',
            link: function link(scope, iElement) {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function () {
                    $animate.leave(iElement).then(function () {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective() {
        return {
            restrict: 'A',
            require: '^mdSidenav',
            link: function link(scope, iElement, iAttrs, MdSidenavCtrl) {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function () {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current) {
                    if (angular.isUndefined(current)) {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('MsShortcutsController', MsShortcutsController).directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService) {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass: 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort: function onSort() {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init() {
            // Load the shortcuts
            vm.loadShortcuts().then(
            // Success
            function (response) {
                vm.shortcuts = response;

                // Add shortcuts as results by default
                if (vm.shortcuts.length > 0) {
                    vm.results = response;
                }
            });

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old) {
                if (angular.isUndefined(current)) {
                    return;
                }

                if (angular.equals(current, old)) {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                // Success
                function (response) {
                    vm.results = response;
                },
                // Error
                function () {
                    vm.results = [];
                }).finally(function () {
                    // Hide the loader
                    vm.resultsLoading = false;
                });
            });
        }

        /**
         * Populate the results
         */
        function populateResults() {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if (vm.query) {
                results = results.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1) {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for (var i = 0; i < results.length; i++) {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for (var y = 0; y < vm.shortcuts.length; y++) {
                        if (vm.shortcuts[y]._id === results[i]._id) {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            } else {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if (vm.shortcuts.length > 0) {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function () {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts() {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if (angular.isUndefined(shortcuts)) {
                shortcuts = [];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts() {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function () {
                deferred.resolve({ 'success': true });
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item) {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item) {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for (var x = 0; x < vm.shortcuts.length; x++) {
                if (vm.shortcuts[x]._id === item._id) {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if (!vm.query) {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if (vm.shortcuts.length === 0) {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else {
                                if (x >= vm.shortcuts.length) {
                                    vm.selectedResultIndex = vm.shortcuts.length - 1;
                                }
                            }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item) {
            // Add or remove the shortcut
            if (item.hasShortcut) {
                vm.removeShortcut(item);
            } else {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event) {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event) {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if (keys.indexOf(keyCode) > -1) {
                event.preventDefault();
            }

            switch (keyCode) {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if (vm.selectedResultIndex - 1 >= 0) {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if (vm.selectedResultIndex + 1 < vm.results.length) {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index) {
            if (vm.ignoreMouseEvents) {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents() {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function () {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible() {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if (resultsEl && selectedItemEl) {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if (resultsEl.scrollTop() > top) {
                    resultsEl.scrollTop(top);
                }

                if (bottom > resultsEl.height() + resultsEl.scrollTop()) {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar() {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective() {
        return {
            restrict: 'E',
            scope: {},
            require: 'msShortcuts',
            controller: 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl: 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile: function compile(tElement) {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement) {
                    // Data

                };
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('MsSearchBarController', MsSearchBarController).directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout) {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init() {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old) {
                if (angular.isUndefined(current)) {
                    return;
                }

                if (angular.equals(current, old)) {
                    return;
                }

                if (vm.collapsed) {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, { query: current }),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = onSearchEvaluated && !!onSearchEvaluated.then;

                if (isArray) {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if (isPromise) {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                    // Success
                    function (response) {
                        // Populate the results
                        vm.populateResults(response);
                    },
                    // Error
                    function () {
                        // Assign an empty array to show
                        // the no-results screen
                        vm.populateResults([]);
                    }).finally(function () {
                        // Hide the loader
                        vm.resultsLoading = false;
                    });
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results) {
            // Before doing anything,
            // make sure the search bar is expanded
            if (vm.collapsed) {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if (!isArray && !isNull) {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand() {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if (vm.onExpand && angular.isFunction(vm.onExpand)) {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if (vm.onCollapse && angular.isFunction(vm.onCollapse)) {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event) {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event) {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if (keys.indexOf(keyCode) > -1) {
                event.preventDefault();
            }

            switch (keyCode) {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if (vm.selectedResultIndex - 1 >= 0) {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if (!vm.results) {
                        return;
                    }

                    // Increase the selected result index
                    if (vm.selectedResultIndex + 1 < vm.results.length) {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index) {
            if (vm.ignoreMouseEvents) {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents() {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function () {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item) {
            if (vm.onResultClick) {
                vm.onResultClick({ item: item });
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible() {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if (resultsEl && selectedItemEl) {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if (resultsEl.scrollTop() > top) {
                    resultsEl.scrollTop(top);
                }

                if (bottom > resultsEl.height() + resultsEl.scrollTop()) {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document) {
        return {
            restrict: 'E',
            scope: {},
            require: 'msSearchBar',
            controller: 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce: '=?',
                onSearch: '@',
                onResultClick: '&?',
                onExpand: '&?',
                onCollapse: '&?'
            },
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile: function compile(tElement) {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement) {
                    // Data
                    var inputEl = void 0,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand() {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse() {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').provider('msScrollConfig', msScrollConfigProvider).directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider() {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed: 1,
            wheelPropagation: false,
            swipePropagation: true,
            minScrollbarLength: null,
            maxScrollbarLength: null,
            useBothWheelAxes: false,
            useKeyboard: true,
            suppressScrollX: false,
            suppressScrollY: false,
            scrollXMarginOffset: 0,
            scrollYMarginOffset: 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration) {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function () {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig() {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig) {
        return {
            restrict: 'AE',
            compile: function compile(tElement) {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if (fuseConfig.getConfig('disableCustomScrollbars')) {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if (fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile()) {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs) {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if (iAttrs.msScroll) {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function () {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function () {
                        return iElement.prop('scrollHeight');
                    }, function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function () {
                        return iElement.prop('scrollWidth');
                    }, function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar() {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function () {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective() {
        return {
            restrict: 'A',
            link: function link(scope, iElement) {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective() {
        return {
            restrict: 'A',
            scope: {
                msRandomClass: '='
            },
            link: function link(scope, iElement) {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * scope.msRandomClass.length)];
                iElement.addClass(randomClass);
            }
        };
    }
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.core').provider('msNavigationService', msNavigationServiceProvider).controller('MsNavigationController', MsNavigationController)
	// Vertical
	.directive('msNavigation', msNavigationDirective).controller('MsNavigationNodeController', MsNavigationNodeController).directive('msNavigationNode', msNavigationNodeDirective).directive('msNavigationItem', msNavigationItemDirective)
	//Horizontal
	.directive('msNavigationHorizontal', msNavigationHorizontalDirective).controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController).directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective).directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

	/** @ngInject */
	function msNavigationServiceProvider() {
		// Inject $log service
		var $log = angular.injector(['ng']).get('$log');

		// Navigation array
		var navigation = [];

		var service = this;

		// Methods
		service.saveItem = saveItem;
		service.deleteItem = deleteItem;
		service.sortByWeight = sortByWeight;

		//////////

		/**
   * Create or update the navigation item
   *
   * @param path
   * @param item
   */
		function saveItem(path, item) {
			if (!angular.isString(path)) {
				$log.error('path must be a string (eg. `dashboard.project`)');
				return;
			}

			var parts = path.split('.');

			// Generate the object id from the parts
			var id = parts[parts.length - 1];

			// Get the parent item from the parts
			var parent = _findOrCreateParent(parts);

			// Decide if we are going to update or create
			var updateItem = false;

			for (var i = 0; i < parent.length; i++) {
				if (parent[i]._id === id) {
					updateItem = parent[i];

					break;
				}
			}

			// Update
			if (updateItem) {
				angular.extend(updateItem, item);

				// Add proper ui-sref
				updateItem.uisref = _getUiSref(updateItem);
			}
			// Create
			else {
					// Create an empty children array in the item
					item.children = [];

					// Add the default weight if not provided or if it's not a number
					if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
						item.weight = 1;
					}

					// Add the item id
					item._id = id;

					// Add the item path
					item._path = path;

					// Add proper ui-sref
					item.uisref = _getUiSref(item);

					// Push the item into the array
					parent.push(item);
				}
		}

		/**
   * Delete navigation item
   *
   * @param path
   */
		function deleteItem(path) {
			if (!angular.isString(path)) {
				$log.error('path must be a string (eg. `dashboard.project`)');
				return;
			}

			// Locate the item by using given path
			var item = navigation,
			    parts = path.split('.');

			for (var p = 0; p < parts.length; p++) {
				var id = parts[p];

				for (var i = 0; i < item.length; i++) {
					if (item[i]._id === id) {
						// If we have a matching path,
						// we have found our object:
						// remove it.
						if (item[i]._path === path) {
							item.splice(i, 1);
							return true;
						}

						// Otherwise grab the children of
						// the current item and continue
						item = item[i].children;
						break;
					}
				}
			}

			return false;
		}

		/**
   * Sort the navigation items by their weights
   *
   * @param parent
   */
		function sortByWeight(parent) {
			// If parent not provided, sort the root items
			if (!parent) {
				parent = navigation;
				parent.sort(_byWeight);
			}

			// Sort the children
			for (var i = 0; i < parent.length; i++) {
				var children = parent[i].children;

				if (children.length > 1) {
					children.sort(_byWeight);
				}

				if (children.length > 0) {
					sortByWeight(children);
				}
			}
		}

		/* ----------------- */
		/* Private Functions */
		/* ----------------- */

		/**
   * Find or create parent
   *
   * @param parts
   * @returns {Array|Boolean}
   * @private
   */
		function _findOrCreateParent(parts) {
			// Store the main navigation
			var parent = navigation;

			// If it's going to be a root item
			// return the navigation itself
			if (parts.length === 1) {
				return parent;
			}

			// Remove the last element from the parts as
			// we don't need that to figure out the parent
			parts.pop();

			// Find and return the parent
			for (var i = 0; i < parts.length; i++) {
				var _id = parts[i],
				    createParent = true;

				for (var p = 0; p < parent.length; p++) {
					if (parent[p]._id === _id) {
						parent = parent[p].children;
						createParent = false;

						break;
					}
				}

				// If there is no parent found, create one, push
				// it into the current parent and assign it as a
				// new parent
				if (createParent) {
					var item = {
						_id: _id,
						_path: parts.join('.'),
						title: _id,
						weight: 1,
						children: []
					};

					parent.push(item);
					parent = item.children;
				}
			}

			return parent;
		}

		/**
   * Sort by weight
   *
   * @param x
   * @param y
   * @returns {number}
   * @private
   */
		function _byWeight(x, y) {
			return parseInt(x.weight) - parseInt(y.weight);
		}

		/**
   * Setup the ui-sref using state & state parameters
   *
   * @param item
   * @returns {string}
   * @private
   */
		function _getUiSref(item) {
			var uisref = '';

			if (angular.isDefined(item.state)) {
				uisref = item.state;

				if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
					uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
				}
			}

			return uisref;
		}

		/* ----------------- */
		/* Service           */
		/* ----------------- */

		this.$get = function () {
			var activeItem = null,
			    navigationScope = null,
			    folded = null,
			    foldedOpen = null;

			var service = {
				saveItem: saveItem,
				deleteItem: deleteItem,
				sort: sortByWeight,
				clearNavigation: clearNavigation,
				setActiveItem: setActiveItem,
				getActiveItem: getActiveItem,
				getNavigation: getNavigation,
				getFlatNavigation: getFlatNavigation,
				setNavigationScope: setNavigationScope,
				setFolded: setFolded,
				getFolded: getFolded,
				setFoldedOpen: setFoldedOpen,
				getFoldedOpen: getFoldedOpen,
				toggleFolded: toggleFolded
			};

			return service;

			//////////

			/**
    * Clear the entire navigation
    */
			function clearNavigation() {
				// Clear the navigation array
				navigation = [];

				// Clear the vm.navigation from main controller
				if (navigationScope) {
					navigationScope.vm.navigation = navigation;
				}
			}

			/**
    * Set active item
    *
    * @param node
    * @param scope
    */
			function setActiveItem(node, scope) {
				activeItem = {
					node: node,
					scope: scope
				};
			}

			/**
    * Return active item
    */
			function getActiveItem() {
				return activeItem;
			}

			/**
    * Return navigation array
    *
    * @param root
    * @returns Array
    */
			function getNavigation(root) {
				if (root) {
					for (var i = 0; i < navigation.length; i++) {
						if (navigation[i]._id === root) {
							return [navigation[i]];
						}
					}

					return null;
				}

				return navigation;
			}

			/**
    * Return flat navigation array
    *
    * @param root
    * @returns Array
    */
			function getFlatNavigation(root) {
				// Get the correct navigation array
				var navigation = getNavigation(root);

				// Flatten the navigation object
				return _flattenNavigation(navigation);
			}

			/**
    * Store navigation's scope for later use
    *
    * @param scope
    */
			function setNavigationScope(scope) {
				navigationScope = scope;
			}

			/**
    * Set folded status
    *
    * @param status
    */
			function setFolded(status) {
				folded = status;
			}

			/**
    * Return folded status
    *
    * @returns {*}
    */
			function getFolded() {
				return folded;
			}

			/**
    * Set folded open status
    *
    * @param status
    */
			function setFoldedOpen(status) {
				foldedOpen = status;
			}

			/**
    * Return folded open status
    *
    * @returns {*}
    */
			function getFoldedOpen() {
				return foldedOpen;
			}

			/**
    * Toggle fold on stored navigation's scope
    */
			function toggleFolded() {
				navigationScope.toggleFolded();
			}

			/**
    * Flatten the given navigation
    *
    * @param navigation
    * @private
    */
			function _flattenNavigation(navigation) {
				var flatNav = [];

				for (var x = 0; x < navigation.length; x++) {
					// Copy and clear the children of the
					// navigation that we want to push
					var navToPush = angular.copy(navigation[x]);
					navToPush.children = [];

					// Push the item
					flatNav.push(navToPush);

					// If there are child items in this navigation,
					// do some nested function magic
					if (navigation[x].children.length > 0) {
						flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
					}
				}

				return flatNav;
			}
		};
	}

	/** @ngInject */
	function MsNavigationController($scope, msNavigationService, $auth, $profile, $rootScope) {
		var vm = this;

		// Data
		if ($scope.root) {
			vm.navigation = msNavigationService.getNavigation($scope.root);
		} else {
			vm.navigation = msNavigationService.getNavigation();
		}

		function isAllowed(profiles, allowedProfiles) {
			var allowed = _.filter(profiles, function (profile) {
				return allowedProfiles.indexOf(profile.identifier) >= 0;
			});
			return allowed.length > 0;
		}

		function filterProfiledNavigation(list) {
			var profiles = $auth.user('profiles');
			return _.filter(_.map(list, function (item) {
				if (!item.profiles || item.profiles.length <= 0) {
					if (item.children.length > 0) {
						item.children = filterProfiledNavigation(item.children);
					}
					return item;
				} else {
					if (isAllowed(profiles, item.profiles)) {
						if (item.children.length > 0) {
							item.children = filterProfiledNavigation(item.children);
						}
						return item;
					} else {
						return false;
					}
				}
			}), function (o) {
				return o !== false;
			});
		}

		function filterPermissionNavigation(list) {
			return _.filter(_.map(angular.copy(list), function (item) {
				if (!item.permissions || item.permissions.length <= 0) {
					if (item.children.length > 0) {
						item.children = filterPermissionNavigation(item.children);
					}
					return item;
				} else {
					if (!$profile.isForbidden(item.permissions)) {
						if (item.children.length > 0) {
							item.children = filterPermissionNavigation(item.children);
						}
						return item;
					} else {
						return false;
					}
				}
			}), function (o) {
				return o !== false;
			});
		}

		vm.navigation = filterPermissionNavigation(angular.copy(vm.navigation));

		// Methods
		vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

		//////////

		init();

		/**
   * Initialize
   */
		function init() {
			// Sort the navigation before doing anything else
			msNavigationService.sort();
		}

		/**
   * Toggle horizontal mobile menu
   */
		function toggleHorizontalMobileMenu() {
			angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
		}

		$rootScope.$on('$auth.user', function () {
			if ($scope.root) {
				vm.navigation = msNavigationService.getNavigation($scope.root);
			} else {
				vm.navigation = msNavigationService.getNavigation();
			}
			vm.navigation = filterPermissionNavigation(angular.copy(vm.navigation));
			init();
		});
	}

	/** @ngInject */
	function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
		return {
			restrict: 'E',
			scope: {
				folded: '=',
				root: '@'
			},
			controller: 'MsNavigationController as vm',
			templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
			transclude: true,
			compile: function compile(tElement) {
				tElement.addClass('ms-navigation');

				return function postLink(scope, iElement) {
					var bodyEl = angular.element('body'),
					    foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
					    foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
					    sidenav = $mdSidenav('navigation');

					// Store the navigation in the service for public access
					msNavigationService.setNavigationScope(scope);

					// Initialize
					init();

					/**
      * Initialize
      */
					function init() {
						// Set the folded status for the first time.
						// First, we have to check if we have a folded
						// status available in the service already. This
						// will prevent navigation to act weird if we already
						// set the fold status, remove the navigation and
						// then re-initialize it, which happens if we
						// change to a view without a navigation and then
						// come back with history.back() function.

						// If the service didn't initialize before, set
						// the folded status from scope, otherwise we
						// won't touch anything because the folded status
						// already set in the service...
						if (msNavigationService.getFolded() === null) {
							msNavigationService.setFolded(scope.folded);
						}

						if (msNavigationService.getFolded()) {
							// Collapse everything.
							// This must be inside a $timeout because by the
							// time we call this, the 'msNavigation::collapse'
							// event listener is not registered yet. $timeout
							// will ensure that it will be called after it is
							// registered.
							$timeout(function () {
								$rootScope.$broadcast('msNavigation::collapse');
							});

							// Add class to the body
							bodyEl.addClass('ms-navigation-folded');

							// Set fold expander
							setFoldExpander();
						}
					}

					// Sidenav locked open status watcher
					scope.$watch(function () {
						return sidenav.isLockedOpen();
					}, function (current, old) {
						if (angular.isUndefined(current) || angular.equals(current, old)) {
							return;
						}

						var folded = msNavigationService.getFolded();

						if (folded) {
							if (current) {
								// Collapse everything
								$rootScope.$broadcast('msNavigation::collapse');
							} else {
								// Expand the active one and its parents
								var activeItem = msNavigationService.getActiveItem();
								if (activeItem) {
									activeItem.scope.$emit('msNavigation::stateMatched');
								}
							}
						}
					});

					// Folded status watcher
					scope.$watch('folded', function (current, old) {
						if (angular.isUndefined(current) || angular.equals(current, old)) {
							return;
						}

						setFolded(current);
					});

					/**
      * Set folded status
      *
      * @param folded
      */
					function setFolded(folded) {
						// Store folded status on the service for global access
						msNavigationService.setFolded(folded);

						if (folded) {
							// Collapse everything
							$rootScope.$broadcast('msNavigation::collapse');

							// Add class to the body
							bodyEl.addClass('ms-navigation-folded');

							// Set fold expander
							setFoldExpander();
						} else {
							// Expand the active one and its parents
							var activeItem = msNavigationService.getActiveItem();
							if (activeItem) {
								activeItem.scope.$emit('msNavigation::stateMatched');
							}

							// Remove body class
							bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

							// Remove fold collapser
							removeFoldCollapser();
						}
					}

					/**
      * Set fold expander
      */
					function setFoldExpander() {
						iElement.parent().append(foldExpanderEl);

						// Let everything settle for a moment
						// before registering the event listener
						$timeout(function () {
							foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
						});
					}

					/**
      * Set fold collapser
      */
					function setFoldCollapser() {
						bodyEl.find('#main').append(foldCollapserEl);
						foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
					}

					/**
      * Remove fold collapser
      */
					function removeFoldCollapser() {
						foldCollapserEl.remove();
					}

					/**
      * onHover event of foldExpander
      */
					function onFoldExpanderHover(event) {
						if (event) {
							event.preventDefault();
						}

						// Set folded open status
						msNavigationService.setFoldedOpen(true);

						// Expand the active one and its parents
						var activeItem = msNavigationService.getActiveItem();
						if (activeItem) {
							activeItem.scope.$emit('msNavigation::stateMatched');
						}

						// Add class to the body
						bodyEl.addClass('ms-navigation-folded-open');

						// Remove the fold opener
						foldExpanderEl.remove();

						// Set fold collapser
						setFoldCollapser();
					}

					/**
      * onHover event of foldCollapser
      */
					function onFoldCollapserHover(event) {
						if (event) {
							event.preventDefault();
						}

						// Set folded open status
						msNavigationService.setFoldedOpen(false);

						// Collapse everything
						$rootScope.$broadcast('msNavigation::collapse');

						// Remove body class
						bodyEl.removeClass('ms-navigation-folded-open');

						// Remove the fold collapser
						foldCollapserEl.remove();

						// Set fold expander
						setFoldExpander();
					}

					/**
      * Public access for toggling folded status externally
      */
					scope.toggleFolded = function () {
						var folded = msNavigationService.getFolded();

						setFolded(!folded);
					};

					/**
      * On $stateChangeStart
      */
					scope.$on('$stateChangeStart', function () {
						// Close the sidenav
						sidenav.close();
					});

					// Cleanup
					scope.$on('$destroy', function () {
						foldCollapserEl.off('mouseenter touchstart');
						foldExpanderEl.off('mouseenter touchstart');
					});
				};
			}
		};
	}

	/** @ngInject */
	function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService) {
		var vm = this;

		// Data
		vm.element = $element;
		vm.node = $scope.node;
		vm.hasChildren = undefined;
		vm.collapsed = undefined;
		vm.collapsable = undefined;
		vm.group = undefined;
		vm.animateHeightClass = 'animate-height';

		// Methods
		vm.toggleCollapsed = toggleCollapsed;
		vm.collapse = collapse;
		vm.expand = expand;
		vm.getClass = getClass;
		vm.isHidden = isHidden;

		//////////

		init();

		/**
   * Initialize
   */
		function init() {
			// Setup the initial values

			// Has children?
			vm.hasChildren = vm.node.children.length > 0;

			// Is group?
			vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

			// Is collapsable?
			if (!vm.hasChildren || vm.group) {
				vm.collapsable = false;
			} else {
				vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
			}

			// Is collapsed?
			if (!vm.collapsable) {
				vm.collapsed = false;
			} else {
				vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
			}

			// Expand all parents if we have a matching state or
			// the current state is a child of the node's state
			if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
				// If state params are defined, make sure they are
				// equal, otherwise do not set the active item
				if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
					return;
				}

				$scope.$emit('msNavigation::stateMatched');

				// Also store the current active menu item
				msNavigationService.setActiveItem(vm.node, $scope);
			}

			$scope.$on('msNavigation::stateMatched', function () {
				// Expand if the current scope is collapsable and is collapsed
				if (vm.collapsable && vm.collapsed) {
					$scope.$evalAsync(function () {
						vm.collapsed = false;
					});
				}
			});

			// Listen for collapse event
			$scope.$on('msNavigation::collapse', function (event, path) {
				if (vm.collapsed || !vm.collapsable) {
					return;
				}

				// If there is no path defined, collapse
				if (angular.isUndefined(path)) {
					vm.collapse();
				}
				// If there is a path defined, do not collapse
				// the items that are inside that path. This will
				// prevent parent items from collapsing
				else {
						var givenPathParts = path.split('.'),
						    activePathParts = [];

						var activeItem = msNavigationService.getActiveItem();
						if (activeItem) {
							activePathParts = activeItem.node._path.split('.');
						}

						// Test for given path
						if (givenPathParts.indexOf(vm.node._id) > -1) {
							return;
						}

						// Test for active path
						if (activePathParts.indexOf(vm.node._id) > -1) {
							return;
						}

						vm.collapse();
					}
			});

			// Listen for $stateChangeSuccess event
			$scope.$on('$stateChangeSuccess', function () {
				if (vm.node.state === $state.current.name) {
					// If state params are defined, make sure they are
					// equal, otherwise do not set the active item
					if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
						return;
					}

					// Update active item on state change
					msNavigationService.setActiveItem(vm.node, $scope);

					// Collapse everything except the one we're using
					$rootScope.$broadcast('msNavigation::collapse', vm.node._path);
				}

				// Expand the parents if we the current
				// state is a child of the node's state
				if ($state.includes(vm.node.state)) {
					// If state params are defined, make sure they are
					// equal, otherwise do not set the active item
					if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
						return;
					}

					// Emit the stateMatched
					$scope.$emit('msNavigation::stateMatched');
				}
			});
		}

		/**
   * Toggle collapsed
   */
		function toggleCollapsed() {
			if (vm.collapsed) {
				vm.expand();
			} else {
				vm.collapse();
			}
		}

		/**
   * Collapse
   */
		function collapse() {
			// Grab the element that we are going to collapse
			var collapseEl = vm.element.children('ul');

			// Grab the height
			var height = collapseEl[0].offsetHeight;

			$scope.$evalAsync(function () {
				// Set collapsed status
				vm.collapsed = true;

				// Add collapsing class to the node
				vm.element.addClass('collapsing');

				// Animate the height
				$animate.animate(collapseEl, {
					'display': 'block',
					'height': height + 'px'
				}, {
					'height': '0px'
				}, vm.animateHeightClass).then(function () {
					// Clear the inline styles after animation done
					collapseEl.css({
						'display': '',
						'height': ''
					});

					// Clear collapsing class from the node
					vm.element.removeClass('collapsing');
				});

				// Broadcast the collapse event so child items can also be collapsed
				$scope.$broadcast('msNavigation::collapse');
			});
		}

		/**
   * Expand
   */
		function expand() {
			// Grab the element that we are going to expand
			var expandEl = vm.element.children('ul');

			// Move the element out of the dom flow and
			// make it block so we can get its height
			expandEl.css({
				'position': 'absolute',
				'visibility': 'hidden',
				'display': 'block',
				'height': 'auto'
			});

			// Grab the height
			var height = expandEl[0].offsetHeight;

			// Reset the style modifications
			expandEl.css({
				'position': '',
				'visibility': '',
				'display': '',
				'height': ''
			});

			$scope.$evalAsync(function () {
				// Set collapsed status
				vm.collapsed = false;

				// Add expanding class to the node
				vm.element.addClass('expanding');

				// Animate the height
				$animate.animate(expandEl, {
					'display': 'block',
					'height': '0px'
				}, {
					'height': height + 'px'
				}, vm.animateHeightClass).then(function () {
					// Clear the inline styles after animation done
					expandEl.css({
						'height': ''
					});

					// Clear expanding class from the node
					vm.element.removeClass('expanding');
				});

				// If item expanded, broadcast the collapse event from rootScope so that the other expanded items
				// can be collapsed. This is necessary for keeping only one parent expanded at any time
				$rootScope.$broadcast('msNavigation::collapse', vm.node._path);
			});
		}

		/**
   * Return the class
   *
   * @returns {*}
   */
		function getClass() {
			return vm.node.class;
		}

		/**
   * Check if node should be hidden
   *
   * @returns {boolean}
   */
		function isHidden() {
			if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
				return vm.node.hidden();
			}

			return false;
		}
	}

	/** @ngInject */
	function msNavigationNodeDirective() {
		return {
			restrict: 'A',
			bindToController: {
				node: '=msNavigationNode'
			},
			controller: 'MsNavigationNodeController as vm',
			compile: function compile(tElement) {
				tElement.addClass('ms-navigation-node');

				return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
					// Add custom classes
					iElement.addClass(MsNavigationNodeCtrl.getClass());

					// Add group class if it's a group
					if (MsNavigationNodeCtrl.group) {
						iElement.addClass('group');
					}
				};
			}
		};
	}

	/** @ngInject */
	function msNavigationItemDirective() {
		return {
			restrict: 'A',
			require: '^msNavigationNode',
			compile: function compile(tElement) {
				tElement.addClass('ms-navigation-item');

				return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
					// If the item is collapsable...
					if (MsNavigationNodeCtrl.collapsable) {
						iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
					}

					// Cleanup
					scope.$on('$destroy', function () {
						iElement.off('click');
					});
				};
			}
		};
	}

	/** @ngInject */
	function msNavigationHorizontalDirective(msNavigationService) {
		return {
			restrict: 'E',
			scope: {
				root: '@'
			},
			controller: 'MsNavigationController as vm',
			templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
			transclude: true,
			compile: function compile(tElement) {
				tElement.addClass('ms-navigation-horizontal');

				return function postLink(scope) {
					// Store the navigation in the service for public access
					msNavigationService.setNavigationScope(scope);
				};
			}
		};
	}

	/** @ngInject */
	function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
		var vm = this;

		// Data
		vm.element = $element;
		vm.node = $scope.node;
		vm.hasChildren = undefined;
		vm.group = undefined;

		// Methods
		vm.getClass = getClass;

		//////////

		init();

		/**
   * Initialize
   */
		function init() {
			// Setup the initial values

			// Is active
			vm.isActive = false;

			// Has children?
			vm.hasChildren = vm.node.children.length > 0;

			// Is group?
			vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

			// Mark all parents as active if we have a matching state
			// or the current state is a child of the node's state
			if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
				// If state params are defined, make sure they are
				// equal, otherwise do not set the active item
				if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
					return;
				}

				$scope.$emit('msNavigation::stateMatched');

				// Also store the current active menu item
				msNavigationService.setActiveItem(vm.node, $scope);
			}

			$scope.$on('msNavigation::stateMatched', function () {
				// Mark as active if has children
				if (vm.hasChildren) {
					$scope.$evalAsync(function () {
						vm.isActive = true;
					});
				}
			});

			// Listen for clearActive event
			$scope.$on('msNavigation::clearActive', function () {
				if (!vm.hasChildren) {
					return;
				}

				var activePathParts = [];

				var activeItem = msNavigationService.getActiveItem();
				if (activeItem) {
					activePathParts = activeItem.node._path.split('.');
				}

				// Test for active path
				if (activePathParts.indexOf(vm.node._id) > -1) {
					$scope.$evalAsync(function () {
						vm.isActive = true;
					});
				} else {
					$scope.$evalAsync(function () {
						vm.isActive = false;
					});
				}
			});

			// Listen for $stateChangeSuccess event
			$scope.$on('$stateChangeSuccess', function () {
				if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
					// If state params are defined, make sure they are
					// equal, otherwise do not set the active item
					if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
						return;
					}

					// Update active item on state change
					msNavigationService.setActiveItem(vm.node, $scope);

					// Clear all active states except the one we're using
					$rootScope.$broadcast('msNavigation::clearActive');
				}
			});
		}

		/**
   * Return the class
   *
   * @returns {*}
   */
		function getClass() {
			return vm.node.class;
		}
	}

	/** @ngInject */
	function msNavigationHorizontalNodeDirective() {
		return {
			restrict: 'A',
			bindToController: {
				node: '=msNavigationHorizontalNode'
			},
			controller: 'MsNavigationHorizontalNodeController as vm',
			compile: function compile(tElement) {
				tElement.addClass('ms-navigation-horizontal-node');

				return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
					// Add custom classes
					iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

					// Add group class if it's a group
					if (MsNavigationHorizontalNodeCtrl.group) {
						iElement.addClass('group');
					}
				};
			}
		};
	}

	/** @ngInject */
	function msNavigationHorizontalItemDirective($mdMedia) {
		return {
			restrict: 'A',
			require: '^msNavigationHorizontalNode',
			compile: function compile(tElement) {
				tElement.addClass('ms-navigation-horizontal-item');

				return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
					iElement.on('click', onClick);

					function onClick() {
						if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
							return;
						}

						iElement.toggleClass('expanded');
					}

					// Cleanup
					scope.$on('$destroy', function () {
						iElement.off('click');
					});
				};
			}
		};
	}
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').factory('msNavFoldService', msNavFoldService).directive('msNavIsFolded', msNavIsFoldedDirective).controller('MsNavController', MsNavController).directive('msNav', msNavDirective).directive('msNavTitle', msNavTitleDirective).directive('msNavButton', msNavButtonDirective).directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService() {
        var foldable = {};

        var service = {
            setFoldable: setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold: toggleFold,
            openFolded: openFolded,
            closeFolded: closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element) {
            foldable = {
                'scope': scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen() {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold() {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded() {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded() {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService) {
        return {
            restrict: 'A',
            link: function link(scope, iElement, iAttrs) {
                var isFolded = iAttrs.msNavIsFolded === 'true',
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if (isFolded) {
                    fold();
                } else {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen() {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold() {
                    isFolded = !isFolded;

                    if (isFolded) {
                        fold();
                    } else {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold() {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event) {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event) {
                    if (angular.isDefined(event)) {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event) {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event) {
                    if (angular.isDefined(event)) {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event) {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold() {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function () {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }

    /** @ngInject */
    function MsNavController() {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled() {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable() {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable() {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope) {
            toggleItems.push({
                'element': element,
                'scope': scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems() {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope) {
            lockedItems.push({
                'element': element,
                'scope': scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems() {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService) {
        return {
            restrict: 'E',
            scope: {},
            controller: 'MsNavController',
            compile: function compile(tElement) {
                tElement.addClass('ms-nav');

                return function postLink(scope) {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation) {
                            navigation.close();

                            if (msNavFoldService.isNavFoldedOpen()) {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function () {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective() {
        return {
            restrict: 'A',
            compile: function compile(tElement) {
                tElement.addClass('ms-nav-title');

                return function postLink() {};
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective() {
        return {
            restrict: 'AE',
            compile: function compile(tElement) {
                tElement.addClass('ms-nav-button');

                return function postLink() {};
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state) {
        return {
            restrict: 'A',
            require: '^msNav',
            scope: true,
            compile: function compile(tElement, tAttrs) {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if (angular.isUndefined(tAttrs.collapsed)) {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl) {
                    var classes = {
                        expanded: 'expanded',
                        expandAnimation: 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link) {
                        var state = angular.element(link).attr('ui-sref');

                        if (angular.isUndefined(state)) {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle() {
                        // If navigation is disabled, do nothing...
                        if (MsNavCtrl.isDisabled()) {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if (isCollapsed()) {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function () {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        } else {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function () {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem) {
                            if (angular.equals(lockedItem.scope, scope)) {
                                locked = true;
                            }
                        });

                        if (locked) {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function () {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function () {
                        // Collapse and then...
                        collapse().then(function () {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function () {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state) {
                            if (currentState === state) {
                                shouldExpand = true;
                            }
                        });

                        if (shouldExpand) {
                            expand();
                        } else {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function () {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed() {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded() {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand() {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if (isExpanded()) {
                            // Reject the deferred object
                            deferred.reject({ 'error': true });

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position': 'absolute',
                            'visibility': 'hidden',
                            'display': 'block',
                            'height': 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position': '',
                            'visibility': '',
                            'display': '',
                            'height': ''
                        });

                        // Animate the height
                        scope.$evalAsync(function () {
                            $animate.animate(elementToExpand, {
                                'display': 'block',
                                'height': '0px'
                            }, {
                                'height': height + 'px'
                            }, classes.expandAnimation).then(function () {
                                // Add expanded class
                                elementToExpand.addClass(classes.expanded);

                                // Clear the inline styles after animation done
                                elementToExpand.css({ 'height': '' });

                                // Resolve the deferred object
                                deferred.resolve({ 'success': true });
                            });
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse() {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if (isCollapsed()) {
                            // Reject the deferred object
                            deferred.reject({ 'error': true });

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function () {
                            $animate.animate(elementToCollapse, {
                                'height': height + 'px'
                            }, {
                                'height': '0px'
                            }, classes.collapseAnimation).then(function () {
                                // Remove expanded class
                                elementToCollapse.removeClass(classes.expanded);

                                // Clear the inline styles after animation done
                                elementToCollapse.css({
                                    'display': '',
                                    'height': ''
                                });

                                // Resolve the deferred object
                                deferred.resolve({ 'success': true });
                            });
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('msMaterialColorPickerController', msMaterialColorPickerController).directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator) {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues) {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue) {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor() {
            vm.selectedColor = {
                palette: '',
                hue: '',
                class: ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor() {
            if (!vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '') {
                removeColor();
                return;
            }

            var palette = void 0,
                hue = void 0;

            // If ModelType Class
            if (vm.msModelType === 'class') {
                var color = vm.modelCtrl.$viewValue.split('-');
                if (color.length >= 5) {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                } else {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if (vm.msModelType === 'obj') {
                    palette = vm.modelCtrl.$viewValue.palette;
                    hue = vm.modelCtrl.$viewValue.hue || 500;
                }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue) {
            vm.selectedColor = {
                palette: palette,
                hue: hue,
                class: 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if (vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue)) {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel() {
            if (vm.msModelType === 'class') {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            } else if (vm.msModelType === 'obj') {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker() {
        return {
            require: ['msMaterialColorPicker', 'ngModel'],
            restrict: 'E',
            scope: {
                ngModel: '=',
                msModelType: '@?'
            },
            controller: 'msMaterialColorPickerController as vm',
            transclude: true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link: function link(scope, element, attrs, controllers, transclude) {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone) {
                    clone = clone.filter(function (i, el) {
                        return el.nodeType === 1 ? true : false;
                    });

                    if (clone.length) {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('msMasonryController', msMasonryController).directive('msMasonry', msMasonry).directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout) {
        var vm = this,
            defaultOpts = {
            columnCount: 5,
            respectItemOrder: false,
            reLayoutDebounce: 400,
            responsive: {
                md: 3,
                sm: 2,
                xs: 1
            }
        },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize() {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);

            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function () {
            reLayout();
        });

        function waitImagesLoaded(element, callback) {
            if (typeof imagesLoaded !== 'undefined') {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function () {
                    callback();
                });
            } else {
                callback();
            }
        }

        function watchContainerResize() {
            $scope.$watch(function () {
                return vm.container.width();
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    reLayout();
                }
            });
        }

        function reLayout() {
            // Debounce for relayout
            if (reLayoutTimeout) {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function () {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');
            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start() {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function () {
                    return 0;
                });

                // set item positions
                for (var i = 0; i < vm.items.length; i++) {
                    var item = vm.items[i],
                        xPos = void 0,
                        yPos = void 0,
                        column = void 0,
                        refTop = void 0;

                    item = angular.element(item);

                    if (item.scope()) {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({ 'width': vm.columnWidth });

                    if (vm.options.respectItemOrder) {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    } else {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({ 'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)' });
                    item.addClass('placed');

                    if (item.scope()) {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions() {
            vm.columnCount = vm.options.columnCount;

            if ($mdMedia('gt-md')) {
                vm.columnCount = vm.options.columnCount;
            } else if ($mdMedia('md')) {
                vm.columnCount = vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount;
            } else if ($mdMedia('sm')) {
                vm.columnCount = vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount;
            } else {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;
        }
    }

    /** @ngInject */
    function msMasonry($timeout) {
        return {
            restrict: 'AEC',
            controller: 'msMasonryController',
            compile: compile
        };
        function compile(element, attributes) {
            return {
                pre: function preLink(scope, iElement, iAttrs, controller) {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller) {
                    $timeout(function () {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem() {
        return {
            restrict: 'AEC',
            require: '^msMasonry',
            priority: 1,
            link: link
        };

        function link(scope, element, attributes, controller) {
            controller.waitImagesLoaded(element, function () {
                controller.reLayout();
            });

            scope.$on('msMasonryItem:finishReLayout', function () {
                scope.$watch(function () {
                    return element.height();
                }, function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function () {
                controller.reLayout();
            });
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document) {
        return {
            restrict: 'E',
            scope: {},
            transclude: true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link: function link(scope, iElement) {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar() {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('MsFormWizardController', MsFormWizardController).directive('msFormWizard', msFormWizardDirective).directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController() {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form) {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep() {
            if (isFirstStep()) {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep() {
            if (isLastStep()) {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep() {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep() {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps() {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep() {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep() {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid() {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid() {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete() {
            for (var x = 0; x < vm.forms.length; x++) {
                if (vm.forms[x].$invalid) {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm() {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for (var x = 0; x < vm.forms.length; x++) {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective() {
        return {
            restrict: 'E',
            scope: true,
            controller: 'MsFormWizardController as msWizard',
            compile: function compile(tElement) {
                tElement.addClass('ms-form-wizard');

                return function postLink() {};
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective() {
        return {
            restrict: 'A',
            require: ['form', '^msFormWizard'],
            compile: function compile(tElement) {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').provider('msDatepickerFixConfig', msDatepickerFixConfigProvider).directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider() {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function formatter(val) {
                if (!val) {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser: function parser(val) {
                if (!val) {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration) {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function () {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig) {
        return {
            require: 'ngModel',
            priority: 1,
            link: function link(scope, elem, attrs, ngModel) {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective() {
        return {
            restrict: 'E',
            scope: {
                templatePath: '=template',
                card: '=ngModel',
                vm: '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile: function compile(tElement) {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement) {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded() {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var INJECT = ['$scope', '$element', '$timeout'];
  var KM_H = 300;
  var DELAY = 50;
  var STEP = KM_H * 1000 * DELAY / 3600000;

  var MapRealtimeDirective = function () {
    function MapRealtimeDirective() {
      _classCallCheck(this, MapRealtimeDirective);

      this.service = this.service.bind(this);
      this.watcher = this.watcher.bind(this);
      this.render = this.render.bind(this);
      this.createMap = this.createMap.bind(this);
      this.manageMarkers = this.manageMarkers.bind(this);
      this.centerOnMarkers = this.centerOnMarkers.bind(this);
      this.addMarkers = this.addMarkers.bind(this);
      this.changeMarker = this.changeMarker.bind(this);

      this.service(arguments);
      this.watcher();
    }

    _createClass(MapRealtimeDirective, [{
      key: 'service',
      value: function service(args) {
        var _this = this;

        if (angular.isString(args)) {
          try {
            return this.constructor.$_map[args];
          } catch (e) {
            console.error('Servicio ' + args + ' no encontrado');
          }
        } else {
          if (!this.constructor.$_map) {
            this.constructor.$_map = {};
          }
          _.each(INJECT, function (s, i) {
            _this.constructor.$_map[s] = args[i];
          });
        }
      }
    }, {
      key: 'watcher',
      value: function watcher() {
        this.service('$scope').$watch('$ctrl.markers', this.render, true);
      }
    }, {
      key: 'render',
      value: function render(positions) {
        var _this2 = this;

        if (window.google) {
          this.map = this.createMap();
          if (positions) {
            this.manageMarkers(positions);
          }
        } else {
          this.service('$timeout')(function () {
            _this2.render(positions);
          }, 500);
        }
      }
    }, {
      key: 'createMap',
      value: function createMap() {
        var _this3 = this;

        if (!this.map) {
          this.map = new window.google.maps.Map(this.service('$element')[0], {
            center: { lat: -33.4532908, lng: -70.7142131 },
            zoom: 15
          });

          this.map.addListener('idle', function () {
            if (_this3.onMove && _this3.map) {
              _this3.onMove({
                map: _this3.map,
                bounds: _this3.map.getBounds()
              });
            }
          });
        }
        return this.map;
      }
    }, {
      key: 'manageMarkers',
      value: function manageMarkers(positions) {
        var _this4 = this;

        if (positions && positions.length > 0) {
          if (this.map) {
            if (!this.marcadores) {
              this.marcadores = [];
              this.addMarkers(positions);
              this.centerOnMarkers(this.marcadores);
            } else {
              /* Remover los que ya no sean necesarios */
              this.marcadores = _.filter(this.marcadores, function (marcador) {
                var index = _.findIndex(positions, { id: marcador.data.id });
                if (index < 0) {
                  marcador.setMap(null);
                }
                return index >= 0;
              });
              /**/
              /* Mover antiguos */
              var oldMarkers = _.filter(positions, function (pos) {
                var index = _.findIndex(_this4.marcadores, function (marcador) {
                  return marcador.data.id === pos.id;
                });
                return index >= 0;
              });
              /* Agregar nuevos */
              var newMarkers = _.filter(positions, function (pos) {
                var index = _.findIndex(_this4.marcadores, function (marcador) {
                  return marcador.data.id === pos.id;
                });
                return index < 0;
              });

              this.addMarkers(newMarkers);
              this.moveMarkers(oldMarkers);
            }
          } else {
            this.service('$timeout')(function () {
              _this4.manageMarkers(positions);
            }, 500);
          }
        } else {
          if (this.marcadores) {
            this.removeAllMarkers();
          }
        }
      }
    }, {
      key: 'addMarkers',
      value: function addMarkers(positions) {
        var _this5 = this;

        _.each(positions, function (pos) {
          if (pos.coords) {
            var latLng = new window.google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
            var marker = new window.google.maps.Marker({
              data: {
                id: pos.id
              },
              position: latLng,
              map: _this5.map,
              icon: pos.icon || '/assets/images/colectivo3.png'
            });
            if (pos.templateInfo) {

              if (!marker.infowindow) {
                marker.infowindow = new window.google.maps.InfoWindow({
                  content: pos.templateInfo
                });
              } else {
                marker.infowindow.setContent(pos.templateInfo);
              }
              console.log('templateInfo', pos.templateInfo);

              marker.addListener('click', function () {
                marker.infowindow.open(_this5.map, marker);
              });
            }
            _this5.marcadores.push(marker);
          }
        });
      }
    }, {
      key: 'moveMarkers',
      value: function moveMarkers(positions) {
        var _this6 = this;

        if (!this.animations) this.animations = {};

        _.each(positions, function (pos) {
          var marker = _.find(_this6.marcadores, function (marker) {
            return marker.data.id === pos.id;
          });
          if (marker) {
            var animate = true;
            if (pos.icon !== marker.getIcon()) {
              animate = false;
            }
            marker.setIcon(pos.icon);

            if (!marker.infowindow) {
              marker.infowindow = new window.google.maps.InfoWindow({
                content: pos.templateInfo
              });
            } else {
              marker.infowindow.setContent(pos.templateInfo);
            }

            if (_this6.animations[marker.data.id]) {
              clearTimeout(_this6.animations[marker.data.id]);
            }
            var positionMarker = marker.getPosition();
            var latLng = new window.google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
            var distance = window.google.maps.geometry.spherical.computeDistanceBetween(latLng, marker.position);
            var numStep = distance / STEP;
            var deltaLat = (latLng.lat() - positionMarker.lat()) / numStep;
            var deltaLng = (latLng.lng() - positionMarker.lng()) / numStep;
            if (animate) {
              _this6.moveMarker(marker, 0, distance, deltaLat, deltaLng, latLng);
            } else {
              _this6.changeMarker(marker, latLng);
            }
          }
        });
      }
    }, {
      key: 'moveMarker',
      value: function moveMarker(marker, i, distance, deltaLat, deltaLng, latLng) {
        var _this7 = this;

        var position = marker.getPosition();
        var lat = position.lat() + deltaLat;
        var lng = position.lng() + deltaLng;
        i += STEP;
        if (this.animations[marker.data.id]) {
          clearTimeout(this.animations[marker.data.id]);
        }
        if (i < distance) {
          marker.setPosition(new window.google.maps.LatLng(lat, lng));
          this.animations[marker.data.id] = setTimeout(function () {
            _this7.moveMarker(marker, i, distance, deltaLat, deltaLng, latLng);
          }, DELAY);
        } else {
          marker.setPosition(latLng);
          this.animations[marker.data.id] = null;
        }
      }
    }, {
      key: 'changeMarker',
      value: function changeMarker(marker, latLng) {
        if (this.animations[marker.data.id]) {
          clearTimeout(this.animations[marker.data.id]);
        }
        marker.setPosition(latLng);
      }
    }, {
      key: 'centerOnMarkers',
      value: function centerOnMarkers(markers) {
        var bounds = new window.google.maps.LatLngBounds();
        _.each(markers, function (marker) {
          bounds.extend(marker.getPosition());
        });

        if (this.map) {
          this.map.fitBounds(bounds);
        }
      }
    }, {
      key: 'removeAllMarkers',
      value: function removeAllMarkers() {
        _.each(this.marcadores, function (marker) {
          marker.setMap(null);
        });

        this.marcadores = [];
      }
    }]);

    return MapRealtimeDirective;
  }();

  MapRealtimeDirective.$inject = INJECT;
  angular.module('map.directive', []).component('mapRealtime', {
    bindings: {
      markers: '=',
      onMove: '&'
    },
    controller: MapRealtimeDirective
  });
})();
'use strict';

angular.module('loading.directive', []).directive('loading', function () {
	return {
		restrict: 'A',
		replace: true,
		templateUrl: 'app/core/directives/loading/loading.html',
		scope: {
			loading: '=',
			message: '='
		},
		link: function link(s, e) {}
	};
});
'use strict';

angular.module('listar.directive', []).directive('listar', function ($rootScope, $q, $state, $timeout, $toast, $mdDialog, $request, $profile, $sce, $auth, $injector) {
	return {
		templateUrl: 'app/core/directives/listar/listar.html',
		replace: true,
		scope: {
			config: '=listar'
		},
		link: function link(s, e) {
			console.debug('LINK S', s);
			var Model = null;

			function init() {
				var defer = $q.defer();
				s.columns = s.config.columns || [];
				s.loading = true;
				s.paginate = s.config.model.paginate;
				s.config.model = s.config.model || {};
				s.filter = angular.copy(s.config.model.filter || {});
				if (s.paginate) {
					if (!angular.isObject(s.paginate)) {
						s.paginate = {};
					}
					s.paginate.limit = s.paginate.limit || 10;
					s.paginate.limitOptions = [s.paginate.limit, s.paginate.limit * 2, s.paginate.limit * 5];
					s.paginate.page = 1;
					s.paginate.skip = 0;
					s.paginate.total = 0;
					s.filter.skip = s.paginate.skip;
					s.filter.limit = s.paginate.limit;
				}
				if (s.config.buttons && s.config.buttons.length > 0) {
					s.columns.push({
						title: 'Acciones'
					});
					var newButtons = [];
					var profile = $auth.getProfile();

					_.forEach(s.config.buttons, function (button) {
						var newMenus = [];
						if (button.action.menus) {
							_.forEach(button.action.menus, function (menu) {
								if (!menu.profiles) {
									newMenus.push(menu);
								} else {
									var allowed = _.includes(menu.profiles, profile);

									if (allowed) {
										newMenus.push(menu);
									}
								}
							});
							button.action.menus = newMenus;
						}

						if (!button.profiles) {
							newButtons.push(button);
						} else {

							var allowed = _.includes(button.profiles, profile);
							if (allowed) {
								newButtons.push(button);
							}
						}
					});
					s.buttons = newButtons;
				}
				if (s.config.model && s.config.model.name && angular.isObject(s.config.model)) {
					Model = $injector.get(s.config.model.name);
					cargarElemento();
				} else if (angular.isObject(s.config.model) && angular.isFunction(s.config.model.get)) {
					cargarFunction(s.filter.skip, s.filter.limit);
				}
				$timeout(function () {
					defer.resolve();
				});
				var updateRootScope = $rootScope.$on('$Update' + s.config.model.name, function (ev, where) {
					s.filter.where = where;
					console.log('update tabla');
					if (s.config.model && s.config.model.name && angular.isObject(s.config.model)) {
						cargarElemento();
					} else if (angular.isObject(s.config.model) && angular.isFunction(s.config.model.get)) {
						cargarFunction(s.filter.skip, s.filter.limit);
					}
				});
				s.$on('$destroy', function () {
					updateRootScope();
				});
				return defer.promise;
			}

			// init();

			/* Bind */
			s.clickButton = clickButton;
			s.conditionButton = conditionButton;
			s.changePage = changePage;
			s.orderBy = orderBy;
			s.getElementValue = getElementValue;
			s.clickValue = clickValue;

			function configElement(value, element, key, columns) {
				var config = _.find(columns, { key: key });
				var clase = '';
				if (config && config.clase) {
					if (angular.isString(config.clase)) {
						clase = config.clase;
					}
					if (angular.isFunction(config.clase)) {
						clase = config.clase(element, value);
					}
				}

				if (config && config.tag) {
					value = angular.element('<div><' + config.tag + ' class="' + clase + '">' + value + '</' + config.tag + '></div>');
				} else {
					value = angular.element('<div><span class="' + clase + '">' + value + '</span></div>');
				}

				return $sce.trustAsHtml(value.html());
			}

			function getElementValue(element, key) {
				return _.get(element.__original, key);
			}

			function clickValue($event, element, key) {
				console.log('CLICK VALUE', key, element);
				var config = _.find(element.__columns, { key: key });
				if (config.onClick && angular.isFunction(config.onClick)) {
					config.onClick($event, element.__original);
				}
			}

			function changePage(page, limit) {
				s.filter.skip = limit * (page - 1);
				s.filter.limit = limit;
				if (s.config.model && s.config.model.name && angular.isObject(s.config.model)) {
					cargarElemento();
				} else if (angular.isObject(s.config.model) && angular.isFunction(s.config.model.get)) {
					cargarFunction(s.filter.skip, s.filter.limit);
				}
			}

			function orderBy(column) {
				console.log('column', column);
				var newKey = false;
				if (column.key.indexOf('.') != -1) {
					var columnKeyArray = column.key.split('.');
					newKey = columnKeyArray[0];
				}
				if (column.order) {
					if (column.ordered) {
						column.direction = column.direction === 'asc' ? 'desc' : 'asc';
					} else {
						s.columns = _.map(s.columns, function (column) {
							column.ordered = false;
							return column;
						});

						column.ordered = true;
						column.direction = 'desc';
					}
					if (newKey) {
						s.filter.order = newKey + 'Id ' + column.direction.toUpperCase();
					} else {
						s.filter.order = column.key + ' ' + column.direction.toUpperCase();
					}

					if (s.config.model && s.config.model.name && angular.isObject(s.config.model)) {
						cargarElemento();
					} else if (angular.isObject(s.config.model) && angular.isFunction(s.config.model.get)) {
						cargarFunction(s.filter.skip, s.filter.limit);
					}
				}
			}

			function cargarElemento() {
				console.log('filter', s.filter.where);
				s.loading = true;
				Model[s.config.model.method || 'find']({ filter: s.filter } || {}).$promise.then(function (res) {
					s.listar = res;
					if (angular.isFunction(s.config.model.onSuccess)) {
						s.config.model.onSuccess(res);
					}
					if (angular.isString(s.config.model.successMessage)) {
						$toast.error(s.config.model.successMessage);
					}
				}).catch(function (err) {
					if (angular.isFunction(s.config.model.onError)) {
						s.config.model.onError(err);
					}
					if (angular.isString(s.config.model.errorMessage)) {
						$toast.error(s.config.model.errorMessage);
					}
				}).finally(function () {
					s.loading = false;
				});
				if (s.paginate) {
					Model[s.config.model.count || 'count']({
						where: s.config.model.filter.where ? s.config.model.filter.where : s.config.model.filter
					}).$promise.then(function (res) {
						s.paginate.total = res.count;
						if (angular.isFunction(s.config.model.onSuccessCount)) {
							s.config.model.onSuccessCount(res.count);
						}
					});
				}
			}

			function cargarFunction(skip, limit) {
				s.loading = true;
				s.config.model.get(skip, limit, $q, $request).then(function (res) {
					s.listar = res;
					if (angular.isFunction(s.config.model.onSuccess)) {
						s.config.model.onSuccess(res);
					}
					if (angular.isString(s.config.model.successMessage)) {
						$toast.error(s.config.model.successMessage);
					}
				}).catch(function (err) {
					if (angular.isFunction(s.config.model.onError)) {
						s.config.model.onError(err);
					}
					if (angular.isString(s.config.model.errorMessage)) {
						$toast.error(s.config.model.errorMessage);
					}
				}).finally(function () {
					s.loading = false;
				});
				if (s.paginate) {
					if (angular.isFunction(s.config.model.count)) {
						s.config.model.count($q, $request).then(function (res) {
							s.paginate.total = res.count;
							if (angular.isFunction(s.config.model.onSuccessCount)) {
								s.config.model.onSuccessCount(res.count);
							}
						});
					}
				}
			}

			function conditionButton(button, element) {
				var canContinue = true;
				if (s.config.permission && canContinue) {
					if (button.action && button.action.type) {
						if (button.action.type === 'edit') {
							canContinue = !$profile.isForbidden([{
								key: s.config.permission,
								edit: true,
								type: 'allow'
							}]);
						} else if (button.action.type === 'delete') {
							canContinue = !$profile.isForbidden([{
								key: s.config.permission,
								remove: true,
								type: 'allow'
							}]);
						}
					}
				}
				if (!button) {
					return true;
				}
				if (!button.condition && canContinue) {
					return true;
				} else if (canContinue) {
					if (angular.isFunction(button.condition)) {
						return button.condition(element, button);
					} else {
						return button.condition;
					}
				} else {
					return canContinue;
				}
			}

			function clickButton($event, button, element) {

				if (button.state) {
					if (button.state.params) {
						goTo(button.state, element);
					}
				}
				if (button.action) {
					if (angular.isFunction(button.action)) {
						button.action($event, element.__original, element, button);
					}
					if (angular.isObject(button.action)) {
						switch (button.action.type) {
							case 'delete':
								goDelete($event, element.__original, button.action, button);
								break;
							case 'edit':
								goEdit(element);
								break;
						}
					}
				}
			}

			/* Utils */

			function goTo(state, element) {
				var params = {};
				_.each(state.params, function (param) {
					if (angular.isString(param)) {
						params[param] = element.__original[param];
					}
					if (angular.isObject(param)) {
						_.forOwn(param, function (value, key) {
							params[key] = element.__original[value];
						});
					}
				});
				$state.go(state.name, params);
			}

			function goEdit(element) {
				if (s.config.routes && s.config.routes.edit) {
					goTo({
						name: s.config.routes.edit,
						params: ['id']
					}, element);
				} else {
					throw 'No se ha definido una ruta de edición (config.routes.edit)';
				}
			}

			function goDelete($event, element, action, button) {
				Model = $injector.get(s.config.model.name);
				$mdDialog.show({
					targetEvent: $event,
					template: '<div>' + '<div loading="dialogLoading" message="\'Borrando...\'"></div>' + '<md-toolbar>' + '<div class="md-toolbar-tools"><h2>' + (action.title || '¿Estás seguro de querer borrar este ' + (s.config.model.singular || 'elemento') + '?') + '</h2></div>' + '</md-toolbar>' + '  <md-content class="md-padding"><p>' + (action.content || 'Esto no se puede deshacer.') + '</p></md-content>' + '  <md-dialog-actions>' + '<md-button ng-click="doCancel()">Cancelar</md-button>' + '<md-button ng-click="doBorrar()" class="md-raised md-warn"><md-icon md-font-icon="icon-trash"></md-icon> Borrar</md-button>' + '  </md-dialog-actions>' + '</div>',
					controller: function controller($scope) {
						$scope.dialogLoading = false;
						$scope.doCancel = function () {
							$mdDialog.cancel();
							if (angular.isFunction(action.onCancel)) {
								action.onCancel(element);
							}
						};
						$scope.doBorrar = function () {
							$scope.dialogLoading = true;

							Model.prototype$updateAttributes({
								id: element.id
							}, {
								state: false
							}).$promise.then(function (res) {
								if (angular.isString(action.successMessage)) {
									$toast.success(action.successMessage);
								}
								if (angular.isFunction(action.onSuccess)) {
									action.onSuccess(res);
								}
								if (s.config.model && s.config.model.name && angular.isObject(s.config.model)) {
									cargarElemento();
								} else if (angular.isObject(s.config.model) && angular.isFunction(s.config.model.get)) {
									cargarFunction(s.filter.skip, s.filter.limit);
								}
							}).catch(function (err) {

								if (angular.isFunction(action.onError)) {
									action.onError(err);
								}
								if (angular.isString(action.errorMessage)) {
									$toast.error(action.errorMessage);
								}
							}).finally(function () {

								$scope.dialogLoading = false;
								$mdDialog.hide();
							});
						};
					}
				});
			}

			function createElements(elements) {
				s.elements = _.map(elements, function (o) {
					var el = {};
					el.__columns = angular.copy(s.columns);
					_.each(s.columns, function (col) {
						if (col.key) {
							if (col.filter && angular.isFunction(col.filter)) {
								el[col.key] = col.filter(o[col.key], o);
							} else {
								el[col.key] = o[col.key];
							}
						}
						if (col.childs) {
							el.__childs = {};
							_.each(col.childs, function (child) {
								el.__childs[col.key] = {};
								el.__childs[col.key][child.key] = col.key;
							});
						}
					});
					if (!el.id && o.id) {
						el.id = o.id;
					}
					el.__original = o;
					return el;
				});
			}

			/* Watcher */

			s.$watch('config', function (elements) {
				if (elements) {
					init();
				}
			});

			s.$watch('listar', function (elements) {
				if (elements) {
					createElements(elements);
				}
			});
		}
	};
});
'use strict';

angular.module('input-horario.directive', []).directive('inputHorario', function ($rootScope, $mdDialog, $mdPanel) {
	return {
		require: 'ngModel',
		transclude: true,
		templateUrl: 'app/core/directives/input-horario/input-horario.html',
		scope: true,
		link: function link(scope, e, a, model) {
			var panel = null;
			var input = null;
			scope.server = $rootScope.server;
			scope.diasSemana = [{ id: 0, name: 'Lunes' }, { id: 1, name: 'Martes' }, { id: 2, name: 'Miércoles' }, { id: 3, name: 'Jueves' }, { id: 4, name: 'Viernes' }, { id: 5, name: 'Sábado' }, { id: 6, name: 'Domingo' }];
			scope.horarios = [];
			scope.goDelete = goDelete;

			if (!angular.isDefined(scope.multiple)) {
				scope.multiple = true;
			}

			/* Panel Add */
			var position = $mdPanel.newPanelPosition().absolute().center();

			var config = {
				attachTo: angular.element(document.body),
				controller: NuevoHorarioDialogCtrl,
				controllerAs: 'ctrl',
				templateUrl: 'app/core/directives/input-horario/input-panel-horario.html',
				hasBackdrop: true,
				panelClass: 'input-panel-horario-container',
				position: position,
				trapFocus: true,
				zIndex: 40,
				clickOutsideToClose: false,
				escapeToClose: false,
				focusOnOpen: true
			};

			function NuevoHorarioDialogCtrl($scope) {
				var ctrl = this;
				var edit = false;
				var indexHorario = -1;
				ctrl.diasSemana = scope.diasSemana;

				ctrl.horario = {
					bloque: 0
				};

				ctrl.cancel = cancel;
				ctrl.accept = accept;

				ctrl.isInvalidForm = isInvalidForm;

				function accept() {
					if (!edit) {
						scope.horarios.push(angular.copy(ctrl.horario));
					} else {
						scope.horarios[indexHorario] = angular.copy(ctrl.horario);
					}
					ctrl.mdPanelRef.close();
					edit = false;
				}

				function cancel() {
					ctrl.mdPanelRef.close();
				}

				function isInvalidForm() {
					if (ctrl.horario.bloque < 0 || isNaN(ctrl.horario.bloque || angular.isUndefined(ctrl.horario.dia))) {
						return true;
					}
					if (!ctrl.horario.horaInicio || !ctrl.horario.horaFin) {
						return true;
					}
					return angular.isUndefined(ctrl.horario.dia);
				}

				$scope.$on('$horario.loaded', function (ev, horario) {
					edit = true;
					ctrl.horario = angular.copy(horario);
					indexHorario = _.findIndex(scope.horarios, horario);
				});

				angular.element(document).on('keyup', function (event) {
					if (event.keyCode === 27) {
						cancel();
						angular.element(document).off('keyup');
					}
				});
			}

			function goDelete($event, horario) {
				$mdDialog.show({
					targetEvent: $event,
					template: '<div>' + '<div loading="dialogLoading" message="\'Borrando...\'"></div>' + '<md-toolbar>' + '<div class="md-toolbar-tools"><h2>' + '¿Estás seguro de querer borrar este horario?' + '</h2></div>' + '</md-toolbar>' + '<md-dialog-actions>' + '  <md-button ng-click="doCancel()">Cancelar</md-button>' + '  <md-button ng-click="doRemove()" class="md-raised md-warn">Borrar</md-button>' + '</md-dialog-actions>' + '</div>',
					controller: function controller($scope) {
						$scope.dialogLoading = false;
						$scope.doCancel = doCancel;
						$scope.doRemove = doRemove;

						function doCancel() {
							$mdDialog.cancel();
						}

						function doRemove() {
							var horarioToDelete = _.findIndex(scope.horarios, horario);
							scope.horarios.splice(horarioToDelete, 1);
							$mdDialog.cancel();
						}
					}
				});
			}

			/* Watcher */
			scope.$watch('horarios', function (horarios) {
				model.$setViewValue(horarios);
			}, true);

			scope.openPanel = function ($event) {
				config.targetEvent = $event;
				scope.server = $rootScope.server;
				$mdPanel.open(config).then(function (result) {
					panel = result;
				});
			};

			scope.editHorario = function ($event, horario) {
				config.targetEvent = $event;
				scope.server = $rootScope.server;
				$mdPanel.open(config).then(function (result) {
					panel = result;
					$rootScope.$broadcast('$horario.loaded', horario);
				});
			};

			scope.duplicarHorario = function ($event, horario) {
				scope.horarios.push(angular.copy(horario));
			};

			model.$formatters.push(function (horarios) {
				if (horarios) {
					scope.horarios = angular.copy(horarios);
				}
			});
		}
	};
});
'use strict';

angular.module('input-galleryfiles.directive', []).directive('itemInputGalleryfiles', function ($rootScope) {
	return {
		replace: true,
		template: '<div class="item" ng-class="{\'active\': file.active}"><div class="img" style="background-image: url(\'{{ server.download + file.name }}\');" alt=""></div> <div class="checkbox-wrapper"> <md-icon md-font-icon="icon-checkbox-marked-circle"></md-icon> </div> <div class="erase-wrapper" > <md-icon md-font-icon="icon-trash"></md-icon> </div></div>',
		scope: {
			file: '=',
			multiple: '='
		},
		link: function link(s, e) {
			s.server = $rootScope.server;
			angular.element(e.children()[2]).on('click', function () {
				s.$evalAsync(function () {
					s.$parent.$parent.$broadcast('$itemInputGallery.active', s.file);
					s.$parent.$parent.ctrl.borrar(s.file);
				});
			});

			angular.element(e.children()[0]).on('click', function () {
				s.$evalAsync(function () {
					s.$parent.$parent.$broadcast('$itemInputGallery.active', s.file);
				});
			});
		}
	};
}).directive('inputGallery', function ($rootScope, $timeout, $mdSidenav, $mdToast, $mdPanel, $mdDialog, $stateParams) {
	return {
		require: 'ngModel',
		transclude: true,
		restrict: 'E',
		replace: true,
		templateUrl: 'app/core/directives/input-galleryfiles/input-galleryfiles.html',
		scope: {
			multiple: '='
		},
		link: function link(scope, element, attr, model) {
			var panel = null;
			var input = null;
			scope.server = $rootScope.server;
			scope.files = [];
			if (!angular.isDefined(scope.multiple)) {
				scope.multiple = true;
			}

			var position = $mdPanel.newPanelPosition().absolute().center();

			var config = {
				attachTo: angular.element(document.body),
				controller: PanelDialogCtrl,
				controllerAs: 'ctrl',
				templateUrl: 'app/core/directives/input-galleryfiles/input-panel-galleryfiles.html',
				hasBackdrop: true,
				panelClass: 'input-panel-galleryfiles-container',
				position: position,
				trapFocus: true,
				zIndex: 150,
				clickOutsideToClose: false,
				escapeToClose: false,
				focusOnOpen: true
			};

			function PanelDialogCtrl($scope, $rootScope, $toast, $timeout, $form, $server, Archivo) {
				var ctrl = this;
				// en caso de no existir files, inicializa un arreglo vacio;
				ctrl.filesSelected = scope.files ? scope.files : [];
				scope.filesTemp = angular.copy(ctrl.filesSelected);
				ctrl.uploading = false;
				ctrl.uploaded = 0;
				ctrl.multiple = scope.multiple;
				ctrl.progress = [];
				ctrl.updating = false;
				ctrl.progressTotal = 0;
				ctrl.textBuscar = '';
				ctrl.cancelPerUpload = cancelPerUpload;
				ctrl.onChangeFile = onChangeFile;
				ctrl.doUpload = doUpload;
				ctrl.tabFileSelected = tabFileSelected;

				function tabFileSelected(tabFileSelect) {
					ctrl.tabFiles = tabFileSelect;
					if (!tabFileSelect) {
						ctrl.showBuscardor = false;
					}
				}

				ctrl.borrar = borrar;
				function borrar(file) {

					var confirm = $mdDialog.confirm().title('¿Está seguro que desea eliminar esta imágen?').content('Esto hará que se desactive en la lista, pero si fue asignada a algún lugar no se perderá').ok('Aceptar').cancel('Cancelar');

					$mdDialog.show(confirm).then(function () {
						ctrl.updating = true;
						Archivo.prototype$updateAttributes({ id: file.id }, { estado: false }).$promise.then(function () {
							$mdToast.show({
								template: '<md-toast><span flex>Borrado exitoso</span></md-toast>',
								position: 'top right',
								hideDelay: 3000
							});
							updateImagenes();
						}, function () {
							$mdToast.show({
								template: '<md-toast><span flex>No se logró borrar la imágen</span></md-toast>',
								position: 'top right',
								hideDelay: 3000
							});
						}).finally(function () {
							ctrl.updating = false;
						});
					}, function () {
						ctrl.updating = false;
						updateImagenes();
					});
				};

				function markFiles() {
					if (scope.filesTemp) {
						if (ctrl.multiple) {
							ctrl.filesSelected = angular.copy(scope.filesTemp);
						} else {
							ctrl.filesSelected.push(angular.copy(scope.filesTemp));
							ctrl.filesSelected = _.uniqBy(_.flatten(ctrl.filesSelected), 'id');
						}
						_.each(ctrl.files, function (file, i) {
							if (_.findIndex(ctrl.filesSelected, { id: file.id }) >= 0) {
								ctrl.files[i].active = true;
							}
						});
					}
					console.log(ctrl.filesSelected);
				}

				function updateImagenes() {
					ctrl.updating = true;
					Archivo.find({
						filter: {
							order: 'fechaCreacion DESC',
							where: {
								isThumb: false,
								estado: true
							}
						}
					}).$promise.then(function (res) {
						ctrl.files = res;
						markFiles();
					}).catch(function () {
						$toast.error('No se lograron obtener los archivos');
					}).finally(function () {
						ctrl.updating = false;
					});
				}

				function onChangeFile(event) {
					$rootScope.$evalAsync(function () {
						if (event && event.files) {
							ctrl.filesPerUpload = event.files;
						}
					});
				}

				function cancelPerUpload() {
					input.val(null);
					ctrl.filesPerUpload = [];
				}

				function doUpload() {
					ctrl.uploading = true;
					var maxPerFile = 100 / ctrl.filesPerUpload.length;
					_.each(ctrl.filesPerUpload, function (file, i) {
						var Form = new FormData();
						Form.append('file', file);
						var uploadUrl = $server.url() + '/containers/imagenes/upload';
						if ($stateParams.id) {
							uploadUrl += '?modelId=' + encodeURIComponent($stateParams.id);
						}
						$form.send(uploadUrl, Form).then(function () {
							$scope.$evalAsync(function () {
								ctrl.uploaded += 1;
								ctrl.progress[i] = maxPerFile;
							});
						}, null, function (value) {
							ctrl.progress[i] = maxPerFile * (value.loaded / value.total);
						});
					});
				}

				$scope.$watch('ctrl.progress', function (values) {
					ctrl.progressTotal = 0;
					_.each(values, function (value) {
						ctrl.progressTotal += value;
					});
				}, true);

				$scope.$watch('ctrl.uploaded', function (value) {
					if (value > 0) {
						if (value === ctrl.filesPerUpload.length) {
							ctrl.progressTotal = 100;
							updateImagenes();
							$timeout(function () {
								ctrl.filesPerUpload = [];
								input.val(null);
								ctrl.uploaded = 0;
								ctrl.uploading = false;
								ctrl.progressTotal = 0;
								ctrl.progress = [];
							}, 2500);
						}
					}
				}, true);

				$timeout(function () {
					input = angular.element(ctrl.mdPanelRef.panelEl).find('input#input-galleryfiles-fileinput');
				});

				var toSearch = null;
				$scope.$watch('ctrl.textBuscar', function (value) {
					if (value) {
						if (toSearch) {
							$timeout.cancel(toSearch);
							ctrl.updating = false;
						}
						toSearch = $timeout(function () {
							ctrl.updating = true;
							Archivo.find({
								filter: {
									where: {
										name: {
											like: value
										},
										isThumb: false,
										estado: true
									}
								}
							}).$promise.then(function (res) {
								ctrl.files = res;
								markFiles();
							}).finally(function () {
								ctrl.updating = false;
							});
						}, 400);
					} else {
						if (toSearch) {
							$timeout.cancel(toSearch);
							ctrl.updating = false;
						}
						toSearch = $timeout(function () {
							updateImagenes();
							markFiles();
						}, 400);
					}
				});

				$scope.$on('$itemInputGallery.active', function (ev, file) {
					var i = _.findIndex(ctrl.filesSelected, { id: file.id });
					var j = _.findIndex(ctrl.files, { id: file.id });
					var active = !file.active;
					if (active) {
						if (!ctrl.multiple) {
							var actIndex = _.findIndex(ctrl.files, { active: true });
							if (actIndex >= 0) {
								ctrl.files[actIndex].active = false;
							}
							ctrl.filesSelected = [];
						}
						ctrl.filesSelected.push(angular.copy(file));
						ctrl.files[j].active = true;
					} else {
						ctrl.filesSelected.splice(i, 1);
						ctrl.files[j].active = false;
					}
					scope.filesTemp = angular.copy(ctrl.filesSelected);
				});

				ctrl.accept = accept;
				ctrl.close = close;

				function accept() {
					console.log($scope);
					var files = angular.copy(ctrl.filesSelected);
					scope.server = $rootScope.server;
					if (scope.multiple) {
						model.$setViewValue(angular.copy(files));
						scope.files = angular.copy(files);
					} else {
						model.$setViewValue(angular.copy([files[0]]));
						scope.files = angular.copy([files[0]]);
					}
					close();
				}

				function close() {
					ctrl.mdPanelRef.close();
				}

				angular.element(document).on('keyup', function (event) {
					if (event.keyCode === 27 && !ctrl.uploading) {
						close();
						angular.element(document).off('keyup');
					}
				});

				updateImagenes();
			}

			model.$formatters.push(function (files) {
				if (!scope.multiple) {
					if (files && files.length > 0) {
						scope.files = angular.copy(files);
					} else {
						scope.files = undefined;
					}
				} else {
					scope.files = angular.copy(files);
				}
			});

			scope.openPanel = function ($event) {
				config.targetEvent = $event;
				scope.server = $rootScope.server;
				$mdPanel.open(config).then(function (result) {
					panel = result;
				});
			};
			//
			// scope.$on('$itemInputGallery.accept', function (ev, files) {
			// 	scope.server = $rootScope.server;
			// 	if (scope.multiple) {
			// 		model.$setViewValue(angular.copy(files));
			// 		scope.files = angular.copy(files);
			// 	} else {
			// 		model.$setViewValue(angular.copy(files[0]));
			// 		scope.files = angular.copy(files[0]);
			// 	}
			// 	panel.close();
			// });
		}
	};
});
'use strict';

angular.module('input-gallery.directive', ['thatisuday.ng-image-gallery']).directive('itemInputGallery', function ($rootScope) {

    return {
        replace: true,
        template: '<div class="item" ng-class="{\'active\': file.active}"> <div class="img" style="background-image: url(\'{{ url }}\');" alt=""></div> <div class="checkbox-wrapper"> <md-icon md-font-icon="icon-checkbox-marked-circle"></md-icon> </div> <div class="erase-wrapper" > <md-icon md-font-icon="icon-trash"></md-icon> </div><span class="filename">{{file.name | limitTo: 20 }}</span></div>',
        scope: {
            file: '=',
            multiple: '='
        },
        controller: function controller($scope, $imagen) {
            if ($scope.file && $scope.file.origin && $scope.file.origin == 'fromCap') {
                $scope.url = $scope.file.thumbUrl;
            } else {
                $scope.url = $imagen.thumb($scope.file);
            }
        },
        link: function link(s, e) {
            s.server = $rootScope.server;
            angular.element(e.children()[2]).on('click', function () {
                s.$evalAsync(function () {
                    s.$parent.$parent.$broadcast('$itemInputGallery.active', s.file);
                    s.$parent.$parent.ctrl.borrar(s.file);
                });
            });

            angular.element(e.children()[0]).on('click', function () {
                s.$evalAsync(function () {
                    s.$parent.$parent.$broadcast('$itemInputGallery.active', s.file);
                });
            });
        }
    };
}).directive('inputGallery', function ($rootScope, $timeout, $mdSidenav, $server, $imagen, $window, $mdToast, $mdPanel, $mdDialog, $stateParams) {
    return {
        require: 'ngModel',
        transclude: true,
        restrict: 'E',
        replace: true,
        templateUrl: 'app/core/directives/input-gallery/input-gallery.html',
        scope: {
            multiple: '=',
            disabled: '=',
            modelo: '='
        },
        link: function link(scope, element, attr, model) {

            var panel = null;
            var input = null;
            scope.server = $rootScope.server;
            scope.files = [];

            /**
             * metodos galeria
             */

            scope.methods = {};
            // so you will bind openGallery method to a button on page
            // to open this gallery like ng-click="openGallery();"
            scope.openGallery = function (imgIndex) {
                $window.scrollTo(0, 0);
                console.log('open panel', imgIndex);
                // You can also open gallery model with visible image index
                // Image at that index will be shown when gallery modal opens
                scope.methods.open(imgIndex);
            };

            // Similar to above function
            scope.closeGallery = function () {
                scope.methods.close();
            };

            scope.nextImg = function () {
                scope.methods.next();
            };

            scope.prevImg = function () {
                scope.methods.prev();
            };
            /**fin metodos galeria */
            if (!angular.isDefined(scope.multiple)) {
                scope.multiple = true;
            }
            scope.download = function (file) {
                var isImage = file.ext == 'png' || file.ext == 'PNG' || file.ext == 'jpg' || file.ext == 'JPG' || file.ext == 'JPEG';
                var url = void 0;
                if (isImage) {
                    console.log('es imagen', file);
                    url = $imagen.image(file);
                } else {
                    console.log('NO ES imagen', file);
                    url = $server.download() + file.name;
                }
                console.log('llego a download', file);
                console.log('url', file);

                $window.open(url, "_blank");
            };

            scope.delete = function (file) {
                if (!scope.multiple) {
                    scope.files = [];
                    model.$setViewValue(null);
                    return;
                }

                var index = scope.files.indexOf(file);
                if (index === -1) {
                    return;
                }

                scope.files.splice(index, 1);
                model.$setViewValue(angular.copy(scope.files));
            };

            var position = $mdPanel.newPanelPosition().absolute().center();

            var config = {
                attachTo: angular.element(document.body),
                controller: PanelDialogCtrl,
                controllerAs: 'ctrl',
                templateUrl: 'app/core/directives/input-gallery/input-panel-gallery.html',
                hasBackdrop: true,
                panelClass: 'input-panel-gallery-container',
                position: position,
                trapFocus: true,
                zIndex: 150,
                clickOutsideToClose: false,
                escapeToClose: false,
                focusOnOpen: true
            };

            function PanelDialogCtrl($scope, $rootScope, $toast, $timeout, $form, $server, Archivo) {
                var ctrl = this;
                // en caso de no existir files, inicializa un arreglo vacio;
                ctrl.filesSelected = scope.files ? scope.files : [];
                scope.filesTemp = angular.copy(ctrl.filesSelected);
                ctrl.uploading = false;
                ctrl.uploaded = 0;
                ctrl.multiple = scope.multiple;
                ctrl.progress = [];
                ctrl.updating = false;
                ctrl.progressTotal = 0;
                ctrl.textBuscar = '';
                ctrl.cancelPerUpload = cancelPerUpload;
                ctrl.onChangeFile = onChangeFile;
                ctrl.doUpload = doUpload;
                ctrl.tabFileSelected = tabFileSelected;

                function tabFileSelected(tabFileSelect) {
                    ctrl.tabFiles = tabFileSelect;
                    if (!tabFileSelect) {
                        ctrl.showBuscardor = false;
                    }
                }

                ctrl.borrar = borrar;

                function borrar(file) {

                    var confirm = $mdDialog.confirm().title('¿Está seguro que desea eliminar esta imágen?').content('Esto hará que se desactive en la lista, pero si fue asignada a algún lugar no se perderá').ok('Aceptar').cancel('Cancelar');

                    $mdDialog.show(confirm).then(function () {
                        ctrl.updating = true;
                        Archivo.prototype$updateAttributes({
                            id: file.id
                        }, {
                            state: false,
                            estado: false
                        }).$promise.then(function () {
                            $mdToast.show({
                                template: '<md-toast><span flex>Borrado exitoso</span></md-toast>',
                                position: 'top right',
                                hideDelay: 3000
                            });
                            updateImagenes();
                        }, function () {
                            $mdToast.show({
                                template: '<md-toast><span flex>No se logró borrar la imágen</span></md-toast>',
                                position: 'top right',
                                hideDelay: 3000
                            });
                        }).finally(function () {
                            ctrl.updating = false;
                        });
                    }, function () {
                        ctrl.updating = false;
                        updateImagenes();
                    });
                };

                function markFiles() {
                    if (scope.filesTemp) {
                        if (ctrl.multiple) {
                            ctrl.filesSelected = angular.copy(scope.filesTemp);
                        } else {
                            ctrl.filesSelected.push(angular.copy(scope.filesTemp));
                            ctrl.filesSelected = _.uniqBy(_.flatten(ctrl.filesSelected), 'id');
                        }
                        _.each(ctrl.files, function (file, i) {
                            if (_.findIndex(ctrl.filesSelected, {
                                id: file.id
                            }) >= 0) {
                                ctrl.files[i].active = true;
                            }
                        });
                    }
                    console.log(ctrl.filesSelected);
                }

                function updateImagenes() {
                    ctrl.updating = true;
                    Archivo.find({
                        filter: {
                            order: 'created DESC',
                            where: {
                                isThumb: false,
                                estado: true,
                                zip: {
                                    neq: true
                                }
                            },
                            limit: 50
                        }
                    }).$promise.then(function (res) {
                        ctrl.files = res;
                        markFiles();
                    }).catch(function () {
                        $toast.error('No se lograron obtener los archivos');
                    }).finally(function () {
                        ctrl.updating = false;
                    });
                }

                function onChangeFile(event) {
                    $rootScope.$evalAsync(function () {
                        if (event && event.files) {
                            ctrl.filesPerUpload = event.files;
                        }
                    });
                }

                function cancelPerUpload() {
                    input.val(null);
                    ctrl.filesPerUpload = [];
                }

                function doUpload() {
                    ctrl.uploading = true;
                    var maxPerFile = 100 / ctrl.filesPerUpload.length;
                    _.each(ctrl.filesPerUpload, function (file, i) {
                        var Form = new FormData();

                        Form.append('file', file);
                        var uploadUrl = $server.url() + '/containers/imagenes/upload';
                        if ($stateParams.id) {
                            uploadUrl += '?modelId=' + encodeURIComponent($stateParams.id);
                        }
                        $form.send(uploadUrl, Form).then(function () {
                            $scope.$evalAsync(function () {
                                ctrl.uploaded += 1;
                                ctrl.progress[i] = maxPerFile;
                            });
                        }, null, function (value) {
                            ctrl.progress[i] = maxPerFile * (value.loaded / value.total);
                        });
                    });
                }

                $scope.$watch('ctrl.progress', function (values) {
                    ctrl.progressTotal = 0;
                    _.each(values, function (value) {
                        ctrl.progressTotal += value;
                    });
                }, true);

                $scope.$watch('ctrl.uploaded', function (value) {
                    if (value > 0) {
                        if (value === ctrl.filesPerUpload.length) {
                            ctrl.progressTotal = 100;
                            updateImagenes();
                            $timeout(function () {
                                ctrl.filesPerUpload = [];
                                input.val(null);
                                ctrl.uploaded = 0;
                                ctrl.uploading = false;
                                ctrl.progressTotal = 0;
                                ctrl.progress = [];
                            }, 2500);
                        }
                    }
                }, true);

                $timeout(function () {
                    input = angular.element(ctrl.mdPanelRef.panelEl).find('input#input-gallery-fileinput');
                });

                var toSearch = null;
                $scope.$watch('ctrl.textBuscar', function (value) {
                    if (value) {
                        if (toSearch) {
                            $timeout.cancel(toSearch);
                            ctrl.updating = false;
                        }
                        toSearch = $timeout(function () {
                            ctrl.updating = true;
                            Archivo.find({
                                filter: {
                                    where: {
                                        name: {
                                            like: ".*" + value + ".*", options: "igm"
                                        },
                                        isThumb: false,
                                        estado: true,
                                        zip: {
                                            neq: true
                                        }
                                    },
                                    limit: 100
                                }
                            }).$promise.then(function (res) {
                                ctrl.files = res;
                                markFiles();
                            }).finally(function () {
                                ctrl.updating = false;
                            });
                        }, 400);
                    } else {
                        if (toSearch) {
                            $timeout.cancel(toSearch);
                            ctrl.updating = false;
                        }
                        toSearch = $timeout(function () {
                            updateImagenes();
                            markFiles();
                        }, 400);
                    }
                });

                $scope.$on('$itemInputGallery.active', function (ev, file) {
                    var i = _.findIndex(ctrl.filesSelected, {
                        id: file.id
                    });
                    var j = _.findIndex(ctrl.files, {
                        id: file.id
                    });
                    var active = !file.active;
                    if (active) {
                        if (!ctrl.multiple) {
                            var actIndex = _.findIndex(ctrl.files, {
                                active: true
                            });
                            if (actIndex >= 0) {
                                ctrl.files[actIndex].active = false;
                            }
                            ctrl.filesSelected = [];
                        }
                        ctrl.filesSelected.push(angular.copy(file));
                        ctrl.files[j].active = true;
                    } else {
                        ctrl.filesSelected.splice(i, 1);
                        ctrl.files[j].active = false;
                    }
                    scope.filesTemp = angular.copy(ctrl.filesSelected);
                });

                ctrl.accept = accept;
                ctrl.close = close;

                function accept() {
                    console.log($scope);
                    var files = angular.copy(ctrl.filesSelected);
                    scope.server = $rootScope.server;
                    if (scope.multiple) {
                        model.$setViewValue(angular.copy(files));
                        scope.files = angular.copy(files);
                    } else {
                        model.$setViewValue(angular.copy([files[0]]));
                        scope.files = angular.copy([files[0]]);
                    }
                    close();
                }

                function close() {
                    ctrl.mdPanelRef.close();
                }

                angular.element(document).on('keyup', function (event) {
                    if (event.keyCode === 27 && !ctrl.uploading) {
                        close();
                        angular.element(document).off('keyup');
                    }
                });

                updateImagenes();
            }
            var filesGallery = [];
            model.$formatters.push(function (files) {
                if (!scope.multiple) {
                    if (files && files.length > 0) {
                        scope.files = angular.copy(files);
                    } else {
                        scope.files = undefined;
                    }
                } else {
                    scope.files = angular.copy(files);
                    _.forEach(files, function (picture, index) {
                        if (picture.ext == 'png' || picture.ext == 'PNG' || picture.ext == 'jpg' || picture.ext == 'JPG' || picture.ext == 'JPEG' || picture.ext == 'jpeg') {
                            var newPic = {
                                id: index,
                                title: picture.name,
                                alt: picture.name,
                                url: 'https://files.alquimio.cloud/imagenes/' + picture.name,
                                thumbUrl: 'https://files.alquimio.cloud/imagenes/thumb-' + picture.name
                            };
                            filesGallery.push(newPic);
                        }
                    });
                    scope.filesGallery = filesGallery;
                }
            });

            scope.openPanel = function ($event) {
                config.targetEvent = $event;
                scope.server = $rootScope.server;
                $mdPanel.open(config).then(function (result) {
                    panel = result;
                });
            };
            //
            // scope.$on('$itemInputGallery.accept', function (ev, files) {
            // 	scope.server = $rootScope.server;
            // 	if (scope.multiple) {
            // 		model.$setViewValue(angular.copy(files));
            // 		scope.files = angular.copy(files);
            // 	} else {
            // 		model.$setViewValue(angular.copy(files[0]));
            // 		scope.files = angular.copy(files[0]);
            // 	}
            // 	panel.close();
            // });
        }
    };
});
'use strict';

angular.module('input-date.directive', []).config(function ($mdpDatePickerProvider) {
	$mdpDatePickerProvider.setDisplayFormat('ddd, DD MMMM');
	$mdpDatePickerProvider.setOKButtonLabel('Aceptar');
	$mdpDatePickerProvider.setCancelButtonLabel('Cancelar');
}).directive('inputDate', function ($filter, $mdpDatePicker) {
	return {
		require: 'ngModel',
		replace: true,
		templateUrl: 'app/core/directives/input-date/input-date.html',
		scope: {
			placeholder: '@',
			initialDate: '=',
			maxDate: '=',
			minDate: '=',
			format: '@'
		},
		link: function link(s, e, a, ctrl) {
			s.onFocus = onFocus;
			function abrirCalendario() {
				var initialDate = new Date();
				if (ctrl.$modelValue) {
					initialDate = new Date(ctrl.$modelValue);
				} else if (ctrl.$viewValue) {
					initialDate = new Date(ctrl.$viewValue);
				} else if (s.initialDate) {
					initialDate = new Date(s.initialDate);
				}
				$mdpDatePicker(initialDate, {
					maxDate: s.maxDate,
					minDate: s.minDate
				}).then(function (selectedDate) {
					ctrl.$setViewValue(new Date(selectedDate));
					s.$evalAsync(function () {
						s.fechaFormateada = moment(new Date(selectedDate)).format(s.format || 'DD-MM-YYYY');
					});
				});
			}

			function onFocus() {
				abrirCalendario();
			}

			ctrl.$formatters.push(function (value) {
				if (value) {
					s.fechaFormateada = moment(new Date(value)).format(s.format || 'DD-MM-YYYY');
				}
			});
		}
	};
});
'use strict';

angular.module('input-autocomplete.directive', []).directive('inputAutocomplete', function ($q, $injector) {
	return {
		require: 'ngModel',
		templateUrl: 'app/core/directives/input-autocomplete/input-autocomplete.html',
		replace: true,
		scope: {
			fieldToSearch: '@',
			fieldToShow: '@',
			label: '@',
			model: '@',
			method: '@',
			filter: '=inputAutocomplete'
		},
		link: function link(s, e, a, model) {
			var Model = $injector.get(s.model);
			s.selectItem = null;
			s.searchText = null;
			s.required = angular.isDefined(a.required);
			s.querySearch = querySearch;
			s.selectedItem = selectedItem;
			s.showFounded = showFounded;

			model.$formatters.push(function (item) {
				if (item && item[s.fieldToShow]) {
					s.selectItem = item;
				}
			});

			function showFounded(item) {
				return item[s.fieldToShow];
			}

			function selectedItem(item) {
				model.$setViewValue(item);
			}

			function sanitizeQuery(query) {
				if (angular.isString(query)) {
					query = query.replace(/a/g, '[aáäà]');
					query = query.replace(/e/g, '[eéëè]');
					query = query.replace(/i/g, '[iíïì]');
					query = query.replace(/o/g, '[oóöò]');
					query = query.replace(/u/g, '[uúüò]');
				}
				return query;
			}

			function buildWhere(query) {
				var where = {
					state: true
				};
				where[s.fieldToSearch] = {
					like: '.*' + query + '.*',
					options: 'igm'
				};
				return where;
			}

			function querySearch(query) {
				var deferred = $q.defer();
				var q = sanitizeQuery(query);
				var filter = _.merge({}, {
					limit: 10,
					where: buildWhere(q)
				}, s.filter);
				Model[s.method || 'find']({
					filter: filter
				}).$promise.then(function (res) {
					deferred.resolve(res);
				}).catch(function (err) {
					deferred.reject(err);
				});
				return deferred.promise;
			}
		}
	};
});
'use strict';

angular.module('input-address.directive', []).directive('inputAddress', function ($toast, $mdPanel) {
	return {
		require: 'ngModel',
		replace: true,
		templateUrl: 'app/core/directives/input-address/input-address.html',
		scope: {
			placeholder: '@'
		},
		link: function link(scope, e, a, model) {
			scope.required = angular.isDefined(a.required);
			var panel = null;
			var position = $mdPanel.newPanelPosition().absolute().center();

			var config = {
				attachTo: angular.element(document.body),
				controller: PanelDialogCtrl,
				controllerAs: 'ctrl',
				templateUrl: 'app/core/directives/input-address/input-panel-address.html',
				hasBackdrop: true,
				panelClass: 'input-panel-gallery-container',
				position: position,
				trapFocus: true,
				zIndex: 150,
				clickOutsideToClose: false,
				escapeToClose: false,
				focusOnOpen: true
			};

			scope.onFocus = function () {
				scope.openPanel();
			};

			scope.openPanel = function ($event) {
				config.targetEvent = $event;

				$mdPanel.open(config).then(function (result) {
					angular.element(document).on('keyup', function (event) {
						if (event.keyCode === 27) {
							result.close();
							angular.element(document).off('keyup');
						}
					});
					panel = result;
				});
			};

			model.$formatters.push(function (m) {
				if (!scope.addressCompleted && m) {
					scope.addressCompleted = m;
					scope.address = m.address;
				}
			});

			function PanelDialogCtrl($q, $scope, $timeout, $interval) {
				var ctrl = this;
				var map = void 0,
				    geocoder = void 0,
				    marker = void 0;
				$timeout(function () {
					map = new google.maps.Map(document.getElementById('map-address'), {
						center: { lat: -34.397, lng: 150.644 },
						zoom: 8
					});
					geocoder = new google.maps.Geocoder();
					if (scope.addressCompleted) {
						ctrl.uploading = true;
						if (!scope.addressCompleted.coords) {
							geocodeAddress(scope.addressCompleted.address).then(function (results) {
								map.setCenter(results[0].geometry.location);
								map.setZoom(14);
								setAddress();
								$timeout(function () {
									google.maps.event.trigger(map, 'resize');
									ctrl.updating = false;
								});
							});
						} else if (!scope.addressCompleted.address) {
							geocodePosition(scope.addressCompleted.coords).then(function (results) {
								map.setCenter(results[0].geometry.location);
								map.setZoom(14);
								setAddress();
								$timeout(function () {
									google.maps.event.trigger(map, 'resize');
									ctrl.updating = false;
								});
							});
						} else {
							ctrl.address = scope.addressCompleted.address;
							createMarker(scope.addressCompleted.coords).then(function () {
								$timeout(function () {
									map.setCenter(scope.addressCompleted.coords);
									map.setZoom(14);
									setAddress();
									ctrl.updating = false;
								}, 1500);
							});
						}
					}
				});

				$interval(function () {
					if (map) {
						google.maps.event.trigger(map, 'resize');
					}
				}, 1000);

				ctrl.accept = accept;
				ctrl.close = close;
				ctrl.doBuscarDireccion = doBuscarDireccion;

				function setAddress() {
					$scope.$evalAsync(function () {
						var position = marker.getPosition();
						ctrl.addressCompleted = {
							address: angular.copy(ctrl.address),
							coords: {
								lat: position.lat(),
								lng: position.lng()
							}
						};
					});
				}

				function positionChangeMarker() {
					$scope.$evalAsync(function () {
						ctrl.updating = true;
						geocoder.geocode({ 'location': marker.getPosition() }, function (results, status) {
							if (status == google.maps.GeocoderStatus.OK) {
								ctrl.address = results[0].formatted_address;
								setAddress();
								ctrl.updating = false;
							} else {
								ctrl.updating = false;
							}
						});
					});
				}

				function geocodePosition(position) {
					var defer = $q.defer();
					$scope.$evalAsync(function () {
						geocoder.geocode({ 'location': position }, function (results, status) {
							if (status == google.maps.GeocoderStatus.OK) {
								ctrl.address = results[0].formatted_address;
								createMarker(results[0].geometry.location);
								setAddress();
								defer.resolve(results);
							} else {
								defer.reject();
								$toast.error('No se logró geolocalizar la dirección');
							}
						});
					});
					return defer.promise;
				}

				function geocodeAddress(address) {
					var defer = $q.defer();
					$scope.$evalAsync(function () {
						ctrl.address = address;
						geocoder.geocode({ 'address': address }, function (results, status) {
							if (status == google.maps.GeocoderStatus.OK) {
								createMarker(results[0].geometry.location);
								defer.resolve(results);
							} else {
								defer.reject();
								$toast.error('No se logró geolocalizar la dirección');
							}
						});
					});
					return defer.promise;
				}

				function createMarker(position) {
					var defer = $q.defer();
					if (marker) {
						marker.setPosition(position);
						defer.resolve();
					} else {
						marker = new google.maps.Marker({
							map: map,
							draggable: true,
							position: position
						});
						marker.addListener('dragend', positionChangeMarker);
						google.maps.event.trigger(map, 'resize');
						defer.resolve();
					}
					return defer.promise;
				}

				function doBuscarDireccion() {
					$scope.$evalAsync(function () {
						ctrl.updating = true;
						geocodeAddress(ctrl.address).then(function (results) {
							map.setCenter(results[0].geometry.location);
							map.setZoom(14);
							setAddress();
							$timeout(function () {
								google.maps.event.trigger(map, 'resize');
								ctrl.updating = false;
							});
						});
					});
				}

				function accept() {
					model.$setViewValue(angular.copy(ctrl.addressCompleted));
					scope.addressCompleted = angular.copy(ctrl.addressCompleted);
					panel.close();
				}

				function close() {
					panel.close();
				}
			}
		}
	};
});
'use strict';

(function () {
    'use strict';

    angular.module('app.hp-connect', []).run(registerHpConnectMenu);

    var ALLOWED_PROFILES = ['GOD', 'HP'];
    var ALLOWED_PROFILE_IDS = ['5886639e743689fcae289441', '5a952f584669ff09e8ebe4fa'];
    var MENU_ITEM_PATH = 'hp-connect';
    var STATIC_CONTENT_KEY = 'hp_connect_dropbox_url';

    function normalize(v) {
        return typeof v === 'string' ? v.trim().toUpperCase() : '';
    }

    function matchesProfileId(v) {
        if (typeof v !== 'string') return false;
        return ALLOWED_PROFILE_IDS.indexOf(v.trim().toLowerCase()) >= 0;
    }

    /** @ngInject */
    function registerHpConnectMenu($rootScope, $auth, StaticContent, msNavigationService, $log) {
        var itemRegistered = false;

        function hasAllowedProfile() {
            if (!($auth.isLogued && $auth.isLogued())) return false;
            var u = $auth.user();
            if (!u) return false;

            if (ALLOWED_PROFILES.indexOf(normalize(u.profile)) >= 0) return true;
            if (ALLOWED_PROFILES.indexOf(normalize(u.profileId)) >= 0) return true;
            if (matchesProfileId(u.profileId)) return true;

            if (u.profiles && u.profiles.length) {
                for (var i = 0; i < u.profiles.length; i++) {
                    var p = u.profiles[i] || {};
                    var id = normalize(p.identifier || p.name || p.code);
                    if (ALLOWED_PROFILES.indexOf(id) >= 0) return true;
                    if (matchesProfileId(p.id || p._id)) return true;
                }
            }

            $log.warn('[hp-connect] user sin perfil permitido, objeto user:', u);
            return false;
        }

        function evaluateAndSync() {
            var allowed = hasAllowedProfile();
            $log.debug('[hp-connect] evaluate -> allowed=' + allowed + ' registered=' + itemRegistered);

            if (!allowed) {
                if (itemRegistered) {
                    msNavigationService.deleteItem(MENU_ITEM_PATH);
                    itemRegistered = false;
                }
                return;
            }

            if (itemRegistered) return;

            StaticContent.byKey({ key: STATIC_CONTENT_KEY }).$promise.then(function (doc) {
                var url = doc && doc.value && doc.value.url;
                if (!url) {
                    $log.warn('[hp-connect] doc sin url', doc);
                    return;
                }

                msNavigationService.saveItem(MENU_ITEM_PATH, {
                    title: 'Altas Retail - Fichas Técnicas',
                    icon: 'icon-cloud-download',
                    href: url,
                    target: '_blank',
                    weight: 15
                });
                itemRegistered = true;
                $log.debug('[hp-connect] item registrado, refrescando nav');
                $rootScope.$emit('$auth.user');
            }).catch(function (err) {
                $log.warn('[hp-connect] No se pudo cargar ' + STATIC_CONTENT_KEY, err);
            });
        }

        evaluateAndSync();
        $rootScope.$on('$auth.user', evaluateAndSync);
    }
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.auth', ['app.auth.login']);
})();
'use strict';

// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function (window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }
  // need to use the urlBase as the base to handle multiple
  // loopback servers behind a proxy/gateway where the host
  // would be the same.
  var urlBaseHost = getHost(urlBase) ? urlBase : location.host;

  /**
   * @ngdoc overview
   * @name lbServices
   * @module
   * @description
   *
   * The `lbServices` module provides services for interacting with
   * the models exposed by the LoopBack server via the REST API.
   *
   */
  var module = angular.module("lbServices", ['ngResource']);

  /**
   * @ngdoc object
   * @name lbServices.User
   * @header lbServices.User
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `User` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("User", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/user/:id", { 'id': '@id' }, {

      /**
       * @ngdoc method
       * @name lbServices.User#prototype$__findById__accessTokens
       * @methodOf lbServices.User
       *
       * @description
       *
       * Find a related item by id for accessTokens.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - user id
       *
       *  - `options` – `{object=}` -
       *
       *  - `fk` – `{*}` - Foreign key for accessTokens
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "prototype$__findById__accessTokens": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/accessTokens/:fk",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#prototype$__destroyById__accessTokens
       * @methodOf lbServices.User
       *
       * @description
       *
       * Delete a related item by id for accessTokens.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - user id
       *
       *  - `options` – `{object=}` -
       *
       *  - `fk` – `{*}` - Foreign key for accessTokens
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * This method returns no data.
       */
      "prototype$__destroyById__accessTokens": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/accessTokens/:fk",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#prototype$__updateById__accessTokens
       * @methodOf lbServices.User
       *
       * @description
       *
       * Update a related item by id for accessTokens.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - user id
       *
       *  - `fk` – `{*}` - Foreign key for accessTokens
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` -
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "prototype$__updateById__accessTokens": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/accessTokens/:fk",
        method: "PUT"
      },

      // INTERNAL. Use User.profiles.findById() instead.
      "prototype$__findById__profiles": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/profiles/:fk",
        method: "GET"
      },

      // INTERNAL. Use User.profiles.destroyById() instead.
      "prototype$__destroyById__profiles": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/profiles/:fk",
        method: "DELETE"
      },

      // INTERNAL. Use User.profiles.updateById() instead.
      "prototype$__updateById__profiles": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/profiles/:fk",
        method: "PUT"
      },

      // INTERNAL. Use User.profiles.link() instead.
      "prototype$__link__profiles": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/profiles/rel/:fk",
        method: "PUT"
      },

      // INTERNAL. Use User.profiles.unlink() instead.
      "prototype$__unlink__profiles": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/profiles/rel/:fk",
        method: "DELETE"
      },

      // INTERNAL. Use User.profiles.exists() instead.
      "prototype$__exists__profiles": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/profiles/rel/:fk",
        method: "HEAD"
      },

      // INTERNAL. Use User.imagen() instead.
      "prototype$__get__imagen": {
        url: urlBase + "/user/:id/imagen",
        method: "GET"
      },

      // INTERNAL. Use User.comapny() instead.
      "prototype$__get__comapny": {
        url: urlBase + "/user/:id/comapny",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#prototype$__get__accessTokens
       * @methodOf lbServices.User
       *
       * @description
       *
       * Queries accessTokens of user.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - user id
       *
       *  - `options` – `{object=}` -
       *
       *  - `filter` – `{object=}` -
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "prototype$__get__accessTokens": {
        isArray: true,
        url: urlBase + "/user/:id/accessTokens",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#prototype$__create__accessTokens
       * @methodOf lbServices.User
       *
       * @description
       *
       * Creates a new instance in accessTokens of this model.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - user id
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` -
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "prototype$__create__accessTokens": {
        url: urlBase + "/user/:id/accessTokens",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#prototype$__delete__accessTokens
       * @methodOf lbServices.User
       *
       * @description
       *
       * Deletes all accessTokens of this model.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - user id
       *
       *  - `options` – `{object=}` -
       *
       *  - `where` – `{object=}` -
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * This method returns no data.
       */
      "prototype$__delete__accessTokens": {
        url: urlBase + "/user/:id/accessTokens",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#prototype$__count__accessTokens
       * @methodOf lbServices.User
       *
       * @description
       *
       * Counts accessTokens of user.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - user id
       *
       *  - `options` – `{object=}` -
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "prototype$__count__accessTokens": {
        url: urlBase + "/user/:id/accessTokens/count",
        method: "GET"
      },

      // INTERNAL. Use User.profiles() instead.
      "prototype$__get__profiles": {
        isArray: true,
        url: urlBase + "/user/:id/profiles",
        method: "GET"
      },

      // INTERNAL. Use User.profiles.create() instead.
      "prototype$__create__profiles": {
        url: urlBase + "/user/:id/profiles",
        method: "POST"
      },

      // INTERNAL. Use User.profiles.destroyAll() instead.
      "prototype$__delete__profiles": {
        url: urlBase + "/user/:id/profiles",
        method: "DELETE"
      },

      // INTERNAL. Use User.profiles.count() instead.
      "prototype$__count__profiles": {
        url: urlBase + "/user/:id/profiles/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#create
       * @methodOf lbServices.User
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/user",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#patchOrCreate
       * @methodOf lbServices.User
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/user",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#replaceOrCreate
       * @methodOf lbServices.User
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/user/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#upsertWithWhere
       * @methodOf lbServices.User
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/user/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#exists
       * @methodOf lbServices.User
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/user/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#findById
       * @methodOf lbServices.User
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/user/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#replaceById
       * @methodOf lbServices.User
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/user/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#find
       * @methodOf lbServices.User
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/user",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#findOne
       * @methodOf lbServices.User
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/user/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#updateAll
       * @methodOf lbServices.User
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/user/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#deleteById
       * @methodOf lbServices.User
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/user/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#count
       * @methodOf lbServices.User
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/user/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#prototype$patchAttributes
       * @methodOf lbServices.User
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - user id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/user/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#createChangeStream
       * @methodOf lbServices.User
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/user/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#login
       * @methodOf lbServices.User
       *
       * @description
       *
       * Login a user with username/email and password.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
       *   Default value: `user`.
       *
       *  - `rememberMe` - `boolean` - Whether the authentication credentials
       *     should be remembered in localStorage across app/browser restarts.
       *     Default: `true`.
       *
       * @param {Object} postData Request data.
       *
       * This method expects a subset of model properties as request parameters.
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * El cuerpo de respuesta contiene propiedades de la AccessToken creada durante el inicio de la sesión.
       * Dependiendo del valor del parámetro `include`, el cuerpo puede contener propiedades adicionales:
       *   - `user` - `U+007BUserU+007D` - Datos del usuario conectado actualmente. (`include=user`)
       *
       */
      "login": {
        params: {
          include: 'user'
        },
        interceptor: {
          response: function response(_response) {
            var accessToken = _response.data;
            LoopBackAuth.setUser(accessToken.id, accessToken.userId, accessToken.user);
            LoopBackAuth.rememberMe = _response.config.params.rememberMe !== false;
            LoopBackAuth.save();
            return _response.resource;
          }
        },
        url: urlBase + "/user/login",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#logout
       * @methodOf lbServices.User
       *
       * @description
       *
       * Logout a user with access token.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * This method returns no data.
       */
      "logout": {
        interceptor: {
          response: function response(_response2) {
            LoopBackAuth.clearUser();
            LoopBackAuth.clearStorage();
            return _response2.resource;
          },
          responseError: function responseError(_responseError) {
            LoopBackAuth.clearUser();
            LoopBackAuth.clearStorage();
            return _responseError.resource;
          }
        },
        url: urlBase + "/user/logout",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#prototype$verify
       * @methodOf lbServices.User
       *
       * @description
       *
       * Trigger user's identity verification with configured verifyOptions
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - user id
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       *  - `verifyOptions` – `{object=}` -
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * This method returns no data.
       */
      "prototype$verify": {
        url: urlBase + "/user/:id/verify",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#confirm
       * @methodOf lbServices.User
       *
       * @description
       *
       * Confirm a user registration with identity verification token.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `uid` – `{string}` -
       *
       *  - `token` – `{string}` -
       *
       *  - `redirect` – `{string=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * This method returns no data.
       */
      "confirm": {
        url: urlBase + "/user/confirm",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#resetPassword
       * @methodOf lbServices.User
       *
       * @description
       *
       * Reset password for a user with email.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       * This method expects a subset of model properties as request parameters.
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * This method returns no data.
       */
      "resetPassword": {
        url: urlBase + "/user/reset",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#changePassword
       * @methodOf lbServices.User
       *
       * @description
       *
       * Change a user's password.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `id` – `{*=}` -
       *
       *  - `oldPassword` – `{string}` -
       *
       *  - `newPassword` – `{string}` -
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * This method returns no data.
       */
      "changePassword": {
        url: urlBase + "/user/change-password",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#setPassword
       * @methodOf lbServices.User
       *
       * @description
       *
       * Reset user's password via a password-reset token.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `id` – `{*=}` -
       *
       *  - `newPassword` – `{string}` -
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * This method returns no data.
       */
      "setPassword": {
        url: urlBase + "/user/reset-password",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#me
       * @methodOf lbServices.User
       *
       * @description
       *
       * Entrega la información del usuario actualmente logeado en el sisitema
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `req` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `access_token` – `{object=}` -
       *
       *  - `me` – `{object=}` -
       */
      "me": {
        url: urlBase + "/user/me",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#refreshToken
       * @methodOf lbServices.User
       *
       * @description
       *
       * Genera nuevo token a partir de un token ya expirado
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `token` – `{string}` - Token a revalidar
       *
       *  - `ttl` – `{number=}` - TTL del nuevo token solicitado
       *
       *  - `req` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `access_token` – `{object=}` -
       */
      "refreshToken": {
        url: urlBase + "/user/refreshToken",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#createMany
       * @methodOf lbServices.User
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `User` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/user",
        method: "POST"
      },

      // INTERNAL. Use Profile.user() instead.
      "::get::Profile::user": {
        url: urlBase + "/profiles/:id/user",
        method: "GET"
      },

      // INTERNAL. Use Profile.users.findById() instead.
      "::findById::Profile::users": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/profiles/:id/users/:fk",
        method: "GET"
      },

      // INTERNAL. Use Profile.users.destroyById() instead.
      "::destroyById::Profile::users": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/profiles/:id/users/:fk",
        method: "DELETE"
      },

      // INTERNAL. Use Profile.users.updateById() instead.
      "::updateById::Profile::users": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/profiles/:id/users/:fk",
        method: "PUT"
      },

      // INTERNAL. Use Profile.users.link() instead.
      "::link::Profile::users": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/profiles/:id/users/rel/:fk",
        method: "PUT"
      },

      // INTERNAL. Use Profile.users.unlink() instead.
      "::unlink::Profile::users": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/profiles/:id/users/rel/:fk",
        method: "DELETE"
      },

      // INTERNAL. Use Profile.users.exists() instead.
      "::exists::Profile::users": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/profiles/:id/users/rel/:fk",
        method: "HEAD"
      },

      // INTERNAL. Use Profile.users() instead.
      "::get::Profile::users": {
        isArray: true,
        url: urlBase + "/profiles/:id/users",
        method: "GET"
      },

      // INTERNAL. Use Profile.users.create() instead.
      "::create::Profile::users": {
        url: urlBase + "/profiles/:id/users",
        method: "POST"
      },

      // INTERNAL. Use Profile.users.createMany() instead.
      "::createMany::Profile::users": {
        isArray: true,
        url: urlBase + "/profiles/:id/users",
        method: "POST"
      },

      // INTERNAL. Use Profile.users.destroyAll() instead.
      "::delete::Profile::users": {
        url: urlBase + "/profiles/:id/users",
        method: "DELETE"
      },

      // INTERNAL. Use Profile.users.count() instead.
      "::count::Profile::users": {
        url: urlBase + "/profiles/:id/users/count",
        method: "GET"
      },

      // INTERNAL. Use UserProfile.user() instead.
      "::get::UserProfile::user": {
        url: urlBase + "/userProfiles/:id/user",
        method: "GET"
      },

      // INTERNAL. Use Log.user() instead.
      "::get::Log::user": {
        url: urlBase + "/logs/:id/user",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.User#getCurrent
       * @methodOf lbServices.User
       *
       * @description
       *
       * Get data of the currently logged user. Fail with HTTP result 401
       * when there is no user logged in.
       *
       * @param {function(Object,Object)=} successCb
       *    Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *    `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       */
      'getCurrent': {
        url: urlBase + "/user" + '/:id',
        method: 'GET',
        params: {
          id: function id() {
            var id = LoopBackAuth.currentUserId;
            if (id == null) id = '__anonymous__';
            return id;
          }
        },
        interceptor: {
          response: function response(_response3) {
            LoopBackAuth.currentUserData = _response3.data;
            return _response3.resource;
          },
          responseError: function responseError(_responseError2) {
            LoopBackAuth.clearUser();
            LoopBackAuth.clearStorage();
            return $q.reject(_responseError2);
          }
        },
        __isGetCurrentUser__: true
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.User#upsert
     * @methodOf lbServices.User
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.User#updateOrCreate
     * @methodOf lbServices.User
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.User#patchOrCreateWithWhere
     * @methodOf lbServices.User
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.User#update
     * @methodOf lbServices.User
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.User#destroyById
     * @methodOf lbServices.User
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.User#removeById
     * @methodOf lbServices.User
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.User#prototype$updateAttributes
     * @methodOf lbServices.User
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
     * @ngdoc method
     * @name lbServices.User#getCachedCurrent
     * @methodOf lbServices.User
     *
     * @description
     *
     * Get data of the currently logged user that was returned by the last
     * call to {@link lbServices.User#login} or
     * {@link lbServices.User#getCurrent}. Return null when there
     * is no user logged in or the data of the current user were not fetched
     * yet.
     *
     * @returns {Object} A User instance.
     */
    R.getCachedCurrent = function () {
      var data = LoopBackAuth.currentUserData;
      return data ? new R(data) : null;
    };

    /**
     * @ngdoc method
     * @name lbServices.User#isAuthenticated
     * @methodOf lbServices.User
     *
     * @returns {boolean} True if the current user is authenticated (logged in).
     */
    R.isAuthenticated = function () {
      return this.getCurrentId() != null;
    };

    /**
     * @ngdoc method
     * @name lbServices.User#getCurrentId
     * @methodOf lbServices.User
     *
     * @returns {Object} Id of the currently logged-in user or null.
     */
    R.getCurrentId = function () {
      return LoopBackAuth.currentUserId;
    };

    /**
    * @ngdoc property
    * @name lbServices.User#modelName
    * @propertyOf lbServices.User
    * @description
    * The name of the model represented by this $resource,
    * i.e. `User`.
    */
    R.modelName = "User";

    /**
     * @ngdoc object
     * @name lbServices.User.profiles
     * @header lbServices.User.profiles
     * @object
     * @description
     *
     * The object `User.profiles` groups methods
     * manipulating `Profile` instances related to `User`.
     *
     * Call {@link lbServices.User#profiles User.profiles()}
     * to query all related instances.
     */

    /**
     * @ngdoc method
     * @name lbServices.User#profiles
     * @methodOf lbServices.User
     *
     * @description
     *
     * Queries profiles of user.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     *  - `options` – `{object=}` -
     *
     *  - `filter` – `{object=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Array.<Object>,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Array.<Object>} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R.profiles = function () {
      var TargetResource = $injector.get("Profile");
      var action = TargetResource["::get::User::profiles"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.User.profiles#count
     * @methodOf lbServices.User.profiles
     *
     * @description
     *
     * Counts profiles of user.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     *  - `options` – `{object=}` -
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Data properties:
     *
     *  - `count` – `{number=}` -
     */
    R.profiles.count = function () {
      var TargetResource = $injector.get("Profile");
      var action = TargetResource["::count::User::profiles"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.User.profiles#create
     * @methodOf lbServices.User.profiles
     *
     * @description
     *
     * Creates a new instance in profiles of this model.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     * @param {Object} postData Request data.
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R.profiles.create = function () {
      var TargetResource = $injector.get("Profile");
      var action = TargetResource["::create::User::profiles"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.User.profiles#createMany
     * @methodOf lbServices.User.profiles
     *
     * @description
     *
     * Creates a new instance in profiles of this model.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     * @param {Object} postData Request data.
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Array.<Object>,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Array.<Object>} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R.profiles.createMany = function () {
      var TargetResource = $injector.get("Profile");
      var action = TargetResource["::createMany::User::profiles"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.User.profiles#destroyAll
     * @methodOf lbServices.User.profiles
     *
     * @description
     *
     * Deletes all profiles of this model.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     *  - `options` – `{object=}` -
     *
     *  - `where` – `{object=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * This method returns no data.
     */
    R.profiles.destroyAll = function () {
      var TargetResource = $injector.get("Profile");
      var action = TargetResource["::delete::User::profiles"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.User.profiles#destroyById
     * @methodOf lbServices.User.profiles
     *
     * @description
     *
     * Delete a related item by id for profiles.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     *  - `options` – `{object=}` -
     *
     *  - `fk` – `{*}` - Foreign key for profiles
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * This method returns no data.
     */
    R.profiles.destroyById = function () {
      var TargetResource = $injector.get("Profile");
      var action = TargetResource["::destroyById::User::profiles"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.User.profiles#exists
     * @methodOf lbServices.User.profiles
     *
     * @description
     *
     * Check the existence of profiles relation to an item by id.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     *  - `options` – `{object=}` -
     *
     *  - `fk` – `{*}` - Foreign key for profiles
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R.profiles.exists = function () {
      var TargetResource = $injector.get("Profile");
      var action = TargetResource["::exists::User::profiles"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.User.profiles#findById
     * @methodOf lbServices.User.profiles
     *
     * @description
     *
     * Find a related item by id for profiles.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     *  - `options` – `{object=}` -
     *
     *  - `fk` – `{*}` - Foreign key for profiles
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R.profiles.findById = function () {
      var TargetResource = $injector.get("Profile");
      var action = TargetResource["::findById::User::profiles"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.User.profiles#link
     * @methodOf lbServices.User.profiles
     *
     * @description
     *
     * Add a related item by id for profiles.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     *  - `fk` – `{*}` - Foreign key for profiles
     *
     * @param {Object} postData Request data.
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R.profiles.link = function () {
      var TargetResource = $injector.get("Profile");
      var action = TargetResource["::link::User::profiles"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.User.profiles#unlink
     * @methodOf lbServices.User.profiles
     *
     * @description
     *
     * Remove the profiles relation to an item by id.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     *  - `options` – `{object=}` -
     *
     *  - `fk` – `{*}` - Foreign key for profiles
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * This method returns no data.
     */
    R.profiles.unlink = function () {
      var TargetResource = $injector.get("Profile");
      var action = TargetResource["::unlink::User::profiles"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.User.profiles#updateById
     * @methodOf lbServices.User.profiles
     *
     * @description
     *
     * Update a related item by id for profiles.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     *  - `fk` – `{*}` - Foreign key for profiles
     *
     * @param {Object} postData Request data.
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R.profiles.updateById = function () {
      var TargetResource = $injector.get("Profile");
      var action = TargetResource["::updateById::User::profiles"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.User#imagen
     * @methodOf lbServices.User
     *
     * @description
     *
     * Fetches belongsTo relation imagen.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Archivo` object.)
     * </em>
     */
    R.imagen = function () {
      var TargetResource = $injector.get("Archivo");
      var action = TargetResource["::get::User::imagen"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.User#comapny
     * @methodOf lbServices.User
     *
     * @description
     *
     * Fetches belongsTo relation comapny.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - user id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Company` object.)
     * </em>
     */
    R.comapny = function () {
      var TargetResource = $injector.get("Company");
      var action = TargetResource["::get::User::comapny"];
      return action.apply(R, arguments);
    };

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Profile
   * @header lbServices.Profile
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Profile` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Profile", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/profiles/:id", { 'id': '@id' }, {

      // INTERNAL. Use Profile.user() instead.
      "prototype$__get__user": {
        url: urlBase + "/profiles/:id/user",
        method: "GET"
      },

      // INTERNAL. Use Profile.users.findById() instead.
      "prototype$__findById__users": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/profiles/:id/users/:fk",
        method: "GET"
      },

      // INTERNAL. Use Profile.users.destroyById() instead.
      "prototype$__destroyById__users": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/profiles/:id/users/:fk",
        method: "DELETE"
      },

      // INTERNAL. Use Profile.users.updateById() instead.
      "prototype$__updateById__users": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/profiles/:id/users/:fk",
        method: "PUT"
      },

      // INTERNAL. Use Profile.users.link() instead.
      "prototype$__link__users": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/profiles/:id/users/rel/:fk",
        method: "PUT"
      },

      // INTERNAL. Use Profile.users.unlink() instead.
      "prototype$__unlink__users": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/profiles/:id/users/rel/:fk",
        method: "DELETE"
      },

      // INTERNAL. Use Profile.users.exists() instead.
      "prototype$__exists__users": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/profiles/:id/users/rel/:fk",
        method: "HEAD"
      },

      // INTERNAL. Use Profile.users() instead.
      "prototype$__get__users": {
        isArray: true,
        url: urlBase + "/profiles/:id/users",
        method: "GET"
      },

      // INTERNAL. Use Profile.users.create() instead.
      "prototype$__create__users": {
        url: urlBase + "/profiles/:id/users",
        method: "POST"
      },

      // INTERNAL. Use Profile.users.destroyAll() instead.
      "prototype$__delete__users": {
        url: urlBase + "/profiles/:id/users",
        method: "DELETE"
      },

      // INTERNAL. Use Profile.users.count() instead.
      "prototype$__count__users": {
        url: urlBase + "/profiles/:id/users/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#create
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Profile` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/profiles",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#patchOrCreate
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Profile` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/profiles",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#replaceOrCreate
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Profile` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/profiles/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#upsertWithWhere
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Profile` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/profiles/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#exists
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/profiles/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#findById
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Profile` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/profiles/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#replaceById
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Profile` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/profiles/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#find
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Profile` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/profiles",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#findOne
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Profile` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/profiles/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#updateAll
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/profiles/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#deleteById
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Profile` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/profiles/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#count
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/profiles/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#prototype$patchAttributes
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - profile id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Profile` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/profiles/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#createChangeStream
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/profiles/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Profile#createMany
       * @methodOf lbServices.Profile
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Profile` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/profiles",
        method: "POST"
      },

      // INTERNAL. Use User.profiles.findById() instead.
      "::findById::User::profiles": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/profiles/:fk",
        method: "GET"
      },

      // INTERNAL. Use User.profiles.destroyById() instead.
      "::destroyById::User::profiles": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/profiles/:fk",
        method: "DELETE"
      },

      // INTERNAL. Use User.profiles.updateById() instead.
      "::updateById::User::profiles": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/profiles/:fk",
        method: "PUT"
      },

      // INTERNAL. Use User.profiles.link() instead.
      "::link::User::profiles": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/profiles/rel/:fk",
        method: "PUT"
      },

      // INTERNAL. Use User.profiles.unlink() instead.
      "::unlink::User::profiles": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/profiles/rel/:fk",
        method: "DELETE"
      },

      // INTERNAL. Use User.profiles.exists() instead.
      "::exists::User::profiles": {
        params: {
          'fk': '@fk'
        },
        url: urlBase + "/user/:id/profiles/rel/:fk",
        method: "HEAD"
      },

      // INTERNAL. Use User.profiles() instead.
      "::get::User::profiles": {
        isArray: true,
        url: urlBase + "/user/:id/profiles",
        method: "GET"
      },

      // INTERNAL. Use User.profiles.create() instead.
      "::create::User::profiles": {
        url: urlBase + "/user/:id/profiles",
        method: "POST"
      },

      // INTERNAL. Use User.profiles.createMany() instead.
      "::createMany::User::profiles": {
        isArray: true,
        url: urlBase + "/user/:id/profiles",
        method: "POST"
      },

      // INTERNAL. Use User.profiles.destroyAll() instead.
      "::delete::User::profiles": {
        url: urlBase + "/user/:id/profiles",
        method: "DELETE"
      },

      // INTERNAL. Use User.profiles.count() instead.
      "::count::User::profiles": {
        url: urlBase + "/user/:id/profiles/count",
        method: "GET"
      },

      // INTERNAL. Use UserProfile.profile() instead.
      "::get::UserProfile::profile": {
        url: urlBase + "/userProfiles/:id/profile",
        method: "GET"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Profile#upsert
     * @methodOf lbServices.Profile
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Profile#updateOrCreate
     * @methodOf lbServices.Profile
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Profile#patchOrCreateWithWhere
     * @methodOf lbServices.Profile
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Profile#update
     * @methodOf lbServices.Profile
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Profile#destroyById
     * @methodOf lbServices.Profile
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Profile#removeById
     * @methodOf lbServices.Profile
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Profile#prototype$updateAttributes
     * @methodOf lbServices.Profile
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Profile#modelName
    * @propertyOf lbServices.Profile
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Profile`.
    */
    R.modelName = "Profile";

    /**
     * @ngdoc method
     * @name lbServices.Profile#user
     * @methodOf lbServices.Profile
     *
     * @description
     *
     * Fetches belongsTo relation user.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R.user = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::get::Profile::user"];
      return action.apply(R, arguments);
    };
    /**
     * @ngdoc object
     * @name lbServices.Profile.users
     * @header lbServices.Profile.users
     * @object
     * @description
     *
     * The object `Profile.users` groups methods
     * manipulating `User` instances related to `Profile`.
     *
     * Call {@link lbServices.Profile#users Profile.users()}
     * to query all related instances.
     */

    /**
     * @ngdoc method
     * @name lbServices.Profile#users
     * @methodOf lbServices.Profile
     *
     * @description
     *
     * Queries users of profile.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     *  - `options` – `{object=}` -
     *
     *  - `filter` – `{object=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Array.<Object>,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Array.<Object>} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R.users = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::get::Profile::users"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Profile.users#count
     * @methodOf lbServices.Profile.users
     *
     * @description
     *
     * Counts users of profile.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     *  - `options` – `{object=}` -
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Data properties:
     *
     *  - `count` – `{number=}` -
     */
    R.users.count = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::count::Profile::users"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Profile.users#create
     * @methodOf lbServices.Profile.users
     *
     * @description
     *
     * Creates a new instance in users of this model.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     * @param {Object} postData Request data.
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R.users.create = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::create::Profile::users"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Profile.users#createMany
     * @methodOf lbServices.Profile.users
     *
     * @description
     *
     * Creates a new instance in users of this model.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     * @param {Object} postData Request data.
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Array.<Object>,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Array.<Object>} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R.users.createMany = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::createMany::Profile::users"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Profile.users#destroyAll
     * @methodOf lbServices.Profile.users
     *
     * @description
     *
     * Deletes all users of this model.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     *  - `options` – `{object=}` -
     *
     *  - `where` – `{object=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * This method returns no data.
     */
    R.users.destroyAll = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::delete::Profile::users"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Profile.users#destroyById
     * @methodOf lbServices.Profile.users
     *
     * @description
     *
     * Delete a related item by id for users.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     *  - `options` – `{object=}` -
     *
     *  - `fk` – `{*}` - Foreign key for users
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * This method returns no data.
     */
    R.users.destroyById = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::destroyById::Profile::users"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Profile.users#exists
     * @methodOf lbServices.Profile.users
     *
     * @description
     *
     * Check the existence of users relation to an item by id.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     *  - `options` – `{object=}` -
     *
     *  - `fk` – `{*}` - Foreign key for users
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R.users.exists = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::exists::Profile::users"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Profile.users#findById
     * @methodOf lbServices.Profile.users
     *
     * @description
     *
     * Find a related item by id for users.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     *  - `options` – `{object=}` -
     *
     *  - `fk` – `{*}` - Foreign key for users
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R.users.findById = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::findById::Profile::users"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Profile.users#link
     * @methodOf lbServices.Profile.users
     *
     * @description
     *
     * Add a related item by id for users.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     *  - `fk` – `{*}` - Foreign key for users
     *
     * @param {Object} postData Request data.
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R.users.link = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::link::Profile::users"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Profile.users#unlink
     * @methodOf lbServices.Profile.users
     *
     * @description
     *
     * Remove the users relation to an item by id.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     *  - `options` – `{object=}` -
     *
     *  - `fk` – `{*}` - Foreign key for users
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * This method returns no data.
     */
    R.users.unlink = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::unlink::Profile::users"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Profile.users#updateById
     * @methodOf lbServices.Profile.users
     *
     * @description
     *
     * Update a related item by id for users.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - profile id
     *
     *  - `fk` – `{*}` - Foreign key for users
     *
     * @param {Object} postData Request data.
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R.users.updateById = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::updateById::Profile::users"];
      return action.apply(R, arguments);
    };

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.UserProfile
   * @header lbServices.UserProfile
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `UserProfile` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("UserProfile", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/userProfiles/:id", { 'id': '@id' }, {

      // INTERNAL. Use UserProfile.profile() instead.
      "prototype$__get__profile": {
        url: urlBase + "/userProfiles/:id/profile",
        method: "GET"
      },

      // INTERNAL. Use UserProfile.user() instead.
      "prototype$__get__user": {
        url: urlBase + "/userProfiles/:id/user",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#create
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `UserProfile` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/userProfiles",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#patchOrCreate
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `UserProfile` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/userProfiles",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#replaceOrCreate
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `UserProfile` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/userProfiles/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#upsertWithWhere
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `UserProfile` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/userProfiles/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#exists
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/userProfiles/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#findById
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `UserProfile` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/userProfiles/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#replaceById
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `UserProfile` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/userProfiles/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#find
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `UserProfile` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/userProfiles",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#findOne
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `UserProfile` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/userProfiles/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#updateAll
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/userProfiles/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#deleteById
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `UserProfile` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/userProfiles/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#count
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/userProfiles/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#prototype$patchAttributes
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - userProfile id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `UserProfile` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/userProfiles/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#createChangeStream
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/userProfiles/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.UserProfile#createMany
       * @methodOf lbServices.UserProfile
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `UserProfile` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/userProfiles",
        method: "POST"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.UserProfile#upsert
     * @methodOf lbServices.UserProfile
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `UserProfile` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.UserProfile#updateOrCreate
     * @methodOf lbServices.UserProfile
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `UserProfile` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.UserProfile#patchOrCreateWithWhere
     * @methodOf lbServices.UserProfile
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `UserProfile` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.UserProfile#update
     * @methodOf lbServices.UserProfile
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.UserProfile#destroyById
     * @methodOf lbServices.UserProfile
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `UserProfile` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.UserProfile#removeById
     * @methodOf lbServices.UserProfile
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `UserProfile` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.UserProfile#prototype$updateAttributes
     * @methodOf lbServices.UserProfile
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - userProfile id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `UserProfile` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.UserProfile#modelName
    * @propertyOf lbServices.UserProfile
    * @description
    * The name of the model represented by this $resource,
    * i.e. `UserProfile`.
    */
    R.modelName = "UserProfile";

    /**
     * @ngdoc method
     * @name lbServices.UserProfile#profile
     * @methodOf lbServices.UserProfile
     *
     * @description
     *
     * Fetches belongsTo relation profile.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - userProfile id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Profile` object.)
     * </em>
     */
    R.profile = function () {
      var TargetResource = $injector.get("Profile");
      var action = TargetResource["::get::UserProfile::profile"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.UserProfile#user
     * @methodOf lbServices.UserProfile
     *
     * @description
     *
     * Fetches belongsTo relation user.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - userProfile id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R.user = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::get::UserProfile::user"];
      return action.apply(R, arguments);
    };

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Modelo
   * @header lbServices.Modelo
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Modelo` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Modelo", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/modelos/:id", { 'id': '@id' }, {

      // INTERNAL. Use Modelo.categoria() instead.
      "prototype$__get__categoria": {
        url: urlBase + "/modelos/:id/categoria",
        method: "GET"
      },

      // INTERNAL. Use Modelo.company() instead.
      "prototype$__get__company": {
        url: urlBase + "/modelos/:id/company",
        method: "GET"
      },

      // INTERNAL. Use Modelo.familia() instead.
      "prototype$__get__familia": {
        url: urlBase + "/modelos/:id/familia",
        method: "GET"
      },

      // INTERNAL. Use Modelo.template() instead.
      "prototype$__get__template": {
        url: urlBase + "/modelos/:id/template",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#create
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/modelos",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#patchOrCreate
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/modelos",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#replaceOrCreate
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/modelos/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#upsertWithWhere
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/modelos/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#exists
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/modelos/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#findById
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/modelos/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#replaceById
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/modelos/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#find
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/modelos",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#findOne
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/modelos/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#updateAll
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/modelos/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#deleteById
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/modelos/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#count
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/modelos/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#prototype$patchAttributes
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - modelo id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/modelos/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#createChangeStream
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/modelos/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#bySku
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `sku` – `{string=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "bySku": {
        isArray: true,
        url: urlBase + "/modelos/bySku",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#updateModels
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `res` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `` – `{undefined=}` -
       */
      "updateModels": {
        url: urlBase + "/modelos/updateModels",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#downloadPdf
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `modelId` – `{string=}` -
       *
       *  - `url` – `{string=}` -
       *
       *  - `mobile` – `{boolean=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "downloadPdf": {
        url: urlBase + "/modelos/downloadPdf",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#downloadHtml
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `modelId` – `{string=}` -
       *
       *  - `mobile` – `{boolean=}` -
       *
       *  - `showFalabella` – `{boolean=}` -
       *
       *  - `res` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `` – `{undefined=}` -
       */
      "downloadHtml": {
        url: urlBase + "/modelos/downloadHtml",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#sd
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `modelId` – `{string=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "sd": {
        url: urlBase + "/modelos/sd",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#site
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `modelId` – `{string=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "site": {
        url: urlBase + "/modelos/site",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#bypass
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "bypass": {
        url: urlBase + "/modelos/bypass",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#excel
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       * This method does not accept any data. Supply an empty object.
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `response` – `{object=}` -
       */
      "excel": {
        url: urlBase + "/modelos/excel",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#zip
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{string=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `response` – `{object=}` -
       */
      "zip": {
        url: urlBase + "/modelos/zip",
        method: "GET"
      },

      /**
       * Removes the PT localization and its indexados, or soft-deletes
       * the complete model when PT is its only safe active language.
       */
      "softDeletePortugueseLocalization": {
        url: urlBase + "/modelos/:id/soft-delete-portuguese-localization",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Modelo#createMany
       * @methodOf lbServices.Modelo
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Modelo` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/modelos",
        method: "POST"
      },

      // INTERNAL. Use Log.modelo() instead.
      "::get::Log::modelo": {
        url: urlBase + "/logs/:id/modelo",
        method: "GET"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Modelo#upsert
     * @methodOf lbServices.Modelo
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Modelo` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Modelo#updateOrCreate
     * @methodOf lbServices.Modelo
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Modelo` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Modelo#patchOrCreateWithWhere
     * @methodOf lbServices.Modelo
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Modelo` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Modelo#update
     * @methodOf lbServices.Modelo
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Modelo#destroyById
     * @methodOf lbServices.Modelo
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Modelo` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Modelo#removeById
     * @methodOf lbServices.Modelo
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Modelo` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Modelo#prototype$updateAttributes
     * @methodOf lbServices.Modelo
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - modelo id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Modelo` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Modelo#modelName
    * @propertyOf lbServices.Modelo
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Modelo`.
    */
    R.modelName = "Modelo";

    /**
     * @ngdoc method
     * @name lbServices.Modelo#categoria
     * @methodOf lbServices.Modelo
     *
     * @description
     *
     * Fetches belongsTo relation categoria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - modelo id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Categoria` object.)
     * </em>
     */
    R.categoria = function () {
      var TargetResource = $injector.get("Categoria");
      var action = TargetResource["::get::Modelo::categoria"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Modelo#company
     * @methodOf lbServices.Modelo
     *
     * @description
     *
     * Fetches belongsTo relation company.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - modelo id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Company` object.)
     * </em>
     */
    R.company = function () {
      var TargetResource = $injector.get("Company");
      var action = TargetResource["::get::Modelo::company"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Modelo#familia
     * @methodOf lbServices.Modelo
     *
     * @description
     *
     * Fetches belongsTo relation familia.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - modelo id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Familia` object.)
     * </em>
     */
    R.familia = function () {
      var TargetResource = $injector.get("Familia");
      var action = TargetResource["::get::Modelo::familia"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Modelo#template
     * @methodOf lbServices.Modelo
     *
     * @description
     *
     * Fetches belongsTo relation template.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - modelo id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Template` object.)
     * </em>
     */
    R.template = function () {
      var TargetResource = $injector.get("Template");
      var action = TargetResource["::get::Modelo::template"];
      return action.apply(R, arguments);
    };

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Archivo
   * @header lbServices.Archivo
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Archivo` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Archivo", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/archivos/:id", { 'id': '@id' }, {

      // INTERNAL. Use Archivo.comapny() instead.
      "prototype$__get__comapny": {
        url: urlBase + "/archivos/:id/comapny",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#create
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Archivo` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/archivos",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#patchOrCreate
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Archivo` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/archivos",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#replaceOrCreate
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Archivo` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/archivos/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#upsertWithWhere
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Archivo` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/archivos/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#exists
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/archivos/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#findById
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Archivo` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/archivos/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#replaceById
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Archivo` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/archivos/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#find
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Archivo` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/archivos",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#findOne
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Archivo` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/archivos/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#updateAll
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/archivos/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#deleteById
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Archivo` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/archivos/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#count
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/archivos/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#prototype$patchAttributes
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - archivo id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Archivo` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/archivos/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#createChangeStream
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/archivos/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Archivo#createMany
       * @methodOf lbServices.Archivo
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Archivo` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/archivos",
        method: "POST"
      },

      // INTERNAL. Use User.imagen() instead.
      "::get::User::imagen": {
        url: urlBase + "/user/:id/imagen",
        method: "GET"
      },

      // INTERNAL. Use Log.archivo() instead.
      "::get::Log::archivo": {
        url: urlBase + "/logs/:id/archivo",
        method: "GET"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Archivo#upsert
     * @methodOf lbServices.Archivo
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Archivo` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Archivo#updateOrCreate
     * @methodOf lbServices.Archivo
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Archivo` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Archivo#patchOrCreateWithWhere
     * @methodOf lbServices.Archivo
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Archivo` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Archivo#update
     * @methodOf lbServices.Archivo
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Archivo#destroyById
     * @methodOf lbServices.Archivo
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Archivo` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Archivo#removeById
     * @methodOf lbServices.Archivo
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Archivo` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Archivo#prototype$updateAttributes
     * @methodOf lbServices.Archivo
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - archivo id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Archivo` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Archivo#modelName
    * @propertyOf lbServices.Archivo
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Archivo`.
    */
    R.modelName = "Archivo";

    /**
     * @ngdoc method
     * @name lbServices.Archivo#comapny
     * @methodOf lbServices.Archivo
     *
     * @description
     *
     * Fetches belongsTo relation comapny.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - archivo id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Company` object.)
     * </em>
     */
    R.comapny = function () {
      var TargetResource = $injector.get("Company");
      var action = TargetResource["::get::Archivo::comapny"];
      return action.apply(R, arguments);
    };

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Container
   * @header lbServices.Container
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Container` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Container", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/containers/:id", { 'id': '@id' }, {

      /**
       * @ngdoc method
       * @name lbServices.Container#getContainers
       * @methodOf lbServices.Container
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Container` object.)
       * </em>
       */
      "getContainers": {
        isArray: true,
        url: urlBase + "/containers",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Container#createContainer
       * @methodOf lbServices.Container
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       * This method expects a subset of model properties as request parameters.
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Container` object.)
       * </em>
       */
      "createContainer": {
        url: urlBase + "/containers",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Container#getFiles
       * @methodOf lbServices.Container
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `container` – `{string}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Container` object.)
       * </em>
       */
      "getFiles": {
        isArray: true,
        url: urlBase + "/containers/:container/files",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Container#upload
       * @methodOf lbServices.Container
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `container` – `{string}` -
       *
       * @param {Object} postData Request data.
       *
       *  - `req` – `{object=}` -
       *
       *  - `res` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `result` – `{object=}` -
       */
      "upload": {
        url: urlBase + "/containers/:container/upload",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Container#download
       * @methodOf lbServices.Container
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `container` – `{string}` -
       *
       *  - `file` – `{string}` -
       *
       *  - `req` – `{object=}` -
       *
       *  - `res` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * This method returns no data.
       */
      "download": {
        url: urlBase + "/containers/:container/download/:file",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Container#sendMail
       * @methodOf lbServices.Container
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `fileId` – `{string=}` -
       *
       *  - `email` – `{string=}` -
       *
       *  - `req` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `response` – `{object=}` -
       */
      "sendMail": {
        url: urlBase + "/containers/sendMail",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Container#translate
       * @methodOf lbServices.Container
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `string` – `{string=}` -
       *
       *  - `array` – `{string=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `response` – `{object=}` -
       */
      "translate": {
        url: urlBase + "/containers/translate",
        method: "POST"
      }
    });

    /**
    * @ngdoc property
    * @name lbServices.Container#modelName
    * @propertyOf lbServices.Container
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Container`.
    */
    R.modelName = "Container";

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Categoria
   * @header lbServices.Categoria
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Categoria` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Categoria", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/categoria/:id", { 'id': '@id' }, {

      // INTERNAL. Use Categoria.comapny() instead.
      "prototype$__get__comapny": {
        url: urlBase + "/categoria/:id/comapny",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#create
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Categoria` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/categoria",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#patchOrCreate
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Categoria` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/categoria",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#replaceOrCreate
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Categoria` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/categoria/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#upsertWithWhere
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Categoria` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/categoria/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#exists
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/categoria/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#findById
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Categoria` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/categoria/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#replaceById
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Categoria` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/categoria/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#find
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Categoria` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/categoria",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#findOne
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Categoria` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/categoria/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#updateAll
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/categoria/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#deleteById
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Categoria` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/categoria/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#count
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/categoria/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#prototype$patchAttributes
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - categoria id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Categoria` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/categoria/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#createChangeStream
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/categoria/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Categoria#createMany
       * @methodOf lbServices.Categoria
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Categoria` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/categoria",
        method: "POST"
      },

      // INTERNAL. Use Modelo.categoria() instead.
      "::get::Modelo::categoria": {
        url: urlBase + "/modelos/:id/categoria",
        method: "GET"
      },

      // INTERNAL. Use Familia.categoria() instead.
      "::get::Familia::categoria": {
        url: urlBase + "/familia/:id/categoria",
        method: "GET"
      },

      // INTERNAL. Use Template.categoria() instead.
      "::get::Template::categoria": {
        url: urlBase + "/templates/:id/categoria",
        method: "GET"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Categoria#upsert
     * @methodOf lbServices.Categoria
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Categoria` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Categoria#updateOrCreate
     * @methodOf lbServices.Categoria
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Categoria` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Categoria#patchOrCreateWithWhere
     * @methodOf lbServices.Categoria
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Categoria` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Categoria#update
     * @methodOf lbServices.Categoria
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Categoria#destroyById
     * @methodOf lbServices.Categoria
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Categoria` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Categoria#removeById
     * @methodOf lbServices.Categoria
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Categoria` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Categoria#prototype$updateAttributes
     * @methodOf lbServices.Categoria
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - categoria id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Categoria` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Categoria#modelName
    * @propertyOf lbServices.Categoria
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Categoria`.
    */
    R.modelName = "Categoria";

    /**
     * @ngdoc method
     * @name lbServices.Categoria#comapny
     * @methodOf lbServices.Categoria
     *
     * @description
     *
     * Fetches belongsTo relation comapny.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - categoria id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Company` object.)
     * </em>
     */
    R.comapny = function () {
      var TargetResource = $injector.get("Company");
      var action = TargetResource["::get::Categoria::comapny"];
      return action.apply(R, arguments);
    };

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Estatico
   * @header lbServices.Estatico
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Estatico` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Estatico", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/estaticos/:id", { 'id': '@id' }, {

      /**
       * @ngdoc method
       * @name lbServices.Estatico#create
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Estatico` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/estaticos",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#patchOrCreate
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Estatico` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/estaticos",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#replaceOrCreate
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Estatico` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/estaticos/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#upsertWithWhere
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Estatico` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/estaticos/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#exists
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/estaticos/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#findById
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Estatico` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/estaticos/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#replaceById
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Estatico` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/estaticos/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#find
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Estatico` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/estaticos",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#findOne
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Estatico` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/estaticos/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#updateAll
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/estaticos/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#deleteById
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Estatico` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/estaticos/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#count
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/estaticos/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#prototype$patchAttributes
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - estatico id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Estatico` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/estaticos/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#createChangeStream
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/estaticos/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Estatico#createMany
       * @methodOf lbServices.Estatico
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Estatico` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/estaticos",
        method: "POST"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Estatico#upsert
     * @methodOf lbServices.Estatico
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Estatico` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Estatico#updateOrCreate
     * @methodOf lbServices.Estatico
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Estatico` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Estatico#patchOrCreateWithWhere
     * @methodOf lbServices.Estatico
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Estatico` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Estatico#update
     * @methodOf lbServices.Estatico
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Estatico#destroyById
     * @methodOf lbServices.Estatico
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Estatico` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Estatico#removeById
     * @methodOf lbServices.Estatico
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Estatico` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Estatico#prototype$updateAttributes
     * @methodOf lbServices.Estatico
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - estatico id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Estatico` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Estatico#modelName
    * @propertyOf lbServices.Estatico
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Estatico`.
    */
    R.modelName = "Estatico";

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Log
   * @header lbServices.Log
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Log` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Log", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/logs/:id", { 'id': '@id' }, {

      // INTERNAL. Use Log.user() instead.
      "prototype$__get__user": {
        url: urlBase + "/logs/:id/user",
        method: "GET"
      },

      // INTERNAL. Use Log.modelo() instead.
      "prototype$__get__modelo": {
        url: urlBase + "/logs/:id/modelo",
        method: "GET"
      },

      // INTERNAL. Use Log.archivo() instead.
      "prototype$__get__archivo": {
        url: urlBase + "/logs/:id/archivo",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#create
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Log` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/logs",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#patchOrCreate
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Log` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/logs",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#replaceOrCreate
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Log` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/logs/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#upsertWithWhere
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Log` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/logs/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#exists
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/logs/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#findById
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Log` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/logs/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#replaceById
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Log` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/logs/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#find
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Log` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/logs",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#findOne
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Log` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/logs/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#updateAll
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/logs/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#deleteById
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Log` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/logs/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#count
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/logs/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#prototype$patchAttributes
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - log id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Log` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/logs/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#createChangeStream
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/logs/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#excel
       * @methodOf lbServices.Log
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       * This method does not accept any data. Supply an empty object.
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `response` – `{object=}` -
       */
      "excel": {
        url: urlBase + "/logs/excel",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Log#createMany
       * @methodOf lbServices.Log
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Log` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/logs",
        method: "POST"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Log#upsert
     * @methodOf lbServices.Log
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Log` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Log#updateOrCreate
     * @methodOf lbServices.Log
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Log` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Log#patchOrCreateWithWhere
     * @methodOf lbServices.Log
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Log` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Log#update
     * @methodOf lbServices.Log
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Log#destroyById
     * @methodOf lbServices.Log
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Log` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Log#removeById
     * @methodOf lbServices.Log
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Log` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Log#prototype$updateAttributes
     * @methodOf lbServices.Log
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - log id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Log` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Log#modelName
    * @propertyOf lbServices.Log
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Log`.
    */
    R.modelName = "Log";

    /**
     * @ngdoc method
     * @name lbServices.Log#user
     * @methodOf lbServices.Log
     *
     * @description
     *
     * Fetches belongsTo relation user.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - log id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `User` object.)
     * </em>
     */
    R.user = function () {
      var TargetResource = $injector.get("User");
      var action = TargetResource["::get::Log::user"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Log#modelo
     * @methodOf lbServices.Log
     *
     * @description
     *
     * Fetches belongsTo relation modelo.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - log id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Modelo` object.)
     * </em>
     */
    R.modelo = function () {
      var TargetResource = $injector.get("Modelo");
      var action = TargetResource["::get::Log::modelo"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Log#archivo
     * @methodOf lbServices.Log
     *
     * @description
     *
     * Fetches belongsTo relation archivo.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - log id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Archivo` object.)
     * </em>
     */
    R.archivo = function () {
      var TargetResource = $injector.get("Archivo");
      var action = TargetResource["::get::Log::archivo"];
      return action.apply(R, arguments);
    };

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Company
   * @header lbServices.Company
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Company` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Company", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/companies/:id", { 'id': '@id' }, {

      /**
       * @ngdoc method
       * @name lbServices.Company#create
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Company` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/companies",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#patchOrCreate
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Company` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/companies",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#replaceOrCreate
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Company` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/companies/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#upsertWithWhere
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Company` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/companies/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#exists
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/companies/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#findById
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Company` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/companies/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#replaceById
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Company` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/companies/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#find
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Company` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/companies",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#findOne
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Company` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/companies/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#updateAll
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/companies/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#deleteById
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Company` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/companies/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#count
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/companies/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#prototype$patchAttributes
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - company id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Company` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/companies/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#createChangeStream
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/companies/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Company#createMany
       * @methodOf lbServices.Company
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Company` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/companies",
        method: "POST"
      },

      // INTERNAL. Use User.comapny() instead.
      "::get::User::comapny": {
        url: urlBase + "/user/:id/comapny",
        method: "GET"
      },

      // INTERNAL. Use Modelo.company() instead.
      "::get::Modelo::company": {
        url: urlBase + "/modelos/:id/company",
        method: "GET"
      },

      // INTERNAL. Use Archivo.comapny() instead.
      "::get::Archivo::comapny": {
        url: urlBase + "/archivos/:id/comapny",
        method: "GET"
      },

      // INTERNAL. Use Categoria.comapny() instead.
      "::get::Categoria::comapny": {
        url: urlBase + "/categoria/:id/comapny",
        method: "GET"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Company#upsert
     * @methodOf lbServices.Company
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Company` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Company#updateOrCreate
     * @methodOf lbServices.Company
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Company` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Company#patchOrCreateWithWhere
     * @methodOf lbServices.Company
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Company` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Company#update
     * @methodOf lbServices.Company
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Company#destroyById
     * @methodOf lbServices.Company
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Company` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Company#removeById
     * @methodOf lbServices.Company
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Company` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Company#prototype$updateAttributes
     * @methodOf lbServices.Company
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - company id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Company` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Company#modelName
    * @propertyOf lbServices.Company
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Company`.
    */
    R.modelName = "Company";

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Familia
   * @header lbServices.Familia
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Familia` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Familia", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/familia/:id", { 'id': '@id' }, {

      // INTERNAL. Use Familia.categoria() instead.
      "prototype$__get__categoria": {
        url: urlBase + "/familia/:id/categoria",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#create
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Familia` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/familia",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#patchOrCreate
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Familia` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/familia",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#replaceOrCreate
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Familia` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/familia/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#upsertWithWhere
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Familia` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/familia/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#exists
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/familia/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#findById
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Familia` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/familia/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#replaceById
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Familia` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/familia/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#find
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Familia` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/familia",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#findOne
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Familia` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/familia/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#updateAll
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/familia/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#deleteById
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Familia` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/familia/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#count
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/familia/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#prototype$patchAttributes
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - familia id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Familia` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/familia/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#createChangeStream
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/familia/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Familia#createMany
       * @methodOf lbServices.Familia
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Familia` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/familia",
        method: "POST"
      },

      // INTERNAL. Use Modelo.familia() instead.
      "::get::Modelo::familia": {
        url: urlBase + "/modelos/:id/familia",
        method: "GET"
      },

      // INTERNAL. Use Template.familia() instead.
      "::get::Template::familia": {
        url: urlBase + "/templates/:id/familia",
        method: "GET"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Familia#upsert
     * @methodOf lbServices.Familia
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Familia` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Familia#updateOrCreate
     * @methodOf lbServices.Familia
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Familia` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Familia#patchOrCreateWithWhere
     * @methodOf lbServices.Familia
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Familia` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Familia#update
     * @methodOf lbServices.Familia
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Familia#destroyById
     * @methodOf lbServices.Familia
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Familia` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Familia#removeById
     * @methodOf lbServices.Familia
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Familia` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Familia#prototype$updateAttributes
     * @methodOf lbServices.Familia
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - familia id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Familia` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Familia#modelName
    * @propertyOf lbServices.Familia
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Familia`.
    */
    R.modelName = "Familia";

    /**
     * @ngdoc method
     * @name lbServices.Familia#categoria
     * @methodOf lbServices.Familia
     *
     * @description
     *
     * Fetches belongsTo relation categoria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - familia id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Categoria` object.)
     * </em>
     */
    R.categoria = function () {
      var TargetResource = $injector.get("Categoria");
      var action = TargetResource["::get::Familia::categoria"];
      return action.apply(R, arguments);
    };

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Template
   * @header lbServices.Template
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Template` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Template", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/templates/:id", { 'id': '@id' }, {

      // INTERNAL. Use Template.familia() instead.
      "prototype$__get__familia": {
        url: urlBase + "/templates/:id/familia",
        method: "GET"
      },

      // INTERNAL. Use Template.categoria() instead.
      "prototype$__get__categoria": {
        url: urlBase + "/templates/:id/categoria",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#create
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Template` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/templates",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#patchOrCreate
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Template` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/templates",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#replaceOrCreate
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Template` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/templates/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#upsertWithWhere
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Template` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/templates/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#exists
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/templates/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#findById
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Template` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/templates/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#replaceById
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Template` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/templates/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#find
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Template` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/templates",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#findOne
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Template` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/templates/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#updateAll
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/templates/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#deleteById
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Template` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/templates/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#count
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/templates/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#prototype$patchAttributes
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - template id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Template` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/templates/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#createChangeStream
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/templates/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Template#createMany
       * @methodOf lbServices.Template
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Template` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/templates",
        method: "POST"
      },

      // INTERNAL. Use Modelo.template() instead.
      "::get::Modelo::template": {
        url: urlBase + "/modelos/:id/template",
        method: "GET"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Template#upsert
     * @methodOf lbServices.Template
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Template` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Template#updateOrCreate
     * @methodOf lbServices.Template
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Template` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Template#patchOrCreateWithWhere
     * @methodOf lbServices.Template
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Template` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Template#update
     * @methodOf lbServices.Template
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Template#destroyById
     * @methodOf lbServices.Template
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Template` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Template#removeById
     * @methodOf lbServices.Template
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Template` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Template#prototype$updateAttributes
     * @methodOf lbServices.Template
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - template id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Template` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Template#modelName
    * @propertyOf lbServices.Template
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Template`.
    */
    R.modelName = "Template";

    /**
     * @ngdoc method
     * @name lbServices.Template#familia
     * @methodOf lbServices.Template
     *
     * @description
     *
     * Fetches belongsTo relation familia.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - template id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Familia` object.)
     * </em>
     */
    R.familia = function () {
      var TargetResource = $injector.get("Familia");
      var action = TargetResource["::get::Template::familia"];
      return action.apply(R, arguments);
    };

    /**
     * @ngdoc method
     * @name lbServices.Template#categoria
     * @methodOf lbServices.Template
     *
     * @description
     *
     * Fetches belongsTo relation categoria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - template id
     *
     *  - `options` – `{object=}` -
     *
     *  - `refresh` – `{boolean=}` -
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Categoria` object.)
     * </em>
     */
    R.categoria = function () {
      var TargetResource = $injector.get("Categoria");
      var action = TargetResource["::get::Template::categoria"];
      return action.apply(R, arguments);
    };

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Caracteristica
   * @header lbServices.Caracteristica
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Caracteristica` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Caracteristica", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/caracteristicas/:id", { 'id': '@id' }, {

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#create
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Caracteristica` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/caracteristicas",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#patchOrCreate
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Caracteristica` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/caracteristicas",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#replaceOrCreate
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Caracteristica` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/caracteristicas/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#upsertWithWhere
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Caracteristica` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/caracteristicas/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#exists
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/caracteristicas/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#findById
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Caracteristica` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/caracteristicas/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#replaceById
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Caracteristica` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/caracteristicas/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#find
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Caracteristica` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/caracteristicas",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#findOne
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Caracteristica` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/caracteristicas/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#updateAll
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/caracteristicas/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#deleteById
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Caracteristica` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/caracteristicas/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#count
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/caracteristicas/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#prototype$patchAttributes
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - caracteristica id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Caracteristica` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/caracteristicas/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#createChangeStream
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/caracteristicas/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Caracteristica#createMany
       * @methodOf lbServices.Caracteristica
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Caracteristica` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/caracteristicas",
        method: "POST"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Caracteristica#upsert
     * @methodOf lbServices.Caracteristica
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Caracteristica` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Caracteristica#updateOrCreate
     * @methodOf lbServices.Caracteristica
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Caracteristica` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Caracteristica#patchOrCreateWithWhere
     * @methodOf lbServices.Caracteristica
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Caracteristica` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Caracteristica#update
     * @methodOf lbServices.Caracteristica
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Caracteristica#destroyById
     * @methodOf lbServices.Caracteristica
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Caracteristica` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Caracteristica#removeById
     * @methodOf lbServices.Caracteristica
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Caracteristica` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Caracteristica#prototype$updateAttributes
     * @methodOf lbServices.Caracteristica
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - caracteristica id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Caracteristica` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Caracteristica#modelName
    * @propertyOf lbServices.Caracteristica
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Caracteristica`.
    */
    R.modelName = "Caracteristica";

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Pregunta
   * @header lbServices.Pregunta
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Pregunta` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Pregunta", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/pregunta/:id", { 'id': '@id' }, {

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#create
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/pregunta",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#patchOrCreate
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/pregunta",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#replaceOrCreate
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/pregunta/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#upsertWithWhere
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/pregunta/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#exists
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/pregunta/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#findById
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/pregunta/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#replaceById
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/pregunta/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#find
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/pregunta",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#findOne
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/pregunta/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#updateAll
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/pregunta/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#deleteById
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/pregunta/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#count
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/pregunta/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#prototype$patchAttributes
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - pregunta id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/pregunta/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#createChangeStream
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/pregunta/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#makeFilters
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "makeFilters": {
        url: urlBase + "/pregunta/makeFilters",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#cleanQuestions
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "cleanQuestions": {
        isArray: true,
        url: urlBase + "/pregunta/cleanQuestions",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Pregunta#createMany
       * @methodOf lbServices.Pregunta
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Pregunta` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/pregunta",
        method: "POST"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Pregunta#upsert
     * @methodOf lbServices.Pregunta
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Pregunta` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Pregunta#updateOrCreate
     * @methodOf lbServices.Pregunta
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Pregunta` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Pregunta#patchOrCreateWithWhere
     * @methodOf lbServices.Pregunta
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Pregunta` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Pregunta#update
     * @methodOf lbServices.Pregunta
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Pregunta#destroyById
     * @methodOf lbServices.Pregunta
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Pregunta` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Pregunta#removeById
     * @methodOf lbServices.Pregunta
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Pregunta` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Pregunta#prototype$updateAttributes
     * @methodOf lbServices.Pregunta
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - pregunta id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Pregunta` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Pregunta#modelName
    * @propertyOf lbServices.Pregunta
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Pregunta`.
    */
    R.modelName = "Pregunta";

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Notebooks
   * @header lbServices.Notebooks
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Notebooks` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Notebooks", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/notebooks/:id", { 'id': '@id' }, {

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#create
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/notebooks",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#patchOrCreate
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/notebooks",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#replaceOrCreate
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/notebooks/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#upsertWithWhere
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/notebooks/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#exists
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/notebooks/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#findById
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/notebooks/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#replaceById
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/notebooks/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#find
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/notebooks",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#findOne
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/notebooks/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#updateAll
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/notebooks/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#deleteById
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/notebooks/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#count
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/notebooks/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#prototype$patchAttributes
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - notebooks id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/notebooks/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#createChangeStream
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/notebooks/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#properties
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "properties": {
        url: urlBase + "/notebooks/getProperties",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#filterModels
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `pais` – `{string=}` -
       *
       *  - `retail` – `{string=}` -
       *
       *  - `filters` – `{object=}` -
       *
       *  - `whyObj` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "filterModels": {
        url: urlBase + "/notebooks/filterModels",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Notebooks#createMany
       * @methodOf lbServices.Notebooks
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Notebooks` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/notebooks",
        method: "POST"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Notebooks#upsert
     * @methodOf lbServices.Notebooks
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Notebooks` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Notebooks#updateOrCreate
     * @methodOf lbServices.Notebooks
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Notebooks` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Notebooks#patchOrCreateWithWhere
     * @methodOf lbServices.Notebooks
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Notebooks` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Notebooks#update
     * @methodOf lbServices.Notebooks
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Notebooks#destroyById
     * @methodOf lbServices.Notebooks
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Notebooks` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Notebooks#removeById
     * @methodOf lbServices.Notebooks
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Notebooks` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Notebooks#prototype$updateAttributes
     * @methodOf lbServices.Notebooks
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - notebooks id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Notebooks` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Notebooks#modelName
    * @propertyOf lbServices.Notebooks
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Notebooks`.
    */
    R.modelName = "Notebooks";

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Retail
   * @header lbServices.Retail
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Retail` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Retail", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/retails/:id", { 'id': '@id' }, {

      /**
       * @ngdoc method
       * @name lbServices.Retail#create
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Retail` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/retails",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#patchOrCreate
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Retail` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/retails",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#replaceOrCreate
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Retail` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/retails/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#upsertWithWhere
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Retail` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/retails/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#exists
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/retails/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#findById
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Retail` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/retails/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#replaceById
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Retail` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/retails/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#find
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Retail` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/retails",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#findOne
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Retail` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/retails/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#updateAll
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/retails/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#deleteById
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Retail` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/retails/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#count
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/retails/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#prototype$patchAttributes
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - retail id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Retail` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/retails/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#createChangeStream
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/retails/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#properties
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * <em>
       * (The remote method definition does not provide any description.)
       * </em>
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Retail` object.)
       * </em>
       */
      "properties": {
        url: urlBase + "/retails/getProperties",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Retail#createMany
       * @methodOf lbServices.Retail
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Retail` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/retails",
        method: "POST"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Retail#upsert
     * @methodOf lbServices.Retail
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Retail` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Retail#updateOrCreate
     * @methodOf lbServices.Retail
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Retail` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Retail#patchOrCreateWithWhere
     * @methodOf lbServices.Retail
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Retail` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Retail#update
     * @methodOf lbServices.Retail
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Retail#destroyById
     * @methodOf lbServices.Retail
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Retail` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Retail#removeById
     * @methodOf lbServices.Retail
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Retail` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Retail#prototype$updateAttributes
     * @methodOf lbServices.Retail
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - retail id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Retail` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Retail#modelName
    * @propertyOf lbServices.Retail
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Retail`.
    */
    R.modelName = "Retail";

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Playbook
   * @header lbServices.Playbook
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Playbook` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Playbook", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/playbooks/:id", { 'id': '@id' }, {

      /**
       * @ngdoc method
       * @name lbServices.Playbook#create
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Playbook` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/playbooks",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#patchOrCreate
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Playbook` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/playbooks",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#replaceOrCreate
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Playbook` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/playbooks/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#upsertWithWhere
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Playbook` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/playbooks/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#exists
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/playbooks/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#findById
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Playbook` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/playbooks/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#replaceById
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Playbook` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/playbooks/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#find
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Playbook` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/playbooks",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#findOne
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Playbook` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/playbooks/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#updateAll
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/playbooks/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#deleteById
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Playbook` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/playbooks/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#count
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/playbooks/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#prototype$patchAttributes
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - playbook id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Playbook` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/playbooks/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#createChangeStream
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/playbooks/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Playbook#createMany
       * @methodOf lbServices.Playbook
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Playbook` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/playbooks",
        method: "POST"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Playbook#upsert
     * @methodOf lbServices.Playbook
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Playbook` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Playbook#updateOrCreate
     * @methodOf lbServices.Playbook
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Playbook` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Playbook#patchOrCreateWithWhere
     * @methodOf lbServices.Playbook
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Playbook` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Playbook#update
     * @methodOf lbServices.Playbook
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Playbook#destroyById
     * @methodOf lbServices.Playbook
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Playbook` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Playbook#removeById
     * @methodOf lbServices.Playbook
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Playbook` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Playbook#prototype$updateAttributes
     * @methodOf lbServices.Playbook
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - playbook id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Playbook` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Playbook#modelName
    * @propertyOf lbServices.Playbook
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Playbook`.
    */
    R.modelName = "Playbook";

    return R;
  }]);

  /**
   * @ngdoc object
   * @name lbServices.Producto
   * @header lbServices.Producto
   * @object
   *
   * @description
   *
   * A $resource object for interacting with the `Producto` model.
   *
   * ## Example
   *
   * See
   * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
   * for an example of using this object.
   *
   */
  module.factory("Producto", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/productos/:id", { 'id': '@id' }, {

      /**
       * @ngdoc method
       * @name lbServices.Producto#create
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Producto` object.)
       * </em>
       */
      "create": {
        url: urlBase + "/productos",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#patchOrCreate
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Patch an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Producto` object.)
       * </em>
       */
      "patchOrCreate": {
        url: urlBase + "/productos",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#replaceOrCreate
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Replace an existing model instance or insert a new one into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Producto` object.)
       * </em>
       */
      "replaceOrCreate": {
        url: urlBase + "/productos/replaceOrCreate",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#upsertWithWhere
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Update an existing model instance or insert a new one into the data source based on the where criteria.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Producto` object.)
       * </em>
       */
      "upsertWithWhere": {
        url: urlBase + "/productos/upsertWithWhere",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#exists
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Check whether a model instance exists in the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `exists` – `{boolean=}` -
       */
      "exists": {
        url: urlBase + "/productos/:id/exists",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#findById
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Find a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Producto` object.)
       * </em>
       */
      "findById": {
        url: urlBase + "/productos/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#replaceById
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Replace attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Producto` object.)
       * </em>
       */
      "replaceById": {
        url: urlBase + "/productos/:id/replace",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#find
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Find all instances of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Producto` object.)
       * </em>
       */
      "find": {
        isArray: true,
        url: urlBase + "/productos",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#findOne
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Find first instance of the model matched by filter from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Producto` object.)
       * </em>
       */
      "findOne": {
        url: urlBase + "/productos/findOne",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#updateAll
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Update instances of the model matched by {{where}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Information related to the outcome of the operation
       */
      "updateAll": {
        url: urlBase + "/productos/update",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#deleteById
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Delete a model instance by {{id}} from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - Model id
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Producto` object.)
       * </em>
       */
      "deleteById": {
        url: urlBase + "/productos/:id",
        method: "DELETE"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#count
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Count instances of the model matched by where from the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `where` – `{object=}` - Criteria to match model instances
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `count` – `{number=}` -
       */
      "count": {
        url: urlBase + "/productos/count",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#prototype$patchAttributes
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Patch attributes for a model instance and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `id` – `{*}` - producto id
       *
       *  - `options` – `{object=}` -
       *
       *  - `data` – `{object=}` - An object of model property name/value pairs
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Producto` object.)
       * </em>
       */
      "prototype$patchAttributes": {
        url: urlBase + "/productos/:id",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#createChangeStream
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Create a change stream.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Object,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * Data properties:
       *
       *  - `changes` – `{ReadableStream=}` -
       */
      "createChangeStream": {
        url: urlBase + "/productos/change-stream",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.Producto#createMany
       * @methodOf lbServices.Producto
       *
       * @description
       *
       * Create a new instance of the model and persist it into the data source.
       *
       * @param {Object=} parameters Request parameters.
       *
       *   This method does not accept any parameters.
       *   Supply an empty object or omit this argument altogether.
       *
       * @param {Object} postData Request data.
       *
       *  - `data` – `{object=}` - Model instance data
       *
       *  - `options` – `{object=}` -
       *
       * @param {function(Array.<Object>,Object)=} successCb
       *   Success callback with two arguments: `value`, `responseHeaders`.
       *
       * @param {function(Object)=} errorCb Error callback with one argument:
       *   `httpResponse`.
       *
       * @returns {Array.<Object>} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       *
       * <em>
       * (The remote method definition does not provide any description.
       * This usually means the response is a `Producto` object.)
       * </em>
       */
      "createMany": {
        isArray: true,
        url: urlBase + "/productos",
        method: "POST"
      }
    });

    /**
     * @ngdoc method
     * @name lbServices.Producto#upsert
     * @methodOf lbServices.Producto
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Producto` object.)
     * </em>
     */
    R["upsert"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Producto#updateOrCreate
     * @methodOf lbServices.Producto
     *
     * @description
     *
     * Patch an existing model instance or insert a new one into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `data` – `{object=}` - Model instance data
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Producto` object.)
     * </em>
     */
    R["updateOrCreate"] = R["patchOrCreate"];

    /**
     * @ngdoc method
     * @name lbServices.Producto#patchOrCreateWithWhere
     * @methodOf lbServices.Producto
     *
     * @description
     *
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Producto` object.)
     * </em>
     */
    R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

    /**
     * @ngdoc method
     * @name lbServices.Producto#update
     * @methodOf lbServices.Producto
     *
     * @description
     *
     * Update instances of the model matched by {{where}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `where` – `{object=}` - Criteria to match model instances
     *
     * @param {Object} postData Request data.
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * Information related to the outcome of the operation
     */
    R["update"] = R["updateAll"];

    /**
     * @ngdoc method
     * @name lbServices.Producto#destroyById
     * @methodOf lbServices.Producto
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Producto` object.)
     * </em>
     */
    R["destroyById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Producto#removeById
     * @methodOf lbServices.Producto
     *
     * @description
     *
     * Delete a model instance by {{id}} from the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - Model id
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Producto` object.)
     * </em>
     */
    R["removeById"] = R["deleteById"];

    /**
     * @ngdoc method
     * @name lbServices.Producto#prototype$updateAttributes
     * @methodOf lbServices.Producto
     *
     * @description
     *
     * Patch attributes for a model instance and persist it into the data source.
     *
     * @param {Object=} parameters Request parameters.
     *
     *  - `id` – `{*}` - producto id
     *
     *  - `options` – `{object=}` -
     *
     *  - `data` – `{object=}` - An object of model property name/value pairs
     *
     *  - `options` – `{object=}` -
     *
     * @param {function(Object,Object)=} successCb
     *   Success callback with two arguments: `value`, `responseHeaders`.
     *
     * @param {function(Object)=} errorCb Error callback with one argument:
     *   `httpResponse`.
     *
     * @returns {Object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Producto` object.)
     * </em>
     */
    R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

    /**
    * @ngdoc property
    * @name lbServices.Producto#modelName
    * @propertyOf lbServices.Producto
    * @description
    * The name of the model represented by this $resource,
    * i.e. `Producto`.
    */
    R.modelName = "Producto";

    return R;
  }]);

  /**
  * @ngdoc object
  * @name lbServices.StaticContent
  * @header lbServices.StaticContent
  * @object
  *
  * @description
  *
  * A $resource object for interacting with the `StaticContent` model.
  *
  */
  module.factory("StaticContent", ['LoopBackResource', 'LoopBackAuth', '$injector', '$q', function (LoopBackResource, LoopBackAuth, $injector, $q) {
    var R = LoopBackResource(urlBase + "/staticContents/:id", { 'id': '@id' }, {

      /**
       * @ngdoc method
       * @name lbServices.StaticContent#byKey
       * @methodOf lbServices.StaticContent
       *
       * @description
       *
       * Fetch a static content entry by its key.
       *
       * @param {Object=} parameters Request parameters.
       *
       *  - `key` – `{string}` - Static content key
       *
       * @returns {Object} An empty reference that will be
       *   populated with the actual data once the response is returned
       *   from the server.
       */
      "byKey": {
        url: urlBase + "/staticContents/byKey/:key",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.StaticContent#find
       * @methodOf lbServices.StaticContent
       */
      "find": {
        isArray: true,
        url: urlBase + "/staticContents",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.StaticContent#findById
       * @methodOf lbServices.StaticContent
       */
      "findById": {
        url: urlBase + "/staticContents/:id",
        method: "GET"
      },

      /**
       * @ngdoc method
       * @name lbServices.StaticContent#create
       * @methodOf lbServices.StaticContent
       */
      "create": {
        url: urlBase + "/staticContents",
        method: "POST"
      },

      /**
       * @ngdoc method
       * @name lbServices.StaticContent#patchOrCreate
       * @methodOf lbServices.StaticContent
       */
      "patchOrCreate": {
        url: urlBase + "/staticContents",
        method: "PATCH"
      },

      /**
       * @ngdoc method
       * @name lbServices.StaticContent#deleteById
       * @methodOf lbServices.StaticContent
       */
      "deleteById": {
        url: urlBase + "/staticContents/:id",
        method: "DELETE"
      }
    });

    R["upsert"] = R["patchOrCreate"];
    R["updateOrCreate"] = R["patchOrCreate"];
    R["destroyById"] = R["deleteById"];
    R["removeById"] = R["deleteById"];

    /**
    * @ngdoc property
    * @name lbServices.StaticContent#modelName
    * @propertyOf lbServices.StaticContent
    * @description
    * The name of the model represented by this $resource,
    * i.e. `StaticContent`.
    */
    R.modelName = "StaticContent";

    return R;
  }]);

  module.factory('LoopBackAuth', function () {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function (name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function () {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function (name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function (accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function () {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function () {
      props.forEach(function (name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  }).config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }]).factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth', function ($q, LoopBackAuth) {
    return {
      'request': function request(config) {
        // filter out external requests
        var host = getHost(config.url);
        if (host && config.url.indexOf(urlBaseHost) === -1) {
          return config;
        }

        if (LoopBackAuth.accessTokenId) {
          config.headers[authHeader] = LoopBackAuth.accessTokenId;
        } else if (config.__isGetCurrentUser__) {
          // Return a stub 401 error for User.getCurrent() when
          // there is no user logged in
          var res = {
            body: { error: { status: 401 } },
            status: 401,
            config: config,
            headers: function headers() {
              return undefined;
            }
          };
          return $q.reject(res);
        }
        return config || $q.when(config);
      }
    };
  }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function (header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function () {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function (url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function () {
      return urlBase;
    };

    this.$get = ['$resource', function ($resource) {
      var LoopBackResource = function LoopBackResource(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function (success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function () {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function () {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);
'use strict';

(function () {
    'use strict';

    angular.module('app.core').service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming) {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes: getRegisteredThemes,
            setActiveTheme: setActiveTheme,
            setThemesList: setThemesList,
            themes: {
                list: {},
                active: {
                    'name': '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes() {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes() {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName) {

            // If theme does not exist, fallback to the default theme
            if (angular.isUndefined(service.themes.list[themeName])) {
                // If there is no theme called "default"...
                if (angular.isUndefined(service.themes.list.default)) {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList) {
            service.themes.list = themeList;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes) {
        // Inject Cookies Service
        var $cookies = void 0;
        angular.injector(['ngCookies']).invoke(['$cookies', function (_$cookies) {
            $cookies = _$cookies;
        }]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if (customTheme) {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette) {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName) {
            $mdThemingProvider.theme(themeName).primaryPalette(theme.primary.name, theme.primary.hues).accentPalette(theme.accent.name, theme.accent.hues).warnPalette(theme.warn.name, theme.warn.hues).backgroundPalette(theme.background.name, theme.background.hues);
        });
    }
})();
"use strict";

(function () {
	'use strict';

	var fuseThemes = {
		default: {
			"primary": { "name": "blue-grey", "hues": { "default": "700", "hue-1": "500", "hue-2": "600", "hue-3": "400" } }, "accent": { "name": "light-blue", "hues": { "default": "600", "hue-1": "400", "hue-2": "700", "hue-3": "A100" } }, "warn": { "name": "red", "hues": { "default": "500", "hue-1": "300", "hue-2": "800", "hue-3": "A100" } }, "background": { "name": "grey", "hues": { "default": "A100", "hue-1": "A100", "hue-2": "100", "hue-3": "300" } }

		},

		'pinkTheme': {
			primary: {
				name: 'blue-grey',
				hues: {
					'default': '800',
					'hue-1': '600',
					'hue-2': '400',
					'hue-3': 'A100'
				}
			},
			accent: {
				name: 'pink',
				hues: {
					'default': '400',
					'hue-1': '300',
					'hue-2': '600',
					'hue-3': 'A100'
				}
			},
			warn: {
				name: 'blue'
			},
			background: {
				name: 'grey',
				hues: {
					'default': 'A100',
					'hue-1': 'A100',
					'hue-2': '100',
					'hue-3': '300'
				}
			}
		},
		'tealTheme': {
			primary: {
				name: 'fuse-blue',
				hues: {
					'default': '900',
					'hue-1': '600',
					'hue-2': '500',
					'hue-3': 'A100'
				}
			},
			accent: {
				name: 'teal',
				hues: {
					'default': '500',
					'hue-1': '400',
					'hue-2': '600',
					'hue-3': 'A100'
				}
			},
			warn: {
				name: 'deep-orange'
			},
			background: {
				name: 'grey',
				hues: {
					'default': 'A100',
					'hue-1': 'A100',
					'hue-2': '100',
					'hue-3': '300'
				}
			}
		}
	};

	angular.module('app.core').constant('fuseThemes', fuseThemes);
})();
'use strict';

(function () {
    'use strict';

    var fusePalettes = [{
        name: 'fuse-blue',
        options: {
            '50': '#ebf1fa',
            '100': '#c2d4ef',
            '200': '#9ab8e5',
            '300': '#78a0dc',
            '400': '#5688d3',
            '500': '#3470ca',
            '600': '#2e62b1',
            '700': '#275498',
            '800': '#21467e',
            '900': '#1a3865',
            'A100': '#c2d4ef',
            'A200': '#9ab8e5',
            'A400': '#5688d3',
            'A700': '#275498',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 A100',
            'contrastStrongLightColors': '300 400'
        }
    }, {
        name: 'fuse-paleblue',
        options: {
            '50': '#ececee',
            '100': '#c5c6cb',
            '200': '#9ea1a9',
            '300': '#7d818c',
            '400': '#5c616f',
            '500': '#3c4252',
            '600': '#353a48',
            '700': '#2d323e',
            '800': '#262933',
            '900': '#1e2129',
            'A100': '#c5c6cb',
            'A200': '#9ea1a9',
            'A400': '#5c616f',
            'A700': '#2d323e',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 A100',
            'contrastStrongLightColors': '300 400'
        }
    }];

    angular.module('app.core').constant('fusePalettes', fusePalettes);
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming) {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba: rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate() {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme) {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName) {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name': colorType.name,
                        'levels': {
                            'default': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName) {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName) {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName) {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName) {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes) {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme) {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName) {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if (selectedTheme) {
                fuseTheming.setActiveTheme(selectedTheme);
            } else {
                fuseTheming.setActiveTheme('default');
            }
        }

        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars) {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched) {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel) {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if (color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255) {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if (contrastLevel) {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if (color.length === 3) {
                return 'rgb(' + color.join(',') + ')';
            } else if (color.length === 4) {
                return 'rgba(' + color.join(',') + ')';
            } else {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel) {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if (color[0] === 255 && color[1] === 255 && color[2] === 255) {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if (color[0] === 0 && color[1] === 0 && color[2] === 0) {
                    color[3] = contrastLevels.black[contrastLevel];
                }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('MsThemeOptionsController', MsThemeOptionsController).directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming) {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [{
            label: 'Boxed',
            value: 'boxed'
        }, {
            label: 'Wide',
            value: 'wide'
        }];
        vm.layoutStyles = [{
            label: 'Vertical Navigation',
            value: 'verticalNavigation',
            figure: '/assets/images/theme-options/vertical-nav.jpg'
        }, {
            label: 'Vertical Navigation with Fullwidth Toolbar',
            value: 'verticalNavigationFullwidthToolbar',
            figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
        }, {
            label: 'Vertical Navigation with Fullwidth Toolbar 2',
            value: 'verticalNavigationFullwidthToolbar2',
            figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
        }, {
            label: 'Horizontal Navigation',
            value: 'horizontalNavigation',
            figure: '/assets/images/theme-options/horizontal-nav.jpg'
        }, {
            label: 'Content with Toolbar',
            value: 'contentWithToolbar',
            figure: '/assets/images/theme-options/content-with-toolbar.jpg'
        }, {
            label: 'Content Only',
            value: 'contentOnly',
            figure: '/assets/images/theme-options/content-only.jpg'
        }];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName) {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme() {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode() {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', vm.layoutMode === 'boxed');
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle() {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav) {
        return {
            restrict: 'E',
            scope: {},
            controller: 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile: function compile(tElement) {
                tElement.addClass('ms-theme-options');

                return function postLink(scope) {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav() {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window) {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists: exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile: isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser() {
            // If we already tested, do not test again
            if (browserInfo) {
                return browserInfo;
            }

            var browserData = [{
                string: $window.navigator.userAgent,
                subString: 'Edge',
                versionSearch: 'Edge',
                identity: 'Edge'
            }, {
                string: $window.navigator.userAgent,
                subString: 'Chrome',
                identity: 'Chrome'
            }, {
                string: $window.navigator.userAgent,
                subString: 'OmniWeb',
                versionSearch: 'OmniWeb/',
                identity: 'OmniWeb'
            }, {
                string: $window.navigator.vendor,
                subString: 'Apple',
                versionSearch: 'Version',
                identity: 'Safari'
            }, {
                prop: $window.opera,
                identity: 'Opera'
            }, {
                string: $window.navigator.vendor,
                subString: 'iCab',
                identity: 'iCab'
            }, {
                string: $window.navigator.vendor,
                subString: 'KDE',
                identity: 'Konqueror'
            }, {
                string: $window.navigator.userAgent,
                subString: 'Firefox',
                identity: 'Firefox'
            }, {
                string: $window.navigator.vendor,
                subString: 'Camino',
                identity: 'Camino'
            }, {
                string: $window.navigator.userAgent,
                subString: 'Netscape',
                identity: 'Netscape'
            }, {
                string: $window.navigator.userAgent,
                subString: 'MSIE',
                identity: 'Explorer',
                versionSearch: 'MSIE'
            }, {
                string: $window.navigator.userAgent,
                subString: 'Trident/7',
                identity: 'Explorer',
                versionSearch: 'rv'
            }, {
                string: $window.navigator.userAgent,
                subString: 'Gecko',
                identity: 'Mozilla',
                versionSearch: 'rv'
            }, {
                string: $window.navigator.userAgent,
                subString: 'Mozilla',
                identity: 'Netscape',
                versionSearch: 'Mozilla'
            }];

            var osData = [{
                string: $window.navigator.platform,
                subString: 'Win',
                identity: 'Windows'
            }, {
                string: $window.navigator.platform,
                subString: 'Mac',
                identity: 'Mac'
            }, {
                string: $window.navigator.platform,
                subString: 'Linux',
                identity: 'Linux'
            }, {
                string: $window.navigator.platform,
                subString: 'iPhone',
                identity: 'iPhone'
            }, {
                string: $window.navigator.platform,
                subString: 'iPod',
                identity: 'iPod'
            }, {
                string: $window.navigator.platform,
                subString: 'iPad',
                identity: 'iPad'
            }, {
                string: $window.navigator.platform,
                subString: 'Android',
                identity: 'Android'
            }];

            var versionSearchString = '';

            function searchString(data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) !== -1) {
                            return data[i].identity;
                        }
                    } else if (dataProp) {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString) {
                var index = dataString.indexOf(versionSearchString);

                if (index === -1) {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os: os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator() {
            var S4 = function S4() {
                return ((1 + Math.random()) * 0x10000 || 0).toString(16).substring(1);
            };
            return S4() + S4() + S4() + S4() + S4() + S4();
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile() {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array) {
            if (array.indexOf(item) === -1) {
                array.push(item);
            } else {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider() {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url) {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl() {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject() {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource) {
            if (!angular.isString(key)) {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if (!angular.isArray(resource)) {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url: baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions: resource[2] || [],
                options: resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope) {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register: register,
                resolve: resolve,
                request: request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters) {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                } else {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                    // Success
                    function (response) {
                        deferred.resolve(response);

                        // Emit an event
                        $rootScope.$broadcast('msApi::resolveSuccess');
                    },

                    // Error
                    function (response) {
                        deferred.reject(response);

                        // Emit an event
                        $rootScope.$broadcast('msApi::resolveError');
                    });
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error) {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                } else {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                    // SUCCESS
                    function (response) {
                        // Emit an event
                        $rootScope.$broadcast('msApi::requestSuccess');

                        // Resolve the promise
                        deferred.resolve(response);

                        // Call the success function if there is one
                        if (angular.isDefined(success) && angular.isFunction(success)) {
                            success(response);
                        }
                    },

                    // ERROR
                    function (response) {
                        // Emit an event
                        $rootScope.$broadcast('msApi::requestError');

                        // Reject the promise
                        deferred.reject(response);

                        // Call the error function if there is one
                        if (angular.isDefined(error) && angular.isFunction(error)) {
                            error(response);
                        }
                    });
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
'use strict';

angular.module('factories.module', ['auth.factory', 'logger.factory', 'form.factory', 'imagen.factory', 'load.factory', 'localstorage.factory', 'permission.factory', 'profile.factory', 'request.factory', 'server.provider', 'toast.factory']);
'use strict';

(function () {
    'use strict';

    angular.module('app.core').factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api) {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters) {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if (!resource || !method) {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if (!apiObject) {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            } else {
                apiObject[method](params,

                // Success
                function (response) {
                    deferred.resolve(response);
                },

                // Error
                function (response) {
                    deferred.reject(response);
                });
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource) {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for (var l = 0; l < resourceParts.length; l++) {
                if (angular.isUndefined(apiObject[resourceParts[l]])) {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if (!apiObject) {
                return false;
            }

            return apiObject;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').filter('filterByTags', filterByTags).filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags() {
        return function (items, tags) {
            if (items.length === 0 || tags.length === 0) {
                return items;
            }

            var filtered = [];

            items.forEach(function (item) {
                var match = tags.every(function (tag) {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag) {
                        if (itemTag.name === tag.name) {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if (match) {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags() {
        return function (itemTags, tags) {
            if (itemTags.length === 0 || tags.length === 0) {
                return;
            }

            if (itemTags.length < tags.length) {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag) {
                var tagExists = false;

                itemTags.forEach(function (itemTag) {
                    if (itemTag.name === tag.name) {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if (match) {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds() {
        return function (items, parameter, ids) {
            if (items.length === 0 || !ids || ids.length === 0) {
                return items;
            }

            var filtered = [];

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var match = false;

                for (var j = 0; j < ids.length; j++) {
                    var id = ids[j];
                    if (item[parameter].indexOf(id) > -1) {
                        match = true;
                        break;
                    }
                }

                if (match) {
                    filtered.push(item);
                }
            }

            return filtered;
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds() {
        return function (items, ids) {

            if (items.length === 0 || !ids) {
                return items;
            }

            if (ids.length === 0) {
                return [];
            }

            var filtered = [];

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var match = false;

                for (var j = 0; j < ids.length; j++) {
                    var id = ids[j];
                    if (item.id === id) {
                        match = true;
                        break;
                    }
                }

                if (match) {
                    filtered.push(item);
                }
            }

            return filtered;
        };
    }
})();
'use strict';

angular.module('filter.module', ['money.filter', 'age.filter', 'fecha.filter', 'time.filter']);
'use strict';

(function () {
    'use strict';

    angular.module('app.core').filter('toTrusted', toTrustedFilter).filter('htmlToPlaintext', htmlToPlainTextFilter).filter('nospace', nospaceFilter).filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter() {
        return function (text) {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter() {
        return function (value) {
            return !value ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter() {
        return function (doc) {
            if (!doc) {
                return;
            }
            if (doc.type === 'directive') {
                return doc.name.replace(/([A-Z])/g, function ($1) {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').filter('altDate', altDate);

    /** @ngInject */
    function altDate() {
        return function (value) {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if (diff < 60 * 60 * 1000) {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if (diff < 60 * 60 * 24 * 1000) {
                    return moment(value).format('HH:mm');
                }
                /*
                 * If in week
                 * e.g "Tuesday"
                 */
                else if (diff < 60 * 60 * 24 * 7 * 1000) {
                        return moment(value).format('dddd');
                    }
                    /*
                     * If more than a week
                     * e.g. 03/29/2016
                     */
                    else {
                            return moment(value).calendar();
                        }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile: function compile(element, attr) {
                var code = void 0;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element('<pre><code class="highlight" ng-non-bindable></code></pre>');
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line.replace(startingWhitespaceRegex, '').replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value.replace(/=<span class="hljs-value">""<\/span>/gi, '').replace('<head>', '').replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
'use strict';

angular.module('directives.module', ['loading.directive', 'input-gallery.directive', 'table.directive', 'input-address.directive', 'input-autocomplete.directive', 'input-horario.directive', 'input-date.directive', 'map.directive', 'listar.directive', 'replace.directive']);
'use strict';

angular.module('decorator.module', []);
'use strict';

angular.module('decorator.module').config(function ($httpProvider) {

	$httpProvider.interceptors.push(['$injector', '$q', '$localStorage', function ($injector, $q, $localStorage) {
		return {
			'request': function request(config) {
				config.url = config.url.replace('http://{{baseurl}}/api', $localStorage.getItem('server.api', 'http://0.0.0.0:3005/api'));
				return config || $q.when(config);
			}
		};
	}]);
});
'use strict';

angular.module('decorator.module').config(function ($httpProvider) {
	$httpProvider.interceptors.push(['$injector', '$q', '$log', function ($injector, $q, $log) {
		return {
			'responseError': function responseError(rejection) {
				var error = 'API UNKNOWN';
				var status = [500, 401, -1];
				rejection.handled = false;
				if (status.indexOf(rejection.status) >= 0) {
					rejection.handled = true;
					if (rejection.status === 500) {
						error = 'API_500';
						$log.error('Error de servidor', ' El servidor no entrega una respuesta (' + error + ' ' + rejection.statusText + ')');
					}
					if (rejection.status === -1) {
						error = 'API_CONNECTION_REFUSED';
						$log.error('Error de servidor', ' Conexión rechazada (' + error + ' ' + rejection.statusText + ')');
					}
					if (rejection.status === 401 && rejection.config.url.indexOf('/user/login') < 0) {
						var defer = $q.defer();
						var $auth = $injector.get('$auth');
						$log.debug(rejection);
						if ($auth.isLogued() && !rejection.config.resended) {
							$log.debug('Renovando TOKEN, 401');
							rejection.config.resended = true;
							$auth.refreshToken().then(function () {
								var LoopBackAuth = $injector.get('LoopBackAuth');
								rejection.config.headers['X-Access-Token'] = LoopBackAuth.accessTokenId;
								$injector.get('$http')(rejection.config).then(function (resp) {
									defer.resolve(resp);
								}, function (err) {
									defer.reject(err);
								});
							}).catch(function (err) {
								defer.reject(err);
							});

							return defer.promise;
						}
					} else {
						rejection.handled = false;
					}
				}
				return $q.reject(rejection);
			}
		};
	}]);
});
'use strict';

(function () {
    'use strict';

    angular.module('app.core').provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider() {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars': false,
            'disableMdInkRippleOnMobile': true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration) {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function () {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName) {
                if (angular.isUndefined(fuseConfiguration[configName])) {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue) {
                fuseConfiguration[configName] = configValue;
            }
        };
    }
})();
'use strict';

angular.module('pages.module', ['app.auth',

//'app.vehiculos',
//'app.reportes',
//'app.conductores',
// 'app.perfiles',
'app.modelos', 'app.logs', 'app.usuario', 'app.categoria', 'app.familia', 'app.estatico', 'app.file-manager', 'app.template', 'app.playbooks', 'app.hp-connect'
// 'app.codigos'
]);
'use strict';

(function () {
	'use strict';

	angular.module('core', ['app.core', 'app.navigation', 'app.toolbar', 'app.quick-panel', 'textAngular', 'platanus.rut', 'pages.module', 'fixed.table.header', 'ngMap', 'mdColorPicker']);
})();
'use strict';

(function () {
    'use strict';

    angular.module('core').controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope) {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.toolbar', []).config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.toolbar').controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController($rootScope, $window, $logger, $q, $request, $mdDialog, $auth, $imagen, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, $log) {
    var vm = this;

    // Data
    $rootScope.global = {
      search: ''
    };

    vm.goToOther = function (other) {
      $window.open(other.url, "_blank");
    };

    vm.bodyEl = angular.element('body');

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.changeLanguage = changeLanguage;
    vm.setUserStatus = setUserStatus;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.search = search;
    vm.searchResultClick = searchResultClick;
    vm.miPerfil = miPerfil;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Get the selected language directly from angular-translate module setting
      vm.user = $auth.user();
      vm.user.imagenURL = $imagen.fileURL(vm.user, function (url) {
        vm.user.imagenURL = url;
      });

      vm.other = {};
      vm.other.url = 'https://hp.alquimio.cloud';
      vm.other.name = 'Español';
      vm.other.short = 'es';

      $auth.me().then(function (res) {
        vm.user = res.me;
        vm.user.imagenURL = $imagen.fileURL(vm.user, function (url) {
          vm.user.imagenURL = url;
        });
      });
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function miPerfil() {
      var userId = $auth.user().id;
      $state.go("app.usuario.editar", { id: userId });
    }

    /**
     * Sets User Status
     * @param status
     */
    function setUserStatus(status) {
      vm.userStatus = status;
    }

    /**
     * Logout Function
     */
    function logout($event) {
      // Do logout here..
      var confirm = $mdDialog.confirm().title('Cerrar sesión').textContent('¿Estás seguro de querer cerrar sesión?').targetEvent($event).ok('Cerrar sesión').cancel('Cancelar');

      $mdDialog.show(confirm).then(function () {
        $logger.trackAction('LOGOUT');
        $auth.logout();
      }).finally(function () {
        confirm = undefined;
      });
    }

    /**
     * Change Language
     */
    function changeLanguage(lang) {
      vm.selectedLanguage = lang;

      /**
       * Show temporary message if user selects a language other than English
       *
       * angular-translate module will try to load language specific json files
       * as soon as you change the language. And because we don't have them, there
       * will be a lot of errors in the page potentially breaking couple functions
       * of the template.
       *
       * To prevent that from happening, we added a simple "return;" statement at the
       * end of this if block. If you have all the translation files, remove this if
       * block and the translations should work without any problems.
       */
      if (lang.code !== 'en') {
        var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
          hideDelay: 7000,
          position: 'top right',
          parent: '#content'
        });
        return;
      }

      // Change the language
      $translate.use(lang.code);
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }

    /**
     * Search action
     *
     * @param query
     * @returns {Promise}
     */
    function search(query) {
      var navigation = [],
          flatNavigation = msNavigationService.getFlatNavigation(),
          deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          navigation.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the navigation;
      // otherwise we will return the entire navigation
      // list. Not exactly a good thing to do but it's
      // for demo purposes.
      if (query) {
        navigation = navigation.filter(function (item) {
          if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
            return true;
          }
        });
      }

      // Fake service delay
      $timeout(function () {
        deferred.resolve(navigation);
      }, 1000);

      return deferred.promise;
    }

    /**
     * Search result click action
     *
     * @param item
     */
    function searchResultClick(item) {
      // If item has a link
      if (item.uisref) {
        // If there are state params,
        // use them...
        if (item.stateParams) {
          $state.go(item.state, item.stateParams);
        } else {
          $state.go(item.state);
        }
      }
    }
  }
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.quick-panel').controller('QuickPanelController', QuickPanelController);

	/** @ngInject */
	function QuickPanelController(msApi) {
		var vm = this;

		// Data
		vm.date = new Date();
		vm.settings = {
			notify: true,
			cloud: false,
			retro: true
		};
	}
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.navigation', []).config(config);

    /** @ngInject */
    function config() {}
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.navigation').controller('NavigationController', NavigationController);

	/** @ngInject */
	function NavigationController($scope) {
		var vm = this;

		// Data
		vm.bodyEl = angular.element('body');
		vm.folded = false;
		vm.msScrollOptions = {
			suppressScrollX: true
		};

		// Methods
		vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

		//////////

		/**
   * Toggle folded status
   */
		function toggleMsNavigationFolded() {
			vm.folded = !vm.folded;
		}

		// Close the mobile menu on $stateChangeSuccess
		$scope.$on('$stateChangeSuccess', function () {
			vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
		});
	}
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig) {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if (fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile()) {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if (msUtils.isMobile()) {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if (browserInfo) {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.core').config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider) {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars': false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile': true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
'use strict';

(function () {
	'use strict';

	angular.module('core').run(runBlock);

	/** @ngInject */
	function runBlock($rootScope, $timeout, $state, $server) {
		moment.locale('es');
		// Activate loading indicator
		var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
			$rootScope.loadingProgress = true;
		});

		// De-activate loading indicator
		var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
			$timeout(function () {
				$rootScope.loadingProgress = false;
			});
		});

		// Store state in the root scope for easy access
		$rootScope.state = $state;
		$server.settings().then(function (server) {
			$rootScope.server = server;
		});
		// Cleanup
		$rootScope.$on('$destroy', function () {
			stateChangeStartEvent();
			stateChangeSuccessEvent();
		});
	}
})();
'use strict';

(function () {
    'use strict';

    angular.module('core').config(routeConfig);

    /** @ngInject */

    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        $locationProvider.html5Mode(false);

        $urlRouterProvider.otherwise('/auth/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies = void 0;

        angular.injector(['ngCookies']).invoke(['$cookies', function (_$cookies) {
            $cookies = _$cookies;
        }]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'main@': {
                    templateUrl: layouts[layoutStyle].main,
                    controller: 'MainController as vm'
                },
                'toolbar@app': {
                    templateUrl: layouts[layoutStyle].toolbar,
                    controller: 'ToolbarController as vm'
                },
                'navigation@app': {
                    templateUrl: layouts[layoutStyle].navigation,
                    controller: 'NavigationController as vm'
                },
                'quickPanel@app': {
                    templateUrl: 'app/quick-panel/quick-panel.html',
                    controller: 'QuickPanelController as vm'
                }
            }
        });
    }
})();
'use strict';

angular.module('core').config(function ($profileProvider) {
	$profileProvider.denyProfiles([{
		identifier: 'USER'
	}]);
}).config(function ($provide) {

	$provide.decorator('$state', function ($delegate) {
		var states = $delegate.get();
		$delegate.login = function (name) {
			var login = _.find(states, {
				user: false,
				root: true
			});
			if (!name) {
				$delegate.go(login.name);
			}
			return login;
		};
		$delegate.home = function (name, forbidden) {
			var home = _.filter(states, {
				user: true,
				root: true
			});
			var sended = false;
			_.each(home, function (h) {
				if (!sended) {
					if (!name) {
						if (forbidden && h.permissions) {
							if (!forbidden(h.permissions)) {
								$delegate.go(h.name);
								sended = true;
							}
						} else {
							$delegate.go(h.name);
							sended = true;
						}
					}
				}
			});

			return home;
		};
		return $delegate;
	});
}).run(function ($rootScope, $state, $profile, $auth) {
	$rootScope.$on('$stateChangeStart', function (ev, state) {
		if (state.name === $state.home(true).name || state.name === $state.login(true).name || state.isRoot) {
			if (state.name !== $state.home(true).name) {
				/* Clear history */
			}
		}

		function isForbidden(permissions) {
			return $profile.isForbidden(permissions);
		}

		function defaultPage(ev) {
			if (state.user || angular.isUndefined(state.user)) {
				if (!isLogued) {
					ev.preventDefault();
					$state.login();
				}
			} else {
				if (isLogued) {
					ev.preventDefault();
					$state.home(null, isForbidden);
				}
			}
		}

		function isAllowed(profiles, allowedProfiles) {
			var allowed = _.filter(profiles, function (profile) {
				return allowedProfiles.indexOf(profile.identifier) >= 0;
			});
			return allowed.length > 0;
		}

		var isLogued = $auth.isLogued();
		if (isLogued) {
			if (state.permissions) {
				if (isForbidden(state.permissions)) {
					ev.preventDefault();
					$state.home(null, isForbidden);
				} else {
					defaultPage(ev);
				}
			} else {
				defaultPage(ev);
			}
		} else {
			defaultPage(ev);
		}
	});
});
'use strict';

(function () {
	'use strict';

	angular.module('core').controller('IndexController', IndexController);

	/** @ngInject */
	function IndexController(fuseTheming) {
		var vm = this;

		// Data
		vm.themes = fuseTheming.themes;

		//////////
	}
})();
'use strict';

(function () {
	'use strict';

	angular.module('core').constant('VER', 'v1.0.0').constant('SERVER', {
		'url': 'http://{{baseurl}}/api',
		'ttl': 60 * 60 * 24 // Un día de token válido
	});
})();
'use strict';

(function () {
	'use strict';

	angular.module('core').config(function ($translateProvider) {
		$translateProvider.useLoader('$translatePartialLoader', {
			urlTemplate: '{part}/i18n/{lang}.json'
		});
		$translateProvider.preferredLanguage('es');
		$translateProvider.useSanitizeValueStrategy('sanitize');
	}).config(function ($serverProvider) {
		var ENV_VARS = {
			apiLocal: 'http://localhost:4000/api',
			apiProduction: 'https://api.br.repositorio.production.alquimio.cloud/api',
			apiStaging: 'https://api.br.repositorio.staging.alquimio.cloud/api'
		};
		$serverProvider.setEnvVariables(ENV_VARS);
	}).config(function (LoopBackResourceProvider, SERVER) {
		LoopBackResourceProvider.setAuthHeader('X-Access-Token');
		LoopBackResourceProvider.setUrlBase(SERVER.url);
	}).config(function ($provide) {
		$provide.decorator('taOptions', ['$delegate', function (taOptions) {
			taOptions.toolbar = [['h1', 'h2', 'h3', 'h4', 'bold', 'italics', 'underline', 'ul', 'ol', 'quote']];

			taOptions.classes = {
				focussed: 'focussed',
				toolbar: 'ta-toolbar',
				toolbarGroup: 'ta-group',
				toolbarButton: 'md-button',
				toolbarButtonActive: 'active',
				disabled: '',
				textEditor: 'form-control',
				htmlEditor: 'form-control'
			};

			return taOptions;
		}]);

		// Text Angular tools
		$provide.decorator('taTools', ['$delegate', function (taTools) {
			taTools.quote.iconclass = 'icon-format-quote';
			taTools.bold.iconclass = 'icon-format-bold';
			taTools.italics.iconclass = 'icon-format-italic';
			taTools.underline.iconclass = 'icon-format-underline';
			taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
			taTools.ul.iconclass = 'icon-format-list-bulleted';
			taTools.ol.iconclass = 'icon-format-list-numbers';
			taTools.redo.iconclass = 'icon-redo';
			taTools.undo.iconclass = 'icon-undo';
			taTools.clear.iconclass = 'icon-close-circle-outline';
			taTools.justifyLeft.iconclass = 'icon-format-align-left';
			taTools.justifyCenter.iconclass = 'icon-format-align-center';
			taTools.justifyRight.iconclass = 'icon-format-align-right';
			taTools.justifyFull.iconclass = 'icon-format-align-justify';
			taTools.indent.iconclass = 'icon-format-indent-increase';
			taTools.outdent.iconclass = 'icon-format-indent-decrease';
			taTools.html.iconclass = 'icon-code-tags';
			taTools.insertImage.iconclass = 'icon-file-image-box';
			taTools.insertLink.iconclass = 'icon-link';
			taTools.insertVideo.iconclass = 'icon-filmstrip';

			return taTools;
		}]);
	});
})();
angular.module("core").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/directives/input-address/input-address.html","<div flex=\"100\"><md-input-container flex=\"100\" md-no-float class=\"md-block\"><label>{{ placeholder }}</label><input \nautocomplete=\"off\" type=\"text\" placeholder=\"{{ placeholder }}\" value=\"{{ addressCompleted.address }}\" \nonfocus=\"angular.element(this).scope().onFocus()\" ng-required=\"required\"><md-icon md-font-icon=\"icon-map-marker\">\n</md-icon></md-input-container></div>");
$templateCache.put("app/core/directives/input-address/input-panel-address.html","<md-card class=\"input-panel-address\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Selección de dirección</h2></div>\n</md-toolbar><md-content class=\"md-padding\"><div loading=\"ctrl.updating\"></div><div flex layout=\"row\">\n<md-input-container flex=\"80\" md-no-float class=\"md-block\"><label>Dirección</label><input type=\"text\" \nng-model=\"ctrl.address\" required md-autofocus><md-icon md-font-icon=\"icon-map-marker\"></md-icon></md-input-container>\n<div flex=\"20\"><md-button class=\"md-raised md-accent\" ng-click=\"ctrl.doBuscarDireccion()\">Buscar</md-button></div>\n</div><md-divider></md-divider><div id=\"map-address\"></div></md-content><md-card-footer><md-button \nng-click=\"ctrl.accept()\" class=\"md-accent\" ng-disabled=\"!ctrl.addressCompleted || ctrl.updating\">Aceptar</md-button>\n<md-button ng-click=\"ctrl.close()\" ng-disabled=\"ctrl.updating\">Cancelar</md-button></md-card-footer></md-card>");
$templateCache.put("app/core/directives/input-autocomplete/input-autocomplete.html","<div><md-autocomplete flex=\"100\" md-input-minlength=\"2\" md-selected-item=\"selectItem\" md-no-cache=\"noCache\" \nmd-selected-item-change=\"selectedItem(item)\" md-search-text=\"searchText\" md-items=\"item in querySearch(searchText)\" \nmd-item-text=\"item.name\" autocomplete=\"off\" ng-required=\"required\" md-floating-label=\"{{ label }}\"><md-item-template>\n<span md-highlight-text=\"searchText\">{{showFounded(item)}}</span></md-item-template></md-autocomplete></div>");
$templateCache.put("app/core/directives/input-date/input-date.html","<div flex=\"100\"><md-input-container flex=\"100\" md-no-float class=\"md-block\"><md-icon md-font-icon=\"icon-calendar\">\n</md-icon><label>{{ placeholder }}</label><input autocomplete=\"off\" type=\"text\" placeholder=\"{{ placeholder }}\" \nvalue=\"{{ fechaFormateada }}\" onfocus=\"angular.element(this).scope().onFocus()\" ng-required=\"required\">\n</md-input-container></div>");
$templateCache.put("app/core/directives/input-gallery/input-gallery.html","<div class=\"input-gallery\"><div class=\"single-wrapper\" ng-if=\"!multiple && files[0]\"><div class=\"item\"><div \nng-if=\"files[0].ext == \'png\' || files[0].ext == \'PNG\' || files[0].ext == \'jpg\' || files[0].ext == \'JPG\' || files[0].ext == \'JPEG\' || files[0].ext == \'jpeg\'\" \nclass=\"img\" style=\"background-image: url(\'{{ server.download +\'thumb-\'+ files[0].name }}\')\" alt=\"\"></div><div \nng-if=\"files[0].ext != \'png\' && files[0].ext != \'PNG\' && files[0].ext != \'jpg\' && files[0].ext != \'JPG\' && files[0].ext != \'JPEG\'\" \nclass=\"img\" style=\"background-image: url(\'https://files.alquimio.cloud/imagenes/documents.png\')\" alt=\"\"></div><div \nclass=\"edit-wrapper\" ng-if=\"files[0]\"><span><md-button class=\"md-fab md-mini md-secondary\" aria-label=\"Editar\" \nng-if=\"!disabled\" ng-click=\"openPanel($event)\"><md-icon md-font-icon=\"icon-border-color\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini md-secondary\" aria-label=\"Descargar\" ng-click=\"download(files[0])\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon></md-button><md-button class=\"md-fab md-mini md-secondary\" \naria-label=\"Eliminar\" ng-if=\"!disabled\" ng-click=\"delete(files[0])\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></span></div><p class=\"filename\" ng-if=\"files[0]\">{{ files[0].name | limitTo: 30 }}</p></div></div>\n<md-button ng-if=\"!disabled && ( multiple || ( !multiple && !files[0] ) )\" type=\"button\" class=\"md-raised md-accent\" \nng-click=\"openPanel($event)\"><ng-transclude></ng-transclude></md-button><div class=\"gallery-wrapper\" ng-if=\"multiple\">\n<div class=\"item\" ng-if=\"!disabled\" ng-repeat=\"picture in files | limitTo: 7\"><div class=\"plus-message\" \nng-if=\"files.length > 7 && $index === 6\"><span>+{{ files.length - 6 }}</span></div><div \nng-if=\"picture.ext == \'png\' || picture.ext == \'PNG\' || picture.ext == \'jpg\' || picture.ext == \'JPG\' || picture.ext == \'JPEG\' || picture.ext == \'jpeg\'\" \nclass=\"img\" style=\"background-image: url(\'{{ server.download + \'thumb-\'+ picture.name }}\')\" alt=\"\"></div><div \nng-if=\"picture.ext != \'png\' && picture.ext != \'PNG\' && picture.ext != \'jpg\' && picture.ext != \'JPG\' && picture.ext != \'JPEG\'\" \nclass=\"img\" style=\"background-image: url(\'https://files.alquimio.cloud/imagenes/documents.png\')\" alt=\"\"></div><div \nclass=\"download-wrapper\"><span><md-button class=\"md-fab md-mini md-secondary\" aria-label=\"Descargar\" \nng-click=\"download(picture)\"><md-icon md-font-icon=\"icon-download\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-secondary\" aria-label=\"Ver\" ng-click=\"openGallery($index)\"><md-icon \nmd-font-icon=\"icon-magnify-plus\"></md-icon></md-button><md-button class=\"md-fab md-mini md-secondary\" \naria-label=\"Eliminar\" ng-if=\"!disabled\" ng-click=\"delete(picture)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></span></div><span class=\"filename\" ng-if=\"files.length <= 7\">{{picture.name | limitTo: 30 }}</span></div>\n<div class=\"item\" ng-if=\"disabled\" ng-repeat=\"picture in files | limitTo: 7\"><div class=\"plus-message\" \nng-if=\"files.length > 7 && $index === 6\"><span>+{{ files.length - 6 }}</span></div><div \nng-if=\"!picture.origin && (picture.ext == \'png\' || picture.ext == \'PNG\' || picture.ext == \'jpg\' || picture.ext == \'JPG\' || picture.ext == \'JPEG\' || picture.ext == \'jpeg\')\" \nclass=\"img\" style=\"background-image: url(\'{{ server.download  +\'thumb-\'+ picture.name }}\')\" alt=\"\"></div><div \nng-if=\"picture.origin ==\'fromCap\' && (picture.ext == \'png\' || picture.ext == \'PNG\' || picture.ext == \'jpg\' || picture.ext == \'JPG\' || picture.ext == \'JPEG\' || picture.ext == \'jpeg\')\" \nclass=\"img\" style=\"background-image: url(\'{{ picture.thumbUrl }}\')\" alt=\"\"></div><div \nng-if=\"picture.ext != \'png\' && picture.ext != \'PNG\' && picture.ext != \'jpg\' && picture.ext != \'JPG\' && picture.ext != \'JPEG\' && picture.ext != \'jpeg\'\" \nclass=\"img\" style=\"background-image: url(\'https://files.alquimio.cloud/imagenes/documents.png\')\" alt=\"\"></div><div \nclass=\"download-wrapper\" ng-if=\"$index != 6\"><span><md-button class=\"md-fab md-mini md-secondary\" \naria-label=\"Descargar\" ng-click=\"download(picture)\"><md-icon md-font-icon=\"icon-download\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini md-secondary\" aria-label=\"Ver\" ng-click=\"openGallery($index)\"><md-icon \nmd-font-icon=\"icon-magnify-plus\"></md-icon></md-button><md-button class=\"md-fab md-mini md-secondary\" \naria-label=\"Eliminar\" ng-if=\"!disabled\" ng-click=\"delete(picture)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></span></div><span class=\"filename\" ng-if=\"files.length <= 7\">{{picture.name | limitTo: 30 }}</span></div>\n<md-button ng-if=\"disabled && files.length > 7 && modelo \" type=\"button\" class=\"md-raised md-accent\" \nui-sref=\"app.file-manager({id : modelo})\">Ver en Documentos</md-button><ng-image-gallery images=\"filesGallery\" \nthumbnails=\"false\" bubbles=\"true\" img-bubbles=\"true\" bg-close=\"true\" piracy=\"true\" img-anim=\"fadeup\" methods=\"methods\" \non-open=\"opened();\" on-close=\"closed();\"></ng-image-gallery></div></div>");
$templateCache.put("app/core/directives/input-gallery/input-panel-gallery.html","<md-card class=\"input-panel-gallery\"><md-toolbar><div class=\"md-toolbar-tools\"><div \nng-show=\"ctrl.showBuscardor && ctrl.tabFiles\" flex class=\"search-bar\"><md-input-container md-no-float class=\"md-block\">\n<input ng-model=\"ctrl.textBuscar\" placeholder=\"Buscar...\"></md-input-container></div><md-button \nng-show=\"ctrl.showBuscardor && ctrl.tabFiles\" class=\"md-icon-button\" ng-click=\"ctrl.showBuscardor = false\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button><h2 ng-show=\"!ctrl.showBuscardor\">Selección de imágenes</h2><span flex \nng-show=\"!ctrl.showBuscardor\"></span><md-button ng-show=\"!ctrl.showBuscardor && ctrl.tabFiles\" class=\"md-icon-button\" \nng-click=\"ctrl.showBuscardor = true\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></md-toolbar>\n<md-content><div loading=\"ctrl.updating\"></div><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=\"always\">\n<md-tab label=\"Subir imágenes\" md-on-select=\"ctrl.tabFileSelected(false)\"><md-content class=\"md-padding\"><div \nclass=\"drop-here-container\"><div ng-if=\"!ctrl.filesPerUpload && !ctrl.uploading\"><input id=\"input-gallery-fileinput\" \naccept=\"*\" onchange=\"angular.element(this).scope().ctrl.onChangeFile(this)\" type=\"file\" \nmultiple=\"{{ multiple ? \'multiple\' : \'\' }}\"><div class=\"icon-wrapper\"><md-icon md-font-icon=\"icon-box-download\">\n</md-icon></div><div class=\"message-wrapper\">Suelta tus archivos aquí</div></div><div \nng-if=\"ctrl.filesPerUpload && ctrl.filesPerUpload.length !== 0 && !ctrl.uploading\"><div class=\"icon-wrapper\"><md-icon \nmd-font-icon=\"icon-file-multiple\"></md-icon></div><div class=\"message-wrapper\"><span \nng-if=\"ctrl.filesPerUpload.length > 1\">{{ ctrl.filesPerUpload.length }} archivos</span> <span \nng-if=\"ctrl.filesPerUpload.length === 1\">{{ ctrl.filesPerUpload[0].name }}</span></div><div class=\"text-center\">\n<md-button class=\"md-accent md-raised\" ng-click=\"ctrl.doUpload()\">Subir<ng-pluralize \ncount=\"ctrl.filesPerUpload.length\" when=\"{\'1\': \'archivo\', \'other\': \'archivos\'}\"></ng-pluralize></md-button><md-button \nclass=\"md-raised\" ng-click=\"ctrl.cancelPerUpload()\">Cancelar</md-button></div></div><div ng-if=\"ctrl.uploading\"><div \nng-if=\"ctrl.progressTotal < 100 &&  ctrl.uploaded !== ctrl.filesPerUpload.length\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{ctrl.progressTotal}}\"></md-progress-linear><div class=\"icon-wrapper\"><md-icon \nmd-font-icon=\"icon-cloud-upload\"></md-icon></div><div class=\"message-wrapper\">\nSubiendo Archivos ({{ ctrl.progressTotal }}%)</div></div><div \nng-if=\"ctrl.progressTotal === 100 && ctrl.uploaded !== ctrl.filesPerUpload.length\"><md-progress-linear \nmd-mode=\"indeterminate\"></md-progress-linear><div class=\"icon-wrapper\"><md-icon md-font-icon=\"icon-cloud-upload\">\n</md-icon></div><div class=\"message-wrapper\">Procesando...</div></div><div \nng-if=\"ctrl.uploaded === ctrl.filesPerUpload.length\"><div class=\"icon-wrapper\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\"></md-icon></div><div class=\"message-wrapper\">Archivos subidos correctamente\n</div></div></div></div></md-content></md-tab><md-tab label=\"Imágenes existentes\" \nmd-on-select=\"ctrl.tabFileSelected(true)\"><md-content class=\"md-padding selectables-container\"><item-input-gallery \nfile=\"file\" ng-repeat=\"file in ctrl.files | orderBy:\'fechaCreacion\':\'desc\'\"></item-input-gallery></md-content></md-tab>\n</md-tabs></md-content><md-card-footer><md-button ng-click=\"ctrl.accept()\" class=\"md-accent\" \nng-disabled=\"ctrl.uploading\">Aceptar <span ng-if=\"ctrl.filesSelected.length > 0\">({{ ctrl.filesSelected.length }})\n</span></md-button><md-button ng-click=\"ctrl.close()\" ng-disabled=\"ctrl.uploading\">Cancelar</md-button>\n</md-card-footer></md-card>");
$templateCache.put("app/core/directives/input-galleryfiles/input-galleryfiles.html","<div class=\"input-galleryfiles\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"openPanel($event)\">\n<ng-transclude></ng-transclude></md-button><div class=\"galleryfiles-wrapper\"><div class=\"item\" \nng-repeat=\"picture in files | limitTo: 7\" ng-click=\"openPanel($event)\"><div class=\"plus-message\" \nng-if=\"files.length > 7 && $index === 6\"><span>+{{ files.length - 3 }}</span></div><div class=\"a\" \nng-if=\"picture.ext == \'png\' || picture.ext == \'PNG\' || picture.ext == \'jpg\' || piacture.ext == \'JPG\' || picture.ext == \'JPEG\' ||picture.ext == \'jpeg\'\" \nclass=\"img\" style=\"background-image: url(\'{{ server.download + picture.name }}\')\" alt=\"\"></div><div class=\"b\" \nng-if=\"picture.ext != \'png\' && picture.ext != \'PNG\' && picture.ext != \'jpg\' && picture.ext != \'JPG\' && picture.ext != \'JPEG\' && picture.ext != \'jpeg\'\" \nclass=\"img\" style=\"background-image: url(\'https://files.alquimio.cloud/imagenes/documents.png\')\" alt=\"\"></div></div>\n</div></div>");
$templateCache.put("app/core/directives/input-galleryfiles/input-panel-galleryfiles.html","<md-card class=\"input-panel-galleryfiles\"><md-toolbar><div class=\"md-toolbar-tools\"><div \nng-show=\"ctrl.showBuscardor && ctrl.tabFiles\" flex class=\"search-bar\"><md-input-container md-no-float class=\"md-block\">\n<input ng-model=\"ctrl.textBuscar\" placeholder=\"Buscar...\"></md-input-container></div><md-button \nng-show=\"ctrl.showBuscardor && ctrl.tabFiles\" class=\"md-icon-button\" ng-click=\"ctrl.showBuscardor = false\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button><h2 ng-show=\"!ctrl.showBuscardor\">Selección de imágenes</h2><span flex \nng-show=\"!ctrl.showBuscardor\"></span><md-button ng-show=\"!ctrl.showBuscardor && ctrl.tabFiles\" class=\"md-icon-button\" \nng-click=\"ctrl.showBuscardor = true\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></md-toolbar>\n<md-content><div loading=\"ctrl.updating\"></div><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=\"always\">\n<md-tab label=\"Subir imágenes\" md-on-select=\"ctrl.tabFileSelected(false)\"><md-content class=\"md-padding\"><div \nclass=\"drop-here-container\"><div ng-if=\"!ctrl.filesPerUpload || ctrl.filesPerUpload.length === 0 && !ctrl.uploading\">\n<input id=\"input-galleryfiles-fileinput\" accept=\"*\" onchange=\"angular.element(this).scope().ctrl.onChangeFile(this)\" \ntype=\"file\" multiple=\"{{ multiple ? \'multiple\' : \'\' }}\"><div class=\"icon-wrapper\"><md-icon \nmd-font-icon=\"icon-box-download\"></md-icon></div><div class=\"message-wrapper\">Suelta tus archivos aquí</div></div><div \nng-if=\"ctrl.filesPerUpload && ctrl.filesPerUpload.length !== 0 && !ctrl.uploading\"><div class=\"icon-wrapper\"><md-icon \nmd-font-icon=\"icon-file-multiple\"></md-icon></div><div class=\"message-wrapper\"><span \nng-if=\"ctrl.filesPerUpload.length > 1\">{{ ctrl.filesPerUpload.length }} archivos</span> <span \nng-if=\"ctrl.filesPerUpload.length === 1\">{{ ctrl.filesPerUpload[0].name }}</span></div><div class=\"text-center\">\n<md-button class=\"md-accent md-raised\" ng-click=\"ctrl.doUpload()\">Subir<ng-pluralize \ncount=\"ctrl.filesPerUpload.length\" when=\"{\'1\': \'archivo\', \'other\': \'archivos\'}\"></ng-pluralize></md-button><md-button \nclass=\"md-raised\" ng-click=\"ctrl.cancelPerUpload()\">Cancelar</md-button></div></div><div ng-if=\"ctrl.uploading\"><div \nng-if=\"ctrl.progressTotal < 100 &&  ctrl.uploaded !== ctrl.filesPerUpload.length\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{ctrl.progressTotal}}\"></md-progress-linear><div class=\"icon-wrapper\"><md-icon \nmd-font-icon=\"icon-cloud-upload\"></md-icon></div><div class=\"message-wrapper\">\nSubiendo Archivos ({{ ctrl.progressTotal }}%)</div></div><div \nng-if=\"ctrl.progressTotal === 100 && ctrl.uploaded !== ctrl.filesPerUpload.length\"><md-progress-linear \nmd-mode=\"indeterminate\"></md-progress-linear><div class=\"icon-wrapper\"><md-icon md-font-icon=\"icon-cloud-upload\">\n</md-icon></div><div class=\"message-wrapper\">Procesando...</div></div><div \nng-if=\"ctrl.uploaded === ctrl.filesPerUpload.length\"><div class=\"icon-wrapper\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\"></md-icon></div><div class=\"message-wrapper\">Archivos subidos correctamente\n</div></div></div></div></md-content></md-tab><md-tab label=\"Imágenes existentes\" \nmd-on-select=\"ctrl.tabFileSelected(true)\"><md-content class=\"md-padding selectables-container\"><item-input-galleryfiles\n file=\"file\" ng-repeat=\"file in ctrl.files | orderBy:\'fechaCreacion\':\'desc\'\"></item-input-galleryfiles></md-content>\n</md-tab></md-tabs></md-content><md-card-footer><md-button ng-click=\"ctrl.accept()\" class=\"md-accent\" \nng-disabled=\"ctrl.uploading\">Aceptar <span ng-if=\"ctrl.filesSelected.length > 0\">({{ ctrl.filesSelected.length }})\n</span></md-button><md-button ng-click=\"ctrl.close()\" ng-disabled=\"ctrl.uploading\">Cancelar</md-button>\n</md-card-footer></md-card>");
$templateCache.put("app/core/directives/input-horario/input-horario.html","<div class=\"input-horario\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"openPanel($event)\">\n<ng-transclude></ng-transclude></md-button><div class=\"horarios-wrapper\" ng-if=\"horarios.length > 0\"><table md-table>\n<thead><tr><th class=\"md-column\"><span>Día</span></th><th class=\"md-column\"><span>Horario</span></th><th \nclass=\"md-column\"><span>Acciones</span></th></tr></thead><tbody><tr ng-repeat=\"horario in horarios | orderBy: \'dia\'\">\n<td class=\"md-column\"><b>{{ diasSemana[horario.dia].name }}</b></td><td class=\"md-column\">\nDesde {{ horario.horaInicio | amDateFormat:\'HH:mm\' }} hasta {{ horario.horaFin | amDateFormat:\'HH:mm\' }} <span \nng-if=\"horario.bloque > 0\">({{ horario.bloque }} minutos por bloque)</span></td><td class=\"md-column\"><md-button \nclass=\"md-raised\" ng-click=\"editHorario($event, horario)\">Editar</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"duplicarHorario($event, horario)\">Duplicar</md-button><md-button class=\"md-warn md-raised\" \nng-click=\"goDelete($event, horario)\">Borrar</md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/core/directives/input-horario/input-panel-horario.html","<md-card class=\"input-panel-horario\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Nuevo horario</h2></div>\n</md-toolbar><md-content class=\"md-padding\" flex><div loading=\"ctrl.updating\"></div><div layout=\"column\" flex>\n<md-input-container flex=\"100\"><label>Día de la semama</label><md-select ng-model=\"ctrl.horario.dia\"><md-option \nng-value=\"dia.id\" ng-repeat=\"dia in ctrl.diasSemana\">{{ dia.name }}</md-option></md-select></md-input-container><div \nflex=\"100\" layout=\"row\" layout-align=\"start center\"><mdp-time-picker flex=\"33\" mdp-placeholder=\"Hora de inicio\" \nmdp-format=\"HH:mm\" mdp-auto-switch=\"true\" ng-model=\"ctrl.horario.horaInicio\"></mdp-time-picker><mdp-time-picker \nflex=\"33\" mdp-placeholder=\"Hora de fin\" mdp-format=\"HH:mm\" mdp-auto-switch=\"true\" ng-model=\"ctrl.horario.horaFin\">\n</mdp-time-picker><md-input-container flex=\"33\"><label>Tamaño del bloque (min)</label><input type=\"number\" \nng-model=\"ctrl.horario.bloque\"><div class=\"hint\">0 para bloques libres</div></md-input-container></div></div>\n</md-content><md-card-footer><md-button ng-disabled=\"ctrl.isInvalidForm()\" class=\"md-accent\" ng-click=\"ctrl.accept()\">\nAceptar</md-button><md-button ng-click=\"ctrl.cancel()\">Cancelar</md-button></md-card-footer></md-card>");
$templateCache.put("app/core/directives/listar/listar.html","<div style=\"overflow: auto; max-height: 400px\"><div loading=\"loading\"></div><table md-table><thead fix-head><tr><th \nclass=\"md-column\" \nng-class=\"{\'order\': column.order, \'ordered\': column.ordered, \'desc\': column.direction === \'desc\', \'asc\': column.direction === \'asc\'}\" \nng-repeat=\"column in columns\"><span class=\"column-title\" ng-click=\"orderBy(column)\">{{column.title}}</span><br></th>\n</tr></thead><tbody><tr ng-repeat=\"element in elements\"><td class=\"md-column\" ng-repeat=\"column in columns\"><div \nng-if=\"column.key\" ng-click=\"clickValue($event, element, column.key)\" \nng-bind-html=\"getElementValue(element, column.key)\"></div><div class=\"child\" ng-if=\"column.childs\" \nng-repeat=\"child in column.childs\" ng-bind-html=\"getElementValue(element, child.key)\"></div><div ng-if=\"!column.key\" \nclass=\"text-right\"><div class=\"button-wrapper\" ng-repeat=\"button in buttons\"><button \nclass=\"md-button md-small {{ button.clase }}\" \nng-if=\"conditionButton(button, element.__original) && button.action.type !== \'menus\'\" \nng-click=\"clickButton($event, button, element)\"><md-icon ng-if=\"button.icon\" md-font-icon=\"{{ button.icon }}\">\n</md-icon>{{ button.title }}</button><md-menu ng-if=\"button.action.type === \'menus\'\"><md-button aria-label=\"Opciones\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item ng-repeat=\"menu in button.action.menus\"><md-button \nng-click=\"clickButton($event, menu, element)\"><md-icon ng-if=\"menu.icon\" md-font-icon=\"{{ menu.icon }}\"></md-icon>\n{{ menu.title }}</md-button></md-menu-item></md-menu-content></md-menu></div></div></td></tr><tr \nng-if=\"elements.length === 0\"><td colspan=\"{{ columns.length }}\"><div class=\"md-padding\"><div class=\"text-center\">\n<md-icon md-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon></div><div class=\"text-center h3\">\nNo hay elementos aún</div></div></td></tr></tbody></table><md-table-pagination ng-if=\"paginate\" \nmd-limit=\"paginate.limit\" md-limit-options=\"paginate.limitOptions\" md-page=\"paginate.page\" \nmd-total=\"{{paginate.total}}\" md-on-paginate=\"changePage\" \nmd-label=\"{\'of\': \'de\', \'page\': \'Página\', \'rowsPerPage\': \'Filas por página\'}\" md-page-select></md-table-pagination>\n</div>");
$templateCache.put("app/core/directives/loading/loading.html","<div class=\"loading-container\" ng-if=\"loading\"><div class=\"progress-wrapper\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular><div class=\"message\">{{ message }}</div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdMenu.open($event)\"><ms-color-picker-button><md-button\n aria-label=\"Row Color\" md-menu-origin ng-click=\"$mdMenu.open($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/replace/input-replace.html","<div class=\"replace\"><span>Valor en idioma {{otherLang}} : {{otherValue}}</span><md-button type=\"button\" \nclass=\"md-raised md-accent\" ng-click=\"replaceValue($event)\">Reemplazar</md-button></div>");
$templateCache.put("app/core/directives/replace/replace.html","<div class=\"hint replace\" ng-hide=\"replaced==true || !othervalue \">\nValor en idioma {{otherlang}} : {{othervalue}} {{modelValueExists}}<md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"setValue($event)\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/table/table-directive.tmpl.html","<table class=\"md-table\"><thead><tr><th ng-repeat=\"column in columns\" ng-click=\"sortClick(column.field)\" \nng-class=\"headerClass(column.field)\"><md-icon ng-show=\"showSortOrder(column.field, true)\" class=\"icon-rotate-90\" \nmd-font-icon=\"zmdi zmdi-arrow-back\"></md-icon><md-icon ng-show=\"showSortOrder(column.field, false)\" \nclass=\"icon-rotate-270\" md-font-icon=\"zmdi zmdi-arrow-back\"></md-icon><span>{{column.title}}</span></th></tr></thead>\n<tbody><tr ng-repeat=\"content in contents | filter:filters | startFrom:page * pageSize | limitTo: pageSize\"><td \nng-repeat=\"column in columns\" ng-bind-html=\"cellContents(column, content)\" ng-class=\"column.field + \'-cell\'\"></td></tr>\n</tbody><tfoot><tr><td colspan=\"{{columns.length}}\"><div class=\"md-table-footer\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"md-table-page-select\" layout=\"row\" layout-align=\"center center\"><span>\nRows per page:</span><md-select ng-model=\"pageSize\" ng-change=\"refresh(true)\"><md-option value=\"5\">5</md-option>\n<md-option value=\"10\">10</md-option><md-option value=\"25\">25</md-option><md-option value=\"50\">50</md-option><md-option \nvalue=\"100\">100</md-option></md-select></div><span class=\"md-table-info\">{{pageStart()}} - {{pageEnd()}} <span \ntranslate>TABLES.OF</span> {{totalItems()}}</span><div class=\"md-table-page-nav\"><md-button ng-disabled=\"page == 0\" \nng-click=\"page = page - 1\" aria-label=\"{{\'TABLES.PREV\' | translate}}\" class=\"md-primary md-icon-button\"><md-icon \nmd-font-icon=\"zmdi zmdi-chevron-left\"></md-icon></md-button><md-button ng-disabled=\"page == numberOfPages() - 1\" \nng-click=\"page = page + 1\" aria-label=\"{{\'TABLES.NEXT\' | translate}}\" class=\"md-primary md-icon-button\"><md-icon \nmd-font-icon=\"zmdi zmdi-chevron-right\"></md-icon></md-button></div></div></td></tr><tr><td>TABLE!</td></tr></tfoot>\n</table>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"><img \nsrc=\"assets/images/logos/logo-hp.png\"> </span><span class=\"logo-text\">HP - Fichas</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/pages/admin/file-manager/file-manager.html","<md-progress-linear md-mode=\"indeterminate\" class=\"md-warn\" ng-if=\"vm.loading\"></md-progress-linear><div \nid=\"file-manager\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/pages/admin/file-manager/sidenavs/main/main-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"header md-accent-bg\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between\"><div class=\"right-side\" layout=\"row\"><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.goBack()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-button \nng-if=\"vm.currentView === \'list\'\" class=\"md-icon-button\" ng-click=\"vm.toggleView()\" aria-label=\"view type\" translate \ntranslate-attr-aria-label=\"FM.GRID_VIEW\"><md-icon md-font-icon=\"icon-view-module\" style=\"font-size:28px\"></md-icon>\n<md-tooltip><span translate=\"FM.GRID_VIEW\">Grid View</span></md-tooltip></md-button><md-button \nng-if=\"vm.currentView === \'grid\'\" class=\"md-icon-button\" aria-label=\"view type\" ng-click=\"vm.toggleView()\" translate \ntranslate-attr-aria-label=\"FM.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon><md-tooltip><span \ntranslate=\"FM.LIST_VIEW\">List View</span></md-tooltip></md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.descargarZip()\">Download Zip</md-button></div></div><div class=\"breadcrumb text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span>{{vm.modelo.nombre}}<md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"icon separator\"></md-icon></span></div></div><div id=\"file-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.upload()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\"></div></div><md-content \nclass=\"content\" flex ms-scroll><div ng-if=\"vm.currentView === \'grid\'\" \nng-include=\"\'app/pages/admin/file-manager/views/grid/grid-view.html\'\"></div><div ng-if=\"vm.currentView === \'list\'\" \nng-include=\"\'app/pages/admin/file-manager/views/list/list-view.html\'\"></div></md-content></div><md-sidenav \nclass=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"details-sidenav\" ng-include=\"\'app/pages/admin/file-manager/sidenavs/details/details-sidenav.html\'\" \nms-scroll ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/pages/auth/login/login.tmpl.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div class=\"logo\">\n<span><img src=\"assets/images/logos/logo-hp.png\" alt=\"\"></span></div><div class=\"title\">\nBem-vindo ao repositório de fichas de produtos HP</div></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div loading=\"vm.loading\"></div><div id=\"login-v2-form\"><div \nclass=\"logo\" hide-gt-sm><span><img src=\"assets/images/logos/logo-hp.png\" alt=\"\"></span></div><div class=\"title\">\nIniciar sessão</div><form name=\"loginForm\" novalidate ng-submit=\"vm.doLogin(loginForm)\"><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"correio eletrônico\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Valor necessário</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"senha\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Esqueceu sua senha</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid\">Entrar</md-button>\n<md-divider></md-divider></form></div></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\">\n<div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target \nclass=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdMenu.open($event)\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Language\" md-menu-origin \nmd-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open($event)\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-menu-bar id=\"user-menu\"><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/por.png\"> <span class=\"iso\">PORTUGUES</span></div></md-button><md-menu-content\n width=\"3\" id=\"language-menu-content\"><md-menu-item><md-button ng-click=\"vm.goToOther(vm.other)\" \naria-label=\"{{vm.other.name}}\" translate translate-attr-aria-label=\"{{vm.other.name}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.other.short}}.png\"> <span>\n{{vm.other.name}}</span></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"{{ vm.user.imagenURL || \'assets/images/avatars/profile.jpg\' }}\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span \nclass=\"username\" hide show-gt-sm>{{ vm.user.nombre || vm.user.name || vm.user.email }}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Cerrar sesión</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open($event)\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"><img src=\"assets/images/logos/gouhed.png\" alt=\"\"> \n</span><span class=\"logo-text\">Hp - Fichas</span></div><div class=\"toolbar-separator\"></div><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><md-button class=\"md-icon-button navigation-fold-toggle\" \nhide show-gt-sm aria-label=\"Toggle navigation fold\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" ng-click=\"vm.toggleMsNavigationFolded()\"><md-icon \nclass=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"{{ server.download + vm.user.file.name || \'assets/images/avatars/profile.jpg\' }}\"></div><span class=\"username\" \nhide-sm>{{ vm.user.name || vm.user.username }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Mi perfil\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout($event)\">Cerrar sesión</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && !node.href && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ng-href=\"{{node.href}}\" target=\"{{node.target || \'_self\'}}\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"!node.uisref && node.href && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation | orderBy: \'weight\'\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n		<div class=\"ms-navigation-button\" ng-if=\"!node.uisref && !node.href && node.title\">\n			<i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n			<span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n			<span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n			<i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n		</div>\n\n		<a class=\"ms-navigation-button\" ng-href=\"{{node.href}}\" target=\"{{node.target || \'_self\'}}\"\n		   ng-if=\"!node.uisref && node.href && node.title\">\n			<i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n			<span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n			<span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n			<i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n		</a>\n\n		<a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n		   ng-if=\"node.uisref && node.title\">\n			<i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n			<span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n			<span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n			<i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n		</a>\n\n	</div>\n\n	<ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n		<li ng-repeat=\"node in node.children | orderBy: \'weight\'\" ms-navigation-node=\"node\"\n		    ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n		    ng-include=\"\'navigation-nested.html\'\"></li>\n	</ul>\n</script>");
$templateCache.put("app/pages/admin/categoria/editar/editar.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-add\"></md-icon><span>&nbsp;Editar categoria</span> </span><span flex></span></div></div>\n<md-input-container class=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div><form \nname=\"nuevoCategoria\" class=\"md-inline-form\" novalidate ng-submit=\"vm.doEdit()\"><md-content class=\"content\" flex><h5 \nclass=\"header-material\">Categoria</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container md-no-float \nflex=\"100\"><label>Nombre</label><input type=\"text\" name=\"name\" ng-model=\"vm.categoria.nombre\" placeholder=\"Nombre\" \nrequired><div ng-messages=\"nuevoCategoria.nombre.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEl nombre es requerido.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-switch ng-model=\"vm.categoria.state\" aria-label=\"Estado\">Estado</md-switch></div></md-content><md-divider>\n</md-divider><md-content class=\"content\" flex><h5 class=\"header-material\">Archivos</h5><input-gallery \nng-model=\"vm.categoria.documentos\" multiple=\"true\">Agregar Documentos</input-gallery></md-content><md-content \nclass=\"content\" flex><h5 class=\"header-material\">Campos de Características</h5><div layout=\"column\" layout-gt-xs=\"row\" \nflex ng-repeat=\"field in vm.categoria.fields track by $index\"><md-input-container md-no-float flex=\"33\"><label>Etiqueta\n</label><input type=\"text\" name=\"label\" ng-model=\"vm.categoria.fields[$index].label\" placeholder=\"Etiqueta\" required>\n</md-input-container><md-input-container md-no-float flex=\"33\"><label>Key</label><input type=\"text\" name=\"value\" \nng-model=\"vm.categoria.fields[$index].value\" placeholder=\"Key\" required></md-input-container><div flex=\"33\"><md-button \ntype=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.deleteField($index)\">Eliminar</md-button></div></div><md-button \ntype=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.addField()\">Agregar Característica</md-button></md-content>\n<md-content class=\"md-padding\"><md-button type=\"submit\" class=\"md-raised md-acºcent\" \nng-disabled=\"nuevoCategoria.$invalid\">Editar</md-button></md-content></form></md-content></md-input-container></div>\n</div>");
$templateCache.put("app/pages/admin/categoria/listar/listar.tmpl.html","<md-progress-linear md-mode=\"indeterminate\" class=\"md-warn\" ng-if=\"vm.loading\"></md-progress-linear><div \nid=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Categorias</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"EC.SEARCH\" ng-model=\"vm.search\" flex></div><div><md-button class=\"md-raised md-primary\" \nui-sref=\"app.categoria.nuevo\">Nuevo Categoria</md-button></div></div><div class=\"content-card\" layout=\"column\" flex>\n<md-content class=\"md-padding\"><div listar=\"vm.listConfig\"></div></md-content></div></div></div>");
$templateCache.put("app/pages/admin/categoria/nuevo/nuevo.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-add\"></md-icon><span>&nbsp;Crear categoria</span> </span><span flex></span></div></div>\n<md-input-container class=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div><form \nname=\"nuevoCategoria\" class=\"md-inline-form\" novalidate ng-submit=\"vm.doCreate()\"><md-content class=\"content\" flex><h5 \nclass=\"header-material\">Categoria</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container md-no-float \nflex=\"100\"><label>Nombre</label><input type=\"text\" name=\"name\" ng-model=\"vm.categoria.nombre\" placeholder=\"Nombre\" \nrequired><div ng-messages=\"nuevoCategoria.nombre.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEl nombre es requerido.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-switch ng-model=\"vm.categoria.state\" aria-label=\"Estado\">Estado</md-switch></div></md-content><md-divider>\n</md-divider><md-content class=\"content\" flex><h5 class=\"header-material\">Archivos</h5><input-gallery \nng-model=\"vm.categoria.documentos\" multiple=\"true\">Agregar Documentos</input-gallery></md-content><md-content \nclass=\"content\" flex><h5 class=\"header-material\">Campos de Características</h5><div layout=\"column\" layout-gt-xs=\"row\" \nflex ng-repeat=\"field in vm.categoria.fields track by $index\"><md-input-container md-no-float flex=\"33\"><label>Etiqueta\n</label><input type=\"text\" name=\"label\" ng-model=\"vm.categoria.fields[$index].label\" placeholder=\"Etiqueta\" required>\n</md-input-container><md-input-container md-no-float flex=\"33\"><label>Key</label><input type=\"text\" name=\"value\" \nng-model=\"vm.categoria.fields[$index].value\" placeholder=\"Key\" required></md-input-container><div flex=\"33\"><md-button \ntype=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.deleteField($index)\">Eliminar</md-button></div></div><md-button \ntype=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.addField()\">Agregar Característica</md-button></md-content>\n<md-content class=\"md-padding\"><md-button type=\"submit\" class=\"md-raised md-acºcent\" \nng-disabled=\"nuevoCategoria.$invalid\">Crear</md-button></md-content></form></md-content></md-input-container></div>\n</div>");
$templateCache.put("app/pages/admin/dashboards/analytics/dashboard-analytics.html","<div id=\"dashboard-analytics\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-24 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><div \nclass=\"text-boxed green-600-bg white-fg\">{{vm.widget1.onlineUsers}} online users</div></div><div \nclass=\"pb-32 border-bottom\"><nvd3 class=\"h-400 remove-x-lines remove-opacity\" options=\"vm.widget1.bigChart.options\" \ndata=\"vm.widget1.bigChart.data\"></nvd3></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.sessions.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.sessions.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.sessions.options\" data=\"vm.widget1.sessions.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pageviews.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pageviews.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.pageviews.options\" data=\"vm.widget1.pageviews.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pagesSessions.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pagesSessions.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.pagesSessions.options\" data=\"vm.widget1.pagesSessions.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.avgSessionDuration.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.avgSessionDuration.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.avgSessionDuration.options\" data=\"vm.widget1.avgSessionDuration.data\"></nvd3></div></div></div>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"65\"><ms-widget-front class=\"white-bg\"><div class=\"p-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div>\n<ui-gmap-google-map center=\"vm.widget2.map.center\" zoom=\"vm.widget2.map.zoom\" options=\"vm.widget2.map.options\">\n<ui-gmap-markers models=\"vm.widget2.map.markers\" coords=\"\'coords\'\"><ui-gmap-windows show=\"show\"><div ng-non-bindable>\n{{sessions}}</div></ui-gmap-windows></ui-gmap-markers></ui-gmap-google-map></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"35\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget3.currentRange\" aria-label=\"Change range\">\n<md-option ng-repeat=\"(key, range) in vm.widget3.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div>\n<div class=\"ph-16 pv-20 border-bottom\" ng-repeat=\"page in vm.widget3.pages[vm.widget3.currentRange]\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><span class=\"h4 pb-10\">{{page.path}}</span>\n<md-progress-linear class=\"md-accent\" md-mode=\"determinate\" value=\"{{page.value}}\"></md-progress-linear></div><div \nclass=\"pl-32 h3 font-weight-500 secondary-text\">{{page.value}}%</div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-16 pb-8 md-accent-bg\"><div class=\"h3\">{{vm.widget4.title}}</div>\n</div><md-tabs class=\"md-accent no-radius\" md-dynamic-height><md-tab label=\"{{tab.label}}\" \nng-repeat=\"tab in vm.widget4.tabs\"><div layout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\" ng-repeat=\"group in tab.groups\"><div class=\"h2 m-16 pb-16 border-bottom\">\n{{group.title}}</div><div class=\"p-16 pb-32\" ng-repeat=\"data in group.data\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between start\"><span class=\"h3\">{{data.title}}</span> <span \nclass=\"h3 secondary-text font-weight-500\">{{data.value}}%</span></div><md-progress-linear \nclass=\"{{data.progressColor}}\" md-mode=\"determinate\" value=\"{{data.value}}\"></md-progress-linear></div></div></div>\n</md-tab></md-tabs></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/pages/admin/dashboards/project/dashboard-project.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Bienvenido Eduardo!</span></div><div \nclass=\"toolbar\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div><div \nlayout=\"row\"><div class=\"selected-project\">{{vm.selectedProject.name}}</div></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height><md-tab label=\"Home\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"vm.widget1.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget1.ranges\" \nvalue=\"{{key}}\">{{range}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Detalles</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget1.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Notebooks</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\">Detalles</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">\n{{vm.widget2.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div><div\n class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Este mes:</span> <span class=\"h4 ml-8\">{{vm.widget2.data.extra.count}}</span>\n</div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}\n</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Detalles</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget3.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget4.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\">Detalles</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">\n{{vm.widget4.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div><div\n class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{vm.widget4.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n{{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><div class=\"pv-16\"><md-select \nclass=\"simplified\" ng-model=\"vm.widget6.currentRange\" ng-change=\"vm.widget6.changeRange(vm.widget6.currentRange)\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select></div></div><div class=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget6.mainChart.config\" \noptions=\"vm.widget6.mainChart.options\" data=\"vm.widget6.mainChart.data\"></nvd3></div><div \nclass=\"pv-8 mh-16 border-top\" layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">\n{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerLeft.title}}</span>\n</div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span \nclass=\"font-size-32\">{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">\n{{vm.widget6.footerRight.title}}</span></div></div></ms-widget-front></ms-widget></div></md-tab><md-tab \nlabel=\"Usuarios\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"p-24 mb-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h2\">Usuarios</div><div class=\"text-boxed red-bg white-fg m-0\">\n{{vm.widget11.table.rows.length}} usuarios</div></div><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.widget11.dtOptions\"><thead><tr><th class=\"secondary-text\" \nng-repeat=\"column in ::vm.widget11.table.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in ::vm.widget11.table.rows\"><td ng-repeat=\"cell in row\"><img \nclass=\"avatar\" ng-if=\"$index === 0\" ng-src=\"assets/images/avatars/{{cell}}\"> <span ng-if=\"$index != 0\">{{cell}}</span>\n</td></tr></tbody></table></ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"widget-group\"><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div \nclass=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" md-menu-origin md-menu-align-target \naria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" \nclass=\"icon\"></md-icon>Refresh</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\">\n<div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.month}}</span></div><div \nclass=\"font-size-72 line-height-88 secondary-text font-weight-400\">{{vm.nowWidget.now.day}}</div><div \nclass=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div><md-divider></md-divider></ms-widget-front>\n</ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4\"><md-icon md-font-icon=\"icon-map-marker\" \nclass=\"icon mr-8\"></md-icon>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" md-menu-origin md-menu-align-target aria-label=\"Options\">\n<md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>Refresh\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class=\"p-16 pb-32\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\">\n<md-icon md-font-icon=\"{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}\" class=\"icon s40 mr-16\">\n</md-icon><span class=\"md-display-2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}} </span><span \nclass=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span \nclass=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div \nclass=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}} </span><span \nclass=\"secondary-text ml-5\">{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class=\"pv-16\">\n<div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days\"><span class=\"h4\">{{day.name}}\n</span><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-16\" md-font-icon=\"{{day.icon}}\" class=\"icon\">\n</md-icon><span class=\"h2\">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span \nclass=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span class=\"h2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div>\n</md-sidenav></div>");
$templateCache.put("app/pages/admin/dashboards/server/dashboard-server.html","<div id=\"dashboard-server\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Notebooks</div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefrescar</md-button></md-menu-item></md-menu-content></md-menu></div><div><nvd3 class=\"h-320\" class=\"remove-x-lines\" \noptions=\"vm.widget1.chart.options\" data=\"vm.widget1.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 pink-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" \nmd-font-icon=\"icon-harddisk\"></md-icon><div class=\"h3\">Impresoras</div></div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetalles</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefrescar</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"h2\">Usuarios Conectados</div><div class=\"h2 secondary-text pl-8\">/ 20</div>\n</div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget2.value.percentage}}\"></md-progress-linear>\n</ms-widget-front><ms-widget-back class=\"p-16 pr-32 pink-400-bg white-fg\"><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 blue-bg white-fg\"><div \nclass=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-server-network\"></md-icon><div class=\"h3\">{{vm.widget3.title}}</div></div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pb-24\" layout=\"row\" layout-align=\"start end\"><div class=\"h2\">{{vm.widget3.value.used}}</div><div \nclass=\"h2 pl-8 secondary-text\">/ {{vm.widget3.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget3.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back \nclass=\"p-16 pr-32 blue-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 teal-400-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-clock-fast\"></md-icon><div class=\"h3\">{{vm.widget4.title}}</div></div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pb-8 h1\">{{vm.widget4.value}}</div><div class=\"chart-fill-16\"><nvd3 \nclass=\"h-50 remove-opacity remove-line-stroke\" config=\"vm.widget4.chart.config\" options=\"vm.widget4.chart.options\" \ndata=\"vm.widget4.chart.data\"></nvd3></div></ms-widget-front><ms-widget-back class=\"p-16 pr-32 teal-400-bg white-fg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 indigo-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-scale\"></md-icon><div class=\"h3\">\n{{vm.widget5.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex><div class=\"h1 pb-8\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.widget5.value}}</span><md-icon md-font-icon=\"icon-trending-down\" \nclass=\"ml-16\"></md-icon></div><div class=\"secondary-text\">{{vm.widget5.footnote}}</div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 pr-32 indigo-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget5.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div\n class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div><nvd3 class=\"h-140 remove-x-lines remove-opacity\" config=\"vm.widget6.chart.config\" \noptions=\"vm.widget6.chart.options\" data=\"vm.widget6.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"60\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget7.title}}\n</span> <span class=\"ml-16 text-boxed pink-bg white-fg\">{{vm.widget7.table.rows.length}} processes</span></div>\n<md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget7.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::vm.widget7.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ::vm.widget7.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">{{cell.value}}\n</span></td></tr></tbody></table></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"40\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget8.title}}\n</span> <span class=\"ml-16 text-boxed blue-bg white-fg\">Showing last {{vm.widget8.activities.length}} activity</span>\n</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"ph-16 pv-15 border-bottom\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"activity in vm.widget8.activities\"><div><i class=\"icon pr-16 mr-16 border-right\" \nng-class=\"{\'icon-arrow-down red-fg\':activity.type === \'Input\', \'icon-arrow-up green-fg\':activity.type === \'Output\'}\">\n</i></div><div class=\"h4 text-bold\" flex>{{activity.process}}</div><div class=\"h4 font-weight-500 secondary-text\">\n{{activity.value}}</div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/pages/admin/estatico/editar/editar.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-add\"></md-icon><span>&nbsp;Editar estatico</span> </span><span flex></span></div></div>\n<md-input-container class=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div><form \nname=\"nuevoEstatico\" class=\"md-inline-form\" novalidate ng-submit=\"vm.doEdit()\"><md-content class=\"content\" flex><h5 \nclass=\"header-material\">Estatico</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container md-no-float \nflex=\"100\"><label>Nombre</label><input type=\"text\" name=\"name\" ng-model=\"vm.estatico.name\" placeholder=\"Nombre\" \nrequired><div ng-messages=\"nuevoEstatico.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEl nombre es requerido.</span></div></div></md-input-container></div></md-content><md-divider></md-divider><md-content \nclass=\"content\" flex><h5 class=\"header-material\">Archivo</h5><input-gallery ng-model=\"vm.estatico.file\" \nmultiple=\"false\">Seleccionar</input-gallery></md-content><md-content class=\"md-padding\"><md-button type=\"submit\" \nclass=\"md-raised md-accent\" ng-disabled=\"nuevoEstatico.$invalid\">Crear</md-button></md-content></form></md-content>\n</md-input-container></div></div>");
$templateCache.put("app/pages/admin/estatico/listar/listar.tmpl.html","<md-progress-linear md-mode=\"indeterminate\" class=\"md-warn\" ng-if=\"vm.loading\"></md-progress-linear><div \nid=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Estaticos</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"EC.SEARCH\" ng-model=\"vm.search\" flex></div><div><md-button class=\"md-raised md-primary\" \nui-sref=\"app.estatico.nuevo\">Nuevo Estatico</md-button></div></div><div class=\"content-card\" layout=\"column\" flex>\n<md-content class=\"md-padding\"><div listar=\"vm.listConfig\"></div></md-content></div></div></div>");
$templateCache.put("app/pages/admin/estatico/nuevo/nuevo.tmpl.html","s<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-add\"></md-icon><span>&nbsp;Nuevo estatico</span> </span><span flex></span><md-button \nclass=\"md-raised md-primary\" profile=\"{\'user\': \'access\'}\" ui-sref=\"app.estatico.listar\">Listar estatico</md-button>\n</div></div><md-input-container class=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div>\n<form name=\"nuevoEstatico\" class=\"md-inline-form\" novalidate ng-submit=\"vm.doCreate()\"><md-content class=\"content\" \nflex><h5 class=\"header-material\">Estatico</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nmd-no-float flex=\"100\"><label>Nombre</label><input type=\"text\" name=\"name\" ng-model=\"vm.estatico.name\" \nplaceholder=\"Nombre\" required><div ng-messages=\"nuevoEstatico.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>El nombre es requerido.</span></div></div></md-input-container></div></md-content><md-divider></md-divider>\n<md-content class=\"content\" flex><h5 class=\"header-material\">Archivo</h5><input-gallery ng-model=\"vm.estatico.file\" \nmultiple=\"false\">Seleccionar</input-gallery></md-content><md-content class=\"md-padding\"><md-button type=\"submit\" \nclass=\"md-raised md-accent\" ng-disabled=\"nuevoEstatico.$invalid\">Crear</md-button></md-content></form></md-content>\n</md-input-container></div></div>");
$templateCache.put("app/pages/admin/familia/editar/editar.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-add\"></md-icon><span>&nbsp;Editar familia</span> </span><span flex></span></div></div>\n<md-input-container class=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div><form \nname=\"nuevoFamilia\" class=\"md-inline-form\" novalidate ng-submit=\"vm.doEdit()\"><md-content class=\"content\" flex><h5 \nclass=\"header-material\">Familia</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container md-no-float \nflex=\"100\"><label>Nombre</label><input type=\"text\" name=\"name\" ng-model=\"vm.familia.nombre\" placeholder=\"Nombre\" \nrequired><div ng-messages=\"nuevoFamilia.nombre.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEl nombre es requerido.</span></div></div></md-input-container></div></md-content><md-divider></md-divider><md-content \nclass=\"md-padding\"><md-button type=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"nuevoFamilia.$invalid\">Editar\n</md-button></md-content></form></md-content></md-input-container></div></div>");
$templateCache.put("app/pages/admin/familia/listar/listar.tmpl.html","<md-progress-linear md-mode=\"indeterminate\" class=\"md-warn\" ng-if=\"vm.loading\"></md-progress-linear><div \nid=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Familias</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"EC.SEARCH\" ng-model=\"vm.search\" flex></div><div><md-button class=\"md-raised md-primary\" \nui-sref=\"app.familia.nuevo\">Nuevo Familia</md-button></div></div><div class=\"content-card\" layout=\"column\" flex>\n<md-content class=\"md-padding\"><div listar=\"vm.listConfig\"></div></md-content></div></div></div>");
$templateCache.put("app/pages/admin/familia/nuevo/nuevo.tmpl.html","s<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-add\"></md-icon><span>&nbsp;Nuevo familia</span> </span><span flex></span><md-button \nclass=\"md-raised md-primary\" profile=\"{\'user\': \'access\'}\" ui-sref=\"app.familia.listar\">Listar familia</md-button></div>\n</div><md-input-container class=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div><form \nname=\"nuevoFamilia\" class=\"md-inline-form\" novalidate ng-submit=\"vm.doCreate()\"><md-content class=\"content\" flex><h5 \nclass=\"header-material\">Familia</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container md-no-float \nflex=\"100\"><label>Nombre</label><input type=\"text\" name=\"name\" ng-model=\"vm.familia.nombre\" placeholder=\"Nombre\" \nrequired><div ng-messages=\"nuevoFamilia.nombre.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEl nombre es requerido.</span></div></div></md-input-container></div></md-content><md-divider></md-divider><md-content \nclass=\"md-padding\"><md-button type=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"nuevoFamilia.$invalid\">Nueva\n</md-button></md-content></form></md-content></md-input-container></div></div>");
$templateCache.put("app/pages/admin/logs/listar/listar.tmpl.html","<md-progress-linear md-mode=\"indeterminate\" class=\"md-warn\" ng-if=\"vm.loading\"></md-progress-linear><div \nid=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>LOGS</span></div><div class=\"product-count secondary-text\">\n<span translate=\"EC.TOTAL_PRODUCTS\">Total Logs:</span> <span>{{vm.logs.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"EC.SEARCH\" ng-model=\"vm.search\" flex></div><div><div flex=\"100\" layout=\"row\" \nlayout-align=\"center center\"><md-menu><md-button aria-label=\"more\" class=\"md-raised md-primary\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>Logs</md-button><md-menu-content \nwidth=\"3\"><md-menu-item ng-click=\"\"><md-button ng-click=\"vm.downloadXls()\">Exportar</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div><div class=\"content-card\" layout=\"column\" flex><md-content \nclass=\"md-padding\"><div listar=\"vm.listConfig\"></div></md-content></div></div></div>");
$templateCache.put("app/pages/admin/logs/ver/ver.tmpl.html","<md-progress-linear md-mode=\"indeterminate\" class=\"md-warn\" ng-if=\"vm.loading\"></md-progress-linear><div id=\"timeline\" \nms-timeline=\"vm.timelineOptions\" ng-if=\"vm.timeline\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item \nlayout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" \nng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon \nmd-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">\n{{timelineItem.time | date : \'dd-MM-yyyy hh:mm\'}}</div><div class=\"event\">{{timelineItem.event}}</div></div><div \nclass=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" \nng-model=\"timelineItem.card\"></ms-card></div></div></div>");
$templateCache.put("app/pages/admin/modelos/aprobacion/listar.tmpl.html","<md-progress-linear md-mode=\"indeterminate\" class=\"md-warn\" ng-if=\"vm.loading\"></md-progress-linear><div \nid=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span translate=\"EC.PRODUCTS\">Modelos</span></div><div \nclass=\"product-count secondary-text\" ng-if=\"vm.search || vm.filterCategoria \"><span id=\"search\" ng-if=\"vm.search\">\n<span>Búsqueda por:</span><br><span>\"{{vm.search}}\"<md-button class=\"md-fab md-mini\" \nng-click=\"vm.clearFilter(\'search\')\" aria-label=\"Restablecer búsqueda\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></span></span><span ng-if=\"vm.filterCategoria\"><span>Categoría : {{vm.filterCategoria.nombre}}</span>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.clearFilter(\'categoria\')\" aria-label=\"Restablecer búsqueda\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></span><span ng-if=\"vm.filterSubCategoria\"><span>\nSubcategoria : {{vm.filterSubCategoria.nombre}}</span><md-button class=\"md-fab md-mini\" \nng-click=\"vm.clearFilter(\'subcategoria\')\" aria-label=\"Restablecer búsqueda\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"EC.SEARCH\" \nng-model=\"vm.search\" flex><md-button class=\"md-primary\">Buscar</md-button></div><div class=\"botones\"><div flex=\"100\" \nlayout=\"row\" layout-align=\"left center\"><md-menu><md-button aria-label=\"more\" class=\"md-raised md-primary\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>Descargas Excel</md-button>\n<md-menu-content width=\"3\"><md-menu-item ng-click=\"vm.downloadXls()\"><md-button>Descargar Excel</md-button>\n</md-menu-item><md-menu-item ng-repeat=\"estatico in vm.estaticos\"><md-button ng-click=\"vm.downloadEstatico(estatico)\">\n{{estatico.name}}</md-button></md-menu-item></md-menu-content></md-menu></div><div flex=\"100\" layout=\"row\" \nlayout-align=\"left center\"><md-menu><md-button aria-label=\"more\" class=\"md-raised md-primary\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><span ng-if=\"!vm.filterCategoria\">\nFiltrar por categoría</span> <span ng-if=\"vm.filterCategoria\">Mostrando : {{vm.filterCategoria.nombre}}</span>\n</md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"categoria in vm.categorias\"><md-button \nng-click=\"vm.setCategoria(categoria)\">{{categoria.nombre}}</md-button></md-menu-item></md-menu-content></md-menu></div>\n<div flex=\"100\" layout=\"row\" layout-align=\"left center\" \nng-if=\"vm.filterCategoria && vm.filterCategoria.nombre ==\'Campañas\'\"><md-menu><md-button aria-label=\"more\" \nclass=\"md-raised md-primary\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><span\n ng-if=\"!vm.filterSubCategoria.nombre\">Filtrar por Subcategoría</span> <span ng-if=\"vm.filterSubCategoria\">\nMostrando : {{vm.filterSubCategoria.nombre}}</span></md-button><md-menu-content width=\"3\"><md-menu-item \nng-repeat=\"subcategoria in vm.subcategoriasCamapana\"><md-button ng-click=\"vm.setSubCategoria(subcategoria)\">\n{{subcategoria.nombre}}</md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><md-content class=\"md-padding\"><div listar=\"vm.listConfig\"></div>\n</md-content></div></div></div>");
$templateCache.put("app/pages/admin/modelos/editar/editar.tmpl.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ui-sref=\"app.modelos.listar\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"product-image\" hide-xs><img \nng-src=\"{{vm.modelo.langs.PT.imagen[0].url}}\"></div><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.modelo.langs.PT.nombre}}</div><div class=\"subtitle secondary-text\"><span translate=\"EC.PRODUCT_DETAIL\">\nProduct Detail</span></div></div></div></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.doEdit()\">\n<span translate=\"EC.SAVE\">SAVE</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab>\n<md-tab-label><span translate=\"EC.BASIC_INFO\">Información Básica</span></md-tab-label><md-tab-body><md-progress-linear \nmd-mode=\"query\" md-class=\"blue-200-bg\" ng-if=\"vm.loading\"></md-progress-linear><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><label>\nNombre Recomendado</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.nombreRecomendado\"><replace \nng-if=\"vm.otherLangAvailable && !vm.modelo.langs.PT.nombreRecomendado\" \nothervalue=\"vm.modelo.langs.esCL.nombreRecomendado\" ng-model=\"vm.modelo.langs.PT.nombreRecomendado\" \notherlang=\"\'Espanol\'\"></replace></md-input-container><md-input-container class=\"md-block\"><label>Nombre</label><input \ntype=\"text\" ng-model=\"vm.modelo.langs.PT.nombre\"><replace ng-if=\"vm.otherLangAvailable && !vm.modelo.langs.PT.nombre\" \nothervalue=\"vm.modelo.langs.esCL.nombre\" ng-model=\"vm.modelo.langs.PT.nombre\" otherlang=\"\'Espanol\'\"></replace>\n</md-input-container><md-input-container class=\"md-block\"><label>EAN</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.eanString\"><replace ng-if=\"vm.otherLangAvailable && !vm.modelo.langs.PT.eanString\" \nothervalue=\"vm.modelo.langs.esCL.eanString\" ng-model=\"vm.modelo.langs.PT.eanString\" otherlang=\"\'Espanol\'\"></replace>\n</md-input-container><md-input-container class=\"md-block\"><md-select ng-model=\"vm.modelo.categoriaId\" \nplaceholder=\"Seleccione Categoria\" ng-change=\"vm.changeCategoria()\"><md-option ng-value=\"categoria.id\" \nng-repeat=\"categoria in vm.categorias\" ng-selected=\"{{ categoria.id === vm.modelo.categoriaId ? \'true\' : \'false\' }}\">\n{{ categoria.nombre }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><md-select \nng-model=\"vm.modelo.langs.PT.familiaId\" placeholder=\"Seleccione Familia de Producto\"><md-option ng-value=\"familia.id\" \nng-repeat=\"familia in vm.familias\">{{ familia.nombre }}</md-option></md-select></md-input-container><md-input-container\n class=\"md-block\"><label>SKU</label><input type=\"text\" ng-model=\"vm.modelo.sku\" disabled=\"disabled\">\n</md-input-container><md-input-container class=\"md-block\"><label>Texto descriptivo</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.introduccion\"><replace ng-if=\"vm.otherLangAvailable && !vm.modelo.langs.PT.introduccion\" \nothervalue=\"vm.modelo.langs.esCL.introduccion\" ng-model=\"vm.modelo.langs.PT.introduccion\" otherlang=\"\'Espanol\'\">\n</replace></md-input-container><md-input-container class=\"md-block\"><label>Keywords</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.keywords\"><replace ng-if=\"vm.otherLangAvailable && !vm.modelo.langs.PT.keywords\" \nothervalue=\"vm.modelo.langs.esCL.keywords\" ng-model=\"vm.modelo.langs.PT.keywords\" otherlang=\"\'Espanol\'\"></replace>\n</md-input-container></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Características do modelo</span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\">\n<md-input-container class=\"md-block\" ng-repeat=\"field in vm.fieldsModelo\" ng-if=\"!vm.isBasicField(field.value)\"><label>\n{{vm.getFieldLabel(field)}}</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT[field.value]\"><replace \nng-if=\"vm.otherLangAvailable && !vm.modelo.langs.PT[field.value] && vm.modelo.langs.esCL[field.value]\" \nothervalue=\"vm.modelo.langs.esCL[field.value]\" ng-model=\"vm.modelo.langs.PT[field.value]\" otherlang=\"\'Espanhol\'\">\n</replace></md-input-container></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Ficha y Documentos</span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div><h5 \nclass=\"header-material\">Ficha de Producto</h5><input-gallery ng-model=\"vm.modelo.langs.PT.ficha\" multiple=\"true\">\nSeleccionar Imagen</input-gallery></div><div><h5 class=\"header-material\">Documentos</h5><input-gallery \nng-model=\"vm.modelo.langs.PT.documentos\" multiple=\"true\">Agregar Documentos</input-gallery></div></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span translate=\"EC.PRODUCT_IMAGES\">Imágenes y Videos del Modelo</span></md-tab-label>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div><h5 \nclass=\"header-material\">Imagen Predeterminada</h5><input-gallery ng-model=\"vm.modelo.langs.PT.imagen\" multiple=\"false\">\nSeleccionar Imagen</input-gallery><h5 class=\"header-material\">Videos</h5><input-gallery \nng-model=\"vm.modelo.langs.PT.videos\" multiple=\"false\">Seleccionar Videos</input-gallery><h5 class=\"header-material\">\nGalería</h5><input-gallery ng-model=\"vm.modelo.langs.PT.galeria\" multiple=\"true\">Agregar imágenes</input-gallery></div>\n</div></md-tab-body></md-tab><md-tab><md-tab-label><span>Diferenciadores y Visuales</span></md-tab-label><md-tab-body>\n<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><h5 class=\"header-material\">\nDiferenciadores</h5><div class=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" flex><md-list><md-list-item \nclass=\"md-3-line\" ng-repeat=\"diferenciador in vm.modelo.langs.PT.diferenciadores track by $index\" \nstyle=\"min-width:800px;max-width:1000px\"><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadores[$index].imagen\" \nmultiple=\"false\">Imagen</input-gallery><div class=\"md-list-item-text\"><h3 ng-if=\"!diferenciador.editing\">\n{{diferenciador.titulo}}</h3><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><input type=\"text\" \nng-model=\"diferenciador.titulo\" placeholder=\"Titulo...\"></md-input-container><p ng-if=\"!diferenciador.editing\">\n{{diferenciador.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><textarea \ntype=\"text\" ng-model=\"diferenciador.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div>\n<div style=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!diferenciador.editing\" ng-click=\"diferenciador.editing = true\"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"diferenciador.editing\" \nng-click=\"diferenciador.editing = false\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarDiferenciador($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.agregarDiferenciador()\">Agregar Diferenciador\n</md-button><h5 class=\"header-material\">Diferenciadores</h5><input-gallery ng-model=\"vm.modelo.langs.PT.visuales\" \nmultiple=\"true\">Agregar Visuales</input-gallery></div></md-tab-body></md-tab><md-tab><md-tab-label><span>\nContenido Indexado</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\">\n<md-select ng-model=\"vm.modelo.langs.PT.templateId\" placeholder=\"Seleccione Template\"><md-option \nng-value=\"template.id\" ng-repeat=\"template in vm.templates\">{{ template.name }}</md-option></md-select>\n</md-input-container><div layout=\"column\" layout-gt-xs=\"row\" flex><md-switch \nng-model=\"vm.modelo.langs.PT.indexadoActive\" aria-label=\"Estado\">Estado</md-switch></div><div \nid=\"templateNuevoAccesorios\" ng-if=\"vm.modelo.langs.PT.templateId==\'5f7482f21d54fa39824dd6e7\'\"><md-input-container \nclass=\"md-block\"><label>Nombre 1 era linea</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.nameFirstLine\">\n</md-input-container><md-input-container class=\"md-block\"><label>Nombre 2 da linea</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.nameSecondLine\"><input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.headerDesktop\" \nmultiple=\"false\">Header Desktop</input-gallery><input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.headerMobile\" \nmultiple=\"false\">Header Mobile</input-gallery><h5 class=\"header-material\">Diferenciadores</h5><div \nclass=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" flex><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"diferenciador in vm.modelo.langs.PT.diferenciadores track by $index\" \nstyle=\"min-width:800px;max-width:1000px\"><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadores[$index].imagen\" \nmultiple=\"false\">Imagen</input-gallery><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadores[$index].imagenBody\" \nmultiple=\"false\">Imagen Contenido</input-gallery><div class=\"md-list-item-text\"><h3 ng-if=\"!diferenciador.editing\">\n{{diferenciador.titulo}}</h3><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><input type=\"text\" \nng-model=\"diferenciador.titulo\" placeholder=\"Titulo...\"></md-input-container><p ng-if=\"!diferenciador.editing\">\n{{diferenciador.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><textarea \ntype=\"text\" ng-model=\"diferenciador.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div>\n<div style=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!diferenciador.editing\" ng-click=\"diferenciador.editing = true\"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"diferenciador.editing\" \nng-click=\"diferenciador.editing = false\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarDiferenciador($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.agregarDiferenciador()\">Agregar Diferenciador\n</md-button><h5 class=\"header-material\">diferenciadores sin Lifestyle</h5><div class=\"diferenciadoresSL\" layout=\"row\" \nlayout-align=\"start center\" flex><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"diferenciadorSL in vm.modelo.langs.PT.diferenciadoresSL track by $index\" \nstyle=\"min-width:800px;max-width:1000px\"><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadoresSL[$index].imagen\" \nmultiple=\"false\">Imagen</input-gallery><div class=\"md-list-item-text\"><h3 ng-if=\"!diferenciadorSL.editing\">\n{{diferenciadorSL.titulo}}</h3><md-input-container class=\"md-block\" ng-if=\"diferenciadorSL.editing\"><input type=\"text\" \nng-model=\"diferenciadorSL.titulo\" placeholder=\"Titulo...\"></md-input-container><p ng-if=\"!diferenciadorSL.editing\">\n{{diferenciadorSL.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"diferenciadorSL.editing\"><textarea \ntype=\"text\" ng-model=\"diferenciadorSL.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div>\n<div style=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!diferenciadorSL.editing\" ng-click=\"diferenciadorSL.editing = true\"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" \nng-if=\"diferenciadorSL.editing\" ng-click=\"diferenciadorSL.editing = false\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" \nng-click=\"vm.eliminardiferenciadorSL($index)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div>\n<md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item></md-list></div><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.agregarDiferenciadorSL()\">Agregar diferenciadorSL</md-button><h5 \nclass=\"header-material\">Galería Sindicado</h5><input-gallery ng-model=\"vm.modelo.langs.PT.galeria\" multiple=\"true\">\nAgregar imágenes</input-gallery><md-input-container class=\"md-block\"><textarea type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.legales\" placeholder=\"Legales...\"></textarea></md-input-container>\n</md-input-container></div><div id=\"templateNuevoMonitor\" \nng-if=\"vm.modelo.langs.PT.templateId==\'5f0cd69420215c2aa50312ec\'\"><md-input-container class=\"md-block\"><label>\nNombre 1 era linea</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.nameFirstLine\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Nombre 2 da linea</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.nameSecondLine\"><input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.headerDesktop\" \nmultiple=\"false\">Header Desktop</input-gallery><input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.headerMobile\" \nmultiple=\"false\">Header Mobile</input-gallery><h5 class=\"header-material\">Diferenciadores</h5><div \nclass=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" flex><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"diferenciador in vm.modelo.langs.PT.diferenciadores track by $index\" \nstyle=\"min-width:800px;max-width:1000px\"><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadores[$index].imagen\" \nmultiple=\"false\">Imagen</input-gallery><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadores[$index].imagenBody\" \nmultiple=\"false\">Imagen Contenido</input-gallery><div class=\"md-list-item-text\"><h3 ng-if=\"!diferenciador.editing\">\n{{diferenciador.titulo}}</h3><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><input type=\"text\" \nng-model=\"diferenciador.titulo\" placeholder=\"Titulo...\"></md-input-container><p ng-if=\"!diferenciador.editing\">\n{{diferenciador.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><textarea \ntype=\"text\" ng-model=\"diferenciador.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div>\n<div style=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!diferenciador.editing\" ng-click=\"diferenciador.editing = true\"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"diferenciador.editing\" \nng-click=\"diferenciador.editing = false\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarDiferenciador($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.agregarDiferenciador()\">Agregar Diferenciador\n</md-button><md-input-container class=\"md-block\"><label>Video 1 ID Youtube</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.video\"></md-input-container><md-input-container class=\"md-block\"><label>\nVideo 2 ID Youtube</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.video2\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Video 3 ID Youtube</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.video3\"></md-input-container><h5 class=\"header-material\">Galería Sindicado</h5>\n<input-gallery ng-model=\"vm.modelo.langs.PT.galeria\" multiple=\"true\">Agregar imágenes</input-gallery>\n<md-input-container class=\"md-block\"><textarea type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.legales\" \nplaceholder=\"Legales...\"></textarea></md-input-container></md-input-container></div><div id=\"templateNuevoNotebook\" \nng-if=\"vm.modelo.langs.PT.templateId==\'5ec53880864e24a3acd37a0c\' || vm.modelo.langs.PT.templateId==\'5eecd39b11dee292483f238c\'\">\n<md-input-container class=\"md-block\"><label>Nombre 1 era linea</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.nameFirstLine\"></md-input-container><md-input-container class=\"md-block\"><label>\nNombre 2 da linea</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.nameSecondLine\"><input-gallery \nng-model=\"vm.modelo.langs.PT.sindicado.headerDesktop\" multiple=\"false\">Header Desktop</input-gallery><input-gallery \nng-model=\"vm.modelo.langs.PT.sindicado.headerMobile\" multiple=\"false\">Header Mobile</input-gallery><h5 \nclass=\"header-material\">Diferenciadores</h5><div class=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" flex>\n<md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"diferenciador in vm.modelo.langs.PT.diferenciadores track by $index\" \nstyle=\"min-width:800px;max-width:1000px\"><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadores[$index].imagen\" \nmultiple=\"false\">Imagen</input-gallery><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadores[$index].imagenBody\" \nmultiple=\"false\">Imagen Contenido</input-gallery><div class=\"md-list-item-text\"><h3 ng-if=\"!diferenciador.editing\">\n{{diferenciador.titulo}}</h3><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><input type=\"text\" \nng-model=\"diferenciador.titulo\" placeholder=\"Titulo...\"></md-input-container><p ng-if=\"!diferenciador.editing\">\n{{diferenciador.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><textarea \ntype=\"text\" ng-model=\"diferenciador.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div>\n<div style=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!diferenciador.editing\" ng-click=\"diferenciador.editing = true\"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"diferenciador.editing\" \nng-click=\"diferenciador.editing = false\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarDiferenciador($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.agregarDiferenciador()\">Agregar Diferenciador\n</md-button><md-input-container class=\"md-block\"><label>Video 1 ID Youtube</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.video\"></md-input-container><md-input-container class=\"md-block\"><label>\nVideo 2 ID Youtube</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.video2\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Video 3 ID Youtube</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.video3\"></md-input-container><md-input-container class=\"md-block\"><label>\nVideo 4 ID Youtube</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.video4\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Video 5 ID Youtube</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.video5\"></md-input-container><h5 class=\"header-material\">Galería Sindicado</h5>\n<input-gallery ng-model=\"vm.modelo.langs.PT.galeria\" multiple=\"true\">Agregar imágenes</input-gallery>\n<md-input-container class=\"md-block\"><textarea type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.legales\" \nplaceholder=\"Legales...\"></textarea></md-input-container></md-input-container></div><div id=\"templateNuevoImpresora\" \nng-if=\"vm.modelo.langs.PT.templateId==\'5ec5386c864e24a3acd37a0a\'\"><md-input-container class=\"md-block\"><label>\nNombre 1 era linea</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.nameFirstLine\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Nombre 2 da linea</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.nameSecondLine\"></md-input-container><input-gallery \nng-model=\"vm.modelo.langs.PT.sindicado.headerDesktop\" multiple=\"false\">Header Desktop</input-gallery><input-gallery \nng-model=\"vm.modelo.langs.PT.sindicado.headerMobile\" multiple=\"false\">Header Mobile</input-gallery><h5 \nclass=\"header-material\">Diferenciadores</h5><div class=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" flex>\n<md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"diferenciador in vm.modelo.langs.PT.diferenciadores track by $index\" \nstyle=\"min-width:800px;max-width:1000px\"><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadores[$index].imagen\" \nmultiple=\"false\">Imagen</input-gallery><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadores[$index].imagenBody\" \nmultiple=\"false\">Imagen Contenido</input-gallery><div class=\"md-list-item-text\"><h3 ng-if=\"!diferenciador.editing\">\n{{diferenciador.titulo}}</h3><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><input type=\"text\" \nng-model=\"diferenciador.titulo\" placeholder=\"Titulo...\"></md-input-container><p ng-if=\"!diferenciador.editing\">\n{{diferenciador.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><textarea \ntype=\"text\" ng-model=\"diferenciador.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div>\n<div style=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!diferenciador.editing\" ng-click=\"diferenciador.editing = true\"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"diferenciador.editing\" \nng-click=\"diferenciador.editing = false\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarDiferenciador($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.agregarDiferenciador()\">Agregar Diferenciador\n</md-button><md-input-container class=\"md-block\"><label>Video 1 ID Youtube</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.video\"></md-input-container><md-input-container class=\"md-block\"><label>\nVideo 2 ID Youtube</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.video2\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Video 3 ID Youtube</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.video3\"></md-input-container><md-input-container class=\"md-block\"><label>\nVideo 4 ID Youtube</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.video4\"></md-input-container><h5 \nclass=\"header-material\">Galería Sindicado</h5><input-gallery ng-model=\"vm.modelo.langs.PT.galeria\" multiple=\"true\">\nAgregar imágenes</input-gallery><md-input-container class=\"md-block\"><textarea type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.legales\" placeholder=\"Legales...\"></textarea></md-input-container></div><div \nid=\"templateNuevoSupplies\" ng-if=\"vm.modelo.langs.PT.templateId==\'5f39c5e59bbb440bba6aead5\'\"><md-input-container \nclass=\"md-block\"><label>Nombre 1 era linea</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.nameFirstLine\">\n</md-input-container><md-input-container class=\"md-block\"><label>Nombre 2 da linea</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.nameSecondLine\"></md-input-container><input-gallery \nng-model=\"vm.modelo.langs.PT.sindicado.headerDesktop\" multiple=\"false\">Header Desktop</input-gallery><input-gallery \nng-model=\"vm.modelo.langs.PT.sindicado.headerMobile\" multiple=\"false\">Header Mobile</input-gallery><h5 \nclass=\"header-material\">Diferenciadores</h5><div class=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" flex>\n<md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"diferenciador in vm.modelo.langs.PT.diferenciadores track by $index\" \nstyle=\"min-width:800px;max-width:1000px\"><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadores[$index].imagen\" \nmultiple=\"false\">Imagen</input-gallery><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadores[$index].imagenBody\" \nmultiple=\"false\">Imagen Contenido</input-gallery><div class=\"md-list-item-text\"><h3 ng-if=\"!diferenciador.editing\">\n{{diferenciador.titulo}}</h3><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><input type=\"text\" \nng-model=\"diferenciador.titulo\" placeholder=\"Titulo...\"></md-input-container><p ng-if=\"!diferenciador.editing\">\n{{diferenciador.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><textarea \ntype=\"text\" ng-model=\"diferenciador.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div>\n<div style=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!diferenciador.editing\" ng-click=\"diferenciador.editing = true\"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"diferenciador.editing\" \nng-click=\"diferenciador.editing = false\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarDiferenciador($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.agregarDiferenciador()\">Agregar Diferenciador\n</md-button><md-input-container class=\"md-block\"><label>Video 1 ID Youtube</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.video\"></md-input-container><md-input-container class=\"md-block\"><label>\nVideo 2 ID Youtube</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.video2\"></md-input-container><h5 \nclass=\"header-material\">Galería Sindicado</h5><input-gallery ng-model=\"vm.modelo.langs.PT.galeria\" multiple=\"true\">\nAgregar imágenes</input-gallery><md-input-container class=\"md-block\"><textarea type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.legales\" placeholder=\"Legales...\"></textarea></md-input-container><input-gallery\n ng-model=\"vm.modelo.langs.PT.indexado.pdf\" multiple=\"false\">PDF Descargable</input-gallery></div><div \nid=\"templateAntiguo\" \nng-if=\"vm.modelo.langs.PT.templateId!=\'5ec5386c864e24a3acd37a0a\' && vm.modelo.langs.PT.templateId!= \'5ec53880864e24a3acd37a0c\' && vm.modelo.langs.PT.templateId != \'5eecd39b11dee292483f238c\' && vm.modelo.langs.PT.templateId !=\'5f39c5e59bbb440bba6aead5\' && vm.modelo.langs.PT.templateId !=\'5f7482f21d54fa39824dd6e7\' \">\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.banner\" multiple=\"false\">Imagen Banner Superior</input-gallery>\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.bannerInferior\" multiple=\"false\">Imagen Banner Inferior\n</input-gallery><md-input-container class=\"md-block\"><label>Video 1 ID Youtube</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.video\"></md-input-container><md-input-container class=\"md-block\"><label>\nVideo 2 ID Youtube</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.video2\"></md-input-container><div \nng-if=\"vm.modelo.langs.PT.categoriaId == \'56c678072405ddbf462d40e7\' || vm.modelo.langs.PT.categoriaId == \'56c677ff2405ddbf462d40e5\'  || vm.modelo.langs.PT.categoriaId == \'590a3eeb77c84c53dc8cace4\' || vm.modelo.langs.PT.categoriaId==\'5e74ac02ad5afe6b087119fc\' \">\n<md-input-container class=\"md-block\"><label>Texto Cabecera Derecha</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.cabeceraDerecha\"></md-input-container><md-input-container class=\"md-block\">\n<label>Subtitulo</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.subtitulo\"></md-input-container>\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.imagenFicha\" multiple=\"false\">Imagen Ficha</input-gallery>\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.imagenEspecificaciones\" multiple=\"false\">Imagen Especificaciones\n</input-gallery><h5 class=\"header-material\">Visuales Plantilla</h5><div class=\"diferenciadores\" layout=\"row\" \nlayout-align=\"start center\" flex><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"visual in vm.modelo.langs.PT.sindicado.visuales track by $index\" style=\"min-width:800px;max-width:1000px\">\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.visuales[$index].imagen\" multiple=\"false\">Imagen</input-gallery>\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.visuales[$index].icono\" multiple=\"false\">Ícono</input-gallery>\n<div class=\"md-list-item-text\"><h3 ng-if=\"!visual.editing\">{{visual.titulo}}</h3><md-input-container class=\"md-block\" \nng-if=\"visual.editing\"><input type=\"text\" ng-model=\"visual.titulo\" placeholder=\"Titulo...\"></md-input-container><p \nng-if=\"!visual.editing\">{{visual.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"visual.editing\"><textarea\n type=\"text\" ng-model=\"visual.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div><div \nstyle=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!visual.editing\" ng-click=\"visual.editing = true\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\n</md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"visual.editing\" \nng-click=\"visual.editing = false\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarVisualSindicado($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.agregarVisualSindicado()\">Agregar Visual\n</md-button><md-input-container class=\"md-block\"><textarea type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.legales\" \nplaceholder=\"Legales...\"></textarea></md-input-container></div><div \nng-if=\"vm.modelo.langs.PT.categoriaId == \'56c678022405ddbf462d40e6\' || vm.modelo.langs.PT.categoriaId == \'57ab452792623112e483e371\' ||  vm.modelo.langs.PT.categoriaId == \'56c677ff2405ddbf462d40e5\'\">\n<md-input-container class=\"md-block\"><label>Título</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.sindicado.titulo\"></md-input-container><md-input-container class=\"md-block\"><label>\nSubtitulo</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.subtitulo\"></md-input-container>\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.imagenFicha\" multiple=\"false\">Imagen Ficha</input-gallery><h5 \nclass=\"header-material\">Diferenciadores</h5><div class=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" flex>\n<md-list><md-list-item class=\"md-3-line\" ng-repeat=\"visual in vm.modelo.langs.PT.sindicado.visuales track by $index\" \nstyle=\"min-width:800px;max-width:1000px\"><input-gallery \nng-model=\"vm.modelo.langs.PT.sindicado.visuales[$index].imagen\" multiple=\"false\">Imagen</input-gallery><div \nclass=\"md-list-item-text\"><h3 ng-if=\"!visual.editing\">{{visual.titulo}}</h3><md-input-container class=\"md-block\" \nng-if=\"visual.editing\"><input type=\"text\" ng-model=\"visual.titulo\" placeholder=\"Titulo...\"></md-input-container><p \nng-if=\"!visual.editing\">{{visual.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"visual.editing\"><textarea\n type=\"text\" ng-model=\"visual.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div><div \nstyle=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!visual.editing\" ng-click=\"visual.editing = true\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\n</md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"visual.editing\" \nng-click=\"visual.editing = false\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarVisualSindicado($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.agregarVisualSindicado()\">Agregar Diferenciador\n</md-button><md-input-container class=\"md-block\"><textarea type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.legales\" \nplaceholder=\"Legales...\"></textarea></md-input-container></div><div \nng-if=\"vm.modelo.langs.PT.categoriaId == \'56c677fb2405ddbf462d40e4\'\"><md-input-container class=\"md-block\"><label>\nSubtitulo</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.subtitulo\"></md-input-container>\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.imagenFicha\" multiple=\"false\">Imagen Ficha</input-gallery><h5 \nclass=\"header-material\">Visuales Plantilla</h5><div class=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" \nflex><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"visual in vm.modelo.langs.PT.sindicado.visuales track by $index\" style=\"min-width:800px;max-width:1000px\">\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.visuales[$index].imagen\" multiple=\"false\">Imagen</input-gallery>\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.visuales[$index].icono\" multiple=\"false\">Ícono</input-gallery>\n<div class=\"md-list-item-text\"><h3 ng-if=\"!visual.editing\">{{visual.titulo}}</h3><md-input-container class=\"md-block\" \nng-if=\"visual.editing\"><input type=\"text\" ng-model=\"visual.titulo\" placeholder=\"Titulo...\"></md-input-container><p \nng-if=\"!visual.editing\">{{visual.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"visual.editing\"><textarea\n type=\"text\" ng-model=\"visual.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div><div \nstyle=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!visual.editing\" ng-click=\"visual.editing = true\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\n</md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"visual.editing\" \nng-click=\"visual.editing = false\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarVisualSindicado($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.agregarVisualSindicado()\">Agregar Visual\n</md-button><h5 class=\"header-material\">Tintas Compatibles</h5><div class=\"diferenciadores\" layout=\"row\" \nlayout-align=\"start center\" flex><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"tinta in vm.modelo.langs.PT.sindicado.tintas track by $index\" style=\"min-width:800px;max-width:1000px\">\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.tintas[$index].imagen\" multiple=\"false\">Imagen</input-gallery>\n<div class=\"md-list-item-text\"><h3 ng-if=\"!tinta.editing\">{{tinta.titulo}}</h3><md-input-container class=\"md-block\" \nng-if=\"tinta.editing\"><input type=\"text\" ng-model=\"tinta.titulo\" placeholder=\"Titulo...\"></md-input-container><p \nng-if=\"!tinta.editing\">{{tinta.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"tinta.editing\"><textarea \ntype=\"text\" ng-model=\"tinta.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div><div \nstyle=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!tinta.editing\" ng-click=\"tinta.editing = true\"><md-icon md-font-icon=\"icon-border-color\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"tinta.editing\" \nng-click=\"tinta.editing = false\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarTintaSindicado($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.agregarTintaSindicado()\">Agregar Tinta Compatible\n</md-button><md-input-container class=\"md-block\"><textarea type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.legales\" \nplaceholder=\"Legales...\"></textarea></md-input-container></div><div \nng-if=\"vm.modelo.langs.PT.categoriaId == \'57ab44ce92623112e483e370\'\"><md-input-container class=\"md-block\"><label>\nSubtitulo</label><input type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.subtitulo\"></md-input-container>\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.imagenFicha\" multiple=\"false\">Imagen Ficha</input-gallery><h5 \nclass=\"header-material\">Visuales Plantilla</h5><div class=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" \nflex><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"visual in vm.modelo.langs.PT.sindicado.visuales track by $index\" style=\"min-width:800px;max-width:1000px\">\n<input-gallery ng-model=\"vm.modelo.langs.PT.sindicado.visuales[$index].imagen\" multiple=\"false\">Imagen</input-gallery>\n<div style=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!visual.editing\" ng-click=\"visual.editing = true\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\n</md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"visual.editing\" \nng-click=\"visual.editing = false\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarVisualSindicado($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.agregarVisualSindicado()\">Agregar Visual\n</md-button><md-input-container class=\"md-block\"><textarea type=\"text\" ng-model=\"vm.modelo.langs.PT.sindicado.legales\" \nplaceholder=\"Legales...\"></textarea></md-input-container></div></div></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.isGod || vm.isHp\"><md-tab-label><span>Contenido Inpage</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div><h5 class=\"header-material\">\nMateriales MELI / A+</h5><p class=\"pb-16\">\nSuba un archivo ZIP con los materiales de contenido Inpage. La URL del archivo se guardará automáticamente.</p>\n<input-gallery ng-model=\"vm.modelo.langs.PT.materialsZip\" multiple=\"false\">Seleccionar archivo ZIP</input-gallery>\n</div><div ng-if=\"vm.modelo.langs.PT.materialsLink\" style=\"margin-top: 20px\"><h5 class=\"header-material\">\nURL actual del material</h5><md-input-container class=\"md-block\"><label>Materiales MELI / A+</label><input type=\"text\" \nng-model=\"vm.modelo.langs.PT.materialsLink\" readonly=\"readonly\" ng-click=\"$event.target.select()\"></md-input-container>\n</div></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/pages/admin/modelos/listar/listar.tmpl.html","<md-progress-linear md-mode=\"indeterminate\" class=\"md-warn\" ng-if=\"vm.loading\"></md-progress-linear><div \nid=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Modelos</span></div><div \nclass=\"product-count secondary-text\" ng-if=\"vm.search || vm.filterCategoria \"><span id=\"search\" ng-if=\"vm.search\">\n<span>Búsqueda por:</span><br><span>\"{{vm.search}}\"<md-button class=\"md-fab md-mini\" \nng-click=\"vm.clearFilter(\'search\')\" aria-label=\"Restablecer búsqueda\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></span></span><span ng-if=\"vm.filterCategoria\"><span>Categoría : {{vm.filterCategoria.nombre}}</span>\n<md-button class=\"md-fab md-mini\" ng-click=\"vm.clearFilter(\'categoria\')\" aria-label=\"Restablecer búsqueda\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></span><span ng-if=\"vm.filterSubCategoria\"><span>\nSubcategoria : {{vm.filterSubCategoria.nombre}}</span><md-button class=\"md-fab md-mini\" \nng-click=\"vm.clearFilter(\'subcategoria\')\" aria-label=\"Restablecer búsqueda\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Pesquisa\" translate-attr-placeholder=\"EC.SEARCH\" ng-model=\"vm.search\" \nflex><md-button class=\"md-primary\">Pesquisa</md-button></div><div class=\"botones\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"left center\"><md-menu><md-button aria-label=\"more\" class=\"md-raised md-primary\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>Downloads Excel</md-button>\n<md-menu-content width=\"3\"><md-menu-item ng-click=\"vm.downloadXls()\"><md-button>Descargar Excel</md-button>\n</md-menu-item><md-menu-item ng-repeat=\"estatico in vm.estaticos\"><md-button ng-click=\"vm.downloadEstatico(estatico)\">\n{{estatico.name}}</md-button></md-menu-item></md-menu-content></md-menu></div><div flex=\"100\" layout=\"row\" \nlayout-align=\"left center\"><md-button class=\"md-raised md-primary\" ui-sref=\"app.modelos.nuevo\" ng-if=\"vm.isGod\">\nAdicionar Modelo</md-button></div></div></div><div class=\"content-card\" layout=\"column\" flex \nstyle=\"overflow:auto !important\"><md-fab-toolbar md-open=\"false\" count=\"0\" md-direction=\"left\" \nstyle=\"right:0 !important;position:absolute\"><md-fab-trigger class=\"align-with-text\"><md-button aria-label=\"menu\" \nclass=\"md-fab md-primary\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button></md-fab-trigger><md-toolbar>\n<md-fab-actions class=\"md-toolbar-tools\"><div flex=\"100\" layout=\"row\" layout-align=\"left center\"><md-menu><md-button \naria-label=\"more\" class=\"md-raised md-primary\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon><span ng-if=\"!vm.filterCategoria\">Filtrar por categoría</span> <span \nng-if=\"vm.filterCategoria\">Mostrando : {{vm.filterCategoria.nombre}}</span></md-button><md-menu-content width=\"3\">\n<md-menu-item ng-repeat=\"categoria in vm.categorias\"><md-button ng-click=\"vm.setCategoria(categoria)\">\n{{categoria.nombre}}</md-button></md-menu-item></md-menu-content></md-menu></div><div flex=\"100\" layout=\"row\" \nlayout-align=\"left center\"><md-menu><md-button aria-label=\"more\" class=\"md-raised md-primary\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><span \nng-if=\"!vm.filterSubCategoria.nombre\">Filtrar por Subcategoría</span> <span ng-if=\"vm.filterSubCategoria\">\nMostrando : {{vm.filterSubCategoria.nombre}}</span></md-button><md-menu-content width=\"3\"><md-menu-item \nng-repeat=\"subcategoria in vm.subcategoriasCamapana\"><md-button ng-click=\"vm.setSubCategoria(subcategoria)\">\n{{subcategoria.nombre}}</md-button></md-menu-item></md-menu-content></md-menu></div></md-fab-actions></md-toolbar>\n</md-fab-toolbar><md-content class=\"md-padding\"><div listar=\"vm.listConfig\"></div></md-content></div></div></div>");
$templateCache.put("app/pages/admin/modelos/nuevo/nuevo.tmpl.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ui-sref=\"app.modelos.listar\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"product-image\" hide-xs><img ng-src=\"{{vm.modelo.imagen[0].url}}\">\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.modelo.nombre}}</div><div \nclass=\"subtitle secondary-text\"><span translate=\"EC.PRODUCT_DETAIL\">Product Detail</span></div></div></div></div><div>\n<md-button class=\"md-raised md-background\" ng-click=\"vm.doCreate()\"><span translate=\"EC.SAVE\">SAVE</span></md-button>\n</div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"EC.BASIC_INFO\">\nInformación Básica</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-progress-linear md-mode=\"query\" \nmd-class=\"blue-200-bg\" ng-if=\"vm.loading\"></md-progress-linear><md-input-container class=\"md-block\"><label>SKU</label>\n<input type=\"text\" ng-model=\"vm.modelo.sku\" ng-blur=\"vm.getDataBySku()\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Nome Recomendado</label><input type=\"text\" ng-model=\"vm.modelo.nombreRecomendado\">\n</md-input-container><md-input-container class=\"md-block\"><label>Nome</label><input type=\"text\" \nng-model=\"vm.modelo.nombre\"></md-input-container><md-input-container class=\"md-block\"><md-select \nng-model=\"vm.modelo.categoriaId\" ng-change=\"vm.changeCategoria()\" placeholder=\"Seleccione Categoria\"><md-option \nng-value=\"categoria.id\" ng-repeat=\"categoria in vm.categorias\">{{ categoria.nombre }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>Texto descriptivo</label><input type=\"text\" \nng-model=\"vm.modelo.introduccion\"></md-input-container><md-input-container class=\"md-block\"><label>Palavras-chave\n</label><input type=\"text\" ng-model=\"vm.modelo.keywords\"></md-input-container></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>Características do Modelo</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\" \nng-repeat=\"field in vm.fieldsCategorias\"><label>{{field.label}}</label><input type=\"text\" \nng-model=\"vm.modelo[field.value]\"></md-input-container></div></md-tab-body></md-tab><md-tab><md-tab><md-tab-label>\n<span>Ficha e Documentos</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div><h5 class=\"header-material\">\nFicha de Producto</h5><input-gallery ng-model=\"vm.modelo.ficha\" multiple=\"true\">Seleccionar Ficha</input-gallery></div>\n<div><h5 class=\"header-material\">Documentos</h5><input-gallery ng-model=\"vm.modelo.documentos\" multiple=\"true\">\nAgregar Documentos</input-gallery></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"EC.PRODUCT_IMAGES\">Imagens</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div><h5 class=\"header-material\">\nImagen Predeterminada</h5><input-gallery ng-model=\"vm.modelo.imagen\" multiple=\"false\">Seleccionar Imagen\n</input-gallery><h5 class=\"header-material\">Videos</h5><input-gallery ng-model=\"vm.modelo.videos\" multiple=\"false\">\nSeleccionar Videos</input-gallery><h5 class=\"header-material\">Galería</h5><input-gallery ng-model=\"vm.modelo.galeria\" \nmultiple=\"true\">Agregar imágenes</input-gallery></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>\nCaracterísticas del Modelo</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div id=\"monitores\" \nng-if=\"vm.modelo.categoriaId==\'590a3eeb77c84c53dc8cace4\'\"><md-input-container class=\"md-block\"><label>Tamaño Pantalla\n</label><input type=\"text\" ng-model=\"vm.modelo.tamanoPantalla\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Resolución</label><input type=\"text\" ng-model=\"vm.modelo.resolucionPantalla\">\n</md-input-container><md-input-container class=\"md-block\"><label>Relación Aspecto</label><input type=\"text\" \nng-model=\"vm.modelo.relacionAspecto\"></md-input-container><md-input-container class=\"md-block\"><label>Tipo Panel\n</label><input type=\"text\" ng-model=\"vm.modelo.tipoPanel\"></md-input-container><md-input-container class=\"md-block\">\n<label>Tasa de Refresco</label><input type=\"text\" ng-model=\"vm.modelo.tasaRefresco\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Tiempo de respuesta</label><input type=\"text\" \nng-model=\"vm.modelo.tiempoRespuesta\"></md-input-container><md-input-container class=\"md-block\"><label>\nContraste Estático</label><input type=\"text\" ng-model=\"vm.modelo.contrasteEstatico\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Puertos</label><input type=\"text\" ng-model=\"vm.modelo.puertos\">\n</md-input-container><md-input-container class=\"md-block\"><label>Color</label><input type=\"text\" \nng-model=\"vm.modelo.color\"></md-input-container><md-input-container class=\"md-block\"><label>Accesorios Incluidos\n</label><input type=\"text\" ng-model=\"vm.modelo.accesoriosIncluidos\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Garantia</label><input type=\"text\" ng-model=\"vm.modelo.garantia\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Ciclos</label><input type=\"text\" ng-model=\"vm.modelo.ciclo\">\n</md-input-container><md-input-container class=\"md-block\"><label>UPC ABM</label><input type=\"text\" \nng-model=\"vm.modelo.ABM\"></md-input-container><md-input-container class=\"md-block\"><label>UPC AKH</label><input \ntype=\"text\" ng-model=\"vm.modelo.AKH\"></md-input-container><md-input-container class=\"md-block\"><label>UPC AC8</label>\n<input type=\"text\" ng-model=\"vm.modelo.AC8\"></md-input-container><md-input-container class=\"md-block\"><label>UPC ABA\n</label><input type=\"text\" ng-model=\"vm.modelo.ABA\"></md-input-container><md-input-container class=\"md-block\"><label>\nUPC AC4</label><input type=\"text\" ng-model=\"vm.modelo.AC4\"></md-input-container><md-input-container class=\"md-block\">\n<label>UPC ACH</label><input type=\"text\" ng-model=\"vm.modelo.ACH\"></md-input-container></div><div id=\"Notebooks\" \nng-if=\"vm.modelo.categoriaId==\'56c678072405ddbf462d40e7\'\"><md-input-container class=\"md-block\"><label>Procesador\n</label><input type=\"text\" ng-model=\"vm.modelo.procesador\"></md-input-container><md-input-container class=\"md-block\">\n<label>Núcleos</label><input type=\"text\" ng-model=\"vm.modelo.nucleos\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Velocidad Procesador Desde</label><input type=\"text\" ng-model=\"vm.modelo.velocidadProcesador\">\n</md-input-container><md-input-container class=\"md-block\"><label>Velocidad Procesador Hasta</label><input type=\"text\" \nng-model=\"vm.modelo.velocidadProcesadorHasta\"></md-input-container><md-input-container class=\"md-block\"><label>\nMemoria RAM</label><input type=\"text\" ng-model=\"vm.modelo.memoriaRam\"></md-input-container><md-input-container \nclass=\"md-block\"><label>RAM expandible</label><input type=\"text\" ng-model=\"vm.modelo.ramExpandible\">\n</md-input-container><md-input-container class=\"md-block\"><label>Disco Duro</label><input type=\"text\" \nng-model=\"vm.modelo.discoDuro\"></md-input-container><md-input-container class=\"md-block\"><label>Disco Duro Sólido\n</label><input type=\"text\" ng-model=\"vm.modelo.discoDuroSolido\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Tarjeta de Video</label><input type=\"text\" ng-model=\"vm.modelo.tarjetaVideo\">\n</md-input-container><md-input-container class=\"md-block\"><label>Tipo de Pantalla</label><input type=\"text\" \nng-model=\"vm.modelo.tipoPantalla\"></md-input-container><md-input-container class=\"md-block\"><label>Tamaño Pantalla\n</label><input type=\"text\" ng-model=\"vm.modelo.tamanoPantalla\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Resolucion de Pantalla</label><input type=\"text\" ng-model=\"vm.modelo.resolucionPantalla\">\n</md-input-container><md-input-container class=\"md-block\"><label>Pantalla Touch</label><input type=\"text\" \nng-model=\"vm.modelo.pantallaTouch\"></md-input-container><md-input-container class=\"md-block\"><label>Sistema de Audio\n</label><input type=\"text\" ng-model=\"vm.modelo.sistemaDeAudio\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Teclado</label><input type=\"text\" ng-model=\"vm.modelo.teclado\"></md-input-container>\n<md-input-container class=\"md-block\"><label>S.O</label><input type=\"text\" ng-model=\"vm.modelo.so\"></md-input-container>\n<md-input-container class=\"md-block\"><label>HDMI</label><input type=\"text\" ng-model=\"vm.modelo.hdmi\">\n</md-input-container><md-input-container class=\"md-block\"><label>Puertos USB</label><input type=\"text\" \nng-model=\"vm.modelo.usb\"></md-input-container><md-input-container class=\"md-block\"><label>Duración de Bateria</label>\n<input type=\"text\" ng-model=\"vm.modelo.duracionBateria\"></md-input-container><md-input-container class=\"md-block\">\n<label>Unidad Óptica</label><input type=\"text\" ng-model=\"vm.modelo.unidadOptica\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Cámara Web</label><input type=\"text\" ng-model=\"vm.modelo.camaraWeb\">\n</md-input-container><md-input-container class=\"md-block\"><label>Conectividad</label><input type=\"text\" \nng-model=\"vm.modelo.conectividad\"></md-input-container><md-input-container class=\"md-block\"><label>Color</label><input \ntype=\"text\" ng-model=\"vm.modelo.color\"></md-input-container><md-input-container class=\"md-block\"><label>\nAccesorios Incluidos</label><input type=\"text\" ng-model=\"vm.modelo.accesoriosIncluidos\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Garantia</label><input type=\"text\" ng-model=\"vm.modelo.garantia\">\n</md-input-container><md-input-container class=\"md-block\"><label>Ciclos</label><input type=\"text\" \nng-model=\"vm.modelo.ciclo\"></md-input-container><md-input-container class=\"md-block\"><label>UPC ABM</label><input \ntype=\"text\" ng-model=\"vm.modelo.ABM\"></md-input-container><md-input-container class=\"md-block\"><label>UPC AKH</label>\n<input type=\"text\" ng-model=\"vm.modelo.AKH\"></md-input-container><md-input-container class=\"md-block\"><label>UPC AC8\n</label><input type=\"text\" ng-model=\"vm.modelo.AC8\"></md-input-container><md-input-container class=\"md-block\"><label>\nUPC ABA</label><input type=\"text\" ng-model=\"vm.modelo.ABA\"></md-input-container><md-input-container class=\"md-block\">\n<label>UPC AC4</label><input type=\"text\" ng-model=\"vm.modelo.AC4\"></md-input-container><md-input-container \nclass=\"md-block\"><label>UPC ACH</label><input type=\"text\" ng-model=\"vm.modelo.ACH\"></md-input-container></div><div \nid=\"AIO\" ng-if=\"vm.modelo.categoriaId==\'56c677ff2405ddbf462d40e5\'\"><md-input-container class=\"md-block\"><label>\nProcesador</label><input type=\"text\" ng-model=\"vm.modelo.procesador\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Núcleos</label><input type=\"text\" ng-model=\"vm.modelo.nucleos\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Velocidad Procesador Desde</label><input type=\"text\" \nng-model=\"vm.modelo.velocidadProcesador\"></md-input-container><md-input-container class=\"md-block\"><label>\nVelocidad Procesador Hasta</label><input type=\"text\" ng-model=\"vm.modelo.velocidadProcesadorHasta\">\n</md-input-container><md-input-container class=\"md-block\"><label>Memoria RAM</label><input type=\"text\" \nng-model=\"vm.modelo.memoriaRam\"></md-input-container><md-input-container class=\"md-block\"><label>RAM expandible</label>\n<input type=\"text\" ng-model=\"vm.modelo.ramExpandible\"></md-input-container><md-input-container class=\"md-block\"><label>\nDisco Duro</label><input type=\"text\" ng-model=\"vm.modelo.discoDuro\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Disco Duro Sólido</label><input type=\"text\" ng-model=\"vm.modelo.discoDuroSolido\">\n</md-input-container><md-input-container class=\"md-block\"><label>Tarjeta de Video</label><input type=\"text\" \nng-model=\"vm.modelo.tarjetaVideo\"></md-input-container><md-input-container class=\"md-block\"><label>Tipo de Pantalla\n</label><input type=\"text\" ng-model=\"vm.modelo.tipoPantalla\"></md-input-container><md-input-container class=\"md-block\">\n<label>Tamaño Pantalla</label><input type=\"text\" ng-model=\"vm.modelo.tamanoPantalla\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Resolucion de Pantalla</label><input type=\"text\" \nng-model=\"vm.modelo.resolucionPantalla\"></md-input-container><md-input-container class=\"md-block\"><label>Pantalla Touch\n</label><input type=\"text\" ng-model=\"vm.modelo.pantallaTouch\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Sistema de Audio</label><input type=\"text\" ng-model=\"vm.modelo.sistemaDeAudio\">\n</md-input-container><md-input-container class=\"md-block\"><label>Teclado</label><input type=\"text\" \nng-model=\"vm.modelo.teclado\"></md-input-container><md-input-container class=\"md-block\"><label>S.O</label><input \ntype=\"text\" ng-model=\"vm.modelo.so\"></md-input-container><md-input-container class=\"md-block\"><label>HDMI</label><input\n type=\"text\" ng-model=\"vm.modelo.hdmi\"></md-input-container><md-input-container class=\"md-block\"><label>Puertos USB\n</label><input type=\"text\" ng-model=\"vm.modelo.usb\"></md-input-container><md-input-container class=\"md-block\"><label>\nDuración de Bateria</label><input type=\"text\" ng-model=\"vm.modelo.duracionBateria\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Unidad Óptica</label><input type=\"text\" ng-model=\"vm.modelo.unidadOptica\">\n</md-input-container><md-input-container class=\"md-block\"><label>Cámara Web</label><input type=\"text\" \nng-model=\"vm.modelo.camaraWeb\"></md-input-container><md-input-container class=\"md-block\"><label>Conectividad</label>\n<input type=\"text\" ng-model=\"vm.modelo.conectividad\"></md-input-container><md-input-container class=\"md-block\"><label>\nColor</label><input type=\"text\" ng-model=\"vm.modelo.color\"></md-input-container><md-input-container class=\"md-block\">\n<label>Alto</label><input type=\"text\" ng-model=\"vm.modelo.alto\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Ciclos</label><input type=\"text\" ng-model=\"vm.modelo.ciclo\"></md-input-container>\n<md-input-container class=\"md-block\"><label>UPC ABM</label><input type=\"text\" ng-model=\"vm.modelo.ABM\">\n</md-input-container><md-input-container class=\"md-block\"><label>UPC AKH</label><input type=\"text\" \nng-model=\"vm.modelo.AKH\"></md-input-container><md-input-container class=\"md-block\"><label>UPC AC8</label><input \ntype=\"text\" ng-model=\"vm.modelo.AC8\"></md-input-container><md-input-container class=\"md-block\"><label>UPC ABA</label>\n<input type=\"text\" ng-model=\"vm.modelo.ABA\"></md-input-container><md-input-container class=\"md-block\"><label>UPC AC4\n</label><input type=\"text\" ng-model=\"vm.modelo.AC4\"></md-input-container><md-input-container class=\"md-block\"><label>\nUPC ACH</label><input type=\"text\" ng-model=\"vm.modelo.ACH\"></md-input-container><md-input-container class=\"md-block\">\n<label>Accesorios Incluidos</label><input type=\"text\" ng-model=\"vm.modelo.accesoriosIncluidos\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Garantia</label><input type=\"text\" ng-model=\"vm.modelo.garantia\">\n</md-input-container></div><div id=\"impresoras\" ng-if=\"vm.modelo.categoriaId==\'56c677fb2405ddbf462d40e4\'\">\n<md-input-container class=\"md-block\"><label>Familia</label><input type=\"text\" ng-model=\"vm.modelo.Familia\">\n</md-input-container><md-input-container class=\"md-block\"><label>Tipo de Inyección</label><input type=\"text\" \nng-model=\"vm.modelo.tipoInyeccion\"></md-input-container><md-input-container class=\"md-block\"><label>Tipo de Impresion\n</label><input type=\"text\" ng-model=\"vm.modelo.tipoImpresion\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Compatibilidad S.O</label><input type=\"text\" ng-model=\"vm.modelo.compatibilidad\">\n</md-input-container><md-input-container class=\"md-block\"><label>Wifi</label><input type=\"text\" \nng-model=\"vm.modelo.wifi\"></md-input-container><md-input-container class=\"md-block\"><label>NFC</label><input \ntype=\"text\" ng-model=\"vm.modelo.nfc\"></md-input-container><md-input-container class=\"md-block\"><label>Velocidad B/N\n</label><input type=\"text\" ng-model=\"vm.modelo.velocidadBn\"></md-input-container><md-input-container class=\"md-block\">\n<label>Velocidad Color</label><input type=\"text\" ng-model=\"vm.modelo.velocidadColor\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Resolucion Scanner</label><input type=\"text\" \nng-model=\"vm.modelo.resolucionColor\"></md-input-container><md-input-container class=\"md-block\"><label>Capacidad Hojas\n</label><input type=\"text\" ng-model=\"vm.modelo.capacidadHojas\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Conexión USB</label><input type=\"text\" ng-model=\"vm.modelo.usb\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Ciclo Mensual</label><input type=\"text\" ng-model=\"vm.modelo.cicloMensual\">\n</md-input-container><md-input-container class=\"md-block\"><label>Consumibles</label><input type=\"text\" \nng-model=\"vm.modelo.newConsumibles\"></md-input-container><md-input-container class=\"md-block\"><label>Rendimiento\n</label><input type=\"text\" ng-model=\"vm.modelo.rendimiento\"></md-input-container><md-input-container class=\"md-block\">\n<label>Ciclos</label><input type=\"text\" ng-model=\"vm.modelo.ciclo\"></md-input-container><md-input-container \nclass=\"md-block\"><label>UPC ABM</label><input type=\"text\" ng-model=\"vm.modelo.ABM\"></md-input-container>\n<md-input-container class=\"md-block\"><label>UPC AKH</label><input type=\"text\" ng-model=\"vm.modelo.AKH\">\n</md-input-container><md-input-container class=\"md-block\"><label>UPC AC8</label><input type=\"text\" \nng-model=\"vm.modelo.AC8\"></md-input-container><md-input-container class=\"md-block\"><label>UPC ABA</label><input \ntype=\"text\" ng-model=\"vm.modelo.ABA\"></md-input-container><md-input-container class=\"md-block\"><label>UPC AC4</label>\n<input type=\"text\" ng-model=\"vm.modelo.AC4\"></md-input-container><md-input-container class=\"md-block\"><label>UPC ACH\n</label><input type=\"text\" ng-model=\"vm.modelo.ACH\"></md-input-container></div><div id=\"tintas\" \nng-if=\"vm.modelo.categoriaId==\'56c678022405ddbf462d40e6\'\"><md-input-container class=\"md-block\"><label>Compatibilidad\n</label><input type=\"text\" ng-model=\"vm.modelo.compatibilidad\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Rendimiento</label><input type=\"text\" ng-model=\"vm.modelo.rendimiento\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Ciclos</label><input type=\"text\" ng-model=\"vm.modelo.ciclo\">\n</md-input-container><md-input-container class=\"md-block\"><label>UPC ABM</label><input type=\"text\" \nng-model=\"vm.modelo.ABM\"></md-input-container><md-input-container class=\"md-block\"><label>UPC AKH</label><input \ntype=\"text\" ng-model=\"vm.modelo.AKH\"></md-input-container><md-input-container class=\"md-block\"><label>UPC AC8</label>\n<input type=\"text\" ng-model=\"vm.modelo.AC8\"></md-input-container><md-input-container class=\"md-block\"><label>UPC ABA\n</label><input type=\"text\" ng-model=\"vm.modelo.ABA\"></md-input-container><md-input-container class=\"md-block\"><label>\nUPC AC4</label><input type=\"text\" ng-model=\"vm.modelo.AC4\"></md-input-container><md-input-container class=\"md-block\">\n<label>UPC ACH</label><input type=\"text\" ng-model=\"vm.modelo.ACH\"></md-input-container></div><div id=\"toners\" \nng-if=\"vm.modelo.categoriaId==\'57ab452792623112e483e371\'\"><md-input-container class=\"md-block\"><label>Compatibilidad\n</label><input type=\"text\" ng-model=\"vm.modelo.compatibilidad\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Rendimiento</label><input type=\"text\" ng-model=\"vm.modelo.rendimiento\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Ciclos</label><input type=\"text\" ng-model=\"vm.modelo.ciclo\">\n</md-input-container><md-input-container class=\"md-block\"><label>UPC ABM</label><input type=\"text\" \nng-model=\"vm.modelo.ABM\"></md-input-container><md-input-container class=\"md-block\"><label>UPC AKH</label><input \ntype=\"text\" ng-model=\"vm.modelo.AKH\"></md-input-container><md-input-container class=\"md-block\"><label>UPC AC8</label>\n<input type=\"text\" ng-model=\"vm.modelo.AC8\"></md-input-container><md-input-container class=\"md-block\"><label>UPC ABA\n</label><input type=\"text\" ng-model=\"vm.modelo.ABA\"></md-input-container><md-input-container class=\"md-block\"><label>\nUPC AC4</label><input type=\"text\" ng-model=\"vm.modelo.AC4\"></md-input-container><md-input-container class=\"md-block\">\n<label>UPC ACH</label><input type=\"text\" ng-model=\"vm.modelo.ACH\"></md-input-container></div><div id=\"campanas\" \nng-if=\"vm.modelo.categoriaId ==\'571034a1d4c653eec41f5e95\'\"><md-input-container class=\"md-block\"><md-select \nplaceholder=\"Seleccione Subcategoría\" ng-model=\"vm.modelo.subCatId\" style=\"min-width: 200px\" \nng-change=\"setNameSubCategoria()\"><md-option ng-value=\"categoria.subCatId\" \nng-repeat=\"categoria in vm.subcategoriasCamapana | orderBy:\'orden\'\">{{categoria.nombre}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>Link</label><input type=\"text\" \nng-model=\"vm.modelo.link\"></md-input-container><h5 class=\"header-material\">ZIP</h5><input-gallery \nng-model=\"vm.modelo.zip\" multiple=\"false\">Agregar ZIP</input-gallery></div><div id=\"accesorios\" \nng-if=\"vm.modelo.categoriaId==\'57ab44ce92623112e483e370\'\"><md-input-container class=\"md-block\"><label>Rendimiento\n</label><input type=\"text\" ng-model=\"vm.modelo.rendimiento\"></md-input-container><md-input-container class=\"md-block\">\n<label>Ciclos</label><input type=\"text\" ng-model=\"vm.modelo.ciclo\"></md-input-container><md-input-container \nclass=\"md-block\"><label>UPC ABM</label><input type=\"text\" ng-model=\"vm.modelo.ABM\"></md-input-container>\n<md-input-container class=\"md-block\"><label>UPC AKH</label><input type=\"text\" ng-model=\"vm.modelo.AKH\">\n</md-input-container><md-input-container class=\"md-block\"><label>UPC AC8</label><input type=\"text\" \nng-model=\"vm.modelo.AC8\"></md-input-container><md-input-container class=\"md-block\"><label>UPC ABA</label><input \ntype=\"text\" ng-model=\"vm.modelo.ABA\"></md-input-container><md-input-container class=\"md-block\"><label>UPC AC4</label>\n<input type=\"text\" ng-model=\"vm.modelo.AC4\"></md-input-container><md-input-container class=\"md-block\"><label>UPC ACH\n</label><input type=\"text\" ng-model=\"vm.modelo.ACH\"></md-input-container></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"EC.DIMENTIONS\">Dimensiones</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><label>\nAlto</label><input type=\"text\" ng-model=\"vm.modelo.alto\"></md-input-container><md-input-container class=\"md-block\">\n<label>Ancho</label><input type=\"text\" ng-model=\"vm.modelo.ancho\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Profundidad</label><input type=\"text\" ng-model=\"vm.modelo.profundidad\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Peso</label><input type=\"text\" ng-model=\"vm.modelo.peso\">\n</md-input-container></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Diferenciadores y Visuales</span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><h5 \nclass=\"header-material\">Diferenciadores</h5><div class=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" flex>\n<md-list><md-list-item class=\"md-3-line\" ng-repeat=\"diferenciador in vm.modelo.diferenciadores track by $index\" \nstyle=\"min-width:800px;max-width:1000px\"><input-gallery ng-model=\"vm.modelo.diferenciadores[$index].imagen\" \nmultiple=\"false\">Imagen</input-gallery><div class=\"md-list-item-text\"><h3 ng-if=\"!diferenciador.editing\">\n{{diferenciador.titulo}}</h3><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><input type=\"text\" \nng-model=\"diferenciador.titulo\" placeholder=\"Titulo...\"></md-input-container><p ng-if=\"!diferenciador.editing\">\n{{diferenciador.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"diferenciador.editing\"><textarea \ntype=\"text\" ng-model=\"diferenciador.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div>\n<div style=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!diferenciador.editing\" ng-click=\"diferenciador.editing = true\"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"diferenciador.editing\" \nng-click=\"diferenciador.editing = false\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarDiferenciador($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.agregarDiferenciador()\">Agregar Diferenciador\n</md-button><h5 class=\"header-material\">Visuales</h5><input-gallery ng-model=\"vm.modelo.visuales\" multiple=\"true\">\nAgregar Visuales</input-gallery></div></md-tab-body></md-tab></md-tab></md-tabs></div></div>");
$templateCache.put("app/pages/admin/modelos/ver/ver.tmpl.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.goBack()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"product-image\" hide-xs><img \nng-src=\"{{vm.modelo.langs.PT.imagen[0].url}}\"></div><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.modelo.langs.PT.nombre}}</div><div class=\"subtitle secondary-text\">Detalhes do produto</div></div></div></div><div\n class=\"botones\" ng-if=\"vm.isGod || vm.isHp\"><div flex=\"100\" layout=\"row\" layout-align=\"left center\"><md-menu>\n<md-button aria-label=\"more\" class=\"md-raised md-primary\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon>Downloads Excel</md-button><md-menu-content width=\"3\"><md-menu-item \nng-click=\"vm.downloadXls()\"><md-button>Baixar Excel</md-button></md-menu-item><md-menu-item \nng-repeat=\"estatico in vm.estaticos\"><md-button ng-click=\"vm.downloadEstatico(estatico)\">{{estatico.name}}</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div><md-button class=\"md-raised md-background\" \nng-if=\"vm.modelo.langs.PT.status == \'En Revisión\' || vm.modelo.langs.PT.status == \'En Revision\' || vm.modelo.langs.PT.status == \'Em Revisão\' || vm.modelo.langs.PT.status == \'Em revisão\'\" \nng-click=\"vm.aprobar(ev,vm.modelo.langs.PT)\"><span>APROVAR</span></md-button></div></div><div class=\"content\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-if=\"vm.hiddenInactiveFilesCount > 0\" \nstyle=\"margin-bottom: 16px\"><div class=\"md-caption\" style=\"padding: 12px 16px\">\n{{vm.hiddenInactiveFilesCount}} arquivo(s) inativo(s) ocultado(s) pelo estado.</div></div><md-tabs md-dynamic-height>\n<md-tab><md-tab-label><span translate=\"EC.BASIC_INFO\">Informações básicas</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><label>\nNome recomendado</label><input disabled=\"disabled\" type=\"text\" ng-model=\"vm.modelo.langs.PT.nombreRecomendado\">\n</md-input-container><md-input-container class=\"md-block\"><label>Nome</label><input disabled=\"disabled\" type=\"text\" \nng-model=\"vm.modelo.langs.PT.nombre\"></md-input-container><md-input-container class=\"md-block\"><label>EAN</label><input\n disabled=\"disabled\" type=\"text\" ng-model=\"vm.modelo.langs.PT.eanString\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Categoria</label><input type=\"text\" ng-model=\"vm.categoriaModelo.nombre\" disabled=\"disabled\">\n</md-input-container><md-input-container class=\"md-block\"><label>SKU</label><input disabled=\"disabled\" type=\"text\" \nng-model=\"vm.modelo.sku\"></md-input-container><md-input-container class=\"md-block\"><label>Status</label><input \ndisabled=\"disabled\" type=\"text\" ng-model=\"vm.modelo.langs.PT.status\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Texto descritivo</label><input disabled=\"disabled\" type=\"text\" \nng-model=\"vm.modelo.langs.PT.introduccion\"></md-input-container><md-input-container class=\"md-block\"><label>\nPalavras-chave</label><input disabled=\"disabled\" type=\"text\" ng-model=\"vm.modelo.langs.PT.keywords\">\n</md-input-container></div></md-tab-body></md-tab><md-tab ng-if=\"vm.hasModelCharacteristics\"><md-tab-label><span>\nCaracterísticas do modelo</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\" \nng-repeat=\"field in vm.fieldsModelo\" ng-show=\"!vm.isBasicField(field.value) && vm.hasFieldValue(field.value)\"><label>\n{{vm.getFieldLabel(field)}}{{vm.isSpanishFallback(field.value) ? \' (ES - tradução pendente)\' : \'\'}}</label><input \ntype=\"text\" ng-value=\"vm.getFieldValue(field.value)\" disabled=\"disabled\"></md-input-container></div></md-tab-body>\n</md-tab><md-tab \nng-if=\"(vm.isGod || vm.isHp) && !vm.hasPlaybook3 && (vm.modelo.langs.PT.indexadoActive || vm.modelo.langs.PT.hasIndexado4 || vm.modelo.langs.PT.hasIndexado5 || vm.modelo.langs.PT.indexadoDefault || vm.modelo.langs.PT.sindicado)\">\n<md-tab-label><span>Conteúdo indexado</span></md-tab-label><md-tab-body><div class=\"md-title\">Script de inserção</div>\n<div class=\"pb-16\">Copie e cole o código apresentado em seu site para inserir o minissite do produto.</div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><textarea\n type=\"text\" placeholder=\"\">{{vm.script}} </textarea></md-input-container></div><div class=\"md-title\">URL do minissite\n</div><div class=\"pb-16\">Use esta URL para apresentar o minissite do produto em um link independente.</div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><input \ntype=\"text\" disabled=\"disabled\" value=\"{{vm.urlMinisitio}}\"></md-input-container></div><div class=\"md-title\">\nQR do minissite</div><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><img \nng-src=\"https://api.qrserver.com/v1/create-qr-code/?size=150x150&data={{vm.qrUrlEncoded}}\"><md-input-container \nclass=\"md-block\"><input type=\"text\" disabled=\"disabled\" ng-value=\"vm.qrUrl\"></md-input-container></div></md-tab-body>\n</md-tab><md-tab ng-if=\"(vm.isGod || vm.isHp) && vm.hasPlaybook3\"><md-tab-label><span>Conteúdo Indexado P3.0</span>\n</md-tab-label><md-tab-body><div class=\"pb-16\">\nCopie e cole o código apresentado em seu site para inserir o minissite do produto.</div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><textarea\n type=\"text\" placeholder=\"\">{{vm.script}}</textarea></md-input-container></div><div class=\"md-title\">URL do minissite\n</div><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nclass=\"md-block\"><input type=\"text\" disabled=\"disabled\" value=\"{{vm.playbook3UrlMinisitio}}\"></md-input-container>\n</div><div class=\"md-title\">QR do minissite</div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><img \nng-src=\"https://api.qrserver.com/v1/create-qr-code/?size=150x150&data={{vm.playbook3QrUrlEncoded}}\"><md-input-container\n class=\"md-block\"><input type=\"text\" disabled=\"disabled\" ng-value=\"vm.playbook3QrUrl\"></md-input-container></div>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.modelo.langs.PT.ficha.length || vm.modelo.langs.PT.documentos.length\">\n<md-tab-label><span>Ficha técnica e documentos</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div><h5 class=\"header-material\">\nFicha do produto</h5><input-gallery disabled=\"true\" ng-model=\"vm.modelo.langs.PT.ficha\" \nmodelo=\"vm.modelo.langs.PT.ficha\" multiple=\"true\">Selecionar imagem</input-gallery></div><div \nng-if=\"vm.modelo.langs.PT.documentos.length\"><h5 class=\"header-material\">Documentos</h5><input-gallery disabled=\"true\" \nng-model=\"vm.modelo.langs.PT.documentos\" modelo=\"vm.modelo.langs.PT.documentos\" multiple=\"true\">Documentos\n</input-gallery></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Imagens e vídeos do modelo</span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div \nng-include=\"\'app/pages/admin/file-manager/views/list/list-view-2.html\'\"></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>Diferenciais e recursos visuais</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><h5 class=\"header-material\">Diferenciais</h5>\n<div class=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" flex><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"diferenciador in vm.modelo.langs.PT.diferenciadores track by $index\" \nstyle=\"min-width:800px;max-width:1000px\"><input-gallery ng-model=\"vm.modelo.langs.PT.diferenciadores[$index].imagen\" \ndisabled=\"true\" multiple=\"false\">Imagem</input-gallery><div class=\"md-list-item-text\"><h3>{{diferenciador.titulo}}</h3>\n<p>{{diferenciador.descripcion}}</p></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item></md-list>\n</div><h5 class=\"header-material\">Recursos visuais</h5><input-gallery ng-model=\"vm.modelo.langs.PT.visuales\" \ndisabled=\"true\" modelo=\"vm.modelo.langs.PT.id\" multiple=\"true\">Recursos visuais</input-gallery></div></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.modelo.langs.PT.materialsLink && (vm.isGod || vm.isRevisor || vm.isHp) && !vm.isRetail\">\n<md-tab-label><span>Conteúdo Inpage</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div><h5 class=\"header-material\">\nMateriales MELI / A+</h5><div class=\"pb-16\">Baixe o arquivo com os materiais de conteúdo Inpage.</div><md-button \nclass=\"md-raised md-primary\" ng-href=\"{{vm.modelo.langs.PT.materialsLink}}\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon>Baixar materiais</md-button></div></div></md-tab-body></md-tab></md-tabs></div>\n</div>");
$templateCache.put("app/pages/admin/perfiles/editar/editar.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-edit\"></md-icon><span>&nbsp;Editar perfil</span> </span><span flex></span><md-button \nclass=\"md-raised md-primary\" profile=\"{\'perfil\': \'access\'}\" ui-sref=\"app.perfiles.listar\">Listar perfiles</md-button>\n</div></div><div class=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div><div \nclass=\"md-yellow-200-bg md-padding\">Precaución al otorgar permisos</div><form name=\"editPerfil\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.guardar()\"><md-content class=\"content\" flex><h5 class=\"header-material\">Datos del perfil</h5>\n<div layout=\"row\" flex><md-input-container md-no-float flex=\"100\"><label>Nombre</label><input type=\"text\" name=\"name\" \nng-model=\"vm.perfil.name\" placeholder=\"Nombre\" required><div ng-messages=\"editPerfil.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>El nombre es requerido.</span></div></div></md-input-container></div><h5 \nclass=\"header-material\">Permisos del perfil</h5><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"{{permission.name}}\" ng-if=\"vm.isAllowed(permission)\" ng-repeat=\"permission in vm.permissions track by $index\">\n<md-content class=\"md-padding\" flex layout=\"row\"><md-list flex=\"50\"><md-subheader class=\"md-no-sticky\">Manejo\n</md-subheader><md-list-item ng-if=\"vm.isAllowed(permission, \'create\')\"><p>Crear</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.permissions[$index].create\"></md-checkbox></md-list-item><md-list-item \nng-if=\"vm.isAllowed(permission, \'edit\')\"><p>Editar</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.permissions[$index].edit\"></md-checkbox></md-list-item><md-list-item \nng-if=\"vm.isAllowed(permission, \'remove\')\"><p>Borrar</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.permissions[$index].remove\"></md-checkbox></md-list-item></md-list><md-list flex=\"50\"><md-subheader \nclass=\"md-no-sticky\">Acceso</md-subheader><md-radio-group ng-model=\"vm.permissions[$index].access\"><md-list-item \nng-if=\"vm.isAllowed(permission, \'access\', \'all\')\"><p>Todos</p><md-radio-button value=\"all\" class=\"md-primary\">\n</md-radio-button></md-list-item><md-list-item ng-if=\"vm.isAllowed(permission, \'access\', \'owner\')\"><p>Dueño</p>\n<md-radio-button value=\"owner\" class=\"md-primary\"></md-radio-button></md-list-item><md-list-item \nng-if=\"vm.isAllowed(permission, \'access\', \'none\')\"><p>Ninguno</p><md-radio-button value=\"none\" class=\"md-primary\">\n</md-radio-button></md-list-item></md-radio-group></md-list></md-content></md-tab></md-tabs></md-content><md-content \nclass=\"md-padding\"><md-button type=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"editPerfil.$invalid\">Guardar\n</md-button></md-content></form></md-content></div></div></div>");
$templateCache.put("app/pages/admin/perfiles/listar/listar.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-lights\"></md-icon><span>&nbsp;Perfiles</span> </span><span flex></span><md-button \nclass=\"md-raised md-primary\" profile=\"{\'perfil\': \'create\'}\" ui-sref=\"app.perfiles.nuevo\">Nuevo perfil</md-button></div>\n</div><div class=\"content-card\" layout=\"column\" flex><md-content class=\"md-padding\"><div listar=\"vm.listConfig\"></div>\n</md-content></div></div></div>");
$templateCache.put("app/pages/admin/perfiles/nuevo/nuevo.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-add\"></md-icon><span>&nbsp;Nuevo perfil</span> </span><span flex></span><md-button \nclass=\"md-raised md-primary\" profile=\"{\'perfil\': \'access\'}\" ui-sref=\"app.perfiles.listar\">Listar perfiles</md-button>\n</div></div><md-input-container class=\"content-card\" layout=\"column\" flex><div class=\"md-yellow-200-bg md-padding\">\nPrecaución al otorgar permisos</div><md-content><div loading=\"vm.loading\"></div><form name=\"nuevoPerfil\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.crear()\"><md-content class=\"content\" flex><h5 class=\"header-material\">\nDatos del perfil</h5><div layout=\"row\" flex><md-input-container md-no-float flex=\"100\"><label>Nombre</label><input \ntype=\"text\" name=\"name\" ng-model=\"vm.perfil.name\" placeholder=\"Nombre\" required><div \nng-messages=\"nuevoPerfil.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>El nombre es requerido.</span>\n</div></div></md-input-container></div><h5 class=\"header-material\">Permisos del perfil</h5><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"{{permission.name}}\" ng-if=\"vm.isAllowed(permission)\" \nng-repeat=\"permission in vm.permissions track by $index\"><md-content class=\"md-padding\" flex layout=\"row\"><md-list \nflex=\"50\"><md-subheader class=\"md-no-sticky\">Manejo</md-subheader><md-list-item \nng-if=\"vm.isAllowed(permission, \'create\')\"><p>Crear</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.permissions[$index].create\"></md-checkbox></md-list-item><md-list-item \nng-if=\"vm.isAllowed(permission, \'edit\')\"><p>Editar</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.permissions[$index].edit\"></md-checkbox></md-list-item><md-list-item \nng-if=\"vm.isAllowed(permission, \'remove\')\"><p>Borrar</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.permissions[$index].remove\"></md-checkbox></md-list-item></md-list><md-list flex=\"50\"><md-subheader \nclass=\"md-no-sticky\">Acceso</md-subheader><md-radio-group ng-model=\"vm.permissions[$index].access\"><md-list-item \nng-if=\"vm.isAllowed(permission, \'access\', \'all\')\"><p>Todos</p><md-radio-button value=\"all\" class=\"md-primary\">\n</md-radio-button></md-list-item><md-list-item ng-if=\"vm.isAllowed(permission, \'access\', \'owner\')\"><p>Dueño</p>\n<md-radio-button value=\"owner\" class=\"md-primary\"></md-radio-button></md-list-item><md-list-item \nng-if=\"vm.isAllowed(permission, \'access\', \'none\')\"><p>Ninguno</p><md-radio-button value=\"none\" class=\"md-primary\">\n</md-radio-button></md-list-item></md-radio-group></md-list></md-content></md-tab></md-tabs></md-content><md-content \nclass=\"md-padding\"><md-button type=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"nuevoPerfil.$invalid\">Crear\n</md-button></md-content></form></md-content></md-input-container></div></div>");
$templateCache.put("app/pages/admin/playbooks/editar/editar.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-add\"></md-icon><span>&nbsp;Editar Playbook</span> </span><span flex></span></div></div>\n<md-input-container class=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div><form \nname=\"nuevoEstatico\" class=\"md-inline-form\" novalidate ng-submit=\"vm.doEdit()\"><md-content class=\"content\" flex><h5 \nclass=\"header-material\">Playbook</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container md-no-float \nflex=\"100\"><label>Categoria</label><input type=\"text\" name=\"name\" ng-model=\"vm.playbook.name\" placeholder=\"Nombre\" \nrequired><div ng-messages=\"nuevoEstatico.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEl nombre es requerido.</span></div></div></md-input-container></div></md-content><md-divider></md-divider><div \nclass=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" flex><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"item in vm.playbook.items track by $index\" style=\"min-width:800px;max-width:1000px\"><div \nclass=\"md-list-item-text\"><h3 ng-if=\"!item.editing\">{{item.name}}</h3><md-input-container class=\"md-block\" \nng-if=\"item.editing\"><input type=\"text\" ng-model=\"item.name\" placeholder=\"Nombre...\"></md-input-container><h3 \nng-if=\"!item.editing\">{{item.ciclo}}</h3><md-input-container class=\"md-block\" ng-if=\"item.editing\"><input type=\"text\" \nng-model=\"item.ciclo\" placeholder=\"Ciclo...\"></md-input-container><md-input-container class=\"md-block\" \nng-if=\"item.editing\"><md-select ng-model=\"item.mes\"><md-option ng-repeat=\"mes in vm.meses\" ng-value=\"mes\">{{mes}}\n</md-option></md-select></md-input-container><h3 ng-if=\"!item.editing\">{{item.ano}}</h3><md-input-container \nclass=\"md-block\" ng-if=\"item.editing\"><input type=\"text\" ng-model=\"item.ano\" placeholder=\"Año...\"></md-input-container>\n<p ng-if=\"!item.editing\">{{item.descripcion}}</p><md-input-container class=\"md-block\" ng-if=\"item.editing\"><textarea \ntype=\"text\" ng-model=\"item.descripcion\" placeholder=\"Descripcion...\"></textarea></md-input-container></div>\n<input-gallery ng-model=\"vm.playbook.items[$index].file\" multiple=\"false\">Archivo</input-gallery><div \nstyle=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!item.editing\" ng-click=\"item.editing = true\"><md-icon md-font-icon=\"icon-border-color\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"item.editing\" ng-click=\"item.editing = false\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-fab md-mini md-warn\" \naria-label=\"Eliminar\" ng-click=\"vm.removeItem($index)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div>\n<md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item></md-list></div><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.addItem()\">Agregar Item</md-button><md-content class=\"md-padding\"><md-button \ntype=\"submit\" class=\"md-raised md-accent\">Editar</md-button></md-content></form></md-content></md-input-container>\n</div></div>");
$templateCache.put("app/pages/admin/playbooks/listar/listar.tmpl.html","<md-progress-linear md-mode=\"indeterminate\" class=\"md-warn\" ng-if=\"vm.loading\"></md-progress-linear><div \nid=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Playbooks</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"EC.SEARCH\" ng-model=\"vm.search\" flex></div><div><md-button class=\"md-raised md-primary\" \nui-sref=\"app.estatico.nuevo\">Nuevo Playbook</md-button></div></div><div class=\"content-card\" layout=\"column\" flex>\n<md-content class=\"md-padding\"><div listar=\"vm.listConfig\"></div></md-content></div></div></div>");
$templateCache.put("app/pages/admin/playbooks/nuevo/nuevo.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-add\"></md-icon><span>&nbsp;Nuevo Playbook</span> </span><span flex></span><md-button \nclass=\"md-raised md-primary\" profile=\"{\'user\': \'access\'}\" ui-sref=\"app.playbook.listar\">Listar Playbook</md-button>\n</div></div><md-input-container class=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div>\n<form name=\"nuevoEstatico\" class=\"md-inline-form\" novalidate ng-submit=\"vm.doCreate()\"><md-content class=\"content\" \nflex><h5 class=\"header-material\">Playbook</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nmd-no-float flex=\"100\"><label>Categoria</label><input type=\"text\" name=\"name\" ng-model=\"vm.playbook.name\" \nplaceholder=\"Nombre\" required><div ng-messages=\"nuevoEstatico.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>El nombre es requerido.</span></div></div></md-input-container></div></md-content><md-divider></md-divider><div \nclass=\"diferenciadores\" layout=\"row\" layout-align=\"start center\" flex><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"item in vm.playbook.items track by $index\" style=\"min-width:800px;max-width:1000px\"><div \nclass=\"md-list-item-text\"><h3 ng-if=\"!item.editing\">{{item.name}}</h3><md-input-container class=\"md-block\" \nng-if=\"item.editing\"><input type=\"text\" ng-model=\"item.name\" placeholder=\"Nombre...\"></md-input-container><h3 \nng-if=\"!item.editing\">{{item.ciclo}}</h3><md-input-container class=\"md-block\" ng-if=\"item.editing\"><input type=\"text\" \nng-model=\"item.ciclo\" placeholder=\"Ciclo...\"></md-input-container><h3 ng-if=\"!item.editing\">{{item.mes}}</h3>\n<md-input-container class=\"md-block\" ng-if=\"item.editing\"><md-select ng-model=\"item.mes\"><md-option \nng-repeat=\"mes in vm.meses\" ng-value=\"mes\">{{mes}}</md-option></md-select></md-input-container><h3 \nng-if=\"!item.editing\">{{item.ano}}</h3><md-input-container class=\"md-block\" ng-if=\"item.editing\"><input type=\"text\" \nng-model=\"item.ano\" placeholder=\"Año...\"></md-input-container><p ng-if=\"!item.editing\">{{item.descripcion}}</p>\n<md-input-container class=\"md-block\" ng-if=\"item.editing\"><textarea type=\"text\" ng-model=\"item.descripcion\" \nplaceholder=\"Descripcion...\"></textarea></md-input-container></div><input-gallery \nng-model=\"vm.playbook.items[$index].file\" multiple=\"false\">Archivo</input-gallery><div \nstyle=\"min-width:200px !important\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Editar\" \nng-if=\"!item.editing\" ng-click=\"item.editing = true\"><md-icon md-font-icon=\"icon-border-color\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini md-primary\" aria-label=\"Guardar\" ng-if=\"item.editing\" ng-click=\"item.editing = false\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-fab md-mini md-warn\" \naria-label=\"Eliminar\" ng-click=\"vm.removeItem($index)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div>\n<md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item></md-list></div><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.addItem()\">Agregar Item</md-button><md-content class=\"md-padding\"><md-button \ntype=\"submit\" class=\"md-raised md-accent\">Crear</md-button></md-content></form></md-content></md-input-container></div>\n</div>");
$templateCache.put("app/pages/admin/playbooks/ver/ver.tmpl.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Explorar Playbooks</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"EC.SEARCH\" ng-model=\"vm.search\" flex></div></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"simple-table-container md-whiteframe-4dp\" \nng-if=\"vm.playbook==null && ( vm.search == \'\' || vm.search==null)\" style=\"overflow-y:scroll !important\"><div \nclass=\"table-title\">Playbooks</div><div class=\"ms-responsive-table-wrapper\"><table class=\"simple\" \nms-responsive-table=\"\"><thead><tr><th>Categoría</th><th># de playbooks</th><th>Acciones</th></tr></thead><tfoot><tr>\n<td></td></tr></tfoot><tbody><tr ng-repeat=\"playbook in vm.playbooks\"><td class=\"name\">{{playbook.name}}</td><td \nclass=\"office\">{{playbook.items.length}}</td><td><md-button class=\"md-accent md-warn\" ng-click=\"vm.verTodos(playbook)\">\nVer Todos</md-button></td></tr></tbody></table></div></div><div class=\"simple-table-container md-whiteframe-4dp\" \nng-if=\"vm.playbook!=null && vm.allItems!=null && ( vm.search == \'\' || vm.search==null)\" \nstyle=\"overflow-y:scroll !important\"><div class=\"table-title\">{{vm.playbook.name}} > Todos</div><md-button \nclass=\"md-accent\" ng-click=\"vm.cerrarTodos()\">Volver</md-button><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"simple\" ms-responsive-table=\"\"><thead><tr><th>Name</th><th>Fecha liberado</th><th>Descripción</th><th>Archivo\n</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-repeat=\"item in vm.allItems\"><td class=\"name\">\n{{item.name}}</td><td class=\"name\">{{item.mes}} - {{item.ano}}</td><td class=\"name\">{{item.descripcion}}</td><td>\n<input-gallery disabled=\"true\" ng-model=\"item.file\" multiple=\"false\" disabled=\"true\" modelo=\"item.file\">\nSeleccionar Imagen</input-gallery></td></tr></tbody></table></div></div><div \nclass=\"simple-table-container md-whiteframe-4dp\" \nng-if=\"vm.ciclos!=null && vm.items == null && vm.allItems == null && ( vm.search == \'\' || vm.search==null)\" \nstyle=\"overflow-y:scroll !important\"><div class=\"table-title\">{{vm.playbook.name }} > Ciclos</div><md-button \nclass=\"md-accent\" ng-click=\"vm.cerrarCiclos()\">Volver</md-button><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"simple\" ms-responsive-table=\"\"><thead><tr><th>Ciclo</th><th># de playbooks</th><th>Acciones</th></tr></thead>\n<tfoot><tr><td></td></tr></tfoot><tbody><tr ng-repeat=\"ciclo in vm.ciclosKeys\"><td class=\"name\">{{ciclo}}</td><td \nclass=\"office\">{{vm.ciclos[ciclo].length}}</td><td><md-button class=\"md-accent\" ng-click=\"vm.setCiclo(ciclo)\">Ver\n</md-button></td></tr></tbody></table></div></div><div class=\"simple-table-container md-whiteframe-4dp\" \nng-if=\"vm.playbook!=null && vm.items!=null && vm.ciclo != null && ( vm.search == \'\' || vm.search==null)\" \nstyle=\"overflow-y:scroll !important\"><div class=\"table-title\">{{vm.playbook.name}} > Ciclos > {{vm.ciclo}}</div>\n<md-button class=\"md-accent\" ng-click=\"vm.volverAciclos()\">Volver</md-button><div class=\"ms-responsive-table-wrapper\">\n<table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th>Nombre</th><th>Fecha liberado</th><th>Descripción</th><th>\nArchivo</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-repeat=\"item in vm.items\"><td class=\"name\">\n{{item.name}}</td><td class=\"name\">{{item.mes || 10}}-{{item.ano}}</td><td class=\"name\">{{item.descripcion}}</td><td>\n<input-gallery disabled=\"true\" ng-model=\"item.file\" multiple=\"false\" disabled=\"true\" modelo=\"item.file\">\nSeleccionar Imagen</input-gallery></td></tr></tbody></table></div></div><div \nclass=\"simple-table-container md-whiteframe-4dp\" ng-if=\"vm.search != \'\' && vm.search!=null\" \nstyle=\"overflow-y:scroll !important\"><div class=\"table-title\">Buscar</div><md-button class=\"md-accent\" \nng-click=\"vm.volverAciclos()\">Volver</md-button><div class=\"ms-responsive-table-wrapper\"><table class=\"simple\" \nms-responsive-table=\"\"><thead><tr><th>Nombre {{vm.search}}</th><th>Fecha liberado</th><th>Descripción</th><th>Archivo\n</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody ng-repeat=\"playbook in vm.playbooks\"><tr \nng-repeat=\"item in playbook.items |filter:vm.search \"><td class=\"name\">{{item.name}}</td><td class=\"name\">\n{{item.mes}} - {{item.ano}}</td><td class=\"name\">{{item.descripcion}}</td><td><input-gallery disabled=\"true\" \nng-model=\"item.file\" multiple=\"false\" disabled=\"true\" modelo=\"item.file\">Seleccionar Imagen</input-gallery></td></tr>\n</tbody></table></div></div></div></div></div>");
$templateCache.put("app/pages/admin/pregunta/editar/editar.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll pregunta\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-add\"></md-icon><span>&nbsp;Nuevo pregunta</span> </span><span flex></span><md-button \nclass=\"md-raised md-primary\" profile=\"{\'user\': \'access\'}\" ui-sref=\"app.pregunta.listar\">Listar pregunta</md-button>\n</div></div><md-content class=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div><form \nname=\"nuevoPregunta\" class=\"md-inline-form\" novalidate ng-submit=\"vm.doEdit()\"><md-content class=\"content\" flex><h5 \nclass=\"header-material\">Nombre</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container md-no-float \nflex=\"50\"><label>Pregunta ES</label><input type=\"text\" name=\"text\" ng-model=\"vm.pregunta.text\" placeholder=\"Pregunta\">\n<div ng-messages=\"nuevoPregunta.text.$error\" role=\"alert\"><div ng-message=\"\"><span>El texto es requerido.</span></div>\n</div></md-input-container><md-input-container md-no-float flex=\"50\"><label>Pregunta ES_COL</label><input type=\"text\" \nname=\"text\" ng-model=\"vm.pregunta.textES_COL\" placeholder=\"Pregunta\"><div ng-messages=\"nuevoPregunta.text.$error\" \nrole=\"alert\"><div ng-message=\"\"><span>El texto es requerido.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-switch ng-model=\"vm.pregunta.multiple\" aria-label=\"multiple\">\nRespuesta Múltiple ?</md-switch></div></md-content><md-content class=\"content\" flex><div class=\"options\" \nng-repeat=\"option in vm.pregunta.options track by $index\"><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container md-no-float flex=\"50\"><label>Título ES</label><input type=\"text\" name=\"text\" \nng-model=\"option.title\" placeholder=\"título\"><div ng-messages=\"nuevoPregunta.text.$error\" role=\"alert\"><div \nng-message=\"\"><span>El texto es requerido.</span></div></div></md-input-container><md-input-container md-no-float \nflex=\"50\"><label>Título ES_COL</label><input type=\"text\" name=\"text\" ng-model=\"option.titleES_COL\" \nplaceholder=\"título\"><div ng-messages=\"nuevoPregunta.text.$error\" role=\"alert\"><div ng-message=\"\"><span>\nEl texto es requerido.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container md-no-float flex=\"50\"><label>Descripción ES</label><input type=\"text\" name=\"text\" \nng-model=\"option.description\" placeholder=\"descripción\"><div ng-messages=\"nuevoPregunta.text.$error\" role=\"alert\"><div \nng-message=\"\"><span>El texto es requerido.</span></div></div></md-input-container><md-input-container md-no-float \nflex=\"50\"><label>Descripción ES_COL</label><input type=\"text\" name=\"text\" ng-model=\"option.descriptionES_COL\" \nplaceholder=\"descripción\"><div ng-messages=\"nuevoPregunta.text.$error\" role=\"alert\"><div ng-message=\"\"><span>\nEl texto es requerido.</span></div></div></md-input-container></div><div><h5 class=\"header-material\">Imagen</h5>\n<input-gallery ng-model=\"option.image\" multiple=\"true\">Seleccionar Imagen</input-gallery></div><div id=\"filtros\"><h5 \nclass=\"header-material\">Filtros {{option.title}}</h5><div layout=\"row\" layout-wrap flex \nng-repeat=\"filter in option.filters track by $index\"><md-select placeholder=\"Seleccione Caracteristica\" \nng-model=\"filter.caracteristica\" flex=\"50\" ng-change=\"vm.changeCaracteristica(filter)\"><md-option \nng-value=\"caracteristica\" ng-repeat=\"caracteristica in vm.caracteristicas\" \nng-selected=\"caracteristica.key==filter.key\">{{caracteristica.name}}</md-option></md-select><fieldset \nclass=\"demo-fieldset\" ng-if=\"filter.caracteristica.type == \'SELECT\'\" flex=\"50\"><legend class=\"demo-legend\">\nSeleccione todas las que apliquen</legend><div layout=\"row\" layout-wrap flex><div class=\"demo-select-all-checkboxes\" \nflex=\"20\" ng-repeat=\"value in filter.caracteristica.options\"><md-checkbox ng-checked=\"vm.exists(value.key, filter)\" \nng-click=\"vm.toggle(value.key, filter)\">{{ value.label }}</md-checkbox></div></div></fieldset><md-select \nplaceholder=\"Seleccione Condición\" ng-if=\"filter.caracteristica.type ==\'NUMBER\'\" ng-model=\"filter.condition\"><md-option\n ng-value=\"optNum.value\" ng-repeat=\"optNum in vm.optionsNumber\">{{optNum.label}}</md-option></md-select>\n<md-input-container md-no-float flex=\"40\" ng-if=\"filter.caracteristica.type ==\'NUMBER\'\"><label>Valor</label><input \ntype=\"text\" name=\"text\" ng-model=\"filter.value\" placeholder=\"Valor\"></md-input-container><md-input-container \nng-if=\"filter.caracteristica.type ==\'BOOLEAN\'\"><label>Posee característica ?</label><md-switch ng-model=\"filter.value\" \naria-label=\"multiple\">Posee característica ?</md-switch></md-input-container><md-button \nclass=\"md-fab md-mini md-primary\" aria-label=\"Eliminar\" ng-click=\"vm.deleteFilter(option, $index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><md-button class=\"md-fab md-mini md-primary\" \naria-label=\"Eliminar\" ng-click=\"vm.deleteOption($index)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini md-primary\" aria-label=\"clone\" ng-click=\"vm.cloneOption(option)\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-blank\"></md-icon></md-button><md-button class=\"md-fab md-mini md-primary\" \naria-label=\"Agregar\" ng-click=\"vm.addFilter(option)\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</div><md-divider></md-divider></md-content><md-button class=\"md-raised md-primary\" ng-click=\"vm.addOption()\">\nAgregar Opción</md-button><md-divider></md-divider><md-content class=\"md-padding\"><md-button type=\"submit\" \nclass=\"md-raised md-accent\" ng-disabled=\"nuevoPregunta.$invalid\">Editar</md-button><md-button ng-click=\"vm.debug()\">\nDebug</md-button></md-content></form></md-content></md-content></div></div>");
$templateCache.put("app/pages/admin/reportes/realtime/realtime.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-edit\"></md-icon><span>&nbsp;Reportes</span> </span><span flex></span></div></div><div \nclass=\"content-card mapas\" layout=\"column\" flex><div layout=\"row\" class=\"date-row\"><md-input-container flex=\"25\" \nng-if=\"!vm.isAdminFlota\"><label>Flota</label><md-select ng-model=\"vm.flotaId\" ng-change=\"vm.listVehiculos()\" \nplaceholder=\"Seleccione flota\"><md-option ng-value=\"flota.id\" ng-repeat=\"flota in vm.flotas\">{{flota.nombre}}\n</md-option></md-select></md-input-container><md-input-container flex=\"50\" style=\"margin-left:20px\"><label>Vehiculo\n</label><md-select ng-model=\"vm.vehiculosSelected\" ng-change=\"vm.changeVehiculos()\" multiple=\"true\" \nplaceholder=\"Seleccione Vehiculo\"><md-option ng-value=\"vehiculo.id\" ng-repeat=\"vehiculo in vm.vehiculos\">\n{{vehiculo.patente}}</md-option></md-select></md-input-container><md-button ng-click=\"vm.actualizar()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"buscar\">Buscar</md-button></div><md-content style=\"flex-grow: 1\">\n<map-realtime markers=\"vm.markers\" on-move=\"vm.onMove(map, bounds)\"></map-realtime></md-content></div></div></div>");
$templateCache.put("app/pages/admin/reportes/resumen/resumen.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-edit\"></md-icon><span>&nbsp;Reportes</span> </span><span flex></span></div></div><div \nclass=\"content-card mapas\" id=\"print\" layout=\"column\" flex><div layout=\"row\" class=\"date-row\"><md-datepicker \nng-model=\"vm.fecha\" md-placeholder=\"Fecha \" ng-model-options=\"{ timezone: \'UTC\' }\" flex=\"20\"></md-datepicker>\n<md-input-container flex=\"15\" ng-if=\"!vm.isAdminFlota\"><label>Flota</label><md-select ng-model=\"vm.flotaId\" \nng-change=\"vm.listVehiculos()\" placeholder=\"Seleccione flota\"><md-option ng-value=\"flota.id\" \nng-repeat=\"flota in vm.flotas\">{{flota.nombre}}</md-option></md-select></md-input-container><md-input-container \nflex=\"15\"><label>Vehiculo</label><md-select ng-model=\"vm.vehiculoId\" placeholder=\"Vehiculo\"><md-option \nng-value=\"vehiculo.id\" ng-repeat=\"vehiculo in vm.vehiculos\">{{vehiculo.patente}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"10\"><label>Hora Inicio</label><md-select ng-model=\"vm.horaInicio\">\n<md-option ng-value=\"hora.hora\" ng-repeat=\"hora in vm.horas\">{{hora.horaF}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"10\"><label>Hora Fin</label><md-select ng-model=\"vm.horaFin\"><md-option \nng-value=\"hora.hora\" ng-repeat=\"hora in vm.horas\">{{hora.horaF}}</md-option></md-select></md-input-container><md-button\n ng-click=\"vm.buscar()\" class=\"save-button md-accent md-raised\" aria-label=\"buscar\" \nng-disabled=\"!vm.vehiculoId || !vm.fecha \">Buscar</md-button><md-button ng-click=\"vm.ajustar()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"ajustar\" ng-disabled=\"!vm.vehiculoId || !vm.fecha \">Ajustar\n</md-button><md-button ng-click=\"vm.print()\" class=\"save-button md-accent md-raised\" aria-label=\"Imprimir\" \nng-disabled=\"!vm.vehiculoId || !vm.fecha \">Imprimir</md-button></div><md-content><div loading=\"vm.loading\"></div>\n<ng-map zoom=\"15\" center=\"{{vm.center}}\" default-style=\"false\" style=\"height: 400px\"><shape name=\"polyline\" id=\"foo\" \npath=\"{{vm.path}}\" stroke-color=\"{{vm.color}}\" stroke-opacity=\"1.0\" stroke-weight=\"3\"></shape><marker \nng-repeat=\"marker in vm.markers\" position=\"{{marker.position}}\" icon=\"{{marker.icon}}\" \non-click=\"vm.showDetail(marker)\" id=\"{{marker.id}}\"></marker><info-window id=\"foo-iw\"><div ng-non-bindable=\"\"><b \nng-if=\"vm.velocidad\">Velocidad:</b> {{vm.velocidad}} km/h<br><b>Hora:</b> {{vm.hora}}<br><b>Conductor:</b>\n {{vm.nombreConductor}}<br></div></info-window></ng-map></md-content><md-content class=\"content\" flex><h5 \nclass=\"header-material\">Datos del Recorrido</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"25\" flex-gt-xs=\"25\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4\">Kilometros Recorridos</div></div><div class=\"pt-8 pb-16\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"indigo-fg font-size-30 line-height-30\">\n{{(vm.distancia).toString().replace(\'.\',\',\')}} Km</div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\" ng-if=\"vm.vProm\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4\">\nVelocidad Promedio</div></div><div class=\"pt-8 pb-16\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"indigo-fg font-size-30 line-height-30\">{{(vm.vProm).toString().replace(\'.\',\',\')}} Km/H</div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"h4\">Tiempo de Viaje</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"indigo-fg font-size-30 line-height-30\">{{vm.duration}}</div><div class=\"h5 secondary-text font-weight-500\">\nHora Inicio : {{vm.tiempoInicio}}</div><div class=\"h5 secondary-text font-weight-500\">Hora Fin : {{vm.tiempoFin}}</div>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"25\" flex-gt-xs=\"25\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\" ng-if=\"vm.vMax\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4\">Velocidad Máxima</div></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"indigo-fg font-size-30 line-height-30\">\n{{vm.vMax.toString().replace(\'.\',\',\') }} km/h</div></div></ms-widget-front></ms-widget></div></div></md-content></div>\n</div></div>");
$templateCache.put("app/pages/admin/settings/settings/settings.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" id=\"settings\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"zmdi zmdi-receipt\"></md-icon><span>Configuración</span></span></div></div><md-input-container \nclass=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div><form name=\"settingsForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.guardar()\"><md-content class=\"content\" flex><h5 \nclass=\"header-material\"></h5><div layout=\"row\" flex><md-input-container flex=\"100\"><label>Precisión deseada [m]</label>\n<md-select ng-model=\"vm.settings.desiredAccuracy\" placeholder=\"Seleccione precisión deseada\"><md-option \nng-value=\"distancia\" ng-repeat=\"distancia in vm.distancias\">{{distancia}}</md-option></md-select><div \nclass=\"hint select\">\nPosición deseada en metros. Mientras más bajo, más batería utiliza ya que el GPS es más preciso. Posibles valores 0, 10, 100, 1000 [ms]\n</div></md-input-container></div><div layout=\"row\" flex><md-input-container md-no-float flex=\"100\"><label>\nRadio Estacionario [m]</label><input type=\"number\" required name=\"stationaryRadius\" \nng-model=\"vm.settings.stationaryRadius\"><div class=\"hint\">\nRadio estacionario en metros. Distancia en metros para volver a activar el GPS cuando se encuentra detenido por un tiempo prolongado.\n</div><div ng-messages=\"settingsForm.stationaryRadius.$error\"><div ng-message=\"min\">El valor mínimo es 1000</div><div \nng-message=\"required\">Campo requerido.</div></div></md-input-container></div><div layout=\"row\" flex><md-input-container\n md-no-float flex=\"100\"><label>Distancia mínima [m]</label><input required name=\"distanceFilter\" type=\"number\" \nng-model=\"vm.settings.distanceFilter\"><div class=\"hint\">\nLa distancia mínima en metros para que se genere un evento de geolocalización.</div><div \nng-messages=\"settingsForm.distanceFilter.$error\"><div ng-message=\"min\">El valor mínimo es 1000</div><div \nng-message=\"required\">Campo requerido.</div></div></md-input-container></div><div layout=\"row\" flex><md-input-container\n md-no-float flex=\"100\"><label>Intervalo [ms]</label><input required name=\"interval\" type=\"number\" \nng-model=\"vm.settings.interval\" min=\"1000\"><div class=\"hint\">\nLa mínima cantidad de tiempo (en milisegundos) en la que se genera un evento de geolocalización.</div><div \nng-messages=\"settingsForm.interval.$error\"><div ng-message=\"min\">El valor mínimo es 1000</div><div \nng-message=\"required\">Campo requerido.</div></div></md-input-container></div><div layout=\"row\" flex><md-input-container\n md-no-float flex=\"100\"><label>Intervalo corto [ms]</label><input required name=\"fastestInterval\" type=\"number\" \nng-model=\"vm.settings.fastestInterval\" min=\"1000\"><div class=\"hint\">\nLa tasa más rápida en milisegundos en que la aplicación registrará cambios en la ubicación.</div><div \nng-messages=\"settingsForm.interval.$error\"><div ng-message=\"min\">El valor mínimo es 1000</div><div \nng-message=\"required\">Campo requerido.</div></div></md-input-container></div><div layout=\"row\" flex><md-input-container\n md-no-float flex=\"100\"><label>Intervalo entre actividades [ms]</label><input required name=\"activitiesInterval\" \ntype=\"number\" ng-model=\"vm.settings.activitiesInterval\" min=\"1000\"><div class=\"hint\">\nValor en milisegundos en los que se produce el reconocimiento de actividad. Los valores más grandes resultarán en menos detecciones de actividad mientras mejora la duración de la batería.\n</div><div ng-messages=\"settingsForm.activitiesInterval.$error\"><div ng-message=\"min\">El valor mínimo es 1000</div><div\n ng-message=\"required\">Campo requerido.</div></div></md-input-container></div><div layout=\"row\" flex>\n<md-input-container md-no-float flex=\"100\"><label>Intervalo estático [ms]</label><input required name=\"staticInterval\" \ntype=\"number\" ng-model=\"vm.settings.staticInterval\" min=\"1000\"><div class=\"hint\">\nCuando está detenido, cada cuántos milisegundos debe enviar el último valor de ubicación registrada.</div><div \nng-messages=\"settingsForm.staticInterval.$error\"><div ng-message=\"min\">El valor mínimo es 1000</div><div \nng-message=\"required\">Campo requerido.</div></div></md-input-container></div></md-content><md-content \nclass=\"md-padding\"><md-button type=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"settingsForm.$invalid\">Guardar\n</md-button></md-content></form></md-content></md-input-container></div></div>");
$templateCache.put("app/pages/admin/template/editar/editar.tmpl.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ui-sref=\"app.templates.listar\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.template.name}}</div></div></div></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.doEdit()\">\n<span translate=\"EC.SAVE\">SAVE</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab>\n<md-tab-label><span translate=\"EC.BASIC_INFO\">Nombre y Header</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><label>\nNombre Template</label><input type=\"text\" ng-model=\"vm.template.name\"></md-input-container><md-input-container \nflex=\"100\"><label>Versión {{vm.template.version}}</label><md-select ng-model=\"vm.template.version\" \nplaceholder=\"version\"><md-option ng-value=\"v\" ng-repeat=\"v in vm.versions\">{{ v }}</md-option></md-select>\n</md-input-container><div ng-if=\"vm.template.version!=2\"><md-input-container class=\"md-block\"><label>\nColor default de fuente</label><div md-color-picker=\"vm.colorOptions\" ng-model=\"vm.template.header.defaultColor\"></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Color de fuente destacado</label><div \nmd-color-picker=\"vm.colorOptions\" ng-model=\"vm.template.header.titleColor\"></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Color título especificaciones</label><div \nmd-color-picker=\"vm.colorOptions\" ng-model=\"vm.template.header.especificaciones\"></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Fondo de subtitulo</label><div md-color-picker=\"vm.colorOptions\" \nng-model=\"vm.template.header.subtitleBackground\"></div></md-input-container><md-input-container class=\"md-block\">\n<label>Color de subtitulo</label><div md-color-picker=\"vm.colorOptions\" ng-model=\"vm.template.header.subtitleColor\">\n</div></md-input-container><div><h5 class=\"header-material\">Logo</h5><input-gallery ng-model=\"vm.template.header.logo\" \nmultiple=\"false\">Seleccionar Logo</input-gallery></div><md-input-container class=\"md-block\"><label>Color de Fondo\n</label><div md-color-picker=\"vm.colorOptions\" ng-model=\"vm.template.header.backgroundColor\"></div>\n</md-input-container><div><h5 class=\"header-material\">Imagen de Fondo</h5><input-gallery \nng-model=\"vm.template.header.backgroundImage\" multiple=\"false\">Seleccionar Imagen de Fondo</input-gallery></div><div>\n<h5 class=\"header-material\">Imagen de Fondo Mobile</h5><input-gallery \nng-model=\"vm.template.header.backgroundImageMobile\" multiple=\"false\">Seleccionar Imagen de Fondo</input-gallery></div>\n</div></div></md-tab-body></md-tab><md-tab ng-if=\"vm.template.version!=2\"><md-tab-label><span>Textos</span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\">\n<md-input-container class=\"md-block\"><label>Título</label><input type=\"text\" ng-model=\"vm.template.textos.titulo\">\n</md-input-container><md-input-container class=\"md-block\"><label>Subtitulo</label><input type=\"text\" \nng-model=\"vm.template.textos.subtitulo\"></md-input-container></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.template.version!=2\"><md-tab-label><span>Especificaciones y visuales</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><label>\nColor de fuente</label><div md-color-picker=\"vm.colorOptions\" ng-model=\"vm.template.body.defaultColor\"></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Color de fuente destacado</label><div \nmd-color-picker=\"vm.colorOptions\" ng-model=\"vm.template.body.titleColor\"></div></md-input-container></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"EC.BASIC_INFO\">Nombre y Header</span></md-tab-label>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container \nflex=\"100\"><label>Categorías</label><md-select ng-model=\"vm.template.categoriaId\" placeholder=\"Categoría\" \nng-change=\"vm.changeCategoria()\"><md-option ng-value=\"categoria.id\" ng-repeat=\"categoria in vm.categorias\">\n{{ categoria.nombre }}</md-option></md-select></md-input-container><md-content class=\"content\" flex><h5 \nclass=\"header-material\">Especifaciones Orden en 0 Para omitir</h5><div layout=\"column\" layout-wrap flex><div \nflex=\"100\" layout=\"row\" ng-repeat=\"field in vm.template.specs track by $index\"><md-input-container class=\"md-no-float\" \nflex=\"30\" ng-if=\"vm.template.version === 2\"><input-gallery ng-model=\"vm.template.specs[$index].imagen\" \nmultiple=\"false\">Seleccionar Imagen</input-gallery></md-input-container><md-input-container class=\"md-no-float\" \nflex=\"40\"><label>{{field.label }} Orden</label><input type=\"number\" ng-model=\"vm.template.specs[$index].order\">\n</md-input-container></div></div></md-content></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/pages/admin/template/listar/listar.tmpl.html","<md-progress-linear md-mode=\"indeterminate\" class=\"md-warn\" ng-if=\"vm.loading\"></md-progress-linear><div \nid=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Templates</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"EC.SEARCH\" ng-model=\"vm.search\" flex></div><div><md-button class=\"md-raised md-primary\" \nui-sref=\"app.template.nuevo\">Nuevo Template</md-button></div></div><div class=\"content-card\" layout=\"column\" flex>\n<md-content class=\"md-padding\"><div listar=\"vm.listConfig\"></div></md-content></div></div></div>");
$templateCache.put("app/pages/admin/template/nuevo/nuevo.tmpl.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ui-sref=\"app.templates.listar\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.template.name}}</div></div></div></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.doCreate()\">\n<span translate=\"EC.SAVE\">SAVE</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab>\n<md-tab-label><span translate=\"EC.BASIC_INFO\">Nombre y Header</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><label>\nNombre Template</label><input type=\"text\" ng-model=\"vm.template.name\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Color default de fuente</label><div md-color-picker=\"vm.colorOptions\" \nng-model=\"vm.template.header.defaultColor\"></div></md-input-container><md-input-container class=\"md-block\"><label>\nColor de fuente destacado</label><div md-color-picker=\"vm.colorOptions\" ng-model=\"vm.template.header.titleColor\"></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Color título especificaciones</label><div \nmd-color-picker=\"vm.colorOptions\" ng-model=\"vm.template.header.especificaciones\"></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Fondo de subtitulo</label><div md-color-picker=\"vm.colorOptions\" \nng-model=\"vm.template.header.subtitleBackground\"></div></md-input-container><md-input-container class=\"md-block\">\n<label>Color de subtitulo</label><div md-color-picker=\"vm.colorOptions\" ng-model=\"vm.template.header.subtitleColor\">\n</div></md-input-container><div><h5 class=\"header-material\">Logo</h5><input-gallery ng-model=\"vm.template.header.logo\" \nmultiple=\"false\">Seleccionar Logo</input-gallery></div><md-input-container class=\"md-block\"><label>Color de Fondo\n</label><div md-color-picker=\"vm.colorOptions\" ng-model=\"vm.template.header.backgroundColor\"></div>\n</md-input-container><div><h5 class=\"header-material\">Imagen de Fondo</h5><input-gallery \nng-model=\"vm.template.header.backgroundImage\" multiple=\"false\">Seleccionar Imagen de Fondo</input-gallery></div><div>\n<h5 class=\"header-material\">Imagen de Fondo Mobile</h5><input-gallery \nng-model=\"vm.template.header.backgroundImageMobile\" multiple=\"false\">Seleccionar Imagen de Fondo</input-gallery></div>\n</div></md-tab-body></md-tab><md-tab><md-tab-label><span>Textos</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-input-container class=\"md-block\"><label>\nTítulo</label><input type=\"text\" ng-model=\"vm.template.textos.titulo\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Subtitulo</label><input type=\"text\" ng-model=\"vm.template.textos.subtitulo\">\n</md-input-container></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Especificaciones y visuales</span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\">\n<md-input-container class=\"md-block\"><label>Color de fuente</label><div md-color-picker=\"vm.colorOptions\" \nng-model=\"vm.template.body.defaultColor\"></div></md-input-container><md-input-container class=\"md-block\"><label>\nColor de fuente destacado</label><div md-color-picker=\"vm.colorOptions\" ng-model=\"vm.template.body.titleColor\"></div>\n</md-input-container></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"EC.BASIC_INFO\">Nombre y Header\n</span></md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\">\n<md-input-container flex=\"100\"><label>Categorías</label><md-select ng-model=\"vm.template.categoriaId\" \nplaceholder=\"Categoría\" ng-change=\"vm.changeCategoria()\"><md-option ng-value=\"categoria.id\" \nng-repeat=\"categoria in vm.categorias\">{{ categoria.nombre }}</md-option></md-select></md-input-container><md-content \nclass=\"content\" flex><h5 class=\"header-material\">Especifaciones</h5><div layout=\"row\" layout-wrap flex><div flex=\"100\" \nng-repeat=\"field in vm.template.specs track by $index\"><md-input-container class=\"md-block\"><label>\n{{field.label }} Orden (0 para omitir)</label><input type=\"number\" ng-model=\"vm.template.specs[$index].order\">\n</md-input-container></div></div></md-content></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/pages/admin/usuario/editar/editar.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-add\"></md-icon><span>&nbsp;Editar usuario</span> </span><span flex></span></div></div>\n<md-input-container class=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div><form \nname=\"nuevoUsuario\" class=\"md-inline-form\" novalidate ng-submit=\"vm.doEdit()\"><md-content class=\"content\" flex><h5 \nclass=\"header-material\">Datos principales</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nmd-no-float flex=\"100\"><label>Nombre</label><input type=\"text\" name=\"name\" ng-model=\"vm.usuario.name\" \nplaceholder=\"Nombre\" required><div ng-messages=\"nuevoUsuario.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>El nombre es requerido.</span></div></div></md-input-container><md-input-container md-no-float flex=\"100\"><label>\nApellido</label><input type=\"text\" name=\"lastname\" ng-model=\"vm.usuario.lastname\" placeholder=\"Apellido\"><div \nng-messages=\"nuevoUsuario.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>El apellido es requerido.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nmd-no-float flex=\"100\"><label>Correo electrónico</label><input type=\"text\" name=\"email\" ng-model=\"vm.usuario.email\" \nplaceholder=\"Correo electrónico\" required><div ng-messages=\"nuevoUsuario.email.$error\" role=\"alert\"><div \nng-message=\"required\"><span>El correo es requerido.</span></div></div></md-input-container><md-input-container \nmd-no-float flex=\"100\"><md-select ng-model=\"vm.usuario.profile\" placeholder=\"Seleccione Perfil\"><md-option \nng-value=\"profile.identifier\" ng-repeat=\"profile in vm.profiles\">{{ profile.name }}</md-option></md-select>\n</md-input-container>--></div><div layout=\"column\" layout-gt-xs=\"row\" flex ng-if=\"vm.usuario.id != vm.logedId\">\n<md-switch ng-model=\"vm.usuario.state\" aria-label=\"Estado\">Estado</md-switch></div></md-content><md-divider>\n</md-divider><md-content class=\"content\" flex><h5 class=\"header-material\">Seguridad</h5><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Contraseña nueva</label><input type=\"password\" \nname=\"password\" ng-model=\"vm.usuario.password\" placeholder=\"Contraseña nueva\"></md-input-container><md-input-container \nflex=\"100\"><label>Repetir contraseña</label><input type=\"password\" name=\"repeatPassword\" \nng-model=\"vm.usuario.repeatPassword\" placeholder=\"Repetir contraseña\"></md-input-container></div></md-content>\n<md-content class=\"md-padding\"><md-button type=\"submit\" class=\"md-raised md-accent\" \nng-disabled=\"nuevoUsuario.$invalid\">Editar</md-button></md-content></form></md-content></md-input-container></div>\n</div>");
$templateCache.put("app/pages/admin/usuario/listar/listar.tmpl.html","<md-progress-linear md-mode=\"indeterminate\" class=\"md-warn\" ng-if=\"vm.loading\"></md-progress-linear><div \nid=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Usuarios</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"EC.SEARCH\" ng-model=\"vm.search\" flex></div><div><md-button class=\"md-raised md-primary\" \nui-sref=\"app.usuario.nuevo\">Nuevo Usuario</md-button></div></div><div class=\"content-card\" layout=\"column\" flex>\n<md-content class=\"md-padding\"><div listar=\"vm.listConfig\"></div></md-content></div></div></div>");
$templateCache.put("app/pages/admin/usuario/nuevo/nuevo.tmpl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" flex layout=\"row\" layout-align=\"start center\"><span class=\"h1\"><md-icon \nmd-font-icon=\"fi flaticon-add\"></md-icon><span>&nbsp;Nuevo usuario</span> </span><span flex></span><md-button \nclass=\"md-raised md-primary\" profile=\"{\'user\': \'access\'}\" ui-sref=\"app.usuario.listar\">Listar usuario</md-button></div>\n</div><md-input-container class=\"content-card\" layout=\"column\" flex><md-content><div loading=\"vm.loading\"></div><form \nname=\"nuevoUsuario\" class=\"md-inline-form\" novalidate ng-submit=\"vm.doCreate()\"><md-content class=\"content\" flex><h5 \nclass=\"header-material\">Datos principales</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nmd-no-float flex=\"100\"><label>Nombre</label><input type=\"text\" name=\"name\" ng-model=\"vm.usuario.name\" \nplaceholder=\"Nombre\" required><div ng-messages=\"nuevoUsuario.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>El nombre es requerido.</span></div></div></md-input-container><md-input-container md-no-float flex=\"100\"><label>\nApellido</label><input type=\"text\" name=\"lastname\" ng-model=\"vm.usuario.lastname\" placeholder=\"Apellido\"><div \nng-messages=\"nuevoUsuario.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>El apellido es requerido.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nmd-no-float flex=\"100\"><label>Correo electrónico</label><input type=\"text\" name=\"email\" ng-model=\"vm.usuario.email\" \nplaceholder=\"Correo electrónico\" required><div ng-messages=\"nuevoUsuario.email.$error\" role=\"alert\"><div \nng-message=\"required\"><span>El correo es requerido.</span></div></div></md-input-container><md-input-container \nmd-no-float flex=\"100\"><md-select ng-model=\"vm.usuario.profile\" placeholder=\"Seleccione Perfil\"><md-option \nng-value=\"profile.identifier\" ng-repeat=\"profile in vm.profiles\">{{ profile.name }}</md-option></md-select>\n</md-input-container></div></md-content><md-divider></md-divider><md-content class=\"content\" flex><h5 \nclass=\"header-material\">Seguridad</h5><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container md-no-float \nflex=\"100\"><label>Contraseña nueva</label><input type=\"password\" name=\"password\" ng-model=\"vm.usuario.password\" \nplaceholder=\"Contraseña nueva\" required></md-input-container><md-input-container md-no-float flex=\"100\"><label>\nRepetir contraseña</label><input type=\"password\" name=\"repeatPassword\" ng-model=\"vm.usuario.repeatPassword\" \nplaceholder=\"Repetir contraseña\" required></md-input-container></div></md-content><md-content class=\"md-padding\">\n<md-button type=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"nuevoUsuario.$invalid\">Crear</md-button></md-content>\n</form></md-content></md-input-container></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Volver</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Siguiente\n</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" \nng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\">Enviar</md-button></div></div>");
$templateCache.put("app/pages/admin/file-manager/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" aria-label=\"Download\" ng-click=\"vm.download(vm.selected)\">\n<md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Descargar</span></md-tooltip>\n</md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span>Subida\n</span>: {{ (vm.selected.fechaCreacion ? vm.selected.fechaCreacion : vm.selected.created ) |date:\'medium\' }}</div>\n</div></div><md-content class=\"content\" flex ms-scroll><div class=\"file-details\"><div class=\"preview file-icon\" \nlayout=\"row\" layout-align=\"center center\"><div \nng-if=\"!vm.selected.origin && ((vm.selected.ext == \'png\') || (vm.selected.ext == \'PNG\') || (vm.selected.ext == \'jpg\') || (vm.selected.ext == \'JPG\') || (vm.selected.ext == \'JPEG\'))\">\n<img width=\"200\" ng-src=\"{{\'https://files.alquimio.cloud/imagenes/thumb-\'+vm.selected.name}}\"></div><div \nng-if=\"vm.selected.origin && vm.selected.origin == \'fromCap\' && ((vm.selected.ext == \'png\') || (vm.selected.ext == \'PNG\') || (vm.selected.ext == \'jpg\') || (vm.selected.ext == \'JPG\') || (vm.selected.ext == \'JPEG\'))\">\n<img width=\"200\" ng-src=\"{{vm.selected.thumbUrl}}\"></div><div \nng-if=\"(vm.selected.ext != \'png\') && (vm.selected.ext != \'PNG\') && (vm.selected.ext != \'jpg\') && (vm.selected.ext != \'JPG\') && (vm.selected.ext != \'JPEG\')\">\n<img width=\"200\" ng-src=\"{{\'https://files.alquimio.cloud/imagenes/documents.png\'}}\"></div></div><div class=\"title\">\nInformación</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr \nclass=\"size\"><th translate=\"FM.SIZE\">Tamaño</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr>\n</table></div></md-content>");
$templateCache.put("app/pages/admin/file-manager/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div \nclass=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" \nplaceholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}\n</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div>\n</md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div>\n</md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">\nSharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" \ntranslate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div\n class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/pages/admin/file-manager/views/grid/grid-view.html","<div class=\"grid-view\" layout=\"column\"><div class=\"folders\" layout=\"row\" layout-wrap><div \nclass=\"md-background-bg md-hue-2 md-whiteframe-1dp item folder\" ng-click=\"vm.select(folder)\" \nng-repeat=\"folder in vm.folders | filter:global.search\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" class=\"title\" layout-align=\"start center\"><span class=\"file-icon\"><i md-font-icon=\"icon-{{folder.type}}\">\n</i> </span><span class=\"name\">{{folder.name}}</span></div><div class=\"show-details\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate translate-attr-aria-label=\"FM.DETAILS\"><md-icon \nmd-font-icon=\"icon-information-outline\" ng-click=\"vm.toggleDetails(folder)\"></md-icon></md-button></div></div></div>\n<div class=\"files\" layout=\"row\" layout-wrap><div ng-click=\"vm.select(file)\" class=\"md-whiteframe-1dp item file\" \nng-repeat=\"file in vm.files | filter:global.search\" layout=\"column\"><div class=\"preview\" \nng-if=\"file.origin && file.origin == \'fromCap\' && ((file.ext == \'png\') || (file.ext == \'PNG\') || (file.ext == \'jpg\') || (file.ext == \'JPG\') || (file.ext == \'JPEG\'))\">\n<img ng-src=\"{{file.thumbUrl}}\"></div><div class=\"preview\" \nng-if=\"!file.origin && ((file.ext == \'png\') || (file.ext == \'PNG\') || (file.ext == \'jpg\') || (file.ext == \'JPG\') || (file.ext == \'JPEG\'))\">\n<img ng-src=\"{{\'https://files.alquimio.cloud/imagenes/thumb-\'+file.name}}\"></div><div class=\"preview\" \nng-if=\"! (file.ext == \'png\') && !(file.ext == \'PNG\') && !(file.ext == \'jpg\') && !(file.ext == \'JPG\') && !(file.ext == \'JPEG\') \">\n<img ng-src=\"{{\'https://files.alquimio.cloud/imagenes/documents.png\'}}\"></div><div \nclass=\"bottom md-background-bg md-hue-2\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nclass=\"title\" layout-align=\"start center\" flex><span class=\"name\">{{file.name}}</span></div><div class=\"show-details\">\n<md-button class=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate translate-attr-aria-label=\"FM.DETAILS\">\n<md-icon md-font-icon=\"icon-information-outline\" ng-click=\"vm.toggleDetails(file)\"></md-icon></md-button></div></div>\n</div></div></div>");
$templateCache.put("app/pages/admin/file-manager/views/list/list-view-2.html","<div><md-button class=\"md-raised md-primary\" ng-click=\"vm.descargarZip()\">Descargar ZIP</md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.editFiles()\" ng-if=\"vm.isEditing === false && vm.isGod == true\">\nEditar Archivos</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.saveFiles()\" \nng-if=\"vm.isEditing === true\">Guardar Archivos</md-button></div><div \nstyle=\"border: 1px solid #e0e0e0; border-radius: 4px; overflow: hidden\"><div \nstyle=\"max-height: 400px; overflow-y: auto; overflow-x: hidden\"><table class=\"simple list-view\" \nstyle=\"width: 100%; border-collapse: collapse\"><thead \nstyle=\"background-color: #f5f5f5; position: sticky; top: 0; z-index: 10\"><tr><th \nstyle=\"padding: 8px 12px; border-bottom: 2px solid #e0e0e0; text-align: left; width: 80px\">Imagen</th><th \nng-click=\"vm.sortByName()\" \nstyle=\"cursor: pointer; user-select: none; padding: 8px 12px; border-bottom: 2px solid #e0e0e0; background-color: #f5f5f5; text-align: left; min-width: 200px\">\n<div style=\"display: flex; align-items: center; gap: 5px\"><span>Nombre</span> <span ng-if=\"!vm.reverse\">▲</span> <span \nng-if=\"vm.reverse\">▼</span></div></th><th hide show-gt-sm \nstyle=\"padding: 8px 12px; border-bottom: 2px solid #e0e0e0; text-align: left; width: 120px\">Tipo</th><th hide \nshow-gt-sm ng-if=\"vm.isEditing!=false\" \nstyle=\"padding: 8px 12px; border-bottom: 2px solid #e0e0e0; text-align: left; width: 100px\">Orden</th><th hide-gt-md \nstyle=\"padding: 8px 12px; border-bottom: 2px solid #e0e0e0; text-align: left; width: 120px\">Descargar</th></tr></thead>\n<tbody><tr ng-repeat=\"file in vm.files | orderBy : vm.sortBy : vm.reverse\" ng-click=\"vm.select(file)\" \nng-class=\"{\'selected\' : vm.selected === file, \'background-red\' : file.tag === \'3_HIDDEN\'}\" \nstyle=\"border-bottom: 1px solid #f0f0f0; transition: background-color 0.2s\" \nonmouseover=\"this.style.backgroundColor=\'#f9f9f9\'\" onmouseout=\"this.style.backgroundColor=\'\'\"><td class=\"file-icon\" \nstyle=\"padding: 8px 12px; width: 80px\"><div \nng-if=\"file.origin && file.origin ==\'fromCap\' && ((file.ext == \'png\') || (file.ext == \'PNG\') || (file.ext == \'jpeg\') || (file.ext == \'jpg\') || (file.ext == \'JPG\') || (file.ext == \'JPEG\'))\">\n<img width=\"40\" ng-src=\"{{file.thumbUrl}}\"></div><div \nng-if=\"!file.origin && ((file.ext == \'png\') || (file.ext == \'PNG\') || (file.ext == \'jpg\') || (file.ext == \'jpeg\') || (file.ext == \'JPG\') || (file.ext == \'JPEG\'))\">\n<img width=\"40\" ng-src=\"{{file.thumbUrl}}\"></div><div \nng-if=\"(file.ext != \'png\') && (file.ext != \'PNG\') && (file.ext != \'jpg\') && (file.ext != \'JPG\') && (file.ext != \'JPEG\') && (file.ext != \'jpeg\') \">\n<img width=\"40\" ng-src=\"{{\'https://files.alquimio.cloud/imagenes/documents.png\'}}\"></div></td><td class=\"name\" \nstyle=\"padding: 8px 12px; min-width: 200px\">{{file.viewName}}</td><td ng-if=\"vm.isEditing!=false\" \nstyle=\"padding: 8px 12px; width: 120px\"><md-select ng-model=\"file.tag\" placeholder=\"Seleccione Tag\"><md-option \nng-value=\"tag.id\" ng-repeat=\"tag in vm.tags\" ng-selected=\"{{ tag.id === file.tag ? \'true\' : \'false\' }}\">{{tag.name}}\n</md-option></md-select></td><td class=\"type\" ng-if=\"vm.isEditing ==false\" style=\"padding: 8px 12px; width: 120px\">\n{{ file.tagName || file.categoria }}</td><td ng-if=\"vm.isEditing!=false\" style=\"padding: 8px 12px; width: 100px\"><input\n type=\"text\" placeholder=\"orden\" ng-model=\"file.order\"></td><td class=\"last-modified\" hide show-gt-md \nstyle=\"padding: 8px 12px; width: 120px\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.download(file)\">Descargar\n</md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/pages/admin/file-manager/views/list/list-view.html","<div style=\"overflow: auto; max-height: 500px\"><table class=\"simple list-view\"><thead fix-head><tr><th></th><th>Nome\n</th><th hide show-gt-sm>Tipo</th><th hide-xs>Tamanho</th><th hide show-gt-md>Data</th><th hide-gt-md></th></tr>\n</thead><tbody><tr ng-repeat=\"file in vm.files | filter:global.search\" ng-click=\"vm.select(file)\" \nng-class=\"{\'selected\' : vm.selected === file}\"><td class=\"file-icon\"><div \nng-if=\"file.categoria && file.categoria ==\'CAP\' && ((file.ext == \'png\') || (file.ext == \'PNG\') || (file.ext == \'jpg\') || (file.ext == \'JPG\') || (file.ext == \'JPEG\'))\">\n<img width=\"40\" ng-src=\"{{file.thumbUrl}}\"></div><div \nng-if=\"!file.origin && ((file.ext == \'png\') || (file.ext == \'PNG\') || (file.ext == \'jpg\') || (file.ext == \'JPG\') || (file.ext == \'JPEG\'))\">\n<img width=\"40\" ng-src=\"{{\'https://files.alquimio.cloud/imagenes/thumb-\'+file.name}}\"></div><div \nng-if=\"(file.ext != \'png\') && (file.ext != \'PNG\') && (file.ext != \'jpg\') && (file.ext != \'JPG\') && (file.ext != \'JPEG\')\">\n<img width=\"40\" ng-src=\"{{\'https://files.alquimio.cloud/imagenes/documents.png\'}}\"></div></td><td class=\"name\">\n{{file.name}}</td><td class=\"type\" hide show-gt-sm>{{file.categoria}}</td><td class=\"size\" hide-xs>\n{{file.size === \'\' ? \'-\': file.size}}</td><td class=\"last-modified\" hide show-gt-md><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.download(file)\">Download</md-button></td><td class=\"show-details\" hide-gt-md>\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(file)\" aria-label=\"Details\" translate \ntranslate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon></md-button></td>\n</tr></tbody></table></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);